import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ActiveStaffSubscriptionInput = {
  id: Scalars['String']['input'];
  paymentIntent?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
};

export type AddPaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type AdditionalContact = {
  __typename?: 'AdditionalContact';
  contactableId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type AdditionalContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** supplier id. Will ignore this while creating the AdditionalContact */
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalContactPayload = {
  __typename?: 'AdditionalContactPayload';
  additionalContact?: Maybe<AdditionalContact>;
  response?: Maybe<Response>;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<AddressTitle>;
  type?: Maybe<AddressType>;
  typeId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPayload = {
  __typename?: 'AddressPayload';
  address?: Maybe<Address>;
  response?: Maybe<Response>;
};

/** Address titles */
export enum AddressTitle {
  OrganizationAddress = 'ORGANIZATION_ADDRESS',
  UserAddress = 'USER_ADDRESS'
}

/** The type is assigned */
export enum AddressType {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export enum AgeGroupType {
  Other = 'OTHER',
  Primary = 'PRIMARY'
}

export type Allergen = {
  __typename?: 'Allergen';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type AllergenPayload = {
  __typename?: 'AllergenPayload';
  allergen?: Maybe<Allergen>;
  response?: Maybe<Response>;
};

export type AllergensPayload = {
  __typename?: 'AllergensPayload';
  data?: Maybe<Array<Allergen>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type Attachment = {
  __typename?: 'Attachment';
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<AttachmentTitle>;
  type?: Maybe<AttachmentType>;
  typeId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentPayload = {
  __typename?: 'AttachmentPayload';
  attachment?: Maybe<Attachment>;
  response?: Maybe<Response>;
};

/** Attachment titles */
export enum AttachmentTitle {
  Capsule = 'CAPSULE',
  ExcelSheet = 'EXCEL_SHEET',
  FactSheet = 'FACT_SHEET',
  FactSheetPng = 'FACT_SHEET_PNG',
  FormulatingType = 'FORMULATING_TYPE',
  FormulaCsv = 'FORMULA_CSV',
  FormulaThumbnail = 'FORMULA_THUMBNAIL',
  OrganizationThumbnail = 'ORGANIZATION_THUMBNAIL',
  Powder = 'POWDER',
  QuotationSheet = 'QUOTATION_SHEET',
  RequestQuotationSheet = 'REQUEST_QUOTATION_SHEET',
  SpecSheet = 'SPEC_SHEET',
  Tablet = 'TABLET',
  UserThumbnail = 'USER_THUMBNAIL'
}

/** The type is assigned */
export enum AttachmentType {
  Dosage = 'DOSAGE',
  Formula = 'FORMULA',
  Ingredient = 'INGREDIENT',
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type BeadletPayload = {
  __typename?: 'BeadletPayload';
  beadlets?: Maybe<Beadlets>;
  response?: Maybe<Response>;
};

export type Beadlets = {
  __typename?: 'Beadlets';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BeadletsPayload = {
  __typename?: 'BeadletsPayload';
  data?: Maybe<Array<Beadlets>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum BottleCapType {
  ChildResistant = 'CHILD_RESISTANT',
  Standard = 'STANDARD'
}

export type BottleCapacitiesPayload = {
  __typename?: 'BottleCapacitiesPayload';
  data?: Maybe<Array<BottleCapacity>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type BottleCapacity = {
  __typename?: 'BottleCapacity';
  bottleSize?: Maybe<BottleSize>;
  bottleSizeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  fillPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lohCost?: Maybe<Scalars['Float']['output']>;
  productSize?: Maybe<ProductSize>;
  productSizeId?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  productTypeId?: Maybe<Scalars['String']['output']>;
  servingSize?: Maybe<ServingSize>;
  servingSizeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BottleCapacityPayload = {
  __typename?: 'BottleCapacityPayload';
  bottleCapacity?: Maybe<BottleCapacity>;
  response?: Maybe<Response>;
};

export type BottlePrice = {
  __typename?: 'BottlePrice';
  bottlePriceSuppliers?: Maybe<Array<Maybe<BottlePriceSupplier>>>;
  bottleSize?: Maybe<BottleSize>;
  bottleSizeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** child resistance */
  isCr?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** Bottle types */
  type?: Maybe<BottleTypeEnum>;
  updatedAt: Scalars['String']['output'];
};

export type BottlePricePayload = {
  __typename?: 'BottlePricePayload';
  bottlePrice?: Maybe<BottlePrice>;
  response?: Maybe<Response>;
};

export type BottlePriceSupplier = {
  __typename?: 'BottlePriceSupplier';
  bottlePriceId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BottlePricesPayload = {
  __typename?: 'BottlePricesPayload';
  data?: Maybe<Array<BottlePrice>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type BottleSize = {
  __typename?: 'BottleSize';
  bottleSizeProductTypes?: Maybe<Array<Maybe<BottleSizeProductType>>>;
  cc?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** lid size will be in mm (millimeter) */
  lidSize?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oz?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BottleSizePayload = {
  __typename?: 'BottleSizePayload';
  bottleSize?: Maybe<BottleSize>;
  response?: Maybe<Response>;
};

export type BottleSizeProductType = {
  __typename?: 'BottleSizeProductType';
  bottleSizeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BottleSizeProductTypePayload = {
  __typename?: 'BottleSizeProductTypePayload';
  bottleSizeProductType?: Maybe<BottleSizeProductType>;
  response?: Maybe<Response>;
};

export type BottleSizeProductTypesPayload = {
  __typename?: 'BottleSizeProductTypesPayload';
  data?: Maybe<Array<BottleSizeProductType>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type BottleSizesPayload = {
  __typename?: 'BottleSizesPayload';
  data?: Maybe<Array<BottleSize>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum BottleTypeEnum {
  Aluminium = 'ALUMINIUM',
  Csp = 'CSP',
  Hdpe = 'HDPE',
  Pet = 'PET'
}

export type CalcFormulaCostInput = {
  ageGroups: Array<CreateFormulaAgeGroupInput>;
  bottleCap?: InputMaybe<BottleCapType>;
  bottleType?: InputMaybe<BottleTypeEnum>;
  capOverride?: InputMaybe<Scalars['Boolean']['input']>;
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  coMfgCostPercentage?: InputMaybe<Scalars['Float']['input']>;
  coMfgCostType?: InputMaybe<CoMfgCostType>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  flavorSystemId?: InputMaybe<Scalars['String']['input']>;
  formulaBlends?: InputMaybe<Array<FormulaBlendInput>>;
  formulaIngredients?: InputMaybe<Array<FormulaIngredientInput>>;
  innerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  miscellaneousCost?: InputMaybe<Scalars['Float']['input']>;
  outerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  productFormulationTypeId: Scalars['String']['input'];
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId: Scalars['String']['input'];
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  sweetenerSystemId?: InputMaybe<Scalars['String']['input']>;
  tabletCoatingId?: InputMaybe<Scalars['String']['input']>;
};

export type CalcFormulaCostPayload = {
  __typename?: 'CalcFormulaCostPayload';
  formulaCostSuggestion: GetFormulaCostPayload;
  response?: Maybe<Response>;
};

export type CancelStaffSubscriptionInput = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CancelSubscriptionInput = {
  id: Scalars['String']['input'];
};

export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  response?: Maybe<Response>;
};

export type CapsulePrice = {
  __typename?: 'CapsulePrice';
  capacity?: Maybe<Scalars['Float']['output']>;
  capsuleType?: Maybe<CapsuleType>;
  createdAt: Scalars['String']['output'];
  density?: Maybe<Density>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productSize?: Maybe<ProductSize>;
  supplier?: Maybe<Supplier>;
  updatedAt: Scalars['String']['output'];
};

export type CapsulePricePayload = {
  __typename?: 'CapsulePricePayload';
  capsulePrice?: Maybe<CapsulePrice>;
  response?: Maybe<Response>;
};

export type CapsulePricesPayload = {
  __typename?: 'CapsulePricesPayload';
  data?: Maybe<Array<CapsulePrice>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type CapsuleType = {
  __typename?: 'CapsuleType';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type CapsuleTypePayload = {
  __typename?: 'CapsuleTypePayload';
  capsuleType?: Maybe<CapsuleType>;
  response?: Maybe<Response>;
};

export type CapsuleTypesPayload = {
  __typename?: 'CapsuleTypesPayload';
  data?: Maybe<Array<CapsuleType>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type CategoriesPayload = {
  __typename?: 'CategoriesPayload';
  data?: Maybe<Array<Category>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type Category = {
  __typename?: 'Category';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CategoryPayload = {
  __typename?: 'CategoryPayload';
  category?: Maybe<Category>;
  response?: Maybe<Response>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChangeSubscriptionPlanInput = {
  newPricingId: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export type ChangeSubscriptionPlanPayload = {
  __typename?: 'ChangeSubscriptionPlanPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Response>;
};

export type ClientSecretPayload = {
  __typename?: 'ClientSecretPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Response>;
};

export enum CoMfgCostType {
  Margin = 'MARGIN',
  Markup = 'MARKUP'
}

export type CoatingFormulationComponent = {
  __typename?: 'CoatingFormulationComponent';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sandComponent?: Maybe<SandComponent>;
  unit?: Maybe<CoatingFormulationComponentUnit>;
  updatedAt: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CoatingFormulationComponentPayload = {
  __typename?: 'CoatingFormulationComponentPayload';
  coatingFormulationComponent?: Maybe<CoatingFormulationComponent>;
  response?: Maybe<Response>;
};

export enum CoatingFormulationComponentUnit {
  Mg = 'MG'
}

export type CoatingFormulationComponentsPayload = {
  __typename?: 'CoatingFormulationComponentsPayload';
  data?: Maybe<Array<CoatingFormulationComponent>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type Contact = {
  __typename?: 'Contact';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<ContactType>;
  contactableId?: Maybe<Scalars['String']['output']>;
  contactableType?: Maybe<ContactableType>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPayload = {
  __typename?: 'ContactPayload';
  contact?: Maybe<Contact>;
  response?: Maybe<Response>;
};

/** Contact information type */
export enum ContactType {
  Company = 'COMPANY',
  Self = 'SELF'
}

/** Contactable type */
export enum ContactableType {
  Supplier = 'SUPPLIER'
}

export type CreateAdditionalContactInput = {
  contactableId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  /** supplier id. Will ignore this while creating the AdditionalContact */
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title: AddressTitle;
  type: AddressType;
  typeId: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAllergenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateBottleCapacityInput = {
  bottleSizeId: Scalars['String']['input'];
  fillPercentage?: InputMaybe<Scalars['Float']['input']>;
  lohCost?: InputMaybe<Scalars['Float']['input']>;
  productSizeId: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  servingSizeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBottlePriceInput = {
  bottlePriceSuppliers: Array<Scalars['String']['input']>;
  bottleSizeId: Scalars['String']['input'];
  /** child resistance */
  isCr: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  /** Bottle types */
  type: BottleTypeEnum;
};

export type CreateBottleSizeInput = {
  bottleSizeProductTypes: Array<Scalars['String']['input']>;
  cc?: InputMaybe<Scalars['Float']['input']>;
  /** lid size will be in mm (millimeter) */
  lidSize?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  oz?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCapsulePriceInput = {
  capacity: Scalars['Float']['input'];
  capsuleTypeId: Scalars['String']['input'];
  densityId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  productSizeId: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCapsuleTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primary: Scalars['Boolean']['input'];
};

export type CreateCoatingFormulationComponentInput = {
  sandCoatingFormulationId: Scalars['String']['input'];
  sandComponentId?: InputMaybe<Scalars['String']['input']>;
  unit: CoatingFormulationComponentUnit;
  weight: Scalars['Float']['input'];
};

export type CreateContactInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactType: ContactType;
  contactableId: Scalars['String']['input'];
  contactableType: ContactableType;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDensityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type CreateExcipientInput = {
  name: Scalars['String']['input'];
};

export type CreateExcipientLabelInput = {
  name: Scalars['String']['input'];
};

export type CreateExcipientTypeInput = {
  excipientLabelId?: InputMaybe<Scalars['String']['input']>;
  loadAdd: Scalars['Float']['input'];
  loadAddUnit: LoadAddUnit;
  name: Scalars['String']['input'];
  /** $/Kg Cost of Excipient type */
  perKgCost: Scalars['Float']['input'];
  productTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFormulaAgeGroupInput = {
  ageGroupType: AgeGroupType;
  dvType: DvConstraintType;
  servingContainer: Scalars['Float']['input'];
  servingSize: Scalars['Float']['input'];
  servingUnit: ServingUnitType;
};

export type CreateFormulaInput = {
  ageGroups: Array<CreateFormulaAgeGroupInput>;
  beadletId?: InputMaybe<Scalars['String']['input']>;
  bottleCap?: InputMaybe<BottleCapType>;
  bottleType?: InputMaybe<BottleTypeEnum>;
  capOverride?: InputMaybe<Scalars['Boolean']['input']>;
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  coMfgCostPercentage?: InputMaybe<Scalars['Float']['input']>;
  coMfgCostType?: InputMaybe<CoMfgCostType>;
  colorCoating?: InputMaybe<TabletCoatingColor>;
  colorCoating2?: InputMaybe<TabletCoatingColor>;
  colorCoating3?: InputMaybe<TabletCoatingColor>;
  colorsHex?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  factBoxType?: InputMaybe<FactBoxType>;
  flavorSystemId?: InputMaybe<Scalars['String']['input']>;
  flavorType?: InputMaybe<SweetenerNatureType>;
  formulaBlends?: InputMaybe<Array<FormulaBlendInput>>;
  formulaIngredients?: InputMaybe<Array<FormulaIngredientInput>>;
  innerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  miniTabFormulation?: InputMaybe<MiniTabFormulationType>;
  miscellaneousCost?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  outerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  productFormulationTypeId: Scalars['String']['input'];
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId: Scalars['String']['input'];
  proteinBase?: InputMaybe<ProteinBaseType>;
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  sweetenerSystemId?: InputMaybe<Scalars['String']['input']>;
  sweetenerType?: InputMaybe<SweetenerNatureType>;
  tabletCoatingId?: InputMaybe<Scalars['String']['input']>;
  tabletTypeId?: InputMaybe<Scalars['String']['input']>;
  veganType?: InputMaybe<VeganType>;
};

export type CreateIngredientInfoInput = {
  /** gram (g) */
  addedSugar?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  arsenic?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  biotin?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  boron?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  cadmium?: InputMaybe<Scalars['String']['input']>;
  /** milligram (mg) */
  calcium?: InputMaybe<Scalars['String']['input']>;
  /** KCal */
  calories?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  carbohydrates?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  chloride?: InputMaybe<Scalars['Float']['input']>;
  /** milligram (mg) */
  cholesterol?: InputMaybe<Scalars['String']['input']>;
  choline?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  chromium?: InputMaybe<Scalars['Float']['input']>;
  /** micro-gram per serving (mcg/serv) */
  copper?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  dietaryFiber?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  folate?: InputMaybe<Scalars['String']['input']>;
  iodine?: InputMaybe<Scalars['String']['input']>;
  /** milligram (mg) */
  iron?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  lead?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  magnesium?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  manganese?: InputMaybe<Scalars['Float']['input']>;
  /** micro-gram per serving (mcg/serv) */
  mercury?: InputMaybe<Scalars['String']['input']>;
  /** Grams (g) */
  moisture?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  molybdenum?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  monounsaturatedFat?: InputMaybe<Scalars['String']['input']>;
  niacin?: InputMaybe<Scalars['String']['input']>;
  /** Percentage (%) */
  organic?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  pantothenicAcid?: InputMaybe<Scalars['Float']['input']>;
  /** micro-gram per serving (mcg/serv) */
  phosphorus?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  polyunsaturatedFat?: InputMaybe<Scalars['String']['input']>;
  /** milligram (mg) */
  potassium?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  protein?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  riboflavin?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  saturatedFat?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  selenium?: InputMaybe<Scalars['Float']['input']>;
  /** milligram (mg) */
  sodium?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  thiamin?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  totalFat?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  totalSugars?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  transFat?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  vitaminA?: InputMaybe<Scalars['String']['input']>;
  vitaminB6?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  vitaminB12?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  vitaminC?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  vitaminD?: InputMaybe<Scalars['String']['input']>;
  vitaminE?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  vitaminK?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  vitaminK2?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  zinc?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIngredientInput = {
  /** amount can be 1 or 100 */
  amount: Scalars['Int']['input'];
  /** Avergage Particle Size unit will be in % */
  avergageParticleSize?: InputMaybe<Scalars['String']['input']>;
  carriers: Array<IngredientCarrierInput>;
  categoryId: Scalars['String']['input'];
  /** Dollar per kilogram ($/kg) */
  cost: Scalars['Float']['input'];
  /** Density for suggest the bottle size */
  density?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Suggested Gummy Overage unit will be in % */
  gummyOverage?: InputMaybe<Scalars['Float']['input']>;
  /** allergens uuids */
  ingredientAllergens?: InputMaybe<Array<Scalars['String']['input']>>;
  ingredientInfo: CreateIngredientInfoInput;
  ingredientSuppliers?: InputMaybe<Array<IngredientSupplierInput>>;
  /** Is the ingredient organic */
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  latinName?: InputMaybe<Scalars['String']['input']>;
  lossOnDrying?: InputMaybe<Scalars['String']['input']>;
  manufacturingCountry?: InputMaybe<Scalars['String']['input']>;
  /** Common name */
  name: Scalars['String']['input'];
  nutrientName?: InputMaybe<Scalars['Boolean']['input']>;
  nutrients: Scalars['Boolean']['input'];
  originCountry?: InputMaybe<Scalars['String']['input']>;
  /** potency unit will be in % (can be range percentage) */
  potency: Scalars['String']['input'];
  proBiotic?: InputMaybe<Scalars['Float']['input']>;
  /** product type uuids */
  productTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scientificName?: InputMaybe<Scalars['String']['input']>;
  /** Months */
  shelfLife?: InputMaybe<Scalars['Float']['input']>;
  showB3?: InputMaybe<Scalars['Boolean']['input']>;
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
  subComponents: Array<IngredientSubComponentInput>;
  /** Suggested Overage unit will be in % */
  suggestedOverage?: InputMaybe<Scalars['Float']['input']>;
  tradeMarkName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<IngredientType>>>;
};

export type CreateOrgStaffInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  staffRole?: InputMaybe<Scalars['String']['input']>;
  trialEnd: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  maxUser: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateProductExcipientInput = {
  excipientId: Scalars['String']['input'];
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  /** $/Kg */
  perKgCost?: InputMaybe<Scalars['Float']['input']>;
  percentage: Scalars['Float']['input'];
  productExcipientSuppliers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateProductFormulationSyrupTypeInput = {
  cost: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  productFormulationTypeId: Scalars['String']['input'];
  productSizeId: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  unit: FormulationSyrupUnit;
  weight: Scalars['Float']['input'];
};

export type CreateProductIngredientInput = {
  name: Scalars['String']['input'];
};

export type CreateProductIngredientSyrupTypeInput = {
  percentage: Scalars['Float']['input'];
  productFormulationSyrupTypeId: Scalars['String']['input'];
  productIngredientId: Scalars['String']['input'];
};

export type CreateProductSizeInput = {
  /** Empty weight mg */
  emptyWtMg?: InputMaybe<Scalars['Float']['input']>;
  /** Total mg weight of gummy */
  gummyWeight?: InputMaybe<Scalars['Float']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSandCoatingFormulationInput = {
  cost: Scalars['Float']['input'];
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId: Scalars['String']['input'];
  sandCoatingId: Scalars['String']['input'];
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type CreateSandCoatingInput = {
  name: Scalars['String']['input'];
};

export type CreateSandComponentInput = {
  name: Scalars['String']['input'];
};

export type CreateServingSizeInput = {
  size: Scalars['Float']['input'];
};

export type CreateStaffInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  paymentIntent?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  staffRole?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubProductTypeInput = {
  name: Scalars['String']['input'];
  productTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionInput = {
  paymentIntent?: InputMaybe<Scalars['String']['input']>;
  pricingId: Scalars['String']['input'];
};

export type CreateSubscriptionPayload = {
  __typename?: 'CreateSubscriptionPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Response>;
};

export type CreateSupplierInput = {
  additionalContact?: InputMaybe<Array<AdditionalContactInput>>;
  contact?: InputMaybe<ContactInput>;
  supplier?: InputMaybe<SupplierInput>;
};

export type CreateSweetenerComponentInput = {
  costPerKg?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSweetenerElementsInput = {
  qtPerMg?: InputMaybe<Scalars['Float']['input']>;
  sweetenerComponentId: Scalars['String']['input'];
  sweetenerId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSweetenerInput = {
  costPerServing: Scalars['Float']['input'];
  mgPerServing: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  nature: SweetenerNatureType;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId: Scalars['String']['input'];
  size: SweetenerSizeType;
  type: SweetenerType;
};

export type CreateSyrupBaseIngredientsInput = {
  /** amount can be 1 or 100 */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Avergage Particle Size unit will be in % */
  avergageParticleSize?: InputMaybe<Scalars['String']['input']>;
  /** Dollar per kilogram ($/kg) */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Density for suggest the bottle size */
  density?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Suggested Gummy Overage unit will be in % */
  gummyOverage?: InputMaybe<Scalars['Float']['input']>;
  ingredientInfo?: InputMaybe<CreateIngredientInfoInput>;
  /** Is the ingredient organic */
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  latinName?: InputMaybe<Scalars['String']['input']>;
  lossOnDrying?: InputMaybe<Scalars['String']['input']>;
  manufacturingCountry?: InputMaybe<Scalars['String']['input']>;
  /** Common name */
  name?: InputMaybe<Scalars['String']['input']>;
  nutrientName?: InputMaybe<Scalars['Boolean']['input']>;
  nutrients?: InputMaybe<Scalars['Boolean']['input']>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  /** potency unit will be in % (can be range percentage) */
  potency?: InputMaybe<Scalars['String']['input']>;
  proBiotic?: InputMaybe<Scalars['Float']['input']>;
  productFormulationSyrupTypeId?: InputMaybe<Scalars['String']['input']>;
  /** product type uuids */
  productTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  scientificName?: InputMaybe<Scalars['String']['input']>;
  /** Months */
  shelfLife?: InputMaybe<Scalars['Float']['input']>;
  showB3?: InputMaybe<Scalars['Boolean']['input']>;
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** Suggested Overage unit will be in % */
  suggestedOverage?: InputMaybe<Scalars['Float']['input']>;
  tradeMarkName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<IngredientType>>;
};

export type CreateTabletCoatingInput = {
  costPerKg: Scalars['Float']['input'];
  loadAdd: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type DailyValueConstraint = {
  __typename?: 'DailyValueConstraint';
  adultsAndChildren?: Maybe<Scalars['Float']['output']>;
  children1To3Years?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  foodComponent?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  infants?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pregnantAndLactatingWomen?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<DailyValueConstraintUnit>;
  updatedAt: Scalars['String']['output'];
};

export type DailyValueConstraintPayload = {
  __typename?: 'DailyValueConstraintPayload';
  dailyValueConstraint?: Maybe<DailyValueConstraint>;
  response?: Maybe<Response>;
};

export enum DailyValueConstraintUnit {
  G = 'G',
  Mcg = 'MCG',
  Mg = 'MG'
}

export type DailyValueConstraintsPayload = {
  __typename?: 'DailyValueConstraintsPayload';
  data?: Maybe<Array<DailyValueConstraint>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type DensitiesPayload = {
  __typename?: 'DensitiesPayload';
  data?: Maybe<Array<Density>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type Density = {
  __typename?: 'Density';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type DensityPayload = {
  __typename?: 'DensityPayload';
  density?: Maybe<Density>;
  response?: Maybe<Response>;
};

export type DosageFormulaCounts = {
  __typename?: 'DosageFormulaCounts';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: ProductTypes;
};

export type DosageFormulasPayload = {
  __typename?: 'DosageFormulasPayload';
  data: Array<Maybe<DosageFormulaCounts>>;
  response?: Maybe<Response>;
};

export type DraftFormulaIngredientInput = {
  ingredientId: Scalars['String']['input'];
  overage?: InputMaybe<Scalars['Float']['input']>;
  potency: Scalars['Float']['input'];
  showCfu: Scalars['Boolean']['input'];
  type?: InputMaybe<FormulaIngredientType>;
  unit: FormulaIngredientUnit;
  value: Scalars['Float']['input'];
};

export enum DvConstraintType {
  AdultsAndChildren = 'ADULTS_AND_CHILDREN',
  Children_1To_3Years = 'CHILDREN_1_TO_3_YEARS',
  Infants = 'INFANTS',
  PregnantAndLactatingWomen = 'PREGNANT_AND_LACTATING_WOMEN'
}

export type Excipient = {
  __typename?: 'Excipient';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ExcipientLabel = {
  __typename?: 'ExcipientLabel';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ExcipientLabelPayload = {
  __typename?: 'ExcipientLabelPayload';
  excipientLabel?: Maybe<ExcipientLabel>;
  response?: Maybe<Response>;
};

export type ExcipientLabelsPayload = {
  __typename?: 'ExcipientLabelsPayload';
  data?: Maybe<Array<ExcipientLabel>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ExcipientPayload = {
  __typename?: 'ExcipientPayload';
  excipient?: Maybe<Excipient>;
  response?: Maybe<Response>;
};

export type ExcipientType = {
  __typename?: 'ExcipientType';
  createdAt: Scalars['String']['output'];
  excipientLabel?: Maybe<ExcipientLabel>;
  excipientLabelId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  loadAdd?: Maybe<Scalars['Int']['output']>;
  loadAddUnit?: Maybe<LoadAddUnit>;
  name?: Maybe<Scalars['String']['output']>;
  /** $/Kg Cost of ExcipientType */
  perKgCost?: Maybe<Scalars['Float']['output']>;
  productExcipients: Array<ProductExcipient>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ExcipientTypePayload = {
  __typename?: 'ExcipientTypePayload';
  excipientType?: Maybe<ExcipientType>;
  response?: Maybe<Response>;
};

export type ExcipientTypesPayload = {
  __typename?: 'ExcipientTypesPayload';
  data?: Maybe<Array<ExcipientType>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ExcipientsPayload = {
  __typename?: 'ExcipientsPayload';
  data?: Maybe<Array<Excipient>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum FactBoxType {
  Nutrition = 'NUTRITION',
  Supplement = 'SUPPLEMENT'
}

export type FindAllAdminInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type FindAllAllergensInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllBeadletsInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllBottleCapacitiesInput = {
  bottleSizeId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  servingSizeId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllBottlePricesInput = {
  bottleSizeId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  type?: InputMaybe<BottleTypeEnum>;
};

export type FindAllBottleSizeProductTypesInput = {
  paginationOptions: PaginationInput;
};

export type FindAllBottleSizesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllCapsulePricesInput = {
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  densityId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllCapsuleTypesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllCategoriesInput = {
  paginationOptions: PaginationInput;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllCoatingFormulationComponentInput = {
  paginationOptions: PaginationInput;
  sandCoatingFormulationId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllDailyValueConstraintsInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllDensitiesInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllDosageFormulasInputs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllDosageTypeFormulasInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllExcipientLabelsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllExcipientTypesInput = {
  excipientLabelId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productType?: InputMaybe<ProductTypes>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllExcipientsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllFormulasInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FormulaStatus>;
};

export type FindAllIngredientsInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productFormulationSyrupTypeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<IngredientType>>;
};

export type FindAllInvoicesInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllOrgStaffInput = {
  organizationId: Scalars['String']['input'];
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type FindAllOrganizationsInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllProductExcipientsInput = {
  excipientId?: InputMaybe<Scalars['String']['input']>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllProductFormulationSyrupTypesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllProductFormulationTypeInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isInnerCapTab?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllProductIngredientSyrupTypesInput = {
  paginationOptions: PaginationInput;
  productFormulationSyrupTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllProductIngredientsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllProductSizesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productType?: InputMaybe<ProductTypes>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllProductTypesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllSandCoatingFormulationInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllSandCoatingInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllSandComponentInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllServingSizesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllStaffInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type FindAllSubProductTypesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllSuppliersInput = {
  paginationOptions: PaginationInput;
  scope?: InputMaybe<Scope>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupplierStatus>;
};

export type FindAllSweetenerComponentsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllSweetenerElementsInput = {
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sweetenerComponentId?: InputMaybe<Scalars['String']['input']>;
  sweetenerId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllSweetenersInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nature?: InputMaybe<SweetenerNatureType>;
  paginationOptions: PaginationInput;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<SweetenerSizeType>;
  type?: InputMaybe<SweetenerType>;
};

export type FindAllTabletCoatingInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  productType?: InputMaybe<ProductTypes>;
  productTypeId?: InputMaybe<ProductTypes>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllUsersInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paginationOptions: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserType>;
};

export type FindBottleCapacityInput = {
  id: Scalars['String']['input'];
};

export type FindFormulasCountByYearInput = {
  ingredients: Array<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type FindInvoicesByOrgIdInput = {
  organizationId: Scalars['String']['input'];
  paginationOptions?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
};

export type FindUserStats = {
  __typename?: 'FindUserStats';
  activeUsers: Scalars['Int']['output'];
  orgAdmins: Scalars['Int']['output'];
  staff: Scalars['Int']['output'];
};

export type FindUserStatsPayload = {
  __typename?: 'FindUserStatsPayload';
  data: FindUserStats;
  response?: Maybe<Response>;
};

export type FindUsersCountByYearInput = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type FindUsersStatsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  response?: Maybe<Response>;
};

export type Formula = {
  __typename?: 'Formula';
  attachment?: Maybe<Attachment>;
  beadlet?: Maybe<Beadlets>;
  beadletId?: Maybe<Scalars['String']['output']>;
  bottleCap?: Maybe<BottleCapType>;
  bottleCapacity?: Maybe<BottleCapacity>;
  bottleCapacityId?: Maybe<Scalars['String']['output']>;
  bottlePrice?: Maybe<BottlePrice>;
  bottlePriceId?: Maybe<Scalars['String']['output']>;
  bottleType?: Maybe<BottleTypeEnum>;
  capOverride?: Maybe<Scalars['Boolean']['output']>;
  capsulePrice?: Maybe<CapsulePrice>;
  capsulePriceId?: Maybe<Scalars['String']['output']>;
  coMfgCost?: Maybe<Scalars['Float']['output']>;
  coMfgCostPercentage?: Maybe<Scalars['Float']['output']>;
  coMfgCostType?: Maybe<CoMfgCostType>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  excelSheet?: Maybe<Attachment>;
  excipientType?: Maybe<ExcipientType>;
  excipientTypeId?: Maybe<Scalars['String']['output']>;
  factBoxType?: Maybe<FactBoxType>;
  factSheet?: Maybe<Attachment>;
  formulaAgeGroups?: Maybe<Array<Maybe<FormulaAgeGroups>>>;
  formulaBlends?: Maybe<Array<Maybe<FormulaBlend>>>;
  formulaCapsuleTypes?: Maybe<Array<Maybe<FormulaCapsuleType>>>;
  formulaCost?: Maybe<FormulaCosts>;
  formulaCostPercentage?: Maybe<FormulaCostsPercentage>;
  formulaIngredients?: Maybe<Array<Maybe<FormulaIngredient>>>;
  formulaSweeteners?: Maybe<Array<Maybe<FormulaSweetener>>>;
  formulaTabletCoatings?: Maybe<Array<Maybe<FormulaTabletCoating>>>;
  formulaWeights?: Maybe<FormulaWeights>;
  formulaWeightsPercentage?: Maybe<FormulaWeightsPercentage>;
  id: Scalars['String']['output'];
  innerCapsulePrice?: Maybe<CapsulePrice>;
  innerCapsulePriceId?: Maybe<Scalars['String']['output']>;
  mfgCost?: Maybe<Scalars['Float']['output']>;
  miniTabFormulation?: Maybe<MiniTabFormulationType>;
  miscellaneousCost?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**  ingredient organic percentage */
  organicPercentage?: Maybe<Scalars['Float']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  outerCapsulePrice?: Maybe<CapsulePrice>;
  outerCapsulePriceId?: Maybe<Scalars['String']['output']>;
  productFormulationType?: Maybe<ProductFormulationType>;
  productFormulationTypeId?: Maybe<Scalars['String']['output']>;
  productSize?: Maybe<ProductSize>;
  productSizeId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  proteinBase?: Maybe<ProteinBaseType>;
  sandCoating?: Maybe<SandCoating>;
  sandCoatingId?: Maybe<Scalars['String']['output']>;
  servingContainer?: Maybe<Scalars['Float']['output']>;
  servingSize?: Maybe<Scalars['Float']['output']>;
  servingUnit?: Maybe<ServingUnitType>;
  specSheet?: Maybe<Attachment>;
  status?: Maybe<FormulaStatus>;
  subProductType?: Maybe<SubProductType>;
  subProductTypeId?: Maybe<Scalars['String']['output']>;
  tabletCoating?: Maybe<TabletCoating>;
  tabletCoatingId?: Maybe<Scalars['String']['output']>;
  tabletType?: Maybe<ProductFormulationType>;
  tabletTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  veganType?: Maybe<VeganType>;
};

export type FormulaAgeGroups = {
  __typename?: 'FormulaAgeGroups';
  /** Type of age group (primary or other) */
  ageGroupType?: Maybe<AgeGroupType>;
  createdAt: Scalars['String']['output'];
  /** Type of age group */
  dvType?: Maybe<DvConstraintType>;
  id: Scalars['String']['output'];
  /** Serving container of the age group */
  servingContainer?: Maybe<Scalars['Float']['output']>;
  /** Serving size of the age group */
  servingSize?: Maybe<Scalars['Float']['output']>;
  /** Serving unit of the age group */
  servingUnit?: Maybe<ServingUnitType>;
  updatedAt: Scalars['String']['output'];
};

export type FormulaBlend = {
  __typename?: 'FormulaBlend';
  createdAt: Scalars['String']['output'];
  formulaId?: Maybe<Scalars['String']['output']>;
  formulaIngredients?: Maybe<Array<Maybe<FormulaIngredient>>>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type FormulaBlendInput = {
  formulaIngredients?: InputMaybe<Array<FormulaIngredientInput>>;
  name: Scalars['String']['input'];
};

export type FormulaCapsuleType = {
  __typename?: 'FormulaCapsuleType';
  capsuleType: CapsuleType;
  capsuleTypeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  formulaId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type?: Maybe<FormulaCapsuleTypeEnum>;
  updatedAt: Scalars['String']['output'];
};

export enum FormulaCapsuleTypeEnum {
  InnerPolymer = 'INNER_POLYMER',
  OuterPolymer = 'OUTER_POLYMER',
  Polymer = 'POLYMER'
}

export type FormulaCosts = {
  __typename?: 'FormulaCosts';
  bottlePrice?: Maybe<Scalars['Float']['output']>;
  coatingCost?: Maybe<Scalars['Float']['output']>;
  conversionCost?: Maybe<Scalars['Float']['output']>;
  excipientCost?: Maybe<Scalars['Float']['output']>;
  flavorCost?: Maybe<Scalars['Float']['output']>;
  ingredientsCost?: Maybe<Scalars['Float']['output']>;
  innerComponentCost?: Maybe<Scalars['Float']['output']>;
  lohCost?: Maybe<Scalars['Float']['output']>;
  neckband?: Maybe<Scalars['Float']['output']>;
  per1000Cost?: Maybe<Scalars['Float']['output']>;
  sandCoatingCost?: Maybe<Scalars['Float']['output']>;
  sweetenerCost?: Maybe<Scalars['Float']['output']>;
  syrupBaseCost?: Maybe<Scalars['Float']['output']>;
};

export type FormulaCostsPercentage = {
  __typename?: 'FormulaCostsPercentage';
  bottlePrice?: Maybe<Scalars['Float']['output']>;
  coatingCost?: Maybe<Scalars['Float']['output']>;
  conversionCost?: Maybe<Scalars['Float']['output']>;
  excipientCost?: Maybe<Scalars['Float']['output']>;
  flavorCost?: Maybe<Scalars['Float']['output']>;
  ingredientsCost?: Maybe<Scalars['Float']['output']>;
  lohCost?: Maybe<Scalars['Float']['output']>;
  miscellaneousCost?: Maybe<Scalars['Float']['output']>;
  neckband?: Maybe<Scalars['Float']['output']>;
  sandCoatingCost?: Maybe<Scalars['Float']['output']>;
  sweetenerCost?: Maybe<Scalars['Float']['output']>;
  syrupBaseCost?: Maybe<Scalars['Float']['output']>;
};

export type FormulaIngredient = {
  __typename?: 'FormulaIngredient';
  createdAt: Scalars['String']['output'];
  /** Ingredient density */
  density?: Maybe<Scalars['Float']['output']>;
  formulaBlendId?: Maybe<Scalars['String']['output']>;
  formulaId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Ingredient cost (%) Contribution */
  ingCostContribution?: Maybe<Scalars['Float']['output']>;
  ingredient?: Maybe<Ingredient>;
  ingredientId?: Maybe<Scalars['String']['output']>;
  macroNutrientsWeight?: Maybe<MacroNutrientsWeights>;
  /** Ingredient Mg Volume with ingredient's potency and overage */
  mgVolume?: Maybe<Scalars['Float']['output']>;
  /** Ingredient Mg weight with ingredient's potency and overage */
  mgWeight?: Maybe<Scalars['Float']['output']>;
  /** Ingredient Mg weight without ingredient's potency and overage */
  mgWt?: Maybe<Scalars['Float']['output']>;
  microNutrientsWeight?: Maybe<MicroNutrientsWeights>;
  overage?: Maybe<Scalars['Float']['output']>;
  potency?: Maybe<Scalars['Float']['output']>;
  /**  ingredient probiotic value */
  probiotic?: Maybe<Scalars['Float']['output']>;
  /** Show the CFU of ingredient with Ingredient name in fact sheet */
  showCfu?: Maybe<Scalars['Boolean']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<FormulaIngredientType>;
  unit?: Maybe<FormulaIngredientUnit>;
  unitCost?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type FormulaIngredientInput = {
  ingredientId: Scalars['String']['input'];
  overage?: InputMaybe<Scalars['Float']['input']>;
  potency: Scalars['Float']['input'];
  showCfu: Scalars['Boolean']['input'];
  type: FormulaIngredientType;
  unit: FormulaIngredientUnit;
  value: Scalars['Float']['input'];
};

export enum FormulaIngredientType {
  Beadlet = 'BEADLET',
  Capsule = 'CAPSULE',
  Gummy = 'GUMMY',
  InnerCapsule = 'INNER_CAPSULE',
  Layer_1 = 'LAYER_1',
  Layer_2 = 'LAYER_2',
  Layer_3 = 'LAYER_3',
  Liquid = 'LIQUID',
  OuterCapsule = 'OUTER_CAPSULE',
  Powder = 'POWDER',
  Tablet = 'TABLET'
}

export enum FormulaIngredientUnit {
  Cfu = 'CFU',
  G = 'G',
  Mcg = 'MCG',
  Mg = 'MG',
  Ml = 'ML'
}

export type FormulaPayload = {
  __typename?: 'FormulaPayload';
  formula?: Maybe<Formula>;
  response?: Maybe<Response>;
};

export enum FormulaStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type FormulaSweetener = {
  __typename?: 'FormulaSweetener';
  createdAt: Scalars['String']['output'];
  formulaId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  nature?: Maybe<SweetenerNatureType>;
  sweetener?: Maybe<Sweetener>;
  sweetenerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SweetenerType>;
  updatedAt: Scalars['String']['output'];
};

export type FormulaTabletCoating = {
  __typename?: 'FormulaTabletCoating';
  coatingColor?: Maybe<TabletCoatingColor>;
  colorsHex?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['String']['output'];
  formulaId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type?: Maybe<TabletCoatingType>;
  updatedAt: Scalars['String']['output'];
};

export type FormulaWeights = {
  __typename?: 'FormulaWeights';
  coatingWeight?: Maybe<Scalars['Float']['output']>;
  excipientWeight?: Maybe<Scalars['Float']['output']>;
  flavorWeight?: Maybe<Scalars['Float']['output']>;
  ingredientsWeight?: Maybe<Scalars['Float']['output']>;
  sandCoatingWeight?: Maybe<Scalars['Float']['output']>;
  sweetenerWeight?: Maybe<Scalars['Float']['output']>;
  syrupBaseWeight?: Maybe<Scalars['Float']['output']>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
};

export type FormulaWeightsPercentage = {
  __typename?: 'FormulaWeightsPercentage';
  coatingWeight?: Maybe<Scalars['Float']['output']>;
  excipientWeight?: Maybe<Scalars['Float']['output']>;
  flavorWeight?: Maybe<Scalars['Float']['output']>;
  ingredientsWeight?: Maybe<Scalars['Float']['output']>;
  sandCoatingWeight?: Maybe<Scalars['Float']['output']>;
  sweetenerWeight?: Maybe<Scalars['Float']['output']>;
  syrupBaseWeight?: Maybe<Scalars['Float']['output']>;
};

export type FormulasCountByYearPayload = {
  __typename?: 'FormulasCountByYearPayload';
  data: Array<Scalars['Int']['output']>;
  response?: Maybe<Response>;
};

export type FormulasIngredient = {
  __typename?: 'FormulasIngredient';
  category?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  usage: Scalars['Int']['output'];
};

export type FormulasIngredientPayload = {
  __typename?: 'FormulasIngredientPayload';
  data: Array<Maybe<FormulasIngredient>>;
  response?: Maybe<Response>;
};

export type FormulasPayload = {
  __typename?: 'FormulasPayload';
  data?: Maybe<Array<Formula>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum FormulationSyrupUnit {
  Mg = 'MG'
}

export type GetAddressInput = {
  id: Scalars['String']['input'];
};

export type GetAllergenInput = {
  id: Scalars['String']['input'];
};

export type GetAttachmentByTypeInput = {
  title: AttachmentTitle;
  type: AttachmentType;
  typeId: Scalars['String']['input'];
};

export type GetAttachmentInput = {
  id: Scalars['String']['input'];
};

export type GetBeadletsInput = {
  id: Scalars['String']['input'];
};

export type GetBottlePriceInput = {
  id: Scalars['String']['input'];
};

export type GetBottleSizeInput = {
  id: Scalars['String']['input'];
};

export type GetBottleSizeProductTypeInput = {
  id: Scalars['String']['input'];
};

export type GetCapsulePriceInput = {
  id: Scalars['String']['input'];
};

export type GetCapsuleTypeInput = {
  id: Scalars['String']['input'];
};

export type GetCategoryInput = {
  id: Scalars['String']['input'];
};

export type GetCoatingFormulationComponentInput = {
  id: Scalars['String']['input'];
};

export type GetContactInput = {
  id: Scalars['String']['input'];
};

export type GetDailyValueConstraintInput = {
  id: Scalars['String']['input'];
};

export type GetDensityInput = {
  id: Scalars['String']['input'];
};

export type GetDosageFormulasCountInput = {
  ingredients: Array<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type GetExcipientInput = {
  id: Scalars['String']['input'];
};

export type GetExcipientLabelInput = {
  id: Scalars['String']['input'];
};

export type GetExcipientTypeInput = {
  id: Scalars['String']['input'];
};

export type GetFactSheetInput = {
  ageGroups: Array<CreateFormulaAgeGroupInput>;
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  factBoxType?: InputMaybe<FactBoxType>;
  formulaBlends?: InputMaybe<Array<FormulaBlendInput>>;
  formulaIngredients?: InputMaybe<Array<FormulaIngredientInput>>;
  innerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  outerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  productFormulationTypeId: Scalars['String']['input'];
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId: Scalars['String']['input'];
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  sweetenerSystemId?: InputMaybe<Scalars['String']['input']>;
  tabletCoatingId?: InputMaybe<Scalars['String']['input']>;
};

export type GetFactSheetPayload = {
  __typename?: 'GetFactSheetPayload';
  pdfStr?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Response>;
};

export type GetFormulaCostPayload = {
  __typename?: 'GetFormulaCostPayload';
  cost: IFormulaCost;
  costPercentage: FormulaCostsPercentage;
  formulaIngredients: Array<FormulaIngredient>;
  organicPercentage?: Maybe<Scalars['Float']['output']>;
  weightPercentage: FormulaWeightsPercentage;
  weights: FormulaWeights;
};

export type GetFormulaInput = {
  id: Scalars['String']['input'];
};

export type GetFormulasIngredientInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  /** If a value is not passed, then return the Top 10 ingredients. It should be one of 10, 50, 100, or 200. */
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type GetIngredientInput = {
  id: Scalars['String']['input'];
};

export type GetInvoiceInput = {
  id: Scalars['String']['input'];
};

export type GetOrgStaffInput = {
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type GetOrgStaffSubscriptionInput = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GetOrganizationInput = {
  id: Scalars['String']['input'];
};

export type GetProductExcipientInput = {
  id: Scalars['String']['input'];
};

export type GetProductFormulationSyrupTypeInput = {
  id: Scalars['String']['input'];
};

export type GetProductFormulationTypeInput = {
  id: Scalars['String']['input'];
};

export type GetProductIngredientInput = {
  id: Scalars['String']['input'];
};

export type GetProductIngredientSyrupTypeInput = {
  id: Scalars['String']['input'];
};

export type GetProductSizeInput = {
  id: Scalars['String']['input'];
};

export type GetProductTypeInput = {
  id: Scalars['String']['input'];
};

export type GetSandCoatingFormulationInput = {
  id: Scalars['String']['input'];
};

export type GetSandCoatingInput = {
  id: Scalars['String']['input'];
};

export type GetSandComponentInput = {
  id: Scalars['String']['input'];
};

export type GetServingSizeInput = {
  id: Scalars['String']['input'];
};

export type GetStripePriceInput = {
  id: Scalars['String']['input'];
  isStaff?: Scalars['Boolean']['input'];
  /** staff id  */
  staffId?: InputMaybe<Scalars['String']['input']>;
};

export type GetSubProductTypeInput = {
  id: Scalars['String']['input'];
};

export type GetSubscriptionByOrgIdInput = {
  organizationId: Scalars['String']['input'];
};

export type GetSubscriptionInput = {
  userId: Scalars['String']['input'];
};

export type GetSupplierInput = {
  id: Scalars['String']['input'];
};

export type GetSweetenerComponentInput = {
  id: Scalars['String']['input'];
};

export type GetSweetenerElementsInput = {
  id: Scalars['String']['input'];
};

export type GetSweetenerInput = {
  id: Scalars['String']['input'];
};

export type GetTabletCoatingInput = {
  id: Scalars['String']['input'];
};

export type GetUserInput = {
  id: Scalars['String']['input'];
};

export type HostedInvoiceUrlPayload = {
  __typename?: 'HostedInvoiceUrlPayload';
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Response>;
};

export type IFormulaCost = {
  __typename?: 'IFormulaCost';
  bottleCapacityInstance?: Maybe<BottleCapacity>;
  bottlePrice?: Maybe<Scalars['Float']['output']>;
  bottlePriceInstance?: Maybe<BottlePrice>;
  capsulePrice?: Maybe<CapsulePrice>;
  coMfgCost: Scalars['Float']['output'];
  coatingCost?: Maybe<Scalars['Float']['output']>;
  conversionCost?: Maybe<Scalars['Float']['output']>;
  excipientCost?: Maybe<Scalars['Float']['output']>;
  flavorCost?: Maybe<Scalars['Float']['output']>;
  ingredientsCost?: Maybe<Scalars['Float']['output']>;
  innerCapsulePrice?: Maybe<CapsulePrice>;
  innerComponentCost?: Maybe<Scalars['Float']['output']>;
  lohCost?: Maybe<Scalars['Float']['output']>;
  mfgCost: Scalars['Float']['output'];
  miscellaneousCost?: Maybe<Scalars['Float']['output']>;
  neckband?: Maybe<Scalars['Float']['output']>;
  outerCapsulePrice?: Maybe<CapsulePrice>;
  per1000Cost?: Maybe<Scalars['Float']['output']>;
  sandCoatingCost?: Maybe<Scalars['Float']['output']>;
  sweetenerCost?: Maybe<Scalars['Float']['output']>;
  syrupBaseCost?: Maybe<Scalars['Float']['output']>;
};

export type Ingredient = {
  __typename?: 'Ingredient';
  /** amount unit is gram (g) */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Avergage Particle Size unit will be in % */
  avergageParticleSize?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']['output']>;
  /** Dollar per kilogram ($/kg) */
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['String']['output']>;
  dailyValueConstraint?: Maybe<DailyValueConstraint>;
  /** For Special Category Ingredients */
  dailyValueConstraintId?: Maybe<Scalars['String']['output']>;
  /** Density for suggest the bottle size */
  density?: Maybe<Scalars['String']['output']>;
  /** For Additional Info */
  description?: Maybe<Scalars['String']['output']>;
  /** Suggested Gummy Overage unit will be in % */
  gummyOverage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  ingredientAllergens?: Maybe<Array<Maybe<IngredientAllergens>>>;
  ingredientCarriers?: Maybe<Array<Maybe<IngredientCarriers>>>;
  ingredientInfo?: Maybe<IngredientInfo>;
  ingredientProductTypes?: Maybe<Array<Maybe<IngredientProductType>>>;
  ingredientSubComponents?: Maybe<Array<Maybe<IngredientSubComponents>>>;
  ingredientSuppliers?: Maybe<Array<Maybe<IngredientSuppliers>>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Is the ingredient organic */
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** Label name */
  latinName?: Maybe<Scalars['String']['output']>;
  lossOnDrying?: Maybe<Scalars['String']['output']>;
  manufacturingCountry?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Show the name of ingredient in B2 section of fact sheet against the micro nutrients */
  nutrientName: Scalars['Boolean']['output'];
  /** Show the Nutrients of ingredient when Even defining amount is 1 */
  nutrients?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originCountry?: Maybe<Scalars['String']['output']>;
  /** potency unit will be in % (can be range percentage) */
  potency?: Maybe<Scalars['String']['output']>;
  /** Probiotic */
  proBiotic?: Maybe<Scalars['String']['output']>;
  productFormulationSyrupType?: Maybe<ProductFormulationSyrupTypes>;
  /** For Gummy Product formulation */
  productFormulationSyrupTypeId?: Maybe<Scalars['String']['output']>;
  scientificName?: Maybe<Scalars['String']['output']>;
  /** Months */
  shelfLife?: Maybe<Scalars['Float']['output']>;
  /** Show the name of ingredient in B3 section of fact sheet */
  showB3?: Maybe<Scalars['Boolean']['output']>;
  subCategory?: Maybe<Category>;
  subCategoryId?: Maybe<Scalars['String']['output']>;
  /** Suggested Overage unit will be in % */
  suggestedOverage?: Maybe<Scalars['Float']['output']>;
  tradeMarkName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Array<Maybe<IngredientType>>>;
  updatedAt: Scalars['String']['output'];
};

export type IngredientAllergens = {
  __typename?: 'IngredientAllergens';
  allergen?: Maybe<Allergen>;
  allergenId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ingredientId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type IngredientCarrierInput = {
  /** carrier uuid */
  carrierId: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

export type IngredientCarriers = {
  __typename?: 'IngredientCarriers';
  carrier?: Maybe<Excipient>;
  carrierId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type IngredientInfo = {
  __typename?: 'IngredientInfo';
  /** gram (g) */
  addedSugar?: Maybe<Scalars['String']['output']>;
  /** micro-gram per serving (mcg/serv) */
  arsenic?: Maybe<Scalars['String']['output']>;
  /** micro gram (mcg) */
  biotin?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  boron?: Maybe<Scalars['String']['output']>;
  /** micro-gram per serving (mcg/serv) */
  cadmium?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  calcium?: Maybe<Scalars['String']['output']>;
  /** kilo calories (kCal) */
  calories?: Maybe<Scalars['String']['output']>;
  /** gram (g) */
  carbohydrates?: Maybe<Scalars['String']['output']>;
  /** (mg) */
  chloride?: Maybe<Scalars['Float']['output']>;
  /** milligram (mg) */
  cholesterol?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  choline?: Maybe<Scalars['String']['output']>;
  /** mcg */
  chromium?: Maybe<Scalars['Float']['output']>;
  /** mg */
  copper?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  /** gram (g) */
  dietaryFiber?: Maybe<Scalars['String']['output']>;
  /** micro gram (mcg) */
  folate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ingredientId?: Maybe<Scalars['String']['output']>;
  /** micro gram (mcg) */
  iodine?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  iron?: Maybe<Scalars['String']['output']>;
  /** micro-gram per serving (mcg/serv) */
  lead?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  magnesium?: Maybe<Scalars['String']['output']>;
  /** mg */
  manganese?: Maybe<Scalars['Float']['output']>;
  /** micro-gram per serving (mcg/serv) */
  mercury?: Maybe<Scalars['String']['output']>;
  /** Grams (g) */
  moisture?: Maybe<Scalars['String']['output']>;
  /** (mcg) */
  molybdenum?: Maybe<Scalars['Float']['output']>;
  /** gram (g) */
  monounsaturatedFat?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  niacin?: Maybe<Scalars['String']['output']>;
  /** Percentage (%) */
  organic?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  pantothenicAcid?: Maybe<Scalars['Float']['output']>;
  /** milligram (mg) */
  phosphorus?: Maybe<Scalars['Float']['output']>;
  /** gram (g) */
  polyunsaturatedFat?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  potassium?: Maybe<Scalars['String']['output']>;
  /** gram (g) */
  protein?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  riboflavin?: Maybe<Scalars['String']['output']>;
  /** gram (g) */
  saturatedFat?: Maybe<Scalars['String']['output']>;
  /** mcg */
  selenium?: Maybe<Scalars['Float']['output']>;
  /** milligram (mg) */
  sodium?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  thiamin?: Maybe<Scalars['String']['output']>;
  /** gram (g) */
  totalFat?: Maybe<Scalars['String']['output']>;
  /** gram (g) */
  totalSugars?: Maybe<Scalars['String']['output']>;
  /** gram (g) */
  transFat?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  /** micro-gram (mcg) */
  vitaminA?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  vitaminB6?: Maybe<Scalars['String']['output']>;
  /** micro gram (mcg) */
  vitaminB12?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  vitaminC?: Maybe<Scalars['String']['output']>;
  /** micro-gram (mcg) */
  vitaminD?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  vitaminE?: Maybe<Scalars['String']['output']>;
  /** micro gram (mcg) */
  vitaminK?: Maybe<Scalars['Float']['output']>;
  /** micro gram (mcg) */
  vitaminK2?: Maybe<Scalars['String']['output']>;
  /** milligram (mg) */
  zinc?: Maybe<Scalars['String']['output']>;
};

export type IngredientPayload = {
  __typename?: 'IngredientPayload';
  ingredient?: Maybe<Ingredient>;
  response?: Maybe<Response>;
};

export type IngredientProductType = {
  __typename?: 'IngredientProductType';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ingredientId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type IngredientSubComponentInput = {
  /** ingredient sub-component id. Will ignore this while creating the ingredient */
  id?: InputMaybe<Scalars['String']['input']>;
  /** sub-component name */
  name: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

export type IngredientSubComponents = {
  __typename?: 'IngredientSubComponents';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Sub-component name of the ingredient */
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type IngredientSupplierInput = {
  /** supplier uuid */
  supplier: Scalars['String']['input'];
  type: SupplierType;
};

export type IngredientSuppliers = {
  __typename?: 'IngredientSuppliers';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ingredientId?: Maybe<Scalars['String']['output']>;
  supplier: Supplier;
  supplierId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SupplierType>;
  updatedAt: Scalars['String']['output'];
};

/** ingredient food type */
export enum IngredientType {
  GlutenFree = 'GLUTEN_FREE',
  Kosher = 'KOSHER',
  NonGmo = 'NON_GMO',
  Vegan = 'VEGAN'
}

export type IngredientsPayload = {
  __typename?: 'IngredientsPayload';
  data?: Maybe<Array<Ingredient>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type InviteOrganizationInput = {
  address: AddressInput;
  organization: CreateOrganizationInput;
  user: CreateUserInput;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  updatedAt: Scalars['String']['output'];
};

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type InvoicesPayload = {
  __typename?: 'InvoicesPayload';
  data?: Maybe<Array<Invoice>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum LoadAddUnit {
  Mg = 'MG'
}

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  response?: Maybe<Response>;
  token: Scalars['String']['output'];
};

export type MacroNutrientsWeights = {
  __typename?: 'MacroNutrientsWeights';
  addedSugar: Scalars['Float']['output'];
  calories: Scalars['Float']['output'];
  carbohydrates: Scalars['Float']['output'];
  cholesterol: Scalars['Float']['output'];
  dietaryFiber: Scalars['Float']['output'];
  moisture: Scalars['Float']['output'];
  monounsaturatedFat: Scalars['Float']['output'];
  polyunsaturatedFat: Scalars['Float']['output'];
  protein: Scalars['Float']['output'];
  saturatedFat: Scalars['Float']['output'];
  totalFat: Scalars['Float']['output'];
  totalSugars: Scalars['Float']['output'];
  transFat: Scalars['Float']['output'];
};

export type MarketingFeatures = {
  __typename?: 'MarketingFeatures';
  name?: Maybe<Scalars['String']['output']>;
};

export type MicroNutrientsWeights = {
  __typename?: 'MicroNutrientsWeights';
  biotin: Scalars['Float']['output'];
  boron: Scalars['Float']['output'];
  calcium: Scalars['Float']['output'];
  chloride: Scalars['Float']['output'];
  choline: Scalars['Float']['output'];
  chromium: Scalars['Float']['output'];
  copper: Scalars['Float']['output'];
  folate: Scalars['Float']['output'];
  folicAcid: Scalars['Float']['output'];
  iodine: Scalars['Float']['output'];
  iron: Scalars['Float']['output'];
  magnesium: Scalars['Float']['output'];
  manganese: Scalars['Float']['output'];
  molybdenum: Scalars['Float']['output'];
  niacin: Scalars['Float']['output'];
  pantothenicAcid: Scalars['Float']['output'];
  phosphorus: Scalars['Float']['output'];
  potassium: Scalars['Float']['output'];
  riboflavin: Scalars['Float']['output'];
  selenium: Scalars['Float']['output'];
  sodium: Scalars['Float']['output'];
  thiamin: Scalars['Float']['output'];
  vitaminA: Scalars['Float']['output'];
  vitaminB6: Scalars['Float']['output'];
  vitaminB12: Scalars['Float']['output'];
  vitaminC: Scalars['Float']['output'];
  vitaminD: Scalars['Float']['output'];
  vitaminE: Scalars['Float']['output'];
  vitaminK: Scalars['Float']['output'];
  vitaminK2: Scalars['Float']['output'];
  zinc: Scalars['Float']['output'];
};

export enum MiniTabFormulationType {
  Same = 'SAME',
  Variable = 'VARIABLE'
}

export type MobileLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activeStaffSubscription: ClientSecretPayload;
  addPaymentMethod: ClientSecretPayload;
  cancelStaffSubscription: CancelSubscriptionPayload;
  cancelSubscription: CancelSubscriptionPayload;
  changePassword: ResponsePayload;
  changeSubscriptionPlan: ChangeSubscriptionPlanPayload;
  createAdditionalContact: AdditionalContactPayload;
  createAddress: AddressPayload;
  createAllergen: AllergenPayload;
  createBottleCapacity: BottleCapacityPayload;
  createBottlePrice: BottlePricePayload;
  createBottleSize: BottleSizePayload;
  createCapsulePrice: CapsulePricePayload;
  createCapsuleType: CapsuleTypePayload;
  createCategory: CategoryPayload;
  createCoatingFormulationComponent: CoatingFormulationComponentPayload;
  createContact: ContactPayload;
  createDensity: DensityPayload;
  createExcipient: ExcipientPayload;
  createExcipientLabel: ExcipientLabelPayload;
  createExcipientType: ExcipientTypePayload;
  createFormula: FormulaPayload;
  createIngredient: IngredientPayload;
  createOrgStaff: UserPayload;
  createProductExcipient: ProductExcipientPayload;
  createProductFormulationSyrupType: ProductFormulationSyrupTypePayload;
  createProductIngredient: ProductIngredientPayload;
  createProductIngredientSyrupType: ProductIngredientSyrupTypePayload;
  createProductSize: ProductSizePayload;
  createSandCoating: SandCoatingPayload;
  createSandCoatingFormulation: SandCoatingFormulationPayload;
  createSandComponent: SandComponentPayload;
  createServingSize: ServingSizePayload;
  createSetupIntent: ClientSecretPayload;
  createStaff: ClientSecretPayload;
  createSubProductType: SubProductTypePayload;
  createSubscription: CreateSubscriptionPayload;
  createSupplier: SupplierPayload;
  createSweetener: SweetenerPayload;
  createSweetenerComponent: SweetenerComponentPayload;
  createSweetenerElement: SweetenerElementPayload;
  createSyrupBaseIngredient: IngredientPayload;
  createTabletCoating: TabletCoatingPayload;
  forgotPassword: ForgotPasswordPayload;
  inviteOrganization: UserPayload;
  login: LoginPayload;
  mobileLogin: LoginPayload;
  removeAddress: ResponsePayload;
  removeAttachment: AttachmentPayload;
  removeCoatingFormulationComponent: CoatingFormulationComponentPayload;
  removePaymentMethod: ResponsePayload;
  removeProductExcipient: ProductExcipientPayload;
  removeProductIngredientSyrupType: ProductIngredientSyrupTypePayload;
  removeSweetenerElement: SweetenerElementPayload;
  saveFormulaAsDraft: FormulaPayload;
  setDefaultPaymentMethod: ResponsePayload;
  signUpUser: ResponsePayload;
  updateAdditionalContact: AdditionalContactPayload;
  updateAdditionalContactByContactableId: ContactPayload;
  updateAddress: ResponsePayload;
  updateAddressByType: ResponsePayload;
  updateAllergen: AllergenPayload;
  updateBottleCapacity: BottleCapacityPayload;
  updateBottlePrice: BottlePricePayload;
  updateBottleSize: BottleSizePayload;
  updateBottleSizeStatus: BottleSizePayload;
  updateCapsulePrice: ResponsePayload;
  updateCapsuleType: CapsuleTypePayload;
  updateCategory: CategoryPayload;
  updateCoatingFormulationComponent: CoatingFormulationComponentPayload;
  updateConsent: ResponsePayload;
  updateContact: ContactPayload;
  updateContactByContactableId: ContactPayload;
  updateDailyValueConstraint: DailyValueConstraintPayload;
  updateDensity: DensityPayload;
  updateDraftedFormula: FormulaPayload;
  updateExcipient: ExcipientPayload;
  updateExcipientLabel: ExcipientLabelPayload;
  updateExcipientType: ExcipientTypePayload;
  updateFormula: FormulaPayload;
  updateFormulaStatus: FormulaPayload;
  updateIngredient: ResponsePayload;
  updateIngredientAllergens: ResponsePayload;
  updateIngredientCarriers: ResponsePayload;
  updateIngredientInfo: ResponsePayload;
  updateIngredientStatus: ResponsePayload;
  updateIngredientSubComponents: ResponsePayload;
  updateIngredientSuppliers: ResponsePayload;
  updateOrgAndUser: ResponsePayload;
  updateOrgStaffInfo: ResponsePayload;
  updatePassword: ResponsePayload;
  updateProductExcipient: ProductExcipientPayload;
  updateProductFormulationSyrupType: ProductFormulationSyrupTypePayload;
  updateProductFormulationType: ProductFormulationTypePayload;
  updateProductIngredient: ProductIngredientPayload;
  updateProductIngredientSyrupType: ProductIngredientSyrupTypePayload;
  updateProductSize: ProductSizePayload;
  updateProductType: ProductTypePayload;
  updateSandCoating: SandCoatingPayload;
  updateSandCoatingFormulation: SandCoatingFormulationPayload;
  updateSandComponent: SandComponentPayload;
  updateServingSize: ServingSizePayload;
  updateStaffInfo: ResponsePayload;
  updateSubProductType: SubProductTypePayload;
  updateSupplier: SupplierPayload;
  updateSweetener: SweetenerPayload;
  updateSweetenerComponent: SweetenerComponentPayload;
  updateSweetenerElement: SweetenerElementPayload;
  updateSyrupBaseIngredient: ResponsePayload;
  updateTabletCoating: TabletCoatingPayload;
  updateUserInfo: ResponsePayload;
  updateUserStatus: ResponsePayload;
  upgradeAttachment: AttachmentPayload;
  uploadAttachment: AttachmentPayload;
  verifyCode: VerifyCodePayload;
  verifyEmailAndSetPassword: ResponsePayload;
};


export type MutationActiveStaffSubscriptionArgs = {
  activeStaffSubscriptionInput: ActiveStaffSubscriptionInput;
};


export type MutationAddPaymentMethodArgs = {
  addPaymentMethodInput: AddPaymentMethodInput;
};


export type MutationCancelStaffSubscriptionArgs = {
  cancelStaffSubscriptionInput: CancelStaffSubscriptionInput;
};


export type MutationCancelSubscriptionArgs = {
  cancelSubscriptionInput: CancelSubscriptionInput;
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationChangeSubscriptionPlanArgs = {
  changeSubscriptionPlanInput: ChangeSubscriptionPlanInput;
};


export type MutationCreateAdditionalContactArgs = {
  createAdditionalContactInput: CreateAdditionalContactInput;
};


export type MutationCreateAddressArgs = {
  createAddressInput: CreateAddressInput;
};


export type MutationCreateAllergenArgs = {
  createAllergenInput: CreateAllergenInput;
};


export type MutationCreateBottleCapacityArgs = {
  createBottleCapacityInput: CreateBottleCapacityInput;
};


export type MutationCreateBottlePriceArgs = {
  createBottlePriceInput: CreateBottlePriceInput;
};


export type MutationCreateBottleSizeArgs = {
  createBottleSizeInput: CreateBottleSizeInput;
};


export type MutationCreateCapsulePriceArgs = {
  createCapsulePriceInput: CreateCapsulePriceInput;
};


export type MutationCreateCapsuleTypeArgs = {
  createCapsuleTypeInput: CreateCapsuleTypeInput;
};


export type MutationCreateCategoryArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationCreateCoatingFormulationComponentArgs = {
  createCoatingFormulationComponentInput: CreateCoatingFormulationComponentInput;
};


export type MutationCreateContactArgs = {
  createContactInput: CreateContactInput;
};


export type MutationCreateDensityArgs = {
  createDensityInput: CreateDensityInput;
};


export type MutationCreateExcipientArgs = {
  createExcipientInput: CreateExcipientInput;
};


export type MutationCreateExcipientLabelArgs = {
  createExcipientLabelInput: CreateExcipientLabelInput;
};


export type MutationCreateExcipientTypeArgs = {
  createExcipientTypeInput: CreateExcipientTypeInput;
};


export type MutationCreateFormulaArgs = {
  createFormulaInput: CreateFormulaInput;
};


export type MutationCreateIngredientArgs = {
  createIngredientInput: CreateIngredientInput;
};


export type MutationCreateOrgStaffArgs = {
  createOrgStaffInput: CreateOrgStaffInput;
};


export type MutationCreateProductExcipientArgs = {
  createProductExcipientInput: CreateProductExcipientInput;
};


export type MutationCreateProductFormulationSyrupTypeArgs = {
  createProductFormulationSyrupTypeInput: CreateProductFormulationSyrupTypeInput;
};


export type MutationCreateProductIngredientArgs = {
  createProductIngredientInput: CreateProductIngredientInput;
};


export type MutationCreateProductIngredientSyrupTypeArgs = {
  createProductIngredientSyrupTypeInput: CreateProductIngredientSyrupTypeInput;
};


export type MutationCreateProductSizeArgs = {
  createProductSizeInput: CreateProductSizeInput;
};


export type MutationCreateSandCoatingArgs = {
  createSandCoatingInput: CreateSandCoatingInput;
};


export type MutationCreateSandCoatingFormulationArgs = {
  createSandCoatingFormulationInput: CreateSandCoatingFormulationInput;
};


export type MutationCreateSandComponentArgs = {
  createSandComponentInput: CreateSandComponentInput;
};


export type MutationCreateServingSizeArgs = {
  createServingSizeInput: CreateServingSizeInput;
};


export type MutationCreateStaffArgs = {
  createStaffInput: CreateStaffInput;
};


export type MutationCreateSubProductTypeArgs = {
  createSubProductTypeInput: CreateSubProductTypeInput;
};


export type MutationCreateSubscriptionArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};


export type MutationCreateSupplierArgs = {
  createSupplierInput: CreateSupplierInput;
};


export type MutationCreateSweetenerArgs = {
  createSweetenerInput: CreateSweetenerInput;
};


export type MutationCreateSweetenerComponentArgs = {
  createSweetenerComponentInput: CreateSweetenerComponentInput;
};


export type MutationCreateSweetenerElementArgs = {
  createSweetenerElementsInput: CreateSweetenerElementsInput;
};


export type MutationCreateSyrupBaseIngredientArgs = {
  createSyrupBaseIngredientsInput: CreateSyrupBaseIngredientsInput;
};


export type MutationCreateTabletCoatingArgs = {
  createTabletCoatingInput: CreateTabletCoatingInput;
};


export type MutationForgotPasswordArgs = {
  forgotPasswordInput: ForgotPasswordInput;
};


export type MutationInviteOrganizationArgs = {
  inviteOrganizationInput: InviteOrganizationInput;
};


export type MutationLoginArgs = {
  loginInput: LoginInput;
};


export type MutationMobileLoginArgs = {
  mobileLoginInput: MobileLoginInput;
};


export type MutationRemoveAddressArgs = {
  removeAddressInput: RemoveAddressInput;
};


export type MutationRemoveAttachmentArgs = {
  removeAttachmentInput: RemoveAttachmentInput;
};


export type MutationRemoveCoatingFormulationComponentArgs = {
  removeCoatingFormulationComponentInput: RemoveCoatingFormulationComponentInput;
};


export type MutationRemovePaymentMethodArgs = {
  removePaymentMethodInput: RemovePaymentMethodInput;
};


export type MutationRemoveProductExcipientArgs = {
  removeProductExcipientInput: RemoveProductExcipientInput;
};


export type MutationRemoveProductIngredientSyrupTypeArgs = {
  removeProductIngredientSyrupTypeInput: RemoveProductIngredientSyrupTypeInput;
};


export type MutationRemoveSweetenerElementArgs = {
  removeSweetenerElementsInput: RemoveSweetenerElementsInput;
};


export type MutationSaveFormulaAsDraftArgs = {
  saveFormulaAsDraftInput: SaveFormulaAsDraftInput;
};


export type MutationSetDefaultPaymentMethodArgs = {
  setDefaultPaymentMethodInput: SetDefaultPaymentMethodInput;
};


export type MutationSignUpUserArgs = {
  userSignUpInput: UserSignUpInput;
};


export type MutationUpdateAdditionalContactArgs = {
  updateAdditionalContactsInput: UpdateAdditionalContactsInput;
};


export type MutationUpdateAdditionalContactByContactableIdArgs = {
  updateContactByContactableIdInput: UpdateContactByContactableIdInput;
};


export type MutationUpdateAddressArgs = {
  updateAddressInput: UpdateAddressInput;
};


export type MutationUpdateAddressByTypeArgs = {
  updateAddressByTypeInput: UpdateAddressByTypeInput;
};


export type MutationUpdateAllergenArgs = {
  updateAllergenInput: UpdateAllergenInput;
};


export type MutationUpdateBottleCapacityArgs = {
  updateBottleCapacityInput: UpdateBottleCapacityInput;
};


export type MutationUpdateBottlePriceArgs = {
  updateBottlePriceInput: UpdateBottlePriceInput;
};


export type MutationUpdateBottleSizeArgs = {
  updateBottleSizeInput: UpdateBottleSizeInput;
};


export type MutationUpdateBottleSizeStatusArgs = {
  updateBottleSizeStatusInput: UpdateBottleSizeStatusInput;
};


export type MutationUpdateCapsulePriceArgs = {
  updateCapsulePriceInput: UpdateCapsulePriceInput;
};


export type MutationUpdateCapsuleTypeArgs = {
  updateCapsuleTypeInput: UpdateCapsuleTypeInput;
};


export type MutationUpdateCategoryArgs = {
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationUpdateCoatingFormulationComponentArgs = {
  updateCoatingFormulationComponentInput: UpdateCoatingFormulationComponentInput;
};


export type MutationUpdateContactArgs = {
  updateContactInput: UpdateContactInput;
};


export type MutationUpdateContactByContactableIdArgs = {
  updateContactByContactableIdInput: UpdateContactByContactableIdInput;
};


export type MutationUpdateDailyValueConstraintArgs = {
  updateDailyValueConstraintInput: UpdateDailyValueConstraintInput;
};


export type MutationUpdateDensityArgs = {
  updateDensityInput: UpdateDensityInput;
};


export type MutationUpdateDraftedFormulaArgs = {
  updateDraftedFormulaInput: UpdateDraftedFormulaInput;
};


export type MutationUpdateExcipientArgs = {
  updateExcipientInput: UpdateExcipientInput;
};


export type MutationUpdateExcipientLabelArgs = {
  updateExcipientLabelInput: UpdateExcipientLabelInput;
};


export type MutationUpdateExcipientTypeArgs = {
  updateExcipientTypeInput: UpdateExcipientTypeInput;
};


export type MutationUpdateFormulaArgs = {
  updateFormulaInput: UpdateFormulaInput;
};


export type MutationUpdateFormulaStatusArgs = {
  updateFormulaStatusInput: UpdateFormulaStatusInput;
};


export type MutationUpdateIngredientArgs = {
  updateIngredientInput: UpdateIngredientInput;
};


export type MutationUpdateIngredientAllergensArgs = {
  updateIngredientAllergensInput: UpdateIngredientAllergensInput;
};


export type MutationUpdateIngredientCarriersArgs = {
  updateIngredientCarriersInput: UpdateIngredientCarriersInput;
};


export type MutationUpdateIngredientInfoArgs = {
  updateIngredientInfoInput: UpdateIngredientInfoInput;
};


export type MutationUpdateIngredientStatusArgs = {
  UpdateIngredientStatus: UpdateIngredientStatus;
};


export type MutationUpdateIngredientSubComponentsArgs = {
  updateIngredientSubComponentsInput: UpdateIngredientSubComponentsInput;
};


export type MutationUpdateIngredientSuppliersArgs = {
  updateIngredientSuppliersInput: UpdateIngredientSuppliersInput;
};


export type MutationUpdateOrgAndUserArgs = {
  updateOrgAndUserInput: UpdateOrgAndUserInput;
};


export type MutationUpdateOrgStaffInfoArgs = {
  updateOrgStaffInfoInput: UpdateOrgStaffInfoInput;
};


export type MutationUpdatePasswordArgs = {
  updatePasswordInput: UpdatePasswordInput;
};


export type MutationUpdateProductExcipientArgs = {
  updateProductExcipientInput: UpdateProductExcipientInput;
};


export type MutationUpdateProductFormulationSyrupTypeArgs = {
  updateProductFormulationSyrupTypeInput: UpdateProductFormulationSyrupTypeInput;
};


export type MutationUpdateProductFormulationTypeArgs = {
  updateProductFormulationTypeInput: UpdateProductFormulationTypeInput;
};


export type MutationUpdateProductIngredientArgs = {
  updateProductIngredientInput: UpdateProductIngredientInput;
};


export type MutationUpdateProductIngredientSyrupTypeArgs = {
  updateProductIngredientSyrupTypeInput: UpdateProductIngredientSyrupTypeInput;
};


export type MutationUpdateProductSizeArgs = {
  updateProductSizeInput: UpdateProductSizeInput;
};


export type MutationUpdateProductTypeArgs = {
  updateProductTypeInput: UpdateProductTypeInput;
};


export type MutationUpdateSandCoatingArgs = {
  updateSandCoatingInput: UpdateSandCoatingInput;
};


export type MutationUpdateSandCoatingFormulationArgs = {
  updateSandCoatingFormulationInput: UpdateSandCoatingFormulationInput;
};


export type MutationUpdateSandComponentArgs = {
  updateSandComponentInput: UpdateSandComponentInput;
};


export type MutationUpdateServingSizeArgs = {
  updateServingSizeInput: UpdateServingSizeInput;
};


export type MutationUpdateStaffInfoArgs = {
  updateStaffInfoInput: UpdateStaffInfoInput;
};


export type MutationUpdateSubProductTypeArgs = {
  updateSubProductTypeInput: UpdateSubProductTypeInput;
};


export type MutationUpdateSupplierArgs = {
  updateSupplierInput: UpdateSupplierInput;
};


export type MutationUpdateSweetenerArgs = {
  updateSweetenerInput: UpdateSweetenerInput;
};


export type MutationUpdateSweetenerComponentArgs = {
  updateSweetenerComponentInput: UpdateSweetenerComponentInput;
};


export type MutationUpdateSweetenerElementArgs = {
  updateSweetenerElementsInput: UpdateSweetenerElementsInput;
};


export type MutationUpdateSyrupBaseIngredientArgs = {
  updateSyrupBaseIngredientsInput: UpdateSyrupBaseIngredientsInput;
};


export type MutationUpdateTabletCoatingArgs = {
  updateTabletCoatingInput: UpdateTabletCoatingInput;
};


export type MutationUpdateUserInfoArgs = {
  updateUserInfoInput: UpdateUserInfoInput;
};


export type MutationUpdateUserStatusArgs = {
  updateUserStatusInput: UpdateUserStatusInput;
};


export type MutationUpgradeAttachmentArgs = {
  upgradeAttachmentInput: UpgradeAttachmentInput;
};


export type MutationUploadAttachmentArgs = {
  uploadAttachmentInput: UploadAttachmentInput;
};


export type MutationVerifyCodeArgs = {
  verifyCodeInput: VerifyCodeInput;
};


export type MutationVerifyEmailAndSetPasswordArgs = {
  verifyEmailAndSetPasswordInput: VerifyUserAndUpdatePasswordInput;
};

export type OrgDashboardPayload = {
  __typename?: 'OrgDashboardPayload';
  formulas?: Maybe<Scalars['Int']['output']>;
  ingredients: Scalars['Int']['output'];
  myFormulas?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Response>;
  users?: Maybe<Scalars['Int']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  activeStaff?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Address>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maxUser?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalStaff?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OrganizationPayload = {
  __typename?: 'OrganizationPayload';
  organization?: Maybe<Organization>;
  response?: Maybe<Response>;
};

export type OrganizationUsersCount = {
  __typename?: 'OrganizationUsersCount';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  usersCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationsPayload = {
  __typename?: 'OrganizationsPayload';
  data?: Maybe<Array<Organization>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type OrganizationsUsersCountPayload = {
  __typename?: 'OrganizationsUsersCountPayload';
  data?: Maybe<Array<Maybe<OrganizationUsersCount>>>;
  response?: Maybe<Response>;
};

export type Pagination = {
  __typename?: 'Pagination';
  limit: Scalars['Int']['output'];
  page?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type PaymentMethodsPayload = {
  __typename?: 'PaymentMethodsPayload';
  paymentMethods?: Maybe<Array<StripePaymentMethod>>;
  response?: Maybe<Response>;
};

export type PlatformUsersCount = {
  __typename?: 'PlatformUsersCount';
  android: Scalars['Int']['output'];
  ios: Scalars['Int']['output'];
  web: Scalars['Int']['output'];
};

export type PlatformUsersCountPayload = {
  __typename?: 'PlatformUsersCountPayload';
  data: PlatformUsersCount;
  response?: Maybe<Response>;
};

export type ProductExcipient = {
  __typename?: 'ProductExcipient';
  createdAt: Scalars['String']['output'];
  excipient?: Maybe<Excipient>;
  excipientId?: Maybe<Scalars['String']['output']>;
  excipientTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** $/Kg */
  perKgCost?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  productExcipientSupplier?: Maybe<Array<Maybe<ProductExcipientSupplier>>>;
  updatedAt: Scalars['String']['output'];
};

export type ProductExcipientPayload = {
  __typename?: 'ProductExcipientPayload';
  productExcipient?: Maybe<ProductExcipient>;
  response?: Maybe<Response>;
};

export type ProductExcipientSupplier = {
  __typename?: 'ProductExcipientSupplier';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productExcipientId?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ProductExcipientsPayload = {
  __typename?: 'ProductExcipientsPayload';
  data?: Maybe<Array<ProductExcipient>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ProductFormulationSyrupTypePayload = {
  __typename?: 'ProductFormulationSyrupTypePayload';
  productFormulationSyrupType?: Maybe<ProductFormulationSyrupTypes>;
  response?: Maybe<Response>;
};

export type ProductFormulationSyrupTypes = {
  __typename?: 'ProductFormulationSyrupTypes';
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productFormulationType?: Maybe<ProductFormulationType>;
  productSize?: Maybe<ProductSize>;
  productType?: Maybe<ProductType>;
  subProductType?: Maybe<SubProductType>;
  unit?: Maybe<FormulationSyrupUnit>;
  updatedAt: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProductFormulationSyrupTypesPayload = {
  __typename?: 'ProductFormulationSyrupTypesPayload';
  data?: Maybe<Array<ProductFormulationSyrupTypes>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ProductFormulationType = {
  __typename?: 'ProductFormulationType';
  attachment?: Maybe<Attachment>;
  conversionCost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  innerComponentCost?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  isInnerCapTab?: Maybe<Scalars['Boolean']['output']>;
  lohInside?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  subProductType?: Maybe<SubProductType>;
  subProductTypeId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProductFormulationTypes>;
  updatedAt: Scalars['String']['output'];
};

export type ProductFormulationTypePayload = {
  __typename?: 'ProductFormulationTypePayload';
  productFormulationType?: Maybe<ProductFormulationType>;
  response?: Maybe<Response>;
};

/** Product Formulation Type */
export enum ProductFormulationTypes {
  AllLiquids = 'ALL_LIQUIDS',
  AllOthers = 'ALL_OTHERS',
  BcaaPowder = 'BCAA_POWDER',
  BiLayeredTablet = 'BI_LAYERED_TABLET',
  CapInCap = 'CAP_IN_CAP',
  ChewableTablet = 'CHEWABLE_TABLET',
  EffervescentTablet = 'EFFERVESCENT_TABLET',
  GreensOrRedsPowder = 'GREENS_OR_REDS_POWDER',
  HydrationPowder = 'HYDRATION_POWDER',
  LiquidFilled = 'LIQUID_FILLED',
  LiquidFilledWithBeadlets = 'LIQUID_FILLED_WITH_BEADLETS',
  LiquidFilledWithMiniTabs = 'LIQUID_FILLED_WITH_MINI_TABS',
  LiquidFilledWithTablet = 'LIQUID_FILLED_WITH_TABLET',
  MiniTablet = 'MINI_TABLET',
  NaturalSugarFree = 'NATURAL_SUGAR_FREE',
  NonGmoSugar = 'NON_GMO_SUGAR',
  OrganicSugar = 'ORGANIC_SUGAR',
  OwnSyrupBlend = 'OWN_SYRUP_BLEND',
  PowderFilled = 'POWDER_FILLED',
  PreOrPostPowder = 'PRE_OR_POST_POWDER',
  ProteinPowder = 'PROTEIN_POWDER',
  SingleLayerTablet = 'SINGLE_LAYER_TABLET',
  SugarAlcohol = 'SUGAR_ALCOHOL',
  SugarBased = 'SUGAR_BASED',
  TriLayerTablet = 'TRI_LAYER_TABLET'
}

export type ProductFormulationTypesPayload = {
  __typename?: 'ProductFormulationTypesPayload';
  data?: Maybe<Array<ProductFormulationType>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ProductIngredient = {
  __typename?: 'ProductIngredient';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ProductIngredientPayload = {
  __typename?: 'ProductIngredientPayload';
  productIngredient?: Maybe<ProductIngredient>;
  response?: Maybe<Response>;
};

export type ProductIngredientSyrupTypePayload = {
  __typename?: 'ProductIngredientSyrupTypePayload';
  productIngredientSyrupType?: Maybe<ProductIngredientSyrupTypes>;
  response?: Maybe<Response>;
};

export type ProductIngredientSyrupTypes = {
  __typename?: 'ProductIngredientSyrupTypes';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  productFormulationSyrupType?: Maybe<ProductFormulationSyrupTypes>;
  productIngredients?: Maybe<ProductIngredient>;
  updatedAt: Scalars['String']['output'];
};

export type ProductIngredientSyrupTypesPayload = {
  __typename?: 'ProductIngredientSyrupTypesPayload';
  data?: Maybe<Array<ProductIngredientSyrupTypes>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ProductIngredientsPayload = {
  __typename?: 'ProductIngredientsPayload';
  data?: Maybe<Array<ProductIngredient>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ProductSize = {
  __typename?: 'ProductSize';
  createdAt: Scalars['String']['output'];
  /** Empty weight mg of capsule */
  emptyWtMg?: Maybe<Scalars['Float']['output']>;
  /** Total mg weight of gummy */
  gummyWeight?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  subProductType?: Maybe<SubProductType>;
  updatedAt: Scalars['String']['output'];
};

export type ProductSizePayload = {
  __typename?: 'ProductSizePayload';
  productSize?: Maybe<ProductSize>;
  response?: Maybe<Response>;
};

export type ProductSizesPayload = {
  __typename?: 'ProductSizesPayload';
  data?: Maybe<Array<ProductSize>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type ProductType = {
  __typename?: 'ProductType';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProductTypes>;
  updatedAt: Scalars['String']['output'];
};

export type ProductTypePayload = {
  __typename?: 'ProductTypePayload';
  productType?: Maybe<ProductType>;
  response?: Maybe<Response>;
};

/** Product Type */
export enum ProductTypes {
  Bars = 'BARS',
  Beverages = 'BEVERAGES',
  Capsule = 'CAPSULE',
  Gummies = 'GUMMIES',
  Liquids = 'LIQUIDS',
  Powder = 'POWDER',
  Tablet = 'TABLET'
}

export type ProductTypesPayload = {
  __typename?: 'ProductTypesPayload';
  data?: Maybe<Array<ProductType>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum ProteinBaseType {
  Animal = 'ANIMAL',
  Plant = 'PLANT'
}

export type Query = {
  __typename?: 'Query';
  calcFormulaCost: CalcFormulaCostPayload;
  fetchUser: UserPayload;
  findAllAdmin: UsersPayload;
  findAllAllergens: AllergensPayload;
  findAllBeadlets: BeadletsPayload;
  findAllBottleCapacity: BottleCapacitiesPayload;
  findAllBottlePrice: BottlePricesPayload;
  findAllBottleSize: BottleSizesPayload;
  findAllBottleSizeProductType: BottleSizeProductTypesPayload;
  findAllCapsulePrices: CapsulePricesPayload;
  findAllCapsuleType: CapsuleTypesPayload;
  findAllCategories: CategoriesPayload;
  findAllCoatingFormulationComponent: CoatingFormulationComponentsPayload;
  findAllDailyValueConstraints: DailyValueConstraintsPayload;
  findAllDensities: DensitiesPayload;
  findAllDosageFormulas: DosageFormulasPayload;
  findAllDosageTypeFormulas: DosageFormulasPayload;
  findAllExcipientLabels: ExcipientLabelsPayload;
  findAllExcipientTypes: ExcipientTypesPayload;
  findAllExcipients: ExcipientsPayload;
  findAllFormulas: FormulasPayload;
  findAllIngredients: IngredientsPayload;
  findAllInvoices: InvoicesPayload;
  findAllOrgInvoices: InvoicesPayload;
  findAllOrgStaff: UsersPayload;
  findAllOrganizations: OrganizationsPayload;
  findAllOrganizationsUsersCount: OrganizationsUsersCountPayload;
  findAllProductExcipients: ProductExcipientsPayload;
  findAllProductFormulationSyrupTypes: ProductFormulationSyrupTypesPayload;
  findAllProductFormulationType: ProductFormulationTypesPayload;
  findAllProductIngredientSyrupTypes: ProductIngredientSyrupTypesPayload;
  findAllProductIngredients: ProductIngredientsPayload;
  findAllProductSize: ProductSizesPayload;
  findAllProductType: ProductTypesPayload;
  findAllSandCoating: SandCoatingsPayload;
  findAllSandCoatingFormulation: SandCoatingFormulationsPayload;
  findAllSandComponent: SandComponentsPayload;
  findAllServingSize: ServingSizesPayload;
  findAllStaff: UsersPayload;
  findAllSubProductType: SubProductTypesPayload;
  findAllSuppliers: SuppliersPayload;
  findAllSweetenerElements: SweetenerElementsPayload;
  findAllSweeteners: SweetenersPayload;
  findAllSweetenersComponent: SweetenerComponentsPayload;
  findAllSyrupBaseIngredients: IngredientsPayload;
  findAllTabletCoating: TabletCoatingsPayload;
  findAllUsers: UsersPayload;
  findFormulasCountByYear: FormulasCountByYearPayload;
  findOnePriceAndProducts: StripePricePayload;
  findPriceAndProducts: StripePricesPayload;
  findUsersCountByYear: UsersCountByYearPayload;
  findUsersStats: FindUserStatsPayload;
  getAddress: AddressPayload;
  getAllergen: AllergenPayload;
  getAttachment: AttachmentPayload;
  getAttachmentByType: AttachmentPayload;
  getBeadlets: BeadletPayload;
  getBottleCapacity: BottleCapacityPayload;
  getBottlePrice: BottlePricePayload;
  getBottleSize: BottleSizePayload;
  getBottleSizeProductType: BottleSizeProductTypePayload;
  getCapsulePrice: CapsulePricePayload;
  getCapsuleType: CapsuleTypePayload;
  getCategory: CategoryPayload;
  getCoatingFormulationComponent: CoatingFormulationComponentPayload;
  getContact: ContactPayload;
  getCurrentUserSubscription: SubscriptionPayload;
  getDailyValueConstraint: DailyValueConstraintPayload;
  getDensity: DensityPayload;
  getDosageFormulasCount: DosageFormulasPayload;
  getExcipient: ExcipientPayload;
  getExcipientLabel: ExcipientLabelPayload;
  getExcipientType: ExcipientTypePayload;
  getFactSheet: GetFactSheetPayload;
  getFormula: FormulaPayload;
  getFormulasIngredient: FormulasIngredientPayload;
  getIngredient: IngredientPayload;
  getInvoice: HostedInvoiceUrlPayload;
  getOrgAdmin: UserPayload;
  getOrgDashboard: OrgDashboardPayload;
  getOrgStaff: UserPayload;
  getOrgStaffSubscription: SubscriptionPayload;
  getOrganization: OrganizationPayload;
  getOrganizationSubscription: SubscriptionPayload;
  getPaymentMethods: PaymentMethodsPayload;
  getPlatformUsersCount: PlatformUsersCountPayload;
  getProductExcipient: ProductExcipientPayload;
  getProductFormulationSyrupType: ProductFormulationSyrupTypePayload;
  getProductFormulationType: ProductFormulationTypePayload;
  getProductIngredient: ProductIngredientPayload;
  getProductIngredientSyrupType: ProductIngredientSyrupTypePayload;
  getProductSize: ProductSizePayload;
  getProductType: ProductTypePayload;
  getSandCoating: SandCoatingPayload;
  getSandCoatingFormulation: SandCoatingFormulationPayload;
  getSandComponent: SandComponentPayload;
  getServingSize: ServingSizePayload;
  getStaffSubscription: SubscriptionPayload;
  getSubProductType: SubProductTypePayload;
  getSuperDashboard: SuperDashboardPayload;
  getSupplier: SupplierPayload;
  getSweetener: SweetenerPayload;
  getSweetenerComponent: SweetenerComponentPayload;
  getSweetenerElement: SweetenerElementPayload;
  getTabletCoating: TabletCoatingPayload;
  getUser: UserPayload;
};


export type QueryCalcFormulaCostArgs = {
  calcFormulaCostInput: CalcFormulaCostInput;
};


export type QueryFindAllAdminArgs = {
  findAllAdminInput: FindAllAdminInput;
};


export type QueryFindAllAllergensArgs = {
  findAllAllergensInput: FindAllAllergensInput;
};


export type QueryFindAllBeadletsArgs = {
  findAllBeadletsInput: FindAllBeadletsInput;
};


export type QueryFindAllBottleCapacityArgs = {
  findAllBottleCapacitiesInput: FindAllBottleCapacitiesInput;
};


export type QueryFindAllBottlePriceArgs = {
  findAllBottlePricesInput: FindAllBottlePricesInput;
};


export type QueryFindAllBottleSizeArgs = {
  findAllBottleSizesInput: FindAllBottleSizesInput;
};


export type QueryFindAllBottleSizeProductTypeArgs = {
  findAllBottleSizeProductTypesInput: FindAllBottleSizeProductTypesInput;
};


export type QueryFindAllCapsulePricesArgs = {
  findAllCapsulePricesInput: FindAllCapsulePricesInput;
};


export type QueryFindAllCapsuleTypeArgs = {
  findAllCapsuleTypesInput: FindAllCapsuleTypesInput;
};


export type QueryFindAllCategoriesArgs = {
  findAllCategoriesInput: FindAllCategoriesInput;
};


export type QueryFindAllCoatingFormulationComponentArgs = {
  findAllCoatingFormulationComponentFormulationInput: FindAllCoatingFormulationComponentInput;
};


export type QueryFindAllDailyValueConstraintsArgs = {
  findAllDailyValueConstraintsInput: FindAllDailyValueConstraintsInput;
};


export type QueryFindAllDensitiesArgs = {
  findAllDensitiesInput: FindAllDensitiesInput;
};


export type QueryFindAllDosageFormulasArgs = {
  findAllDosageFormulasInputs: FindAllDosageFormulasInputs;
};


export type QueryFindAllDosageTypeFormulasArgs = {
  findAllDosageTypeFormulasInput: FindAllDosageTypeFormulasInput;
};


export type QueryFindAllExcipientLabelsArgs = {
  findAllExcipientLabelsInput: FindAllExcipientLabelsInput;
};


export type QueryFindAllExcipientTypesArgs = {
  findAllExcipientTypesInput: FindAllExcipientTypesInput;
};


export type QueryFindAllExcipientsArgs = {
  findAllExcipientsInput: FindAllExcipientsInput;
};


export type QueryFindAllFormulasArgs = {
  findAllFormulasInput: FindAllFormulasInput;
};


export type QueryFindAllIngredientsArgs = {
  findAllIngredientsInput: FindAllIngredientsInput;
};


export type QueryFindAllInvoicesArgs = {
  findAllInvoicesInput: FindAllInvoicesInput;
};


export type QueryFindAllOrgInvoicesArgs = {
  findInvoicesByOrgIdInput: FindInvoicesByOrgIdInput;
};


export type QueryFindAllOrgStaffArgs = {
  findAllOrgStaffInput: FindAllOrgStaffInput;
};


export type QueryFindAllOrganizationsArgs = {
  findAllOrganizationsInput: FindAllOrganizationsInput;
};


export type QueryFindAllProductExcipientsArgs = {
  findAllProductExcipientsInput: FindAllProductExcipientsInput;
};


export type QueryFindAllProductFormulationSyrupTypesArgs = {
  findAllProductFormulationSyrupTypesInput: FindAllProductFormulationSyrupTypesInput;
};


export type QueryFindAllProductFormulationTypeArgs = {
  findAllProductFormulationTypeInput: FindAllProductFormulationTypeInput;
};


export type QueryFindAllProductIngredientSyrupTypesArgs = {
  findAllProductIngredientSyrupTypesInput: FindAllProductIngredientSyrupTypesInput;
};


export type QueryFindAllProductIngredientsArgs = {
  findAllProductIngredientsInput: FindAllProductIngredientsInput;
};


export type QueryFindAllProductSizeArgs = {
  findAllProductSizesInput: FindAllProductSizesInput;
};


export type QueryFindAllProductTypeArgs = {
  findAllProductTypeInput: FindAllProductTypesInput;
};


export type QueryFindAllSandCoatingArgs = {
  findAllSandCoatingInput: FindAllSandCoatingInput;
};


export type QueryFindAllSandCoatingFormulationArgs = {
  findAllSandCoatingFormulationInput: FindAllSandCoatingFormulationInput;
};


export type QueryFindAllSandComponentArgs = {
  findAllSandComponentInput: FindAllSandComponentInput;
};


export type QueryFindAllServingSizeArgs = {
  findAllServingSizesInput: FindAllServingSizesInput;
};


export type QueryFindAllStaffArgs = {
  findAllStaffInput: FindAllStaffInput;
};


export type QueryFindAllSubProductTypeArgs = {
  findAllSubProductTypeInput: FindAllSubProductTypesInput;
};


export type QueryFindAllSuppliersArgs = {
  findAllSuppliersInput: FindAllSuppliersInput;
};


export type QueryFindAllSweetenerElementsArgs = {
  findAllSweetenerElementsInput: FindAllSweetenerElementsInput;
};


export type QueryFindAllSweetenersArgs = {
  findAllSweetenersInput: FindAllSweetenersInput;
};


export type QueryFindAllSweetenersComponentArgs = {
  findAllSweetenerComponentsInput: FindAllSweetenerComponentsInput;
};


export type QueryFindAllSyrupBaseIngredientsArgs = {
  findAllIngredientsInput: FindAllIngredientsInput;
};


export type QueryFindAllTabletCoatingArgs = {
  findAllTabletCoatingInput: FindAllTabletCoatingInput;
};


export type QueryFindAllUsersArgs = {
  findAllUsersInput: FindAllUsersInput;
};


export type QueryFindFormulasCountByYearArgs = {
  findFormulasCountByYearInput: FindFormulasCountByYearInput;
};


export type QueryFindOnePriceAndProductsArgs = {
  getStripePriceInput: GetStripePriceInput;
};


export type QueryFindUsersCountByYearArgs = {
  findUsersCountByYearInput: FindUsersCountByYearInput;
};


export type QueryFindUsersStatsArgs = {
  findUsersStatsInput: FindUsersStatsInput;
};


export type QueryGetAddressArgs = {
  getAddressInput: GetAddressInput;
};


export type QueryGetAllergenArgs = {
  getAllergenInput: GetAllergenInput;
};


export type QueryGetAttachmentArgs = {
  getAttachmentInput: GetAttachmentInput;
};


export type QueryGetAttachmentByTypeArgs = {
  getAttachmentByTypeInput: GetAttachmentByTypeInput;
};


export type QueryGetBeadletsArgs = {
  getBeadletsInput: GetBeadletsInput;
};


export type QueryGetBottleCapacityArgs = {
  findBottleCapacityInput: FindBottleCapacityInput;
};


export type QueryGetBottlePriceArgs = {
  getBottlePriceInput: GetBottlePriceInput;
};


export type QueryGetBottleSizeArgs = {
  getBottleSizeInput: GetBottleSizeInput;
};


export type QueryGetBottleSizeProductTypeArgs = {
  getBottleSizeProductTypeInput: GetBottleSizeProductTypeInput;
};


export type QueryGetCapsulePriceArgs = {
  getCapsulePriceInput: GetCapsulePriceInput;
};


export type QueryGetCapsuleTypeArgs = {
  getCapsuleTypeInput: GetCapsuleTypeInput;
};


export type QueryGetCategoryArgs = {
  getCategoryInput: GetCategoryInput;
};


export type QueryGetCoatingFormulationComponentArgs = {
  getCoatingFormulationComponentInput: GetCoatingFormulationComponentInput;
};


export type QueryGetContactArgs = {
  getContactInput: GetContactInput;
};


export type QueryGetDailyValueConstraintArgs = {
  getDailyValueConstraintInput: GetDailyValueConstraintInput;
};


export type QueryGetDensityArgs = {
  getDensityInput: GetDensityInput;
};


export type QueryGetDosageFormulasCountArgs = {
  getDosageFormulasCountInput: GetDosageFormulasCountInput;
};


export type QueryGetExcipientArgs = {
  getExcipientInput: GetExcipientInput;
};


export type QueryGetExcipientLabelArgs = {
  getExcipientLabelInput: GetExcipientLabelInput;
};


export type QueryGetExcipientTypeArgs = {
  getExcipientTypeInput: GetExcipientTypeInput;
};


export type QueryGetFactSheetArgs = {
  getFactSheetInput: GetFactSheetInput;
};


export type QueryGetFormulaArgs = {
  getFormulaInput: GetFormulaInput;
};


export type QueryGetFormulasIngredientArgs = {
  getFormulasIngredientInput: GetFormulasIngredientInput;
};


export type QueryGetIngredientArgs = {
  getIngredientInput: GetIngredientInput;
};


export type QueryGetInvoiceArgs = {
  getInvoiceInput: GetInvoiceInput;
};


export type QueryGetOrgAdminArgs = {
  getUserInput: GetUserInput;
};


export type QueryGetOrgStaffArgs = {
  getOrgStaffInput: GetOrgStaffInput;
};


export type QueryGetOrgStaffSubscriptionArgs = {
  getOrgStaffSubscriptionInput: GetOrgStaffSubscriptionInput;
};


export type QueryGetOrganizationArgs = {
  getOrganizationInput: GetOrganizationInput;
};


export type QueryGetOrganizationSubscriptionArgs = {
  getSubscriptionByOrgIdInput: GetSubscriptionByOrgIdInput;
};


export type QueryGetProductExcipientArgs = {
  getProductExcipientInput: GetProductExcipientInput;
};


export type QueryGetProductFormulationSyrupTypeArgs = {
  getProductFormulationSyrupTypeInput: GetProductFormulationSyrupTypeInput;
};


export type QueryGetProductFormulationTypeArgs = {
  getProductFormulationTypeInput: GetProductFormulationTypeInput;
};


export type QueryGetProductIngredientArgs = {
  getProductIngredientInput: GetProductIngredientInput;
};


export type QueryGetProductIngredientSyrupTypeArgs = {
  getProductIngredientSyrupTypeInput: GetProductIngredientSyrupTypeInput;
};


export type QueryGetProductSizeArgs = {
  getProductSizeInput: GetProductSizeInput;
};


export type QueryGetProductTypeArgs = {
  getProductTypeInput: GetProductTypeInput;
};


export type QueryGetSandCoatingArgs = {
  getSandCoatingInput: GetSandCoatingInput;
};


export type QueryGetSandCoatingFormulationArgs = {
  getSandCoatingFormulationInput: GetSandCoatingFormulationInput;
};


export type QueryGetSandComponentArgs = {
  getSandComponentInput: GetSandComponentInput;
};


export type QueryGetServingSizeArgs = {
  getServingSizeInput: GetServingSizeInput;
};


export type QueryGetStaffSubscriptionArgs = {
  getSubscriptionInput: GetSubscriptionInput;
};


export type QueryGetSubProductTypeArgs = {
  getSubProductTypeInput: GetSubProductTypeInput;
};


export type QueryGetSupplierArgs = {
  getSupplierInput: GetSupplierInput;
};


export type QueryGetSweetenerArgs = {
  getSweetenerInput: GetSweetenerInput;
};


export type QueryGetSweetenerComponentArgs = {
  getSweetenerComponentInput: GetSweetenerComponentInput;
};


export type QueryGetSweetenerElementArgs = {
  getSweetenerElementsInput: GetSweetenerElementsInput;
};


export type QueryGetTabletCoatingArgs = {
  getTabletCoatingInput: GetTabletCoatingInput;
};


export type QueryGetUserArgs = {
  getUserInput: GetUserInput;
};

export type RemoveAddressInput = {
  id: Scalars['String']['input'];
};

export type RemoveAttachmentInput = {
  id: Scalars['String']['input'];
};

export type RemoveCoatingFormulationComponentInput = {
  id: Scalars['String']['input'];
};

export type RemovePaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type RemoveProductExcipientInput = {
  id: Scalars['String']['input'];
};

export type RemoveProductIngredientSyrupTypeInput = {
  id: Scalars['String']['input'];
};

export type RemoveSweetenerElementsInput = {
  id: Scalars['String']['input'];
};

export type Response = {
  __typename?: 'Response';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type ResponsePayload = {
  __typename?: 'ResponsePayload';
  response?: Maybe<Response>;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserRoles>;
  updatedAt: Scalars['String']['output'];
};

export type SandCoating = {
  __typename?: 'SandCoating';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SandCoatingFormulation = {
  __typename?: 'SandCoatingFormulation';
  coatingFormulationComponent?: Maybe<Array<Maybe<CoatingFormulationComponent>>>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  productSize?: Maybe<ProductSize>;
  productSizeId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  sandCoating?: Maybe<SandCoating>;
  sandCoatingId?: Maybe<Scalars['String']['output']>;
  subProductType?: Maybe<SubProductType>;
  subProductTypeId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type SandCoatingFormulationPayload = {
  __typename?: 'SandCoatingFormulationPayload';
  response?: Maybe<Response>;
  sandCoatingFormulation?: Maybe<SandCoatingFormulation>;
};

export type SandCoatingFormulationsPayload = {
  __typename?: 'SandCoatingFormulationsPayload';
  data?: Maybe<Array<SandCoatingFormulation>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type SandCoatingPayload = {
  __typename?: 'SandCoatingPayload';
  response?: Maybe<Response>;
  sandCoating?: Maybe<SandCoating>;
};

export type SandCoatingsPayload = {
  __typename?: 'SandCoatingsPayload';
  data?: Maybe<Array<SandCoating>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type SandComponent = {
  __typename?: 'SandComponent';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SandComponentPayload = {
  __typename?: 'SandComponentPayload';
  response?: Maybe<Response>;
  sandComponent?: Maybe<SandComponent>;
};

export type SandComponentsPayload = {
  __typename?: 'SandComponentsPayload';
  data?: Maybe<Array<SandComponent>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type SaveFormulaAsDraftInput = {
  ageGroups?: InputMaybe<Array<CreateFormulaAgeGroupInput>>;
  beadletId?: InputMaybe<Scalars['String']['input']>;
  bottleCap?: InputMaybe<BottleCapType>;
  bottleType?: InputMaybe<BottleTypeEnum>;
  capOverride?: InputMaybe<Scalars['Boolean']['input']>;
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  coMfgCostPercentage?: InputMaybe<Scalars['Float']['input']>;
  coMfgCostType?: InputMaybe<CoMfgCostType>;
  colorCoating?: InputMaybe<TabletCoatingColor>;
  colorCoating2?: InputMaybe<TabletCoatingColor>;
  colorCoating3?: InputMaybe<TabletCoatingColor>;
  colorsHex?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  factBoxType?: InputMaybe<FactBoxType>;
  flavorSystemId?: InputMaybe<Scalars['String']['input']>;
  flavorType?: InputMaybe<SweetenerNatureType>;
  formulaBlends?: InputMaybe<Array<FormulaBlendInput>>;
  formulaIngredients?: InputMaybe<Array<DraftFormulaIngredientInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  innerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  miniTabFormulation?: InputMaybe<MiniTabFormulationType>;
  miscellaneousCost?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  proteinBase?: InputMaybe<ProteinBaseType>;
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  sweetenerSystemId?: InputMaybe<Scalars['String']['input']>;
  sweetenerType?: InputMaybe<SweetenerNatureType>;
  tabletCoatingId?: InputMaybe<Scalars['String']['input']>;
  tabletTypeId?: InputMaybe<Scalars['String']['input']>;
  veganType?: InputMaybe<VeganType>;
};

export enum Scope {
  All = 'ALL',
  Global = 'GLOBAL',
  Local = 'LOCAL'
}

export type ServingSize = {
  __typename?: 'ServingSize';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  size?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ServingSizePayload = {
  __typename?: 'ServingSizePayload';
  response?: Maybe<Response>;
  servingSize?: Maybe<ServingSize>;
};

export type ServingSizesPayload = {
  __typename?: 'ServingSizesPayload';
  data?: Maybe<Array<ServingSize>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum ServingUnitType {
  Bottle = 'BOTTLE',
  Can = 'CAN',
  Capsule = 'CAPSULE',
  Capsules = 'CAPSULES',
  Carton = 'CARTON',
  Cup = 'CUP',
  Drop = 'DROP',
  Dropper = 'DROPPER',
  FlOz = 'FL_OZ',
  Gummies = 'GUMMIES',
  Gummy = 'GUMMY',
  Ml = 'ML',
  Packet = 'PACKET',
  Pouch = 'POUCH',
  Scoop = 'SCOOP',
  Scoops = 'SCOOPS',
  Shot = 'SHOT',
  StickPack = 'STICK_PACK',
  Tablet = 'TABLET',
  Tablets = 'TABLETS',
  Tbsp = 'TBSP',
  Tsp = 'TSP'
}

export type SetDefaultPaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export enum StripeIntervalType {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StripePaymentMethodType>;
};

/** Type of Stripe payment method (ACH bank account or card) */
export enum StripePaymentMethodType {
  Ach = 'ACH',
  Card = 'CARD'
}

export type StripePrice = {
  __typename?: 'StripePrice';
  amount?: Maybe<Scalars['Float']['output']>;
  billAbleAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  interval?: Maybe<StripeIntervalType>;
  isTrialEnded?: Maybe<Scalars['Boolean']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  product?: Maybe<StripeProduct>;
};

export type StripePricePayload = {
  __typename?: 'StripePricePayload';
  price?: Maybe<StripePrice>;
  response?: Maybe<Response>;
};

export type StripePricesPayload = {
  __typename?: 'StripePricesPayload';
  prices?: Maybe<Array<Maybe<StripePrice>>>;
  response?: Maybe<Response>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  marketingFeatures?: Maybe<Array<MarketingFeatures>>;
  name: Scalars['String']['output'];
};

export type SubProductType = {
  __typename?: 'SubProductType';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SubProductTypePayload = {
  __typename?: 'SubProductTypePayload';
  response?: Maybe<Response>;
  subProductType?: Maybe<SubProductType>;
};

export type SubProductTypesPayload = {
  __typename?: 'SubProductTypesPayload';
  data?: Maybe<Array<SubProductType>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cancelAt?: Maybe<Scalars['String']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  interval?: Maybe<StripeIntervalType>;
  pricingId: Scalars['String']['output'];
  status: SubscriptionStatus;
  trialEnd?: Maybe<Scalars['String']['output']>;
  trialStart?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SubscriptionPayload = {
  __typename?: 'SubscriptionPayload';
  response?: Maybe<Response>;
  subscription?: Maybe<Subscription>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type SuperDashboardPayload = {
  __typename?: 'SuperDashboardPayload';
  currentMonthUsers?: Maybe<Scalars['Int']['output']>;
  ingredients: Scalars['Int']['output'];
  response?: Maybe<Response>;
  users?: Maybe<Scalars['Int']['output']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  additionalContacts?: Maybe<Array<AdditionalContact>>;
  contact?: Maybe<Contact>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SupplierStatus>;
  updatedAt: Scalars['String']['output'];
};

export type SupplierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<SupplierStatus>;
};

export type SupplierPayload = {
  __typename?: 'SupplierPayload';
  response?: Maybe<Response>;
  supplier?: Maybe<Supplier>;
};

export enum SupplierStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** ingredient supplier type */
export enum SupplierType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type SuppliersPayload = {
  __typename?: 'SuppliersPayload';
  data?: Maybe<Array<Supplier>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type Sweetener = {
  __typename?: 'Sweetener';
  costPerServing?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  mgPerServing?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nature?: Maybe<SweetenerNatureType>;
  productFormulationType?: Maybe<ProductFormulationType>;
  productFormulationTypeId?: Maybe<Scalars['String']['output']>;
  productSize?: Maybe<ProductSize>;
  productSizeId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  size?: Maybe<SweetenerSizeType>;
  sweetenerElements?: Maybe<Array<SweetenerElement>>;
  type?: Maybe<SweetenerType>;
  updatedAt: Scalars['String']['output'];
};

export type SweetenerComponent = {
  __typename?: 'SweetenerComponent';
  costPerKg?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SweetenerComponentPayload = {
  __typename?: 'SweetenerComponentPayload';
  response?: Maybe<Response>;
  sweetenerComponent?: Maybe<SweetenerComponent>;
};

export type SweetenerComponentsPayload = {
  __typename?: 'SweetenerComponentsPayload';
  data?: Maybe<Array<SweetenerComponent>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type SweetenerElement = {
  __typename?: 'SweetenerElement';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Quantity per mg (milligram) */
  qtPerMg?: Maybe<Scalars['Float']['output']>;
  sweetenerComponent?: Maybe<SweetenerComponent>;
  sweetenerComponentId?: Maybe<Scalars['String']['output']>;
  sweetenerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SweetenerElementPayload = {
  __typename?: 'SweetenerElementPayload';
  response?: Maybe<Response>;
  sweetenerElement?: Maybe<SweetenerElement>;
};

export type SweetenerElementsPayload = {
  __typename?: 'SweetenerElementsPayload';
  data?: Maybe<Array<SweetenerElement>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

/** Nature Type */
export enum SweetenerNatureType {
  Artificial = 'ARTIFICIAL',
  Natural = 'NATURAL'
}

export type SweetenerPayload = {
  __typename?: 'SweetenerPayload';
  response?: Maybe<Response>;
  sweetener?: Maybe<Sweetener>;
};

/** Sweetener Size Type */
export enum SweetenerSizeType {
  High = 'HIGH',
  Low = 'LOW',
  Mid = 'MID'
}

/** Sweetener Type */
export enum SweetenerType {
  Flavor = 'FLAVOR',
  Sweetener = 'SWEETENER'
}

export type SweetenersPayload = {
  __typename?: 'SweetenersPayload';
  data?: Maybe<Array<Sweetener>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type TabletCoating = {
  __typename?: 'TabletCoating';
  costPerKg?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  loadAdd?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  updatedAt: Scalars['String']['output'];
};

export enum TabletCoatingColor {
  Multi = 'MULTI',
  Single = 'SINGLE'
}

export type TabletCoatingPayload = {
  __typename?: 'TabletCoatingPayload';
  response?: Maybe<Response>;
  tabletCoating?: Maybe<TabletCoating>;
};

export enum TabletCoatingType {
  BiLayered = 'BI_LAYERED',
  SingleLayered = 'SINGLE_LAYERED',
  TriLayered = 'TRI_LAYERED'
}

export type TabletCoatingsPayload = {
  __typename?: 'TabletCoatingsPayload';
  data?: Maybe<Array<TabletCoating>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export type UpdateAdditionalContactsInput = {
  additionalContacts: Array<AdditionalContactInput>;
  contactableId: Scalars['String']['input'];
};

export type UpdateAddressByTypeInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title: AddressTitle;
  type: AddressType;
  typeId: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<AddressTitle>;
  type?: InputMaybe<AddressType>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAllergenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBottleCapacityInput = {
  bottleSizeId?: InputMaybe<Scalars['String']['input']>;
  fillPercentage?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lohCost?: InputMaybe<Scalars['Float']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  servingSizeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBottlePriceInput = {
  bottlePriceSuppliers?: InputMaybe<Array<Scalars['String']['input']>>;
  bottleSizeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** child resistance */
  isCr?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Bottle types */
  type?: InputMaybe<BottleTypeEnum>;
};

export type UpdateBottleSizeInput = {
  bottleSizeProductTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  cc?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  /** lid size will be in mm (millimeter) */
  lidSize?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oz?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBottleSizeStatusInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCapsulePriceInput = {
  capacity?: InputMaybe<Scalars['Float']['input']>;
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  densityId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCapsuleTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCoatingFormulationComponentInput = {
  id: Scalars['String']['input'];
  sandCoatingFormulationId?: InputMaybe<Scalars['String']['input']>;
  sandComponentId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<CoatingFormulationComponentUnit>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateContactByContactableIdInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactType: ContactType;
  contactableId: Scalars['String']['input'];
  contactableType: ContactableType;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDailyValueConstraintInput = {
  adultsAndChildren?: InputMaybe<Scalars['Float']['input']>;
  children1To3Years?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  infants?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pregnantAndLactatingWomen?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<DailyValueConstraintUnit>;
};

export type UpdateDensityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateDraftedFormulaInput = {
  ageGroups?: InputMaybe<Array<CreateFormulaAgeGroupInput>>;
  beadletId?: InputMaybe<Scalars['String']['input']>;
  bottleCap?: InputMaybe<BottleCapType>;
  bottleType?: InputMaybe<BottleTypeEnum>;
  capOverride?: InputMaybe<Scalars['Boolean']['input']>;
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  coMfgCostPercentage?: InputMaybe<Scalars['Float']['input']>;
  coMfgCostType?: InputMaybe<CoMfgCostType>;
  colorCoating?: InputMaybe<TabletCoatingColor>;
  colorCoating2?: InputMaybe<TabletCoatingColor>;
  colorCoating3?: InputMaybe<TabletCoatingColor>;
  colorsHex?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  factBoxType?: InputMaybe<FactBoxType>;
  flavorSystemId?: InputMaybe<Scalars['String']['input']>;
  flavorType?: InputMaybe<SweetenerNatureType>;
  formulaBlends?: InputMaybe<Array<FormulaBlendInput>>;
  formulaIngredients?: InputMaybe<Array<DraftFormulaIngredientInput>>;
  id: Scalars['String']['input'];
  innerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  miniTabFormulation?: InputMaybe<MiniTabFormulationType>;
  miscellaneousCost?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  proteinBase?: InputMaybe<ProteinBaseType>;
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  sweetenerSystemId?: InputMaybe<Scalars['String']['input']>;
  sweetenerType?: InputMaybe<SweetenerNatureType>;
  tabletCoatingId?: InputMaybe<Scalars['String']['input']>;
  tabletTypeId?: InputMaybe<Scalars['String']['input']>;
  veganType?: InputMaybe<VeganType>;
};

export type UpdateExcipientInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExcipientLabelInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExcipientTypeInput = {
  excipientLabelId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loadAdd?: InputMaybe<Scalars['Float']['input']>;
  loadAddUnit?: InputMaybe<LoadAddUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** $/Kg Cost of Excipient type */
  perKgCost?: InputMaybe<Scalars['Float']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormulaInput = {
  ageGroups?: InputMaybe<Array<CreateFormulaAgeGroupInput>>;
  beadletId?: InputMaybe<Scalars['String']['input']>;
  bottleCap?: InputMaybe<BottleCapType>;
  bottleType?: InputMaybe<BottleTypeEnum>;
  capOverride?: InputMaybe<Scalars['Boolean']['input']>;
  capsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  coMfgCostPercentage?: InputMaybe<Scalars['Float']['input']>;
  coMfgCostType?: InputMaybe<CoMfgCostType>;
  colorCoating?: InputMaybe<TabletCoatingColor>;
  colorCoating2?: InputMaybe<TabletCoatingColor>;
  colorCoating3?: InputMaybe<TabletCoatingColor>;
  colorsHex?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  factBoxType?: InputMaybe<FactBoxType>;
  flavorSystemId?: InputMaybe<Scalars['String']['input']>;
  flavorType?: InputMaybe<SweetenerNatureType>;
  formulaBlends?: InputMaybe<Array<FormulaBlendInput>>;
  formulaIngredients?: InputMaybe<Array<FormulaIngredientInput>>;
  id: Scalars['String']['input'];
  innerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  miniTabFormulation?: InputMaybe<MiniTabFormulationType>;
  miscellaneousCost?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outerCapsuleTypeId?: InputMaybe<Scalars['String']['input']>;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  proteinBase?: InputMaybe<ProteinBaseType>;
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  sweetenerSystemId?: InputMaybe<Scalars['String']['input']>;
  sweetenerType?: InputMaybe<SweetenerNatureType>;
  tabletCoatingId?: InputMaybe<Scalars['String']['input']>;
  tabletTypeId?: InputMaybe<Scalars['String']['input']>;
  veganType?: InputMaybe<VeganType>;
};

export type UpdateFormulaStatusInput = {
  id: Scalars['String']['input'];
  status: FormulaStatus;
};

export type UpdateIngredientAllergensInput = {
  /** allergens uuids */
  ingredientAllergens?: InputMaybe<Array<Scalars['String']['input']>>;
  ingredientId: Scalars['String']['input'];
};

export type UpdateIngredientCarriersInput = {
  carriers: Array<IngredientCarrierInput>;
  ingredientId: Scalars['String']['input'];
};

export type UpdateIngredientInfoInput = {
  /** gram (g) */
  addedSugar?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  arsenic?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  biotin?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  boron?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  cadmium?: InputMaybe<Scalars['String']['input']>;
  /** milligram (mg) */
  calcium?: InputMaybe<Scalars['String']['input']>;
  /** KCal */
  calories?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  carbohydrates?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  chloride?: InputMaybe<Scalars['Float']['input']>;
  /** milligram (mg) */
  cholesterol?: InputMaybe<Scalars['String']['input']>;
  choline?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  chromium?: InputMaybe<Scalars['Float']['input']>;
  /** micro-gram per serving (mcg/serv) */
  copper?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  dietaryFiber?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  folate?: InputMaybe<Scalars['String']['input']>;
  ingredientId: Scalars['String']['input'];
  iodine?: InputMaybe<Scalars['String']['input']>;
  /** milligram (mg) */
  iron?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  lead?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  magnesium?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  manganese?: InputMaybe<Scalars['Float']['input']>;
  /** micro-gram per serving (mcg/serv) */
  mercury?: InputMaybe<Scalars['String']['input']>;
  /** Grams (g) */
  moisture?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  molybdenum?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  monounsaturatedFat?: InputMaybe<Scalars['String']['input']>;
  niacin?: InputMaybe<Scalars['String']['input']>;
  /** Percentage (%) */
  organic?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  pantothenicAcid?: InputMaybe<Scalars['Float']['input']>;
  /** micro-gram per serving (mcg/serv) */
  phosphorus?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  polyunsaturatedFat?: InputMaybe<Scalars['String']['input']>;
  /** milligram (mg) */
  potassium?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  protein?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  riboflavin?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  saturatedFat?: InputMaybe<Scalars['String']['input']>;
  /** micro-gram per serving (mcg/serv) */
  selenium?: InputMaybe<Scalars['Float']['input']>;
  /** milligram (mg) */
  sodium?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  thiamin?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  totalFat?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  totalSugars?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  transFat?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  vitaminA?: InputMaybe<Scalars['String']['input']>;
  vitaminB6?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  vitaminB12?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  vitaminC?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  vitaminD?: InputMaybe<Scalars['String']['input']>;
  vitaminE?: InputMaybe<Scalars['String']['input']>;
  /** micro gram (mcg) */
  vitaminK?: InputMaybe<Scalars['Float']['input']>;
  /** gram (g) */
  vitaminK2?: InputMaybe<Scalars['String']['input']>;
  /** gram (g) */
  zinc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIngredientInput = {
  /** amount can be 1 or 100 */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Avergage Particle Size unit will be in % */
  avergageParticleSize?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Dollar per kilogram ($/kg) */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Density for suggest the bottle size */
  density?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Suggested Gummy Overage unit will be in % */
  gummyOverage?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  /** Is the ingredient organic */
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  latinName?: InputMaybe<Scalars['String']['input']>;
  lossOnDrying?: InputMaybe<Scalars['String']['input']>;
  manufacturingCountry?: InputMaybe<Scalars['String']['input']>;
  /** Common name */
  name?: InputMaybe<Scalars['String']['input']>;
  nutrientName?: InputMaybe<Scalars['Boolean']['input']>;
  nutrients?: InputMaybe<Scalars['Boolean']['input']>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  /** potency unit will be in % (can be range percentage) */
  potency?: InputMaybe<Scalars['String']['input']>;
  proBiotic?: InputMaybe<Scalars['Float']['input']>;
  /** product type uuids */
  productTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  scientificName?: InputMaybe<Scalars['String']['input']>;
  /** Months */
  shelfLife?: InputMaybe<Scalars['Float']['input']>;
  showB3?: InputMaybe<Scalars['Boolean']['input']>;
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
  subComponents?: InputMaybe<Array<IngredientSubComponentInput>>;
  /** Suggested Overage unit will be in % */
  suggestedOverage?: InputMaybe<Scalars['Float']['input']>;
  tradeMarkName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<IngredientType>>;
};

export type UpdateIngredientStatus = {
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type UpdateIngredientSubComponentsInput = {
  ingredientId: Scalars['String']['input'];
  subComponents: Array<IngredientSubComponentInput>;
};

export type UpdateIngredientSuppliersInput = {
  ingredientId: Scalars['String']['input'];
  ingredientSuppliers?: InputMaybe<Array<IngredientSupplierInput>>;
};

export type UpdateOrgAndUserInput = {
  organization: UpdateOrganizationInput;
  user: UpdateUserInput;
};

export type UpdateOrgStaffInfoInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  maxUser?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePasswordInput = {
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UpdateProductExcipientInput = {
  excipientId?: InputMaybe<Scalars['String']['input']>;
  excipientTypeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** $/Kg */
  perKgCost?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  productExcipientSuppliers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProductFormulationSyrupTypeInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<FormulationSyrupUnit>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductFormulationTypeInput = {
  conversionCost?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  innerComponentCost?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isInnerCapTab?: InputMaybe<Scalars['Boolean']['input']>;
  lohInside?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  propagateToOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductIngredientInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductIngredientSyrupTypeInput = {
  id: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  productFormulationSyrupTypeId?: InputMaybe<Scalars['String']['input']>;
  productIngredientId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductSizeInput = {
  /** Empty weight mg */
  emptyWtMg?: InputMaybe<Scalars['Float']['input']>;
  /** Total mg weight of gummy */
  gummyWeight?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductTypeInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propagateToOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSandCoatingFormulationInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  sandCoatingId?: InputMaybe<Scalars['String']['input']>;
  subProductTypeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSandCoatingInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSandComponentInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServingSizeInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStaffInfoInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubProductTypeInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupplierStatus>;
};

export type UpdateSweetenerComponentInput = {
  costPerKg?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSweetenerElementsInput = {
  id: Scalars['String']['input'];
  qtPerMg?: InputMaybe<Scalars['Float']['input']>;
  sweetenerComponentId?: InputMaybe<Scalars['String']['input']>;
  sweetenerId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSweetenerInput = {
  costPerServing?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mgPerServing?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nature?: InputMaybe<SweetenerNatureType>;
  productFormulationTypeId?: InputMaybe<Scalars['String']['input']>;
  productSizeId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<SweetenerSizeType>;
  type?: InputMaybe<SweetenerType>;
};

export type UpdateSyrupBaseIngredientsInput = {
  /** amount can be 1 or 100 */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Avergage Particle Size unit will be in % */
  avergageParticleSize?: InputMaybe<Scalars['String']['input']>;
  /** Dollar per kilogram ($/kg) */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Density for suggest the bottle size */
  density?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Suggested Gummy Overage unit will be in % */
  gummyOverage?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  /** Is the ingredient organic */
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  latinName?: InputMaybe<Scalars['String']['input']>;
  lossOnDrying?: InputMaybe<Scalars['String']['input']>;
  manufacturingCountry?: InputMaybe<Scalars['String']['input']>;
  /** Common name */
  name?: InputMaybe<Scalars['String']['input']>;
  nutrientName?: InputMaybe<Scalars['Boolean']['input']>;
  nutrients?: InputMaybe<Scalars['Boolean']['input']>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  /** potency unit will be in % (can be range percentage) */
  potency?: InputMaybe<Scalars['String']['input']>;
  proBiotic?: InputMaybe<Scalars['Float']['input']>;
  productFormulationSyrupTypeId?: InputMaybe<Scalars['String']['input']>;
  /** product type uuids */
  productTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  scientificName?: InputMaybe<Scalars['String']['input']>;
  /** Months */
  shelfLife?: InputMaybe<Scalars['Float']['input']>;
  showB3?: InputMaybe<Scalars['Boolean']['input']>;
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** Suggested Overage unit will be in % */
  suggestedOverage?: InputMaybe<Scalars['Float']['input']>;
  tradeMarkName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<IngredientType>>;
};

export type UpdateTabletCoatingInput = {
  costPerKg?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loadAdd?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInfoInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserStatusInput = {
  id: Scalars['String']['input'];
  status: UserStatus;
};

export type UpgradeAttachmentInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<AttachmentTitle>;
  type?: InputMaybe<AttachmentType>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type UploadAttachmentInput = {
  file: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  title: AttachmentTitle;
  type: AttachmentType;
  typeId: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** For the staff or admin, accepted the consent form or not */
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  staffRole?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  thumbnail?: Maybe<Attachment>;
  updatedAt: Scalars['String']['output'];
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
};

export type UserPayload = {
  __typename?: 'UserPayload';
  response?: Maybe<Response>;
  user?: Maybe<User>;
};

export type UserRole = {
  __typename?: 'UserRole';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

/** The user role assigned */
export enum UserRoles {
  Admin = 'ADMIN',
  Staff = 'STAFF',
  SuperAdmin = 'SUPER_ADMIN'
}

export type UserSignUpInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
};

/** The user status */
export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** The type of user for filtering */
export enum UserType {
  Admin = 'ADMIN',
  Staff = 'STAFF'
}

export type UsersCountByYearPayload = {
  __typename?: 'UsersCountByYearPayload';
  data: Array<Scalars['Int']['output']>;
  response?: Maybe<Response>;
};

export type UsersPayload = {
  __typename?: 'UsersPayload';
  data?: Maybe<Array<User>>;
  pagination: Pagination;
  response?: Maybe<Response>;
};

export enum VeganType {
  No = 'NO',
  Yes = 'YES'
}

export type VerifyCodeInput = {
  code: Scalars['Float']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};

export type VerifyCodePayload = {
  __typename?: 'VerifyCodePayload';
  response?: Maybe<Response>;
  token: Scalars['String']['output'];
};

export type VerifyUserAndUpdatePasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UpdateAddressByTypeMutationVariables = Exact<{
  input: UpdateAddressByTypeInput;
}>;


export type UpdateAddressByTypeMutation = { __typename?: 'Mutation', updateAddressByType: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type GetAttachmentByTypeQueryVariables = Exact<{
  getAttachmentByTypeInput: GetAttachmentByTypeInput;
}>;


export type GetAttachmentByTypeQuery = { __typename?: 'Query', getAttachmentByType: { __typename?: 'AttachmentPayload', response?: { __typename?: 'Response', status?: number | null } | null, attachment?: { __typename?: 'Attachment', name?: string | null, attachmentUrl?: string | null } | null } };

export type GetAttachmentQueryVariables = Exact<{
  getAttachmentByTypeInput: GetAttachmentByTypeInput;
}>;


export type GetAttachmentQuery = { __typename?: 'Query', getAttachmentByType: { __typename?: 'AttachmentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, attachmentUrl?: string | null } | null } };

export type RemoveAttachmentMutationVariables = Exact<{
  removeAttachmentInput: RemoveAttachmentInput;
}>;


export type RemoveAttachmentMutation = { __typename?: 'Mutation', removeAttachment: { __typename?: 'AttachmentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllTabletCoatingQueryVariables = Exact<{
  findAllTabletCoatingInput: FindAllTabletCoatingInput;
}>;


export type FindAllTabletCoatingQuery = { __typename?: 'Query', findAllTabletCoating: { __typename?: 'TabletCoatingsPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'TabletCoating', id: string, name?: string | null, isActive: boolean }> | null } };

export type FindAllBaseCoatingTableQueryVariables = Exact<{
  findAllTabletCoatingInput: FindAllTabletCoatingInput;
}>;


export type FindAllBaseCoatingTableQuery = { __typename?: 'Query', findAllTabletCoating: { __typename?: 'TabletCoatingsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'TabletCoating', id: string, name?: string | null, loadAdd?: number | null, isActive: boolean, costPerKg?: number | null, productType?: { __typename?: 'ProductType', name?: string | null } | null }> | null } };

export type GetBaseCoatingQueryVariables = Exact<{
  getTabletCoatingInput: GetTabletCoatingInput;
}>;


export type GetBaseCoatingQuery = { __typename?: 'Query', getTabletCoating: { __typename?: 'TabletCoatingPayload', response?: { __typename?: 'Response', status?: number | null } | null, tabletCoating?: { __typename?: 'TabletCoating', id: string, name?: string | null, loadAdd?: number | null, costPerKg?: number | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null } | null } };

export type CreateBaseCoatingMutationVariables = Exact<{
  createTabletCoatingInput: CreateTabletCoatingInput;
}>;


export type CreateBaseCoatingMutation = { __typename?: 'Mutation', createTabletCoating: { __typename?: 'TabletCoatingPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateBaseCoatingMutationVariables = Exact<{
  updateTabletCoatingInput: UpdateTabletCoatingInput;
}>;


export type UpdateBaseCoatingMutation = { __typename?: 'Mutation', updateTabletCoating: { __typename?: 'TabletCoatingPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllBeadletsQueryVariables = Exact<{
  findAllBeadletsInput: FindAllBeadletsInput;
}>;


export type FindAllBeadletsQuery = { __typename?: 'Query', findAllBeadlets: { __typename?: 'BeadletsPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'Beadlets', id: string, name?: string | null }> | null } };

export type FindAllBottleCapacityQueryVariables = Exact<{
  findAllBottleCapacitiesInput: FindAllBottleCapacitiesInput;
}>;


export type FindAllBottleCapacityQuery = { __typename?: 'Query', findAllBottleCapacity: { __typename?: 'BottleCapacitiesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'BottleCapacity', id: string, lohCost?: number | null, isActive?: boolean | null, fillPercentage?: number | null, bottleSize?: { __typename?: 'BottleSize', name?: string | null, isActive?: boolean | null } | null, productType: { __typename?: 'ProductType', name?: string | null }, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, servingSize?: { __typename?: 'ServingSize', size?: number | null } | null }> | null } };

export type GetBottleCapacityQueryVariables = Exact<{
  findBottleCapacityInput: FindBottleCapacityInput;
}>;


export type GetBottleCapacityQuery = { __typename?: 'Query', getBottleCapacity: { __typename?: 'BottleCapacityPayload', bottleCapacity?: { __typename?: 'BottleCapacity', lohCost?: number | null, isActive?: boolean | null, fillPercentage?: number | null, bottleSize?: { __typename?: 'BottleSize', id: string, name?: string | null } | null, productType: { __typename?: 'ProductType', id: string, name?: string | null, type?: ProductTypes | null }, productSize?: { __typename?: 'ProductSize', id: string, name?: string | null } | null, servingSize?: { __typename?: 'ServingSize', id: string, size?: number | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateBottleCapacityMutationVariables = Exact<{
  updateBottleCapacityInput: UpdateBottleCapacityInput;
}>;


export type UpdateBottleCapacityMutation = { __typename?: 'Mutation', updateBottleCapacity: { __typename?: 'BottleCapacityPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateBottleCapacityMutationVariables = Exact<{
  createBottleCapacityInput: CreateBottleCapacityInput;
}>;


export type CreateBottleCapacityMutation = { __typename?: 'Mutation', createBottleCapacity: { __typename?: 'BottleCapacityPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllBottlePriceQueryVariables = Exact<{
  findAllBottlePricesInput: FindAllBottlePricesInput;
}>;


export type FindAllBottlePriceQuery = { __typename?: 'Query', findAllBottlePrice: { __typename?: 'BottlePricesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'BottlePrice', id: string, isCr?: boolean | null, type?: BottleTypeEnum | null, price?: number | null, isActive?: boolean | null, bottleSize?: { __typename?: 'BottleSize', name?: string | null } | null, bottlePriceSuppliers?: Array<{ __typename?: 'BottlePriceSupplier', supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null }> | null } };

export type GetBottlePriceQueryVariables = Exact<{
  getBottlePriceInput: GetBottlePriceInput;
}>;


export type GetBottlePriceQuery = { __typename?: 'Query', getBottlePrice: { __typename?: 'BottlePricePayload', bottlePrice?: { __typename?: 'BottlePrice', id: string, type?: BottleTypeEnum | null, isCr?: boolean | null, price?: number | null, isActive?: boolean | null, bottleSize?: { __typename?: 'BottleSize', id: string, name?: string | null } | null, bottlePriceSuppliers?: Array<{ __typename?: 'BottlePriceSupplier', supplier?: { __typename?: 'Supplier', id: string, name?: string | null } | null } | null> | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateBottlePriceMutationVariables = Exact<{
  updateBottlePriceInput: UpdateBottlePriceInput;
}>;


export type UpdateBottlePriceMutation = { __typename?: 'Mutation', updateBottlePrice: { __typename?: 'BottlePricePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateBottlePriceMutationVariables = Exact<{
  createBottlePriceInput: CreateBottlePriceInput;
}>;


export type CreateBottlePriceMutation = { __typename?: 'Mutation', createBottlePrice: { __typename?: 'BottlePricePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllBottleSizeQueryVariables = Exact<{
  findAllBottleSizesInput: FindAllBottleSizesInput;
}>;


export type FindAllBottleSizeQuery = { __typename?: 'Query', findAllBottleSize: { __typename?: 'BottleSizesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'BottleSize', id: string, cc?: number | null, oz?: number | null, name?: string | null, lidSize?: number | null, isActive?: boolean | null, bottleSizeProductTypes?: Array<{ __typename?: 'BottleSizeProductType', productType?: { __typename?: 'ProductType', name?: string | null } | null } | null> | null }> | null } };

export type FindAllBottleSizeSelectorQueryVariables = Exact<{
  findAllBottleSizesInput: FindAllBottleSizesInput;
}>;


export type FindAllBottleSizeSelectorQuery = { __typename?: 'Query', findAllBottleSize: { __typename?: 'BottleSizesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number }, data?: Array<{ __typename?: 'BottleSize', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type GetBottleSizeQueryVariables = Exact<{
  getBottleSizeInput: GetBottleSizeInput;
}>;


export type GetBottleSizeQuery = { __typename?: 'Query', getBottleSize: { __typename?: 'BottleSizePayload', bottleSize?: { __typename?: 'BottleSize', id: string, cc?: number | null, oz?: number | null, name?: string | null, lidSize?: number | null, bottleSizeProductTypes?: Array<{ __typename?: 'BottleSizeProductType', productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null } | null> | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateBottleSizeMutationVariables = Exact<{
  updateBottleSizeInput: UpdateBottleSizeInput;
}>;


export type UpdateBottleSizeMutation = { __typename?: 'Mutation', updateBottleSize: { __typename?: 'BottleSizePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateBottleSizeMutationVariables = Exact<{
  createBottleSizeInput: CreateBottleSizeInput;
}>;


export type CreateBottleSizeMutation = { __typename?: 'Mutation', createBottleSize: { __typename?: 'BottleSizePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateBottleSizeStatusMutationVariables = Exact<{
  updateBottleSizeStatusInput: UpdateBottleSizeStatusInput;
}>;


export type UpdateBottleSizeStatusMutation = { __typename?: 'Mutation', updateBottleSizeStatus: { __typename?: 'BottleSizePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllCapsulePricesTableQueryVariables = Exact<{
  findAllCapsulePricesInput: FindAllCapsulePricesInput;
}>;


export type FindAllCapsulePricesTableQuery = { __typename?: 'Query', findAllCapsulePrices: { __typename?: 'CapsulePricesPayload', data?: Array<{ __typename?: 'CapsulePrice', id: string, price?: number | null, isActive?: boolean | null, capacity?: number | null, density?: { __typename?: 'Density', name?: string | null } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, capsuleType?: { __typename?: 'CapsuleType', name?: string | null } | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number } } };

export type GetCapsulePriceQueryVariables = Exact<{
  getCapsulePriceInput: GetCapsulePriceInput;
}>;


export type GetCapsulePriceQuery = { __typename?: 'Query', getCapsulePrice: { __typename?: 'CapsulePricePayload', capsulePrice?: { __typename?: 'CapsulePrice', id: string, price?: number | null, capacity?: number | null, density?: { __typename?: 'Density', id: string, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id: string, name?: string | null } | null, productSize?: { __typename?: 'ProductSize', id: string, name?: string | null } | null, capsuleType?: { __typename?: 'CapsuleType', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CreateCapsulePriceMutationVariables = Exact<{
  createCapsulePriceInput: CreateCapsulePriceInput;
}>;


export type CreateCapsulePriceMutation = { __typename?: 'Mutation', createCapsulePrice: { __typename?: 'CapsulePricePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateCapsulePriceMutationVariables = Exact<{
  updateCapsulePriceInput: UpdateCapsulePriceInput;
}>;


export type UpdateCapsulePriceMutation = { __typename?: 'Mutation', updateCapsulePrice: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllCapsuleTypeRadioGroupQueryVariables = Exact<{
  findAllCapsuleTypesInput: FindAllCapsuleTypesInput;
}>;


export type FindAllCapsuleTypeRadioGroupQuery = { __typename?: 'Query', findAllCapsuleType: { __typename?: 'CapsuleTypesPayload', data?: Array<{ __typename?: 'CapsuleType', id: string, name?: string | null, description?: string | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllCapsuleTypeSelectorQueryVariables = Exact<{
  findAllCapsuleTypesInput: FindAllCapsuleTypesInput;
}>;


export type FindAllCapsuleTypeSelectorQuery = { __typename?: 'Query', findAllCapsuleType: { __typename?: 'CapsuleTypesPayload', data?: Array<{ __typename?: 'CapsuleType', id: string, name?: string | null, isActive?: boolean | null, description?: string | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type FindAllCapsuleTypeTableQueryVariables = Exact<{
  findAllCapsuleTypesInput: FindAllCapsuleTypesInput;
}>;


export type FindAllCapsuleTypeTableQuery = { __typename?: 'Query', findAllCapsuleType: { __typename?: 'CapsuleTypesPayload', data?: Array<{ __typename?: 'CapsuleType', id: string, name?: string | null, isActive?: boolean | null, description?: string | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number } } };

export type GetCapsuleTypeQueryVariables = Exact<{
  getCapsuleTypeInput: GetCapsuleTypeInput;
}>;


export type GetCapsuleTypeQuery = { __typename?: 'Query', getCapsuleType: { __typename?: 'CapsuleTypePayload', capsuleType?: { __typename?: 'CapsuleType', id: string, name?: string | null, description?: string | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CreateCapsuleTypeMutationVariables = Exact<{
  createCapsuleTypeInput: CreateCapsuleTypeInput;
}>;


export type CreateCapsuleTypeMutation = { __typename?: 'Mutation', createCapsuleType: { __typename?: 'CapsuleTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateCapsuleTypeMutationVariables = Exact<{
  updateCapsuleTypeInput: UpdateCapsuleTypeInput;
}>;


export type UpdateCapsuleTypeMutation = { __typename?: 'Mutation', updateCapsuleType: { __typename?: 'CapsuleTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllCategoryForSelectorQueryVariables = Exact<{
  findAllCategoriesInput: FindAllCategoriesInput;
}>;


export type FindAllCategoryForSelectorQuery = { __typename?: 'Query', findAllCategories: { __typename?: 'CategoriesPayload', data?: Array<{ __typename?: 'Category', id: string, name?: string | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type FindAllCoatingFormulationComponentQueryVariables = Exact<{
  getSandCoatingFormulationInput: GetSandCoatingFormulationInput;
}>;


export type FindAllCoatingFormulationComponentQuery = { __typename?: 'Query', getSandCoatingFormulation: { __typename?: 'SandCoatingFormulationPayload', response?: { __typename?: 'Response', status?: number | null } | null, sandCoatingFormulation?: { __typename?: 'SandCoatingFormulation', id: string, cost?: number | null, weight?: number | null, unit?: string | null, isActive?: boolean | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, sandCoating?: { __typename?: 'SandCoating', name?: string | null } | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', name?: string | null } | null, coatingFormulationComponent?: Array<{ __typename?: 'CoatingFormulationComponent', id: string, weight?: number | null, unit?: CoatingFormulationComponentUnit | null, sandComponent?: { __typename?: 'SandComponent', id: string, name?: string | null, isActive?: boolean | null } | null } | null> | null } | null } };

export type UpdateCoatingFormulationComponentMutationVariables = Exact<{
  updateCoatingFormulationComponentInput: UpdateCoatingFormulationComponentInput;
}>;


export type UpdateCoatingFormulationComponentMutation = { __typename?: 'Mutation', updateCoatingFormulationComponent: { __typename?: 'CoatingFormulationComponentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateCoatingFormulationComponentMutationVariables = Exact<{
  createCoatingFormulationComponentInput: CreateCoatingFormulationComponentInput;
}>;


export type CreateCoatingFormulationComponentMutation = { __typename?: 'Mutation', createCoatingFormulationComponent: { __typename?: 'CoatingFormulationComponentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type RemoveCoatingFormulationComponentMutationVariables = Exact<{
  removeCoatingFormulationComponentInput: RemoveCoatingFormulationComponentInput;
}>;


export type RemoveCoatingFormulationComponentMutation = { __typename?: 'Mutation', removeCoatingFormulationComponent: { __typename?: 'CoatingFormulationComponentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type GetSuperDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuperDashboardQuery = { __typename?: 'Query', getSuperDashboard: { __typename?: 'SuperDashboardPayload', users?: number | null, ingredients: number, currentMonthUsers?: number | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetAdminDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminDashboardQuery = { __typename?: 'Query', getOrgDashboard: { __typename?: 'OrgDashboardPayload', users?: number | null, formulas?: number | null, ingredients: number, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetStaffDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffDashboardQuery = { __typename?: 'Query', getOrgDashboard: { __typename?: 'OrgDashboardPayload', formulas?: number | null, myFormulas?: number | null, ingredients: number, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllDensitySelectorQueryVariables = Exact<{
  findAllDensitiesInput: FindAllDensitiesInput;
}>;


export type FindAllDensitySelectorQuery = { __typename?: 'Query', findAllDensities: { __typename?: 'DensitiesPayload', data?: Array<{ __typename?: 'Density', id: string, name?: string | null, description?: string | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type FindAllDvConstraintsTableQueryVariables = Exact<{
  findAllDailyValueConstraintsInput: FindAllDailyValueConstraintsInput;
}>;


export type FindAllDvConstraintsTableQuery = { __typename?: 'Query', findAllDailyValueConstraints: { __typename?: 'DailyValueConstraintsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'DailyValueConstraint', id: string, name?: string | null, unit?: DailyValueConstraintUnit | null, infants?: number | null, foodComponent?: string | null, adultsAndChildren?: number | null, children1To3Years?: number | null, pregnantAndLactatingWomen?: number | null }> | null } };

export type GetDvConstraintQueryVariables = Exact<{
  getDailyValueConstraintInput: GetDailyValueConstraintInput;
}>;


export type GetDvConstraintQuery = { __typename?: 'Query', getDailyValueConstraint: { __typename?: 'DailyValueConstraintPayload', dailyValueConstraint?: { __typename?: 'DailyValueConstraint', name?: string | null, unit?: DailyValueConstraintUnit | null, infants?: number | null, foodComponent?: string | null, adultsAndChildren?: number | null, children1To3Years?: number | null, pregnantAndLactatingWomen?: number | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateDvConstraintMutationVariables = Exact<{
  updateDailyValueConstraintInput: UpdateDailyValueConstraintInput;
}>;


export type UpdateDvConstraintMutation = { __typename?: 'Mutation', updateDailyValueConstraint: { __typename?: 'DailyValueConstraintPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllExcipientsQueryVariables = Exact<{
  findAllExcipientsInput: FindAllExcipientsInput;
}>;


export type FindAllExcipientsQuery = { __typename?: 'Query', findAllExcipients: { __typename?: 'ExcipientsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'Excipient', id: string, name?: string | null, isActive: boolean }> | null } };

export type FindAllExcipientSelectorQueryVariables = Exact<{
  findAllExcipientsInput: FindAllExcipientsInput;
}>;


export type FindAllExcipientSelectorQuery = { __typename?: 'Query', findAllExcipients: { __typename?: 'ExcipientsPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'Excipient', id: string, name?: string | null }> | null } };

export type GetExcipientQueryVariables = Exact<{
  getExcipientInput: GetExcipientInput;
}>;


export type GetExcipientQuery = { __typename?: 'Query', getExcipient: { __typename?: 'ExcipientPayload', excipient?: { __typename?: 'Excipient', name?: string | null, isActive: boolean } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateExcipientMutationVariables = Exact<{
  updateExcipientInput: UpdateExcipientInput;
}>;


export type UpdateExcipientMutation = { __typename?: 'Mutation', updateExcipient: { __typename?: 'ExcipientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateExcipientMutationVariables = Exact<{
  createExcipientInput: CreateExcipientInput;
}>;


export type CreateExcipientMutation = { __typename?: 'Mutation', createExcipient: { __typename?: 'ExcipientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllExcipientLabelSelectQueryVariables = Exact<{
  findAllExcipientLabelsInput: FindAllExcipientLabelsInput;
}>;


export type FindAllExcipientLabelSelectQuery = { __typename?: 'Query', findAllExcipientLabels: { __typename?: 'ExcipientLabelsPayload', pagination: { __typename?: 'Pagination', totalPages: number }, response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'ExcipientLabel', id: string, name?: string | null, isActive: boolean }> | null } };

export type FindAllExcipientLabelsQueryVariables = Exact<{
  findAllExcipientLabelsInput: FindAllExcipientLabelsInput;
}>;


export type FindAllExcipientLabelsQuery = { __typename?: 'Query', findAllExcipientLabels: { __typename?: 'ExcipientLabelsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'ExcipientLabel', id: string, name?: string | null, isActive: boolean }> | null } };

export type GetExcipientLabelQueryVariables = Exact<{
  getExcipientLabelInput: GetExcipientLabelInput;
}>;


export type GetExcipientLabelQuery = { __typename?: 'Query', getExcipientLabel: { __typename?: 'ExcipientLabelPayload', excipientLabel?: { __typename?: 'ExcipientLabel', name?: string | null, isActive: boolean } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CreateExcipientLabelMutationVariables = Exact<{
  createExcipientLabelInput: CreateExcipientLabelInput;
}>;


export type CreateExcipientLabelMutation = { __typename?: 'Mutation', createExcipientLabel: { __typename?: 'ExcipientLabelPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateExcipientLabelMutationVariables = Exact<{
  updateExcipientLabelInput: UpdateExcipientLabelInput;
}>;


export type UpdateExcipientLabelMutation = { __typename?: 'Mutation', updateExcipientLabel: { __typename?: 'ExcipientLabelPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllExcipientTypesQueryVariables = Exact<{
  findAllExcipientTypesInput: FindAllExcipientTypesInput;
}>;


export type FindAllExcipientTypesQuery = { __typename?: 'Query', findAllExcipientTypes: { __typename?: 'ExcipientTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'ExcipientType', id: string, name?: string | null, isActive: boolean, loadAdd?: number | null, loadAddUnit?: LoadAddUnit | null, perKgCost?: number | null, excipientLabel?: { __typename?: 'ExcipientLabel', name?: string | null } | null, productType?: { __typename?: 'ProductType', name?: string | null } | null }> | null } };

export type FindAllExcipientTypesSelectorQueryVariables = Exact<{
  findAllExcipientTypesInput: FindAllExcipientTypesInput;
}>;


export type FindAllExcipientTypesSelectorQuery = { __typename?: 'Query', findAllExcipientTypes: { __typename?: 'ExcipientTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'ExcipientType', id: string, name?: string | null, isActive: boolean }> | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type GetExcipientTypeQueryVariables = Exact<{
  getExcipientTypeInput: GetExcipientTypeInput;
}>;


export type GetExcipientTypeQuery = { __typename?: 'Query', getExcipientType: { __typename?: 'ExcipientTypePayload', excipientType?: { __typename?: 'ExcipientType', id: string, name?: string | null, isActive: boolean, loadAdd?: number | null, loadAddUnit?: LoadAddUnit | null, perKgCost?: number | null, excipientLabel?: { __typename?: 'ExcipientLabel', id: string } | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateExcipientTypeMutationVariables = Exact<{
  updateExcipientTypeInput: UpdateExcipientTypeInput;
}>;


export type UpdateExcipientTypeMutation = { __typename?: 'Mutation', updateExcipientType: { __typename?: 'ExcipientTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateExcipientTypeMutationVariables = Exact<{
  createExcipientTypeInput: CreateExcipientTypeInput;
}>;


export type CreateExcipientTypeMutation = { __typename?: 'Mutation', createExcipientType: { __typename?: 'ExcipientTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllFlavorsTableQueryVariables = Exact<{
  findAllSweetenersInput: FindAllSweetenersInput;
}>;


export type FindAllFlavorsTableQuery = { __typename?: 'Query', findAllSweeteners: { __typename?: 'SweetenersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'Sweetener', id: string, name?: string | null, size?: SweetenerSizeType | null, nature?: SweetenerNatureType | null, isActive?: boolean | null, mgPerServing?: number | null, costPerServing?: number | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null }> | null } };

export type GetFlavorQueryVariables = Exact<{
  getSweetenerInput: GetSweetenerInput;
}>;


export type GetFlavorQuery = { __typename?: 'Query', getSweetener: { __typename?: 'SweetenerPayload', sweetener?: { __typename?: 'Sweetener', name?: string | null, size?: SweetenerSizeType | null, nature?: SweetenerNatureType | null, isActive?: boolean | null, mgPerServing?: number | null, costPerServing?: number | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null, productSize?: { __typename?: 'ProductSize', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CreateFlavorMutationVariables = Exact<{
  createSweetenerInput: CreateSweetenerInput;
}>;


export type CreateFlavorMutation = { __typename?: 'Mutation', createSweetener: { __typename?: 'SweetenerPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateFlavorMutationVariables = Exact<{
  updateSweetenerInput: UpdateSweetenerInput;
}>;


export type UpdateFlavorMutation = { __typename?: 'Mutation', updateSweetener: { __typename?: 'SweetenerPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindRecentFormulasQueryVariables = Exact<{
  findAllFormulasInput: FindAllFormulasInput;
}>;


export type FindRecentFormulasQuery = { __typename?: 'Query', findAllFormulas: { __typename?: 'FormulasPayload', data?: Array<{ __typename?: 'Formula', id: string, name?: string | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', name?: string | null } | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllFormulasQueryVariables = Exact<{
  findAllFormulasInput: FindAllFormulasInput;
}>;


export type FindAllFormulasQuery = { __typename?: 'Query', findAllFormulas: { __typename?: 'FormulasPayload', data?: Array<{ __typename?: 'Formula', id: string, name?: string | null, createdAt: string, status?: FormulaStatus | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', name?: string | null } | null }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CalcFormulaCostQueryVariables = Exact<{
  calcFormulaCostInput: CalcFormulaCostInput;
}>;


export type CalcFormulaCostQuery = { __typename?: 'Query', calcFormulaCost: { __typename?: 'CalcFormulaCostPayload', response?: { __typename?: 'Response', status?: number | null } | null, formulaCostSuggestion: { __typename?: 'GetFormulaCostPayload', organicPercentage?: number | null, cost: { __typename?: 'IFormulaCost', mfgCost: number, coMfgCost: number, lohCost?: number | null, neckband?: number | null, flavorCost?: number | null, per1000Cost?: number | null, coatingCost?: number | null, bottlePrice?: number | null, sweetenerCost?: number | null, syrupBaseCost?: number | null, excipientCost?: number | null, conversionCost?: number | null, ingredientsCost?: number | null, sandCoatingCost?: number | null, miscellaneousCost?: number | null, bottleCapacityInstance?: { __typename?: 'BottleCapacity', id: string, fillPercentage?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, bottleSize?: { __typename?: 'BottleSize', name?: string | null, lidSize?: number | null } | null } | null, outerCapsulePrice?: { __typename?: 'CapsulePrice', price?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null } | null, innerCapsulePrice?: { __typename?: 'CapsulePrice', price?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null } | null, capsulePrice?: { __typename?: 'CapsulePrice', price?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, density?: { __typename?: 'Density', name?: string | null } | null } | null }, weights: { __typename?: 'FormulaWeights', totalWeight?: number | null, flavorWeight?: number | null, coatingWeight?: number | null, excipientWeight?: number | null, syrupBaseWeight?: number | null, sweetenerWeight?: number | null, ingredientsWeight?: number | null, sandCoatingWeight?: number | null }, weightPercentage: { __typename?: 'FormulaWeightsPercentage', flavorWeight?: number | null, coatingWeight?: number | null, excipientWeight?: number | null, sweetenerWeight?: number | null, syrupBaseWeight?: number | null, ingredientsWeight?: number | null, sandCoatingWeight?: number | null }, costPercentage: { __typename?: 'FormulaCostsPercentage', lohCost?: number | null, neckband?: number | null, flavorCost?: number | null, coatingCost?: number | null, bottlePrice?: number | null, sweetenerCost?: number | null, syrupBaseCost?: number | null, excipientCost?: number | null, conversionCost?: number | null, sandCoatingCost?: number | null, ingredientsCost?: number | null, miscellaneousCost?: number | null }, formulaIngredients: Array<{ __typename?: 'FormulaIngredient', ingCostContribution?: number | null, ingredient?: { __typename?: 'Ingredient', name?: string | null } | null, macroNutrientsWeight?: { __typename?: 'MacroNutrientsWeights', moisture: number, calories: number, protein: number, carbohydrates: number, dietaryFiber: number, totalSugars: number, addedSugar: number, totalFat: number, saturatedFat: number, monounsaturatedFat: number, polyunsaturatedFat: number, transFat: number, cholesterol: number } | null, microNutrientsWeight?: { __typename?: 'MicroNutrientsWeights', vitaminA: number, biotin: number, pantothenicAcid: number, thiamin: number, riboflavin: number, niacin: number, vitaminB6: number, vitaminB12: number, vitaminC: number, vitaminD: number, vitaminE: number, folate: number, vitaminK: number, vitaminK2: number, folicAcid: number, calcium: number, phosphorus: number, magnesium: number, sodium: number, potassium: number, chloride: number, iron: number, zinc: number, iodine: number, selenium: number, copper: number, manganese: number, chromium: number, molybdenum: number, boron: number, choline: number } | null }> } } };

export type GetFormulaQueryVariables = Exact<{
  getFormulaInput: GetFormulaInput;
}>;


export type GetFormulaQuery = { __typename?: 'Query', getFormula: { __typename?: 'FormulaPayload', response?: { __typename?: 'Response', status?: number | null } | null, formula?: { __typename?: 'Formula', name?: string | null, description?: string | null, status?: FormulaStatus | null, bottleCap?: BottleCapType | null, bottleType?: BottleTypeEnum | null, coMfgCostType?: CoMfgCostType | null, capOverride?: boolean | null, coMfgCost?: number | null, coMfgCostPercentage?: number | null, veganType?: VeganType | null, proteinBase?: ProteinBaseType | null, factBoxType?: FactBoxType | null, miscellaneousCost?: number | null, organicPercentage?: number | null, beadletId?: string | null, tabletTypeId?: string | null, servingSize?: number | null, servingUnit?: ServingUnitType | null, servingContainer?: number | null, miniTabFormulation?: MiniTabFormulationType | null, sandCoatingId?: string | null, tabletCoatingId?: string | null, formulaAgeGroups?: Array<{ __typename?: 'FormulaAgeGroups', ageGroupType?: AgeGroupType | null, dvType?: DvConstraintType | null, servingSize?: number | null, servingUnit?: ServingUnitType | null, servingContainer?: number | null } | null> | null, productSize?: { __typename?: 'ProductSize', id: string, name?: string | null } | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null, type?: ProductTypes | null } | null, subProductType?: { __typename?: 'SubProductType', id: string, name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', id: string, name?: string | null, type?: ProductFormulationTypes | null } | null, excipientType?: { __typename?: 'ExcipientType', id: string, name?: string | null, excipientLabel?: { __typename?: 'ExcipientLabel', id: string } | null } | null, formulaTabletCoatings?: Array<{ __typename?: 'FormulaTabletCoating', id: string, type?: TabletCoatingType | null, colorsHex?: Array<string> | null, coatingColor?: TabletCoatingColor | null } | null> | null, formulaCapsuleTypes?: Array<{ __typename?: 'FormulaCapsuleType', type?: FormulaCapsuleTypeEnum | null, capsuleType: { __typename?: 'CapsuleType', id: string, name?: string | null } } | null> | null, formulaSweeteners?: Array<{ __typename?: 'FormulaSweetener', id: string, type?: SweetenerType | null, nature?: SweetenerNatureType | null, sweetener?: { __typename?: 'Sweetener', id: string, name?: string | null } | null } | null> | null, formulaIngredients?: Array<{ __typename?: 'FormulaIngredient', id: string, value?: number | null, unit?: FormulaIngredientUnit | null, type?: FormulaIngredientType | null, potency?: number | null, overage?: number | null, ingredientId?: string | null, showCfu?: boolean | null, ingredient?: { __typename?: 'Ingredient', name?: string | null, potency?: string | null, isActive?: boolean | null } | null } | null> | null, formulaBlends?: Array<{ __typename?: 'FormulaBlend', name?: string | null, formulaIngredients?: Array<{ __typename?: 'FormulaIngredient', id: string, unit?: FormulaIngredientUnit | null, type?: FormulaIngredientType | null, value?: number | null, potency?: number | null, overage?: number | null, ingredientId?: string | null, showCfu?: boolean | null, ingredient?: { __typename?: 'Ingredient', name?: string | null, potency?: string | null, isActive?: boolean | null } | null } | null> | null } | null> | null } | null } };

export type GetFactSheetQueryVariables = Exact<{
  getFactSheetInput: GetFactSheetInput;
}>;


export type GetFactSheetQuery = { __typename?: 'Query', getFactSheet: { __typename?: 'GetFactSheetPayload', pdfStr?: string | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetFormulaDetailQueryVariables = Exact<{
  getFormulaInput: GetFormulaInput;
}>;


export type GetFormulaDetailQuery = { __typename?: 'Query', getFormula: { __typename?: 'FormulaPayload', response?: { __typename?: 'Response', status?: number | null } | null, formula?: { __typename?: 'Formula', name?: string | null, description?: string | null, servingSize?: number | null, servingContainer?: number | null, mfgCost?: number | null, bottleCap?: BottleCapType | null, bottleType?: BottleTypeEnum | null, coMfgCost?: number | null, coMfgCostType?: CoMfgCostType | null, coMfgCostPercentage?: number | null, beadletId?: string | null, tabletTypeId?: string | null, tabletCoatingId?: string | null, miscellaneousCost?: number | null, organicPercentage?: number | null, veganType?: VeganType | null, proteinBase?: ProteinBaseType | null, factBoxType?: FactBoxType | null, miniTabFormulation?: MiniTabFormulationType | null, formulaAgeGroups?: Array<{ __typename?: 'FormulaAgeGroups', ageGroupType?: AgeGroupType | null, dvType?: DvConstraintType | null, servingSize?: number | null, servingUnit?: ServingUnitType | null, servingContainer?: number | null } | null> | null, productType?: { __typename?: 'ProductType', name?: string | null, type?: ProductTypes | null } | null, subProductType?: { __typename?: 'SubProductType', name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', name?: string | null } | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, excipientType?: { __typename?: 'ExcipientType', name?: string | null, excipientLabel?: { __typename?: 'ExcipientLabel', name?: string | null } | null } | null, sandCoating?: { __typename?: 'SandCoating', name?: string | null } | null, beadlet?: { __typename?: 'Beadlets', name?: string | null } | null, tabletCoating?: { __typename?: 'TabletCoating', name?: string | null } | null, formulaTabletCoatings?: Array<{ __typename?: 'FormulaTabletCoating', type?: TabletCoatingType | null, coatingColor?: TabletCoatingColor | null } | null> | null, formulaCapsuleTypes?: Array<{ __typename?: 'FormulaCapsuleType', type?: FormulaCapsuleTypeEnum | null, capsuleType: { __typename?: 'CapsuleType', name?: string | null } } | null> | null, formulaSweeteners?: Array<{ __typename?: 'FormulaSweetener', type?: SweetenerType | null, nature?: SweetenerNatureType | null, sweetener?: { __typename?: 'Sweetener', size?: SweetenerSizeType | null } | null } | null> | null, outerCapsulePrice?: { __typename?: 'CapsulePrice', price?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null } | null, innerCapsulePrice?: { __typename?: 'CapsulePrice', price?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null } | null, capsulePrice?: { __typename?: 'CapsulePrice', price?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, density?: { __typename?: 'Density', name?: string | null } | null } | null, formulaCost?: { __typename?: 'FormulaCosts', lohCost?: number | null, neckband?: number | null, flavorCost?: number | null, per1000Cost?: number | null, coatingCost?: number | null, bottlePrice?: number | null, sweetenerCost?: number | null, syrupBaseCost?: number | null, excipientCost?: number | null, conversionCost?: number | null, ingredientsCost?: number | null, sandCoatingCost?: number | null } | null, formulaWeights?: { __typename?: 'FormulaWeights', totalWeight?: number | null, flavorWeight?: number | null, coatingWeight?: number | null, excipientWeight?: number | null, syrupBaseWeight?: number | null, sweetenerWeight?: number | null, ingredientsWeight?: number | null, sandCoatingWeight?: number | null } | null, formulaWeightsPercentage?: { __typename?: 'FormulaWeightsPercentage', flavorWeight?: number | null, coatingWeight?: number | null, excipientWeight?: number | null, sweetenerWeight?: number | null, syrupBaseWeight?: number | null, ingredientsWeight?: number | null, sandCoatingWeight?: number | null } | null, formulaCostPercentage?: { __typename?: 'FormulaCostsPercentage', lohCost?: number | null, neckband?: number | null, flavorCost?: number | null, coatingCost?: number | null, bottlePrice?: number | null, sweetenerCost?: number | null, syrupBaseCost?: number | null, excipientCost?: number | null, conversionCost?: number | null, sandCoatingCost?: number | null, ingredientsCost?: number | null, miscellaneousCost?: number | null } | null, formulaIngredients?: Array<{ __typename?: 'FormulaIngredient', value?: number | null, potency?: number | null, unit?: FormulaIngredientUnit | null, type?: FormulaIngredientType | null, mgWeight?: number | null, mgVolume?: number | null, density?: number | null, totalCost?: number | null, ingCostContribution?: number | null, showCfu?: boolean | null, ingredient?: { __typename?: 'Ingredient', id: string, name?: string | null } | null, macroNutrientsWeight?: { __typename?: 'MacroNutrientsWeights', moisture: number, calories: number, protein: number, carbohydrates: number, dietaryFiber: number, totalSugars: number, addedSugar: number, totalFat: number, saturatedFat: number, monounsaturatedFat: number, polyunsaturatedFat: number, transFat: number, cholesterol: number } | null, microNutrientsWeight?: { __typename?: 'MicroNutrientsWeights', vitaminA: number, biotin: number, pantothenicAcid: number, thiamin: number, riboflavin: number, niacin: number, vitaminB6: number, vitaminB12: number, vitaminC: number, vitaminD: number, vitaminE: number, folate: number, vitaminK: number, vitaminK2: number, folicAcid: number, calcium: number, phosphorus: number, magnesium: number, sodium: number, potassium: number, chloride: number, iron: number, zinc: number, iodine: number, selenium: number, copper: number, manganese: number, chromium: number, molybdenum: number, boron: number, choline: number } | null } | null> | null, formulaBlends?: Array<{ __typename?: 'FormulaBlend', name?: string | null, formulaIngredients?: Array<{ __typename?: 'FormulaIngredient', value?: number | null, potency?: number | null, unit?: FormulaIngredientUnit | null, type?: FormulaIngredientType | null, mgWeight?: number | null, totalCost?: number | null, ingCostContribution?: number | null, showCfu?: boolean | null, ingredient?: { __typename?: 'Ingredient', id: string, name?: string | null } | null, macroNutrientsWeight?: { __typename?: 'MacroNutrientsWeights', moisture: number, calories: number, protein: number, carbohydrates: number, dietaryFiber: number, totalSugars: number, addedSugar: number, totalFat: number, saturatedFat: number, monounsaturatedFat: number, polyunsaturatedFat: number, transFat: number, cholesterol: number } | null, microNutrientsWeight?: { __typename?: 'MicroNutrientsWeights', vitaminA: number, biotin: number, pantothenicAcid: number, thiamin: number, riboflavin: number, niacin: number, vitaminB6: number, vitaminB12: number, vitaminC: number, vitaminD: number, vitaminE: number, folate: number, vitaminK: number, vitaminK2: number, folicAcid: number, calcium: number, phosphorus: number, magnesium: number, sodium: number, potassium: number, chloride: number, iron: number, zinc: number, iodine: number, selenium: number, copper: number, manganese: number, chromium: number, molybdenum: number, boron: number, choline: number } | null } | null> | null } | null> | null, attachment?: { __typename?: 'Attachment', attachmentUrl?: string | null } | null, bottleCapacity?: { __typename?: 'BottleCapacity', fillPercentage?: number | null, productSize?: { __typename?: 'ProductSize', name?: string | null, max?: number | null } | null, bottleSize?: { __typename?: 'BottleSize', lidSize?: number | null, name?: string | null } | null } | null } | null } };

export type FindAllDosageFormulasQueryVariables = Exact<{
  findAllDosageFormulasInputs: FindAllDosageFormulasInputs;
}>;


export type FindAllDosageFormulasQuery = { __typename?: 'Query', findAllDosageFormulas: { __typename?: 'DosageFormulasPayload', data: Array<{ __typename?: 'DosageFormulaCounts', name: string, count: number } | null>, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllDosageTypeFormulasQueryVariables = Exact<{
  findAllDosageTypeFormulasInput: FindAllDosageTypeFormulasInput;
}>;


export type FindAllDosageTypeFormulasQuery = { __typename?: 'Query', findAllDosageTypeFormulas: { __typename?: 'DosageFormulasPayload', data: Array<{ __typename?: 'DosageFormulaCounts', name: string, count: number } | null>, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindFormulasCountByYearQueryVariables = Exact<{
  findFormulasCountByYearInput: FindFormulasCountByYearInput;
}>;


export type FindFormulasCountByYearQuery = { __typename?: 'Query', findFormulasCountByYear: { __typename?: 'FormulasCountByYearPayload', data: Array<number>, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetDosageFormulasCountQueryVariables = Exact<{
  getDosageFormulasCountInput: GetDosageFormulasCountInput;
}>;


export type GetDosageFormulasCountQuery = { __typename?: 'Query', getDosageFormulasCount: { __typename?: 'DosageFormulasPayload', response?: { __typename?: 'Response', status?: number | null } | null, data: Array<{ __typename?: 'DosageFormulaCounts', name: string, count: number } | null> } };

export type GetFormulasIngredientReportQueryVariables = Exact<{
  getFormulasIngredientInput: GetFormulasIngredientInput;
}>;


export type GetFormulasIngredientReportQuery = { __typename?: 'Query', getFormulasIngredient: { __typename?: 'FormulasIngredientPayload', response?: { __typename?: 'Response', status?: number | null } | null, data: Array<{ __typename?: 'FormulasIngredient', category?: string | null, subCategory?: string | null, name: string, usage: number, rank: number } | null> } };

export type UpdateFormulaStatusMutationVariables = Exact<{
  updateFormulaStatusInput: UpdateFormulaStatusInput;
}>;


export type UpdateFormulaStatusMutation = { __typename?: 'Mutation', updateFormulaStatus: { __typename?: 'FormulaPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateFormulaMutationVariables = Exact<{
  createFormulaInput: CreateFormulaInput;
}>;


export type CreateFormulaMutation = { __typename?: 'Mutation', createFormula: { __typename?: 'FormulaPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateFormulaMutationVariables = Exact<{
  updateFormulaInput: UpdateFormulaInput;
}>;


export type UpdateFormulaMutation = { __typename?: 'Mutation', updateFormula: { __typename?: 'FormulaPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateDraftedFormulaMutationVariables = Exact<{
  updateDraftedFormulaInput: UpdateDraftedFormulaInput;
}>;


export type UpdateDraftedFormulaMutation = { __typename?: 'Mutation', updateDraftedFormula: { __typename?: 'FormulaPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type SaveFormulaAsDraftMutationVariables = Exact<{
  saveFormulaAsDraftInput: SaveFormulaAsDraftInput;
}>;


export type SaveFormulaAsDraftMutation = { __typename?: 'Mutation', saveFormulaAsDraft: { __typename?: 'FormulaPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null, formula?: { __typename?: 'Formula', id: string } | null } };

export type FindAllProductIngredientSyrupTypesTableQueryVariables = Exact<{
  findAllProductIngredientSyrupTypesInput: FindAllProductIngredientSyrupTypesInput;
}>;


export type FindAllProductIngredientSyrupTypesTableQuery = { __typename?: 'Query', findAllProductIngredientSyrupTypes: { __typename?: 'ProductIngredientSyrupTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'ProductIngredientSyrupTypes', id: string, percentage?: number | null, productIngredients?: { __typename?: 'ProductIngredient', id: string, name?: string | null, isActive?: boolean | null } | null }> | null } };

export type CreateProductIngredientSyrupTypeMutationVariables = Exact<{
  createProductIngredientSyrupTypeInput: CreateProductIngredientSyrupTypeInput;
}>;


export type CreateProductIngredientSyrupTypeMutation = { __typename?: 'Mutation', createProductIngredientSyrupType: { __typename?: 'ProductIngredientSyrupTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateProductIngredientSyrupTypeMutationVariables = Exact<{
  updateProductIngredientSyrupTypeInput: UpdateProductIngredientSyrupTypeInput;
}>;


export type UpdateProductIngredientSyrupTypeMutation = { __typename?: 'Mutation', updateProductIngredientSyrupType: { __typename?: 'ProductIngredientSyrupTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type RemoveProductIngredientSyrupTypeMutationVariables = Exact<{
  removeProductIngredientSyrupTypeInput: RemoveProductIngredientSyrupTypeInput;
}>;


export type RemoveProductIngredientSyrupTypeMutation = { __typename?: 'Mutation', removeProductIngredientSyrupType: { __typename?: 'ProductIngredientSyrupTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllProductFormulationSyrupTypesTableQueryVariables = Exact<{
  findAllProductFormulationSyrupTypesInput: FindAllProductFormulationSyrupTypesInput;
}>;


export type FindAllProductFormulationSyrupTypesTableQuery = { __typename?: 'Query', findAllProductFormulationSyrupTypes: { __typename?: 'ProductFormulationSyrupTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'ProductFormulationSyrupTypes', id: string, name?: string | null, cost?: number | null, weight?: number | null, isActive?: boolean | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', name?: string | null } | null }> | null } };

export type FindAllProductFormulationSyrupTypesSelectorQueryVariables = Exact<{
  findAllProductFormulationSyrupTypesInput: FindAllProductFormulationSyrupTypesInput;
}>;


export type FindAllProductFormulationSyrupTypesSelectorQuery = { __typename?: 'Query', findAllProductFormulationSyrupTypes: { __typename?: 'ProductFormulationSyrupTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number }, data?: Array<{ __typename?: 'ProductFormulationSyrupTypes', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type GetProductFormulationSyrupTypeQueryVariables = Exact<{
  getProductFormulationSyrupTypeInput: GetProductFormulationSyrupTypeInput;
}>;


export type GetProductFormulationSyrupTypeQuery = { __typename?: 'Query', getProductFormulationSyrupType: { __typename?: 'ProductFormulationSyrupTypePayload', productFormulationSyrupType?: { __typename?: 'ProductFormulationSyrupTypes', cost?: number | null, unit?: FormulationSyrupUnit | null, weight?: number | null, name?: string | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', id: string, name?: string | null } | null, productSize?: { __typename?: 'ProductSize', id: string, name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CreateProductFormulationSyrupTypeMutationVariables = Exact<{
  createProductFormulationSyrupTypeInput: CreateProductFormulationSyrupTypeInput;
}>;


export type CreateProductFormulationSyrupTypeMutation = { __typename?: 'Mutation', createProductFormulationSyrupType: { __typename?: 'ProductFormulationSyrupTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateProductFormulationSyrupTypeMutationVariables = Exact<{
  updateProductFormulationSyrupTypeInput: UpdateProductFormulationSyrupTypeInput;
}>;


export type UpdateProductFormulationSyrupTypeMutation = { __typename?: 'Mutation', updateProductFormulationSyrupType: { __typename?: 'ProductFormulationSyrupTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllIngredientsQueryVariables = Exact<{
  findAllIngredientsInput: FindAllIngredientsInput;
}>;


export type FindAllIngredientsQuery = { __typename?: 'Query', findAllIngredients: { __typename?: 'IngredientsPayload', data?: Array<{ __typename?: 'Ingredient', id: string, name?: string | null, cost?: number | null, isActive?: boolean | null, category?: { __typename?: 'Category', name?: string | null } | null, subCategory?: { __typename?: 'Category', name?: string | null } | null }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllSyrupBaseIngredientsQueryVariables = Exact<{
  findAllIngredientsInput: FindAllIngredientsInput;
}>;


export type FindAllSyrupBaseIngredientsQuery = { __typename?: 'Query', findAllSyrupBaseIngredients: { __typename?: 'IngredientsPayload', data?: Array<{ __typename?: 'Ingredient', id: string, name?: string | null, isActive?: boolean | null, productFormulationSyrupType?: { __typename?: 'ProductFormulationSyrupTypes', name?: string | null } | null }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllIngredientsSelectorQueryVariables = Exact<{
  findAllIngredientsInput: FindAllIngredientsInput;
}>;


export type FindAllIngredientsSelectorQuery = { __typename?: 'Query', findAllIngredients: { __typename?: 'IngredientsPayload', data?: Array<{ __typename?: 'Ingredient', id: string, name?: string | null, isActive?: boolean | null }> | null, pagination: { __typename?: 'Pagination', totalPages: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllIngredientsForSelectorQueryVariables = Exact<{
  findAllIngredientsInput: FindAllIngredientsInput;
}>;


export type FindAllIngredientsForSelectorQuery = { __typename?: 'Query', findAllIngredients: { __typename?: 'IngredientsPayload', data?: Array<{ __typename?: 'Ingredient', id: string, name?: string | null, potency?: string | null, suggestedOverage?: number | null, isActive?: boolean | null, gummyOverage?: number | null }> | null, pagination: { __typename?: 'Pagination', totalPages: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllAllergensQueryVariables = Exact<{
  findAllAllergensInput: FindAllAllergensInput;
}>;


export type FindAllAllergensQuery = { __typename?: 'Query', findAllAllergens: { __typename?: 'AllergensPayload', data?: Array<{ __typename?: 'Allergen', id: string, name?: string | null, description?: string | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetIngredientQueryVariables = Exact<{
  getIngredientInput: GetIngredientInput;
}>;


export type GetIngredientQuery = { __typename?: 'Query', getIngredient: { __typename?: 'IngredientPayload', response?: { __typename?: 'Response', status?: number | null } | null, ingredient?: { __typename?: 'Ingredient', id: string, name?: string | null, type?: Array<IngredientType | null> | null, latinName?: string | null, tradeMarkName?: string | null, scientificName?: string | null, description?: string | null, isOrganic?: boolean | null, cost?: number | null, amount?: number | null, showB3?: boolean | null, potency?: string | null, shelfLife?: number | null, nutrients?: boolean | null, nutrientName: boolean, gummyOverage?: number | null, suggestedOverage?: number | null, proBiotic?: string | null, manufacturingCountry?: string | null, originCountry?: string | null, density?: string | null, lossOnDrying?: string | null, avergageParticleSize?: string | null, ingredientProductTypes?: Array<{ __typename?: 'IngredientProductType', productTypeId?: string | null } | null> | null, ingredientAllergens?: Array<{ __typename?: 'IngredientAllergens', allergen?: { __typename?: 'Allergen', id: string } | null } | null> | null, ingredientSuppliers?: Array<{ __typename?: 'IngredientSuppliers', type?: SupplierType | null, supplier: { __typename?: 'Supplier', id: string, name?: string | null } } | null> | null, category?: { __typename?: 'Category', id: string, name?: string | null } | null, subCategory?: { __typename?: 'Category', id: string, name?: string | null } | null, ingredientInfo?: { __typename?: 'IngredientInfo', ingredientId?: string | null, organic?: string | null, moisture?: string | null, calories?: string | null, protein?: string | null, carbohydrates?: string | null, dietaryFiber?: string | null, totalSugars?: string | null, addedSugar?: string | null, totalFat?: string | null, saturatedFat?: string | null, monounsaturatedFat?: string | null, polyunsaturatedFat?: string | null, transFat?: string | null, vitaminA?: string | null, biotin?: string | null, thiamin?: string | null, riboflavin?: string | null, niacin?: string | null, vitaminB6?: string | null, vitaminB12?: string | null, vitaminC?: string | null, vitaminD?: string | null, vitaminE?: string | null, magnesium?: string | null, zinc?: string | null, vitaminK2?: string | null, choline?: string | null, iodine?: string | null, folate?: string | null, cholesterol?: string | null, calcium?: string | null, iron?: string | null, potassium?: string | null, boron?: string | null, sodium?: string | null, arsenic?: string | null, cadmium?: string | null, lead?: string | null, mercury?: string | null, chloride?: number | null, copper?: number | null, chromium?: number | null, selenium?: number | null, manganese?: number | null, phosphorus?: number | null, molybdenum?: number | null, pantothenicAcid?: number | null } | null, ingredientCarriers?: Array<{ __typename?: 'IngredientCarriers', percentage?: number | null, carrier?: { __typename?: 'Excipient', id: string, name?: string | null } | null } | null> | null, ingredientSubComponents?: Array<{ __typename?: 'IngredientSubComponents', name?: string | null, percentage?: number | null } | null> | null } | null } };

export type GetSyrupBaseIngredientQueryVariables = Exact<{
  getIngredientInput: GetIngredientInput;
}>;


export type GetSyrupBaseIngredientQuery = { __typename?: 'Query', getIngredient: { __typename?: 'IngredientPayload', response?: { __typename?: 'Response', status?: number | null } | null, ingredient?: { __typename?: 'Ingredient', id: string, name?: string | null, type?: Array<IngredientType | null> | null, productFormulationSyrupType?: { __typename?: 'ProductFormulationSyrupTypes', id: string, name?: string | null } | null, ingredientProductTypes?: Array<{ __typename?: 'IngredientProductType', productTypeId?: string | null } | null> | null, ingredientInfo?: { __typename?: 'IngredientInfo', ingredientId?: string | null, organic?: string | null, moisture?: string | null, calories?: string | null, protein?: string | null, carbohydrates?: string | null, dietaryFiber?: string | null, totalSugars?: string | null, addedSugar?: string | null, totalFat?: string | null, saturatedFat?: string | null, monounsaturatedFat?: string | null, polyunsaturatedFat?: string | null, transFat?: string | null, vitaminA?: string | null, biotin?: string | null, thiamin?: string | null, riboflavin?: string | null, niacin?: string | null, vitaminB6?: string | null, vitaminB12?: string | null, vitaminC?: string | null, vitaminD?: string | null, vitaminE?: string | null, magnesium?: string | null, zinc?: string | null, vitaminK2?: string | null, choline?: string | null, iodine?: string | null, folate?: string | null, cholesterol?: string | null, calcium?: string | null, iron?: string | null, potassium?: string | null, boron?: string | null, sodium?: string | null, arsenic?: string | null, cadmium?: string | null, lead?: string | null, mercury?: string | null, chloride?: number | null, copper?: number | null, chromium?: number | null, selenium?: number | null, manganese?: number | null, phosphorus?: number | null, molybdenum?: number | null, pantothenicAcid?: number | null } | null } | null } };

export type CreateIngredientMutationVariables = Exact<{
  createIngredientInput: CreateIngredientInput;
}>;


export type CreateIngredientMutation = { __typename?: 'Mutation', createIngredient: { __typename?: 'IngredientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateSyrupBaseIngredientMutationVariables = Exact<{
  createSyrupBaseIngredientsInput: CreateSyrupBaseIngredientsInput;
}>;


export type CreateSyrupBaseIngredientMutation = { __typename?: 'Mutation', createSyrupBaseIngredient: { __typename?: 'IngredientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateIngredientMutationVariables = Exact<{
  updateIngredientInput: UpdateIngredientInput;
}>;


export type UpdateIngredientMutation = { __typename?: 'Mutation', updateIngredient: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateSyrupBaseIngredientMutationVariables = Exact<{
  updateSyrupBaseIngredientsInput: UpdateSyrupBaseIngredientsInput;
}>;


export type UpdateSyrupBaseIngredientMutation = { __typename?: 'Mutation', updateSyrupBaseIngredient: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateIngredientInfoMutationVariables = Exact<{
  updateIngredientInfoInput: UpdateIngredientInfoInput;
}>;


export type UpdateIngredientInfoMutation = { __typename?: 'Mutation', updateIngredientInfo: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateIngredientAllergensMutationVariables = Exact<{
  updateIngredientAllergensInput: UpdateIngredientAllergensInput;
}>;


export type UpdateIngredientAllergensMutation = { __typename?: 'Mutation', updateIngredientAllergens: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateIngredientSuppliersMutationVariables = Exact<{
  updateIngredientSuppliersInput: UpdateIngredientSuppliersInput;
}>;


export type UpdateIngredientSuppliersMutation = { __typename?: 'Mutation', updateIngredientSuppliers: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateIngredientStatusMutationVariables = Exact<{
  UpdateIngredientStatus: UpdateIngredientStatus;
}>;


export type UpdateIngredientStatusMutation = { __typename?: 'Mutation', updateIngredientStatus: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateIngredientCarriersMutationVariables = Exact<{
  updateIngredientCarriersInput: UpdateIngredientCarriersInput;
}>;


export type UpdateIngredientCarriersMutation = { __typename?: 'Mutation', updateIngredientCarriers: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateIngredientSubComponentsMutationVariables = Exact<{
  updateIngredientSubComponentsInput: UpdateIngredientSubComponentsInput;
}>;


export type UpdateIngredientSubComponentsMutation = { __typename?: 'Mutation', updateIngredientSubComponents: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllOrganizationsUsersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllOrganizationsUsersCountQuery = { __typename?: 'Query', findAllOrganizationsUsersCount: { __typename?: 'OrganizationsUsersCountPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'OrganizationUsersCount', id?: string | null, name?: string | null, usersCount?: number | null } | null> | null } };

export type FindAllProductExcipientsQueryVariables = Exact<{
  getExcipientTypeInput: GetExcipientTypeInput;
}>;


export type FindAllProductExcipientsQuery = { __typename?: 'Query', getExcipientType: { __typename?: 'ExcipientTypePayload', excipientType?: { __typename?: 'ExcipientType', id: string, name?: string | null, loadAdd?: number | null, excipientLabel?: { __typename?: 'ExcipientLabel', name?: string | null } | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, productExcipients: Array<{ __typename?: 'ProductExcipient', id: string, percentage?: number | null, perKgCost?: number | null, excipient?: { __typename?: 'Excipient', id: string, name?: string | null } | null, productExcipientSupplier?: Array<{ __typename?: 'ProductExcipientSupplier', supplier?: { __typename?: 'Supplier', id: string, name?: string | null } | null } | null> | null }> } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateProductExcipientMutationVariables = Exact<{
  updateProductExcipientInput: UpdateProductExcipientInput;
}>;


export type UpdateProductExcipientMutation = { __typename?: 'Mutation', updateProductExcipient: { __typename?: 'ProductExcipientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateProductExcipientMutationVariables = Exact<{
  createProductExcipientInput: CreateProductExcipientInput;
}>;


export type CreateProductExcipientMutation = { __typename?: 'Mutation', createProductExcipient: { __typename?: 'ProductExcipientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type RemoveProductExcipientMutationVariables = Exact<{
  removeProductExcipientInput: RemoveProductExcipientInput;
}>;


export type RemoveProductExcipientMutation = { __typename?: 'Mutation', removeProductExcipient: { __typename?: 'ProductExcipientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllProductFormulationTypeTableQueryVariables = Exact<{
  findAllProductFormulationTypeInput: FindAllProductFormulationTypeInput;
}>;


export type FindAllProductFormulationTypeTableQuery = { __typename?: 'Query', findAllProductFormulationType: { __typename?: 'ProductFormulationTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'ProductFormulationType', id: string, name?: string | null, isActive: boolean, conversionCost?: number | null, isInnerCapTab?: boolean | null, innerComponentCost?: number | null, lohInside?: number | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', id: string, name?: string | null } | null }> | null } };

export type FindAllProductFormulationTypeSelectorQueryVariables = Exact<{
  findAllProductFormulationTypeInput: FindAllProductFormulationTypeInput;
}>;


export type FindAllProductFormulationTypeSelectorQuery = { __typename?: 'Query', findAllProductFormulationType: { __typename?: 'ProductFormulationTypesPayload', data?: Array<{ __typename?: 'ProductFormulationType', id: string, name?: string | null, type?: ProductFormulationTypes | null, isActive: boolean }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type GetProductFormulationTypeQueryVariables = Exact<{
  getProductFormulationTypeInput: GetProductFormulationTypeInput;
}>;


export type GetProductFormulationTypeQuery = { __typename?: 'Query', getProductFormulationType: { __typename?: 'ProductFormulationTypePayload', productFormulationType?: { __typename?: 'ProductFormulationType', id: string, name?: string | null, isActive: boolean, conversionCost?: number | null, isInnerCapTab?: boolean | null, innerComponentCost?: number | null, lohInside?: number | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null, type?: ProductTypes | null } | null, subProductType?: { __typename?: 'SubProductType', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateProductFormulationTypeMutationVariables = Exact<{
  updateProductFormulationTypeInput: UpdateProductFormulationTypeInput;
}>;


export type UpdateProductFormulationTypeMutation = { __typename?: 'Mutation', updateProductFormulationType: { __typename?: 'ProductFormulationTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllProductIngredientsSelectorQueryVariables = Exact<{
  findAllProductIngredientsInput: FindAllProductIngredientsInput;
}>;


export type FindAllProductIngredientsSelectorQuery = { __typename?: 'Query', findAllProductIngredients: { __typename?: 'ProductIngredientsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number }, data?: Array<{ __typename?: 'ProductIngredient', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type FindAllProductIngredientsQueryVariables = Exact<{
  findAllProductIngredientsInput: FindAllProductIngredientsInput;
}>;


export type FindAllProductIngredientsQuery = { __typename?: 'Query', findAllProductIngredients: { __typename?: 'ProductIngredientsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'ProductIngredient', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type GetProductIngredientQueryVariables = Exact<{
  getProductIngredientInput: GetProductIngredientInput;
}>;


export type GetProductIngredientQuery = { __typename?: 'Query', getProductIngredient: { __typename?: 'ProductIngredientPayload', productIngredient?: { __typename?: 'ProductIngredient', id: string, name?: string | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateProductIngredientMutationVariables = Exact<{
  updateProductIngredientInput: UpdateProductIngredientInput;
}>;


export type UpdateProductIngredientMutation = { __typename?: 'Mutation', updateProductIngredient: { __typename?: 'ProductIngredientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateProductIngredientMutationVariables = Exact<{
  createProductIngredientInput: CreateProductIngredientInput;
}>;


export type CreateProductIngredientMutation = { __typename?: 'Mutation', createProductIngredient: { __typename?: 'ProductIngredientPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllProductSizeSelectorQueryVariables = Exact<{
  findAllProductSizesInput: FindAllProductSizesInput;
}>;


export type FindAllProductSizeSelectorQuery = { __typename?: 'Query', findAllProductSize: { __typename?: 'ProductSizesPayload', data?: Array<{ __typename?: 'ProductSize', id: string, name?: string | null, isActive: boolean }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type FindAllProductSizeQueryVariables = Exact<{
  findAllProductSizesInput: FindAllProductSizesInput;
}>;


export type FindAllProductSizeQuery = { __typename?: 'Query', findAllProductSize: { __typename?: 'ProductSizesPayload', data?: Array<{ __typename?: 'ProductSize', id: string, name?: string | null, min?: number | null, max?: number | null, gummyWeight?: number | null, isActive: boolean, emptyWtMg?: number | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', name?: string | null } | null }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetProductSizeQueryVariables = Exact<{
  getProductSizeInput: GetProductSizeInput;
}>;


export type GetProductSizeQuery = { __typename?: 'Query', getProductSize: { __typename?: 'ProductSizePayload', productSize?: { __typename?: 'ProductSize', id: string, name?: string | null, min?: number | null, max?: number | null, gummyWeight?: number | null, emptyWtMg?: number | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateProductSizeMutationVariables = Exact<{
  updateProductSizeInput: UpdateProductSizeInput;
}>;


export type UpdateProductSizeMutation = { __typename?: 'Mutation', updateProductSize: { __typename?: 'ProductSizePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateProductSizeMutationVariables = Exact<{
  createProductSizeInput: CreateProductSizeInput;
}>;


export type CreateProductSizeMutation = { __typename?: 'Mutation', createProductSize: { __typename?: 'ProductSizePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindProductTypeTableQueryVariables = Exact<{
  findAllProductTypeInput: FindAllProductTypesInput;
}>;


export type FindProductTypeTableQuery = { __typename?: 'Query', findAllProductType: { __typename?: 'ProductTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'ProductType', id: string, name?: string | null, type?: ProductTypes | null, isActive: boolean }> | null } };

export type FindAllProductTypeSelectQueryVariables = Exact<{
  findAllProductTypeInput: FindAllProductTypesInput;
}>;


export type FindAllProductTypeSelectQuery = { __typename?: 'Query', findAllProductType: { __typename?: 'ProductTypesPayload', pagination: { __typename?: 'Pagination', totalPages: number }, response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'ProductType', id: string, name?: string | null, isActive: boolean }> | null } };

export type FindAllProductTypeQueryVariables = Exact<{
  findAllProductTypeInput: FindAllProductTypesInput;
}>;


export type FindAllProductTypeQuery = { __typename?: 'Query', findAllProductType: { __typename?: 'ProductTypesPayload', data?: Array<{ __typename?: 'ProductType', id: string, name?: string | null, type?: ProductTypes | null, isActive: boolean }> | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetProductTypeQueryVariables = Exact<{
  getProductTypeInput: GetProductTypeInput;
}>;


export type GetProductTypeQuery = { __typename?: 'Query', getProductType: { __typename?: 'ProductTypePayload', productType?: { __typename?: 'ProductType', name?: string | null, isActive: boolean } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateProductTypeMutationVariables = Exact<{
  updateProductTypeInput: UpdateProductTypeInput;
}>;


export type UpdateProductTypeMutation = { __typename?: 'Mutation', updateProductType: { __typename?: 'ProductTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllSandCoatingQueryVariables = Exact<{
  findAllSandCoatingInput: FindAllSandCoatingInput;
}>;


export type FindAllSandCoatingQuery = { __typename?: 'Query', findAllSandCoating: { __typename?: 'SandCoatingsPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'SandCoating', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type FindAllSandCoatingSelectorQueryVariables = Exact<{
  findAllSandCoatingInput: FindAllSandCoatingInput;
}>;


export type FindAllSandCoatingSelectorQuery = { __typename?: 'Query', findAllSandCoating: { __typename?: 'SandCoatingsPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'SandCoating', id: string, name?: string | null, isActive?: boolean | null }> | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type FindAllSandCoatingTableQueryVariables = Exact<{
  findAllSandCoatingInput: FindAllSandCoatingInput;
}>;


export type FindAllSandCoatingTableQuery = { __typename?: 'Query', findAllSandCoating: { __typename?: 'SandCoatingsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'SandCoating', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type GetSandCoatingQueryVariables = Exact<{
  getSandCoatingInput: GetSandCoatingInput;
}>;


export type GetSandCoatingQuery = { __typename?: 'Query', getSandCoating: { __typename?: 'SandCoatingPayload', response?: { __typename?: 'Response', status?: number | null } | null, sandCoating?: { __typename?: 'SandCoating', id: string, name?: string | null, isActive?: boolean | null } | null } };

export type CreateSandCoatingMutationVariables = Exact<{
  createSandCoatingInput: CreateSandCoatingInput;
}>;


export type CreateSandCoatingMutation = { __typename?: 'Mutation', createSandCoating: { __typename?: 'SandCoatingPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateSandCoatingMutationVariables = Exact<{
  updateSandCoatingInput: UpdateSandCoatingInput;
}>;


export type UpdateSandCoatingMutation = { __typename?: 'Mutation', updateSandCoating: { __typename?: 'SandCoatingPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllSandCoatingFormulationQueryVariables = Exact<{
  findAllSandCoatingFormulationInput: FindAllSandCoatingFormulationInput;
}>;


export type FindAllSandCoatingFormulationQuery = { __typename?: 'Query', findAllSandCoatingFormulation: { __typename?: 'SandCoatingFormulationsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'SandCoatingFormulation', id: string, cost?: number | null, weight?: number | null, unit?: string | null, isActive?: boolean | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, sandCoating?: { __typename?: 'SandCoating', name?: string | null } | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', name?: string | null } | null }> | null } };

export type GetSandCoatingFormulationQueryVariables = Exact<{
  getSandCoatingFormulationInput: GetSandCoatingFormulationInput;
}>;


export type GetSandCoatingFormulationQuery = { __typename?: 'Query', getSandCoatingFormulation: { __typename?: 'SandCoatingFormulationPayload', response?: { __typename?: 'Response', status?: number | null } | null, sandCoatingFormulation?: { __typename?: 'SandCoatingFormulation', id: string, cost?: number | null, weight?: number | null, unit?: string | null, isActive?: boolean | null, productSize?: { __typename?: 'ProductSize', id: string, name?: string | null } | null, sandCoating?: { __typename?: 'SandCoating', id: string, name?: string | null } | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null, subProductType?: { __typename?: 'SubProductType', id: string, name?: string | null } | null } | null } };

export type CreateSandCoatingFormulationMutationVariables = Exact<{
  createSandCoatingFormulationInput: CreateSandCoatingFormulationInput;
}>;


export type CreateSandCoatingFormulationMutation = { __typename?: 'Mutation', createSandCoatingFormulation: { __typename?: 'SandCoatingFormulationPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateSandCoatingFormulationMutationVariables = Exact<{
  updateSandCoatingFormulationInput: UpdateSandCoatingFormulationInput;
}>;


export type UpdateSandCoatingFormulationMutation = { __typename?: 'Mutation', updateSandCoatingFormulation: { __typename?: 'SandCoatingFormulationPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllSandComponentForSelectorQueryVariables = Exact<{
  findAllSandComponentInput: FindAllSandComponentInput;
}>;


export type FindAllSandComponentForSelectorQuery = { __typename?: 'Query', findAllSandComponent: { __typename?: 'SandComponentsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number }, data?: Array<{ __typename?: 'SandComponent', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type FindAllSandComponentTableQueryVariables = Exact<{
  findAllSandComponentInput: FindAllSandComponentInput;
}>;


export type FindAllSandComponentTableQuery = { __typename?: 'Query', findAllSandComponent: { __typename?: 'SandComponentsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'SandComponent', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type GetSandComponentQueryVariables = Exact<{
  getSandComponentInput: GetSandComponentInput;
}>;


export type GetSandComponentQuery = { __typename?: 'Query', getSandComponent: { __typename?: 'SandComponentPayload', response?: { __typename?: 'Response', status?: number | null } | null, sandComponent?: { __typename?: 'SandComponent', id: string, name?: string | null, isActive?: boolean | null } | null } };

export type CreateSandComponentMutationVariables = Exact<{
  createSandComponentInput: CreateSandComponentInput;
}>;


export type CreateSandComponentMutation = { __typename?: 'Mutation', createSandComponent: { __typename?: 'SandComponentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateSandComponentMutationVariables = Exact<{
  updateSandComponentInput: UpdateSandComponentInput;
}>;


export type UpdateSandComponentMutation = { __typename?: 'Mutation', updateSandComponent: { __typename?: 'SandComponentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllServingSizeSelectorQueryVariables = Exact<{
  findAllServingSizesInput: FindAllServingSizesInput;
}>;


export type FindAllServingSizeSelectorQuery = { __typename?: 'Query', findAllServingSize: { __typename?: 'ServingSizesPayload', data?: Array<{ __typename?: 'ServingSize', id: string, size?: number | null, isActive: boolean }> | null, pagination: { __typename?: 'Pagination', totalPages: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllServingSizeQueryVariables = Exact<{
  findAllServingSizesInput: FindAllServingSizesInput;
}>;


export type FindAllServingSizeQuery = { __typename?: 'Query', findAllServingSize: { __typename?: 'ServingSizesPayload', data?: Array<{ __typename?: 'ServingSize', id: string, size?: number | null, isActive: boolean }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetServingSizeQueryVariables = Exact<{
  getServingSizeInput: GetServingSizeInput;
}>;


export type GetServingSizeQuery = { __typename?: 'Query', getServingSize: { __typename?: 'ServingSizePayload', servingSize?: { __typename?: 'ServingSize', id: string, size?: number | null, isActive: boolean } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateServingSizeMutationVariables = Exact<{
  updateServingSizeInput: UpdateServingSizeInput;
}>;


export type UpdateServingSizeMutation = { __typename?: 'Mutation', updateServingSize: { __typename?: 'ServingSizePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateServingSizeMutationVariables = Exact<{
  createServingSizeInput: CreateServingSizeInput;
}>;


export type CreateServingSizeMutation = { __typename?: 'Mutation', createServingSize: { __typename?: 'ServingSizePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FetchUserSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserSettingQuery = { __typename?: 'Query', fetchUser: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null } | null, user?: { __typename?: 'User', id: string, email: string, phone?: string | null, lastName?: string | null, firstName?: string | null, organization?: { __typename?: 'Organization', id: string, name?: string | null, address?: { __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, state?: string | null, countryCode?: string | null } | null } | null } | null } };

export type UpdateUserInfoMutationVariables = Exact<{
  updateUserInfoInput: UpdateUserInfoInput;
}>;


export type UpdateUserInfoMutation = { __typename?: 'Mutation', updateUserInfo: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllStaffQueryVariables = Exact<{
  findAllStaffInput: FindAllStaffInput;
}>;


export type FindAllStaffQuery = { __typename?: 'Query', findAllStaff: { __typename?: 'UsersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, status: UserStatus, staffRole?: string | null, createdAt: string }> | null } };

export type FindAllOrgStaffQueryVariables = Exact<{
  findAllOrgStaffInput: FindAllOrgStaffInput;
}>;


export type FindAllOrgStaffQuery = { __typename?: 'Query', findAllOrgStaff: { __typename?: 'UsersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, status: UserStatus, staffRole?: string | null, createdAt: string }> | null } };

export type GetOrgStaffQueryVariables = Exact<{
  getOrgStaffInput: GetOrgStaffInput;
}>;


export type GetOrgStaffQuery = { __typename?: 'Query', getOrgStaff: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null } | null, user?: { __typename?: 'User', id: string, email: string, phone?: string | null, lastName?: string | null, firstName?: string | null, staffRole?: string | null } | null } };

export type CreateStaffMutationVariables = Exact<{
  createStaffInput: CreateStaffInput;
}>;


export type CreateStaffMutation = { __typename?: 'Mutation', createStaff: { __typename?: 'ClientSecretPayload', clientSecret?: string | null, response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateOrgStaffMutationVariables = Exact<{
  createOrgStaffInput: CreateOrgStaffInput;
}>;


export type CreateOrgStaffMutation = { __typename?: 'Mutation', createOrgStaff: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateStaffInfoMutationVariables = Exact<{
  updateStaffInfoInput: UpdateStaffInfoInput;
}>;


export type UpdateStaffInfoMutation = { __typename?: 'Mutation', updateStaffInfo: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateOrgStaffInfoMutationVariables = Exact<{
  updateOrgStaffInfoInput: UpdateOrgStaffInfoInput;
}>;


export type UpdateOrgStaffInfoMutation = { __typename?: 'Mutation', updateOrgStaffInfo: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type ActiveStaffSubscriptionMutationVariables = Exact<{
  activeStaffSubscriptionInput: ActiveStaffSubscriptionInput;
}>;


export type ActiveStaffSubscriptionMutation = { __typename?: 'Mutation', activeStaffSubscription: { __typename?: 'ClientSecretPayload', clientSecret?: string | null, response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindPriceAndProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindPriceAndProductsQuery = { __typename?: 'Query', findPriceAndProducts: { __typename?: 'StripePricesPayload', prices?: Array<{ __typename?: 'StripePrice', id: string, amount?: number | null, interval?: StripeIntervalType | null, product?: { __typename?: 'StripeProduct', id: string, name: string, description?: string | null, images?: Array<string> | null, marketingFeatures?: Array<{ __typename?: 'MarketingFeatures', name?: string | null }> | null } | null } | null> | null, response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type CreateSubscriptionMutationVariables = Exact<{
  createSubscriptionInput: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateSubscriptionPayload', clientSecret?: string | null, response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type FindOnePriceAndProductsQueryVariables = Exact<{
  getStripePriceInput: GetStripePriceInput;
}>;


export type FindOnePriceAndProductsQuery = { __typename?: 'Query', findOnePriceAndProducts: { __typename?: 'StripePricePayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, price?: { __typename?: 'StripePrice', amount?: number | null, interval?: StripeIntervalType | null, isTrialEnded?: boolean | null, billAbleAmount?: number | null } | null } };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { __typename?: 'Query', getPaymentMethods: { __typename?: 'PaymentMethodsPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, paymentMethods?: Array<{ __typename?: 'StripePaymentMethod', id: string, brand?: string | null, type?: StripePaymentMethodType | null, last4?: string | null, name?: string | null, default?: boolean | null }> | null } };

export type RemovePaymentMethodMutationVariables = Exact<{
  removePaymentMethodInput: RemovePaymentMethodInput;
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  setDefaultPaymentMethodInput: SetDefaultPaymentMethodInput;
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type CancelSubscriptionMutationVariables = Exact<{
  cancelSubscriptionInput: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'CancelSubscriptionPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type ChangeSubscriptionPlanMutationVariables = Exact<{
  changeSubscriptionPlanInput: ChangeSubscriptionPlanInput;
}>;


export type ChangeSubscriptionPlanMutation = { __typename?: 'Mutation', changeSubscriptionPlan: { __typename?: 'ChangeSubscriptionPlanPayload', clientSecret?: string | null, response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type AddPaymentMethodMutationVariables = Exact<{
  addPaymentMethodInput: AddPaymentMethodInput;
}>;


export type AddPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethod: { __typename?: 'ClientSecretPayload', clientSecret?: string | null, response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'ClientSecretPayload', clientSecret?: string | null, response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type FindAllInvoicesQueryVariables = Exact<{
  findAllInvoicesInput: FindAllInvoicesInput;
}>;


export type FindAllInvoicesQuery = { __typename?: 'Query', findAllInvoices: { __typename?: 'InvoicesPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, data?: Array<{ __typename?: 'Invoice', id: string, amount: number, status: InvoiceStatus, createdAt: string, invoiceNumber?: string | null }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number } } };

export type GetInvoiceQueryVariables = Exact<{
  getInvoiceInput: GetInvoiceInput;
}>;


export type GetInvoiceQuery = { __typename?: 'Query', getInvoice: { __typename?: 'HostedInvoiceUrlPayload', hostedInvoiceUrl?: string | null, response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null } };

export type FindAllOrgInvoicesQueryVariables = Exact<{
  findInvoicesByOrgIdInput: FindInvoicesByOrgIdInput;
}>;


export type FindAllOrgInvoicesQuery = { __typename?: 'Query', findAllOrgInvoices: { __typename?: 'InvoicesPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, data?: Array<{ __typename?: 'Invoice', id: string, amount: number, status: InvoiceStatus, createdAt: string, invoiceNumber?: string | null }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number } } };

export type FindAllSubProductTypeTableQueryVariables = Exact<{
  findAllSubProductTypeInput: FindAllSubProductTypesInput;
}>;


export type FindAllSubProductTypeTableQuery = { __typename?: 'Query', findAllSubProductType: { __typename?: 'SubProductTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'SubProductType', id: string, name?: string | null, isActive: boolean, productType?: { __typename?: 'ProductType', name?: string | null } | null }> | null } };

export type FindAllSubProductTypeQueryVariables = Exact<{
  findAllSubProductTypeInput: FindAllSubProductTypesInput;
}>;


export type FindAllSubProductTypeQuery = { __typename?: 'Query', findAllSubProductType: { __typename?: 'SubProductTypesPayload', data?: Array<{ __typename?: 'SubProductType', id: string, name?: string | null, isActive: boolean }> | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllSubProductTypeSelectorQueryVariables = Exact<{
  findAllSubProductTypeInput: FindAllSubProductTypesInput;
}>;


export type FindAllSubProductTypeSelectorQuery = { __typename?: 'Query', findAllSubProductType: { __typename?: 'SubProductTypesPayload', data?: Array<{ __typename?: 'SubProductType', id: string, name?: string | null, isActive: boolean }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type GetSubProductTypeQueryVariables = Exact<{
  getSubProductTypeInput: GetSubProductTypeInput;
}>;


export type GetSubProductTypeQuery = { __typename?: 'Query', getSubProductType: { __typename?: 'SubProductTypePayload', subProductType?: { __typename?: 'SubProductType', name?: string | null, isActive: boolean, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateSubProductTypeMutationVariables = Exact<{
  updateSubProductTypeInput: UpdateSubProductTypeInput;
}>;


export type UpdateSubProductTypeMutation = { __typename?: 'Mutation', updateSubProductType: { __typename?: 'SubProductTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateSubProductTypeMutationVariables = Exact<{
  createSubProductTypeInput: CreateSubProductTypeInput;
}>;


export type CreateSubProductTypeMutation = { __typename?: 'Mutation', createSubProductType: { __typename?: 'SubProductTypePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindTableSuppliersQueryVariables = Exact<{
  findAllSuppliersInput: FindAllSuppliersInput;
}>;


export type FindTableSuppliersQuery = { __typename?: 'Query', findAllSuppliers: { __typename?: 'SuppliersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'Supplier', id: string, name?: string | null, status?: SupplierStatus | null, organizationId?: string | null, contact?: { __typename?: 'Contact', name?: string | null, designation?: string | null } | null }> | null } };

export type FindAllSuppliersQueryVariables = Exact<{
  findAllSuppliersInput: FindAllSuppliersInput;
}>;


export type FindAllSuppliersQuery = { __typename?: 'Query', findAllSuppliers: { __typename?: 'SuppliersPayload', data?: Array<{ __typename?: 'Supplier', id: string, name?: string | null, status?: SupplierStatus | null, description?: string | null }> | null, pagination: { __typename?: 'Pagination', page?: number | null, totalPages: number }, response?: { __typename?: 'Response', status?: number | null } | null } };

export type FindAllSuppliersSelectQueryVariables = Exact<{
  findAllSuppliersInput: FindAllSuppliersInput;
}>;


export type FindAllSuppliersSelectQuery = { __typename?: 'Query', findAllSuppliers: { __typename?: 'SuppliersPayload', data?: Array<{ __typename?: 'Supplier', id: string, name?: string | null }> | null, response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number } } };

export type GetSupplierQueryVariables = Exact<{
  getSupplierInput: GetSupplierInput;
}>;


export type GetSupplierQuery = { __typename?: 'Query', getSupplier: { __typename?: 'SupplierPayload', supplier?: { __typename?: 'Supplier', name?: string | null, description?: string | null, contact?: { __typename?: 'Contact', id: string, city?: string | null, name?: string | null, email?: string | null, state?: string | null, phoneNo?: string | null, zipCode?: string | null, country?: string | null, address1?: string | null, address2?: string | null, designation?: string | null, countryCode?: string | null } | null, additionalContacts?: Array<{ __typename?: 'AdditionalContact', id: string, name?: string | null, email?: string | null }> | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CreateSupplierMutationVariables = Exact<{
  createSupplierInput: CreateSupplierInput;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier: { __typename?: 'SupplierPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateSupplierMutationVariables = Exact<{
  updateSupplierInput: UpdateSupplierInput;
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier: { __typename?: 'SupplierPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateContactByContactableIdMutationVariables = Exact<{
  updateContactByContactableIdInput: UpdateContactByContactableIdInput;
}>;


export type UpdateContactByContactableIdMutation = { __typename?: 'Mutation', updateContactByContactableId: { __typename?: 'ContactPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateContactMutationVariables = Exact<{
  createContactInput: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'ContactPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateAdditionalContactMutationVariables = Exact<{
  updateAdditionalContactsInput: UpdateAdditionalContactsInput;
}>;


export type UpdateAdditionalContactMutation = { __typename?: 'Mutation', updateAdditionalContact: { __typename?: 'AdditionalContactPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateAdditionalContactMutationVariables = Exact<{
  createAdditionalContactInput: CreateAdditionalContactInput;
}>;


export type CreateAdditionalContactMutation = { __typename?: 'Mutation', createAdditionalContact: { __typename?: 'AdditionalContactPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FetchSweetenerComponentSelectorQueryVariables = Exact<{
  findAllSweetenerComponentsInput: FindAllSweetenerComponentsInput;
}>;


export type FetchSweetenerComponentSelectorQuery = { __typename?: 'Query', findAllSweetenersComponent: { __typename?: 'SweetenerComponentsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number }, data?: Array<{ __typename?: 'SweetenerComponent', id: string, name?: string | null, isActive?: boolean | null }> | null } };

export type FindAllSweetenersComponentQueryVariables = Exact<{
  findAllSweetenerComponentsInput: FindAllSweetenerComponentsInput;
}>;


export type FindAllSweetenersComponentQuery = { __typename?: 'Query', findAllSweetenersComponent: { __typename?: 'SweetenerComponentsPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'SweetenerComponent', id: string, name?: string | null, costPerKg?: number | null, isActive?: boolean | null }> | null } };

export type GetSweetenerComponentQueryVariables = Exact<{
  getSweetenerComponentInput: GetSweetenerComponentInput;
}>;


export type GetSweetenerComponentQuery = { __typename?: 'Query', getSweetenerComponent: { __typename?: 'SweetenerComponentPayload', sweetenerComponent?: { __typename?: 'SweetenerComponent', id: string, name?: string | null, costPerKg?: number | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateSweetenerComponentMutationVariables = Exact<{
  updateSweetenerComponentInput: UpdateSweetenerComponentInput;
}>;


export type UpdateSweetenerComponentMutation = { __typename?: 'Mutation', updateSweetenerComponent: { __typename?: 'SweetenerComponentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateSweetenerComponentMutationVariables = Exact<{
  createSweetenerComponentInput: CreateSweetenerComponentInput;
}>;


export type CreateSweetenerComponentMutation = { __typename?: 'Mutation', createSweetenerComponent: { __typename?: 'SweetenerComponentPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllSweetenerElementsQueryVariables = Exact<{
  getSweetenerInput: GetSweetenerInput;
}>;


export type FindAllSweetenerElementsQuery = { __typename?: 'Query', getSweetener: { __typename?: 'SweetenerPayload', sweetener?: { __typename?: 'Sweetener', id: string, name?: string | null, type?: SweetenerType | null, size?: SweetenerSizeType | null, nature?: SweetenerNatureType | null, isActive?: boolean | null, costPerServing?: number | null, mgPerServing?: number | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', name?: string | null } | null, sweetenerElements?: Array<{ __typename?: 'SweetenerElement', id: string, qtPerMg?: number | null, sweetenerComponent?: { __typename?: 'SweetenerComponent', id: string, name?: string | null, isActive?: boolean | null } | null }> | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type UpdateSweetenerElementMutationVariables = Exact<{
  updateSweetenerElementsInput: UpdateSweetenerElementsInput;
}>;


export type UpdateSweetenerElementMutation = { __typename?: 'Mutation', updateSweetenerElement: { __typename?: 'SweetenerElementPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type CreateSweetenerElementMutationVariables = Exact<{
  createSweetenerElementsInput: CreateSweetenerElementsInput;
}>;


export type CreateSweetenerElementMutation = { __typename?: 'Mutation', createSweetenerElement: { __typename?: 'SweetenerElementPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type RemoveSweetenerElementMutationVariables = Exact<{
  removeSweetenerElementsInput: RemoveSweetenerElementsInput;
}>;


export type RemoveSweetenerElementMutation = { __typename?: 'Mutation', removeSweetenerElement: { __typename?: 'SweetenerElementPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllSweetenersQueryVariables = Exact<{
  findAllSweetenersInput: FindAllSweetenersInput;
}>;


export type FindAllSweetenersQuery = { __typename?: 'Query', findAllSweeteners: { __typename?: 'SweetenersPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'Sweetener', name?: string | null, id: string }> | null } };

export type FindAllSweetenersTableQueryVariables = Exact<{
  findAllSweetenersInput: FindAllSweetenersInput;
}>;


export type FindAllSweetenersTableQuery = { __typename?: 'Query', findAllSweeteners: { __typename?: 'SweetenersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'Sweetener', id: string, name?: string | null, size?: SweetenerSizeType | null, nature?: SweetenerNatureType | null, isActive?: boolean | null, mgPerServing?: number | null, costPerServing?: number | null, productType?: { __typename?: 'ProductType', name?: string | null } | null, productSize?: { __typename?: 'ProductSize', name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', name?: string | null } | null }> | null } };

export type GetSweetenerQueryVariables = Exact<{
  getSweetenerInput: GetSweetenerInput;
}>;


export type GetSweetenerQuery = { __typename?: 'Query', getSweetener: { __typename?: 'SweetenerPayload', sweetener?: { __typename?: 'Sweetener', name?: string | null, size?: SweetenerSizeType | null, nature?: SweetenerNatureType | null, isActive?: boolean | null, mgPerServing?: number | null, costPerServing?: number | null, productType?: { __typename?: 'ProductType', id: string, name?: string | null } | null, productSize?: { __typename?: 'ProductSize', id: string, name?: string | null } | null, productFormulationType?: { __typename?: 'ProductFormulationType', id: string, name?: string | null } | null } | null, response?: { __typename?: 'Response', status?: number | null } | null } };

export type CreateSweetenerMutationVariables = Exact<{
  createSweetenerInput: CreateSweetenerInput;
}>;


export type CreateSweetenerMutation = { __typename?: 'Mutation', createSweetener: { __typename?: 'SweetenerPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateSweetenerMutationVariables = Exact<{
  updateSweetenerInput: UpdateSweetenerInput;
}>;


export type UpdateSweetenerMutation = { __typename?: 'Mutation', updateSweetener: { __typename?: 'SweetenerPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type FindAllTabletTypeQueryVariables = Exact<{
  findAllProductFormulationTypeInput: FindAllProductFormulationTypeInput;
}>;


export type FindAllTabletTypeQuery = { __typename?: 'Query', findAllProductFormulationType: { __typename?: 'ProductFormulationTypesPayload', response?: { __typename?: 'Response', status?: number | null } | null, data?: Array<{ __typename?: 'ProductFormulationType', id: string, name?: string | null, isActive: boolean }> | null } };

export type FetchUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserQuery = { __typename?: 'Query', fetchUser: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, isAccepted?: boolean | null, userRoles?: Array<{ __typename?: 'UserRole', role?: { __typename?: 'Role', type?: UserRoles | null } | null } | null> | null } | null } };

export type FindAllAdminQueryVariables = Exact<{
  findAllAdminInput: FindAllAdminInput;
}>;


export type FindAllAdminQuery = { __typename?: 'Query', findAllAdmin: { __typename?: 'UsersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, status: UserStatus, createdAt: string, organizationId?: string | null, organization?: { __typename?: 'Organization', name?: string | null, maxUser?: number | null, activeStaff?: number | null, totalStaff?: number | null } | null }> | null } };

export type FindAllUsersQueryVariables = Exact<{
  findAllUsersInput: FindAllUsersInput;
}>;


export type FindAllUsersQuery = { __typename?: 'Query', findAllUsers: { __typename?: 'UsersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, createdAt: string, userRoles?: Array<{ __typename?: 'UserRole', role?: { __typename?: 'Role', name?: string | null } | null } | null> | null, organization?: { __typename?: 'Organization', name?: string | null } | null }> | null } };

export type FindAllUsersSelectQueryVariables = Exact<{
  findAllUsersInput: FindAllUsersInput;
}>;


export type FindAllUsersSelectQuery = { __typename?: 'Query', findAllUsers: { __typename?: 'UsersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', page?: number | null, totalCount: number }, data?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> | null } };

export type FindOrgUserSelectQueryVariables = Exact<{
  findAllAdminInput: FindAllAdminInput;
}>;


export type FindOrgUserSelectQuery = { __typename?: 'Query', findAllAdmin: { __typename?: 'UsersPayload', response?: { __typename?: 'Response', status?: number | null } | null, pagination: { __typename?: 'Pagination', totalPages: number }, data?: Array<{ __typename?: 'User', firstName?: string | null, lastName?: string | null, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null }> | null } };

export type FindUsersCountByYearQueryVariables = Exact<{
  findUsersCountByYearInput: FindUsersCountByYearInput;
}>;


export type FindUsersCountByYearQuery = { __typename?: 'Query', findUsersCountByYear: { __typename?: 'UsersCountByYearPayload', data: Array<number>, response?: { __typename?: 'Response', status?: number | null } | null } };

export type GetPlatformUsersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformUsersCountQuery = { __typename?: 'Query', getPlatformUsersCount: { __typename?: 'PlatformUsersCountPayload', response?: { __typename?: 'Response', status?: number | null } | null, data: { __typename?: 'PlatformUsersCount', ios: number, web: number, android: number } } };

export type FindUsersStatsQueryVariables = Exact<{
  findUsersStatsInput: FindUsersStatsInput;
}>;


export type FindUsersStatsQuery = { __typename?: 'Query', findUsersStats: { __typename?: 'FindUserStatsPayload', response?: { __typename?: 'Response', status?: number | null } | null, data: { __typename?: 'FindUserStats', staff: number, orgAdmins: number, activeUsers: number } } };

export type GetUserQueryVariables = Exact<{
  getUserInput: GetUserInput;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null } | null, user?: { __typename?: 'User', id: string, email: string, phone?: string | null, lastName?: string | null, staffRole?: string | null, firstName?: string | null, organization?: { __typename?: 'Organization', id: string, name?: string | null, maxUser?: number | null, address?: { __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, state?: string | null, countryCode?: string | null } | null } | null } | null } };

export type GetStaffQueryVariables = Exact<{
  getUserInput: GetUserInput;
}>;


export type GetStaffQuery = { __typename?: 'Query', getUser: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null } | null, user?: { __typename?: 'User', id: string, email: string, phone?: string | null, lastName?: string | null, firstName?: string | null, staffRole?: string | null } | null } };

export type GetCurrentUserSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserSubscriptionQuery = { __typename?: 'Query', getCurrentUserSubscription: { __typename?: 'SubscriptionPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, subscription?: { __typename?: 'Subscription', id: string, createdAt: string, trialStart?: string | null, trialEnd?: string | null, status: SubscriptionStatus, interval?: StripeIntervalType | null, currentPeriodStart?: string | null, currentPeriodEnd?: string | null, cancelAtPeriodEnd: boolean, cancelAt?: string | null, pricingId: string } | null } };

export type GetStaffSubscriptionQueryVariables = Exact<{
  getSubscriptionInput: GetSubscriptionInput;
}>;


export type GetStaffSubscriptionQuery = { __typename?: 'Query', getStaffSubscription: { __typename?: 'SubscriptionPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, subscription?: { __typename?: 'Subscription', id: string, createdAt: string, trialStart?: string | null, trialEnd?: string | null, status: SubscriptionStatus, interval?: StripeIntervalType | null, pricingId: string, cancelAtPeriodEnd: boolean, currentPeriodStart?: string | null, currentPeriodEnd?: string | null, cancelAt?: string | null } | null } };

export type GetOrgStaffSubscriptionQueryVariables = Exact<{
  getOrgStaffSubscriptionInput: GetOrgStaffSubscriptionInput;
}>;


export type GetOrgStaffSubscriptionQuery = { __typename?: 'Query', getOrgStaffSubscription: { __typename?: 'SubscriptionPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, subscription?: { __typename?: 'Subscription', id: string, createdAt: string, trialStart?: string | null, trialEnd?: string | null, status: SubscriptionStatus, interval?: StripeIntervalType | null, pricingId: string, cancelAtPeriodEnd: boolean, currentPeriodStart?: string | null, currentPeriodEnd?: string | null, cancelAt?: string | null } | null } };

export type GetOrganizationSubscriptionQueryVariables = Exact<{
  getSubscriptionByOrgIdInput: GetSubscriptionByOrgIdInput;
}>;


export type GetOrganizationSubscriptionQuery = { __typename?: 'Query', getOrganizationSubscription: { __typename?: 'SubscriptionPayload', response?: { __typename?: 'Response', message?: string | null, status?: number | null } | null, subscription?: { __typename?: 'Subscription', id: string, trialStart?: string | null, trialEnd?: string | null, status: SubscriptionStatus, interval?: StripeIntervalType | null, cancelAtPeriodEnd: boolean, currentPeriodStart?: string | null, currentPeriodEnd?: string | null, cancelAt?: string | null } | null } };

export type GetOrgAdminQueryVariables = Exact<{
  getUserInput: GetUserInput;
}>;


export type GetOrgAdminQuery = { __typename?: 'Query', getOrgAdmin: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null } | null, user?: { __typename?: 'User', id: string, email: string, phone?: string | null, lastName?: string | null, staffRole?: string | null, firstName?: string | null, organization?: { __typename?: 'Organization', id: string, name?: string | null, maxUser?: number | null } | null } | null } };

export type LoginMutationVariables = Exact<{
  loginInput: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginPayload', token: string, response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type SignUpUserMutationVariables = Exact<{
  userSignUpInput: UserSignUpInput;
}>;


export type SignUpUserMutation = { __typename?: 'Mutation', signUpUser: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type InviteOrganizationMutationVariables = Exact<{
  inviteOrganizationInput: InviteOrganizationInput;
}>;


export type InviteOrganizationMutation = { __typename?: 'Mutation', inviteOrganization: { __typename?: 'UserPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateOrgAndUserMutationVariables = Exact<{
  updateOrgAndUserInput: UpdateOrgAndUserInput;
}>;


export type UpdateOrgAndUserMutation = { __typename?: 'Mutation', updateOrgAndUser: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdatePasswordMutationVariables = Exact<{
  updatePasswordInput: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordInput: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordPayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type ConfirmPasswordMutationVariables = Exact<{
  verifyEmailAndSetPasswordInput: VerifyUserAndUpdatePasswordInput;
}>;


export type ConfirmPasswordMutation = { __typename?: 'Mutation', verifyEmailAndSetPassword: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type ChangePasswordMutationVariables = Exact<{
  changePasswordInput: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateUserStatusMutationVariables = Exact<{
  updateUserStatusInput: UpdateUserStatusInput;
}>;


export type UpdateUserStatusMutation = { __typename?: 'Mutation', updateUserStatus: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type UpdateConsentMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateConsentMutation = { __typename?: 'Mutation', updateConsent: { __typename?: 'ResponsePayload', response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };

export type VerifyCodeMutationVariables = Exact<{
  verifyCodeInput: VerifyCodeInput;
}>;


export type VerifyCodeMutation = { __typename?: 'Mutation', verifyCode: { __typename?: 'VerifyCodePayload', token: string, response?: { __typename?: 'Response', status?: number | null, message?: string | null } | null } };


export const UpdateAddressByTypeDocument = gql`
    mutation UpdateAddressByType($input: UpdateAddressByTypeInput!) {
  updateAddressByType(updateAddressByTypeInput: $input) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateAddressByTypeMutationFn = Apollo.MutationFunction<UpdateAddressByTypeMutation, UpdateAddressByTypeMutationVariables>;

/**
 * __useUpdateAddressByTypeMutation__
 *
 * To run a mutation, you first call `useUpdateAddressByTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressByTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressByTypeMutation, { data, loading, error }] = useUpdateAddressByTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressByTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressByTypeMutation, UpdateAddressByTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressByTypeMutation, UpdateAddressByTypeMutationVariables>(UpdateAddressByTypeDocument, options);
      }
export type UpdateAddressByTypeMutationHookResult = ReturnType<typeof useUpdateAddressByTypeMutation>;
export type UpdateAddressByTypeMutationResult = Apollo.MutationResult<UpdateAddressByTypeMutation>;
export type UpdateAddressByTypeMutationOptions = Apollo.BaseMutationOptions<UpdateAddressByTypeMutation, UpdateAddressByTypeMutationVariables>;
export const GetAttachmentByTypeDocument = gql`
    query GetAttachmentByType($getAttachmentByTypeInput: GetAttachmentByTypeInput!) {
  getAttachmentByType(getAttachmentByTypeInput: $getAttachmentByTypeInput) {
    response {
      status
    }
    attachment {
      name
      attachmentUrl
    }
  }
}
    `;

/**
 * __useGetAttachmentByTypeQuery__
 *
 * To run a query within a React component, call `useGetAttachmentByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentByTypeQuery({
 *   variables: {
 *      getAttachmentByTypeInput: // value for 'getAttachmentByTypeInput'
 *   },
 * });
 */
export function useGetAttachmentByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentByTypeQuery, GetAttachmentByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentByTypeQuery, GetAttachmentByTypeQueryVariables>(GetAttachmentByTypeDocument, options);
      }
export function useGetAttachmentByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentByTypeQuery, GetAttachmentByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentByTypeQuery, GetAttachmentByTypeQueryVariables>(GetAttachmentByTypeDocument, options);
        }
export type GetAttachmentByTypeQueryHookResult = ReturnType<typeof useGetAttachmentByTypeQuery>;
export type GetAttachmentByTypeLazyQueryHookResult = ReturnType<typeof useGetAttachmentByTypeLazyQuery>;
export type GetAttachmentByTypeQueryResult = Apollo.QueryResult<GetAttachmentByTypeQuery, GetAttachmentByTypeQueryVariables>;
export const GetAttachmentDocument = gql`
    query GetAttachment($getAttachmentByTypeInput: GetAttachmentByTypeInput!) {
  getAttachmentByType(getAttachmentByTypeInput: $getAttachmentByTypeInput) {
    response {
      status
      message
    }
    attachment {
      id
      attachmentUrl
    }
  }
}
    `;

/**
 * __useGetAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentQuery({
 *   variables: {
 *      getAttachmentByTypeInput: // value for 'getAttachmentByTypeInput'
 *   },
 * });
 */
export function useGetAttachmentQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
      }
export function useGetAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
        }
export type GetAttachmentQueryHookResult = ReturnType<typeof useGetAttachmentQuery>;
export type GetAttachmentLazyQueryHookResult = ReturnType<typeof useGetAttachmentLazyQuery>;
export type GetAttachmentQueryResult = Apollo.QueryResult<GetAttachmentQuery, GetAttachmentQueryVariables>;
export const RemoveAttachmentDocument = gql`
    mutation RemoveAttachment($removeAttachmentInput: RemoveAttachmentInput!) {
  removeAttachment(removeAttachmentInput: $removeAttachmentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type RemoveAttachmentMutationFn = Apollo.MutationFunction<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>;

/**
 * __useRemoveAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentMutation, { data, loading, error }] = useRemoveAttachmentMutation({
 *   variables: {
 *      removeAttachmentInput: // value for 'removeAttachmentInput'
 *   },
 * });
 */
export function useRemoveAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>(RemoveAttachmentDocument, options);
      }
export type RemoveAttachmentMutationHookResult = ReturnType<typeof useRemoveAttachmentMutation>;
export type RemoveAttachmentMutationResult = Apollo.MutationResult<RemoveAttachmentMutation>;
export type RemoveAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>;
export const FindAllTabletCoatingDocument = gql`
    query FindAllTabletCoating($findAllTabletCoatingInput: FindAllTabletCoatingInput!) {
  findAllTabletCoating(findAllTabletCoatingInput: $findAllTabletCoatingInput) {
    response {
      status
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllTabletCoatingQuery__
 *
 * To run a query within a React component, call `useFindAllTabletCoatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllTabletCoatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllTabletCoatingQuery({
 *   variables: {
 *      findAllTabletCoatingInput: // value for 'findAllTabletCoatingInput'
 *   },
 * });
 */
export function useFindAllTabletCoatingQuery(baseOptions: Apollo.QueryHookOptions<FindAllTabletCoatingQuery, FindAllTabletCoatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllTabletCoatingQuery, FindAllTabletCoatingQueryVariables>(FindAllTabletCoatingDocument, options);
      }
export function useFindAllTabletCoatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllTabletCoatingQuery, FindAllTabletCoatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllTabletCoatingQuery, FindAllTabletCoatingQueryVariables>(FindAllTabletCoatingDocument, options);
        }
export type FindAllTabletCoatingQueryHookResult = ReturnType<typeof useFindAllTabletCoatingQuery>;
export type FindAllTabletCoatingLazyQueryHookResult = ReturnType<typeof useFindAllTabletCoatingLazyQuery>;
export type FindAllTabletCoatingQueryResult = Apollo.QueryResult<FindAllTabletCoatingQuery, FindAllTabletCoatingQueryVariables>;
export const FindAllBaseCoatingTableDocument = gql`
    query FindAllBaseCoatingTable($findAllTabletCoatingInput: FindAllTabletCoatingInput!) {
  findAllTabletCoating(findAllTabletCoatingInput: $findAllTabletCoatingInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      loadAdd
      isActive
      costPerKg
      productType {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllBaseCoatingTableQuery__
 *
 * To run a query within a React component, call `useFindAllBaseCoatingTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllBaseCoatingTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllBaseCoatingTableQuery({
 *   variables: {
 *      findAllTabletCoatingInput: // value for 'findAllTabletCoatingInput'
 *   },
 * });
 */
export function useFindAllBaseCoatingTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllBaseCoatingTableQuery, FindAllBaseCoatingTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllBaseCoatingTableQuery, FindAllBaseCoatingTableQueryVariables>(FindAllBaseCoatingTableDocument, options);
      }
export function useFindAllBaseCoatingTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllBaseCoatingTableQuery, FindAllBaseCoatingTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllBaseCoatingTableQuery, FindAllBaseCoatingTableQueryVariables>(FindAllBaseCoatingTableDocument, options);
        }
export type FindAllBaseCoatingTableQueryHookResult = ReturnType<typeof useFindAllBaseCoatingTableQuery>;
export type FindAllBaseCoatingTableLazyQueryHookResult = ReturnType<typeof useFindAllBaseCoatingTableLazyQuery>;
export type FindAllBaseCoatingTableQueryResult = Apollo.QueryResult<FindAllBaseCoatingTableQuery, FindAllBaseCoatingTableQueryVariables>;
export const GetBaseCoatingDocument = gql`
    query GetBaseCoating($getTabletCoatingInput: GetTabletCoatingInput!) {
  getTabletCoating(getTabletCoatingInput: $getTabletCoatingInput) {
    response {
      status
    }
    tabletCoating {
      id
      name
      loadAdd
      costPerKg
      productType {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetBaseCoatingQuery__
 *
 * To run a query within a React component, call `useGetBaseCoatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseCoatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseCoatingQuery({
 *   variables: {
 *      getTabletCoatingInput: // value for 'getTabletCoatingInput'
 *   },
 * });
 */
export function useGetBaseCoatingQuery(baseOptions: Apollo.QueryHookOptions<GetBaseCoatingQuery, GetBaseCoatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaseCoatingQuery, GetBaseCoatingQueryVariables>(GetBaseCoatingDocument, options);
      }
export function useGetBaseCoatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaseCoatingQuery, GetBaseCoatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaseCoatingQuery, GetBaseCoatingQueryVariables>(GetBaseCoatingDocument, options);
        }
export type GetBaseCoatingQueryHookResult = ReturnType<typeof useGetBaseCoatingQuery>;
export type GetBaseCoatingLazyQueryHookResult = ReturnType<typeof useGetBaseCoatingLazyQuery>;
export type GetBaseCoatingQueryResult = Apollo.QueryResult<GetBaseCoatingQuery, GetBaseCoatingQueryVariables>;
export const CreateBaseCoatingDocument = gql`
    mutation CreateBaseCoating($createTabletCoatingInput: CreateTabletCoatingInput!) {
  createTabletCoating(createTabletCoatingInput: $createTabletCoatingInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateBaseCoatingMutationFn = Apollo.MutationFunction<CreateBaseCoatingMutation, CreateBaseCoatingMutationVariables>;

/**
 * __useCreateBaseCoatingMutation__
 *
 * To run a mutation, you first call `useCreateBaseCoatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaseCoatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaseCoatingMutation, { data, loading, error }] = useCreateBaseCoatingMutation({
 *   variables: {
 *      createTabletCoatingInput: // value for 'createTabletCoatingInput'
 *   },
 * });
 */
export function useCreateBaseCoatingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBaseCoatingMutation, CreateBaseCoatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBaseCoatingMutation, CreateBaseCoatingMutationVariables>(CreateBaseCoatingDocument, options);
      }
export type CreateBaseCoatingMutationHookResult = ReturnType<typeof useCreateBaseCoatingMutation>;
export type CreateBaseCoatingMutationResult = Apollo.MutationResult<CreateBaseCoatingMutation>;
export type CreateBaseCoatingMutationOptions = Apollo.BaseMutationOptions<CreateBaseCoatingMutation, CreateBaseCoatingMutationVariables>;
export const UpdateBaseCoatingDocument = gql`
    mutation UpdateBaseCoating($updateTabletCoatingInput: UpdateTabletCoatingInput!) {
  updateTabletCoating(updateTabletCoatingInput: $updateTabletCoatingInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateBaseCoatingMutationFn = Apollo.MutationFunction<UpdateBaseCoatingMutation, UpdateBaseCoatingMutationVariables>;

/**
 * __useUpdateBaseCoatingMutation__
 *
 * To run a mutation, you first call `useUpdateBaseCoatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaseCoatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaseCoatingMutation, { data, loading, error }] = useUpdateBaseCoatingMutation({
 *   variables: {
 *      updateTabletCoatingInput: // value for 'updateTabletCoatingInput'
 *   },
 * });
 */
export function useUpdateBaseCoatingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaseCoatingMutation, UpdateBaseCoatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaseCoatingMutation, UpdateBaseCoatingMutationVariables>(UpdateBaseCoatingDocument, options);
      }
export type UpdateBaseCoatingMutationHookResult = ReturnType<typeof useUpdateBaseCoatingMutation>;
export type UpdateBaseCoatingMutationResult = Apollo.MutationResult<UpdateBaseCoatingMutation>;
export type UpdateBaseCoatingMutationOptions = Apollo.BaseMutationOptions<UpdateBaseCoatingMutation, UpdateBaseCoatingMutationVariables>;
export const FindAllBeadletsDocument = gql`
    query FindAllBeadlets($findAllBeadletsInput: FindAllBeadletsInput!) {
  findAllBeadlets(findAllBeadletsInput: $findAllBeadletsInput) {
    response {
      status
    }
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useFindAllBeadletsQuery__
 *
 * To run a query within a React component, call `useFindAllBeadletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllBeadletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllBeadletsQuery({
 *   variables: {
 *      findAllBeadletsInput: // value for 'findAllBeadletsInput'
 *   },
 * });
 */
export function useFindAllBeadletsQuery(baseOptions: Apollo.QueryHookOptions<FindAllBeadletsQuery, FindAllBeadletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllBeadletsQuery, FindAllBeadletsQueryVariables>(FindAllBeadletsDocument, options);
      }
export function useFindAllBeadletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllBeadletsQuery, FindAllBeadletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllBeadletsQuery, FindAllBeadletsQueryVariables>(FindAllBeadletsDocument, options);
        }
export type FindAllBeadletsQueryHookResult = ReturnType<typeof useFindAllBeadletsQuery>;
export type FindAllBeadletsLazyQueryHookResult = ReturnType<typeof useFindAllBeadletsLazyQuery>;
export type FindAllBeadletsQueryResult = Apollo.QueryResult<FindAllBeadletsQuery, FindAllBeadletsQueryVariables>;
export const FindAllBottleCapacityDocument = gql`
    query FindAllBottleCapacity($findAllBottleCapacitiesInput: FindAllBottleCapacitiesInput!) {
  findAllBottleCapacity(
    findAllBottleCapacitiesInput: $findAllBottleCapacitiesInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      lohCost
      isActive
      fillPercentage
      bottleSize {
        name
        isActive
      }
      productType {
        name
      }
      productSize {
        name
      }
      servingSize {
        size
      }
    }
  }
}
    `;

/**
 * __useFindAllBottleCapacityQuery__
 *
 * To run a query within a React component, call `useFindAllBottleCapacityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllBottleCapacityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllBottleCapacityQuery({
 *   variables: {
 *      findAllBottleCapacitiesInput: // value for 'findAllBottleCapacitiesInput'
 *   },
 * });
 */
export function useFindAllBottleCapacityQuery(baseOptions: Apollo.QueryHookOptions<FindAllBottleCapacityQuery, FindAllBottleCapacityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllBottleCapacityQuery, FindAllBottleCapacityQueryVariables>(FindAllBottleCapacityDocument, options);
      }
export function useFindAllBottleCapacityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllBottleCapacityQuery, FindAllBottleCapacityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllBottleCapacityQuery, FindAllBottleCapacityQueryVariables>(FindAllBottleCapacityDocument, options);
        }
export type FindAllBottleCapacityQueryHookResult = ReturnType<typeof useFindAllBottleCapacityQuery>;
export type FindAllBottleCapacityLazyQueryHookResult = ReturnType<typeof useFindAllBottleCapacityLazyQuery>;
export type FindAllBottleCapacityQueryResult = Apollo.QueryResult<FindAllBottleCapacityQuery, FindAllBottleCapacityQueryVariables>;
export const GetBottleCapacityDocument = gql`
    query GetBottleCapacity($findBottleCapacityInput: FindBottleCapacityInput!) {
  getBottleCapacity(findBottleCapacityInput: $findBottleCapacityInput) {
    bottleCapacity {
      lohCost
      isActive
      fillPercentage
      bottleSize {
        id
        name
      }
      productType {
        id
        name
        type
      }
      productSize {
        id
        name
      }
      servingSize {
        id
        size
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetBottleCapacityQuery__
 *
 * To run a query within a React component, call `useGetBottleCapacityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBottleCapacityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBottleCapacityQuery({
 *   variables: {
 *      findBottleCapacityInput: // value for 'findBottleCapacityInput'
 *   },
 * });
 */
export function useGetBottleCapacityQuery(baseOptions: Apollo.QueryHookOptions<GetBottleCapacityQuery, GetBottleCapacityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBottleCapacityQuery, GetBottleCapacityQueryVariables>(GetBottleCapacityDocument, options);
      }
export function useGetBottleCapacityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBottleCapacityQuery, GetBottleCapacityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBottleCapacityQuery, GetBottleCapacityQueryVariables>(GetBottleCapacityDocument, options);
        }
export type GetBottleCapacityQueryHookResult = ReturnType<typeof useGetBottleCapacityQuery>;
export type GetBottleCapacityLazyQueryHookResult = ReturnType<typeof useGetBottleCapacityLazyQuery>;
export type GetBottleCapacityQueryResult = Apollo.QueryResult<GetBottleCapacityQuery, GetBottleCapacityQueryVariables>;
export const UpdateBottleCapacityDocument = gql`
    mutation UpdateBottleCapacity($updateBottleCapacityInput: UpdateBottleCapacityInput!) {
  updateBottleCapacity(updateBottleCapacityInput: $updateBottleCapacityInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateBottleCapacityMutationFn = Apollo.MutationFunction<UpdateBottleCapacityMutation, UpdateBottleCapacityMutationVariables>;

/**
 * __useUpdateBottleCapacityMutation__
 *
 * To run a mutation, you first call `useUpdateBottleCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBottleCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBottleCapacityMutation, { data, loading, error }] = useUpdateBottleCapacityMutation({
 *   variables: {
 *      updateBottleCapacityInput: // value for 'updateBottleCapacityInput'
 *   },
 * });
 */
export function useUpdateBottleCapacityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBottleCapacityMutation, UpdateBottleCapacityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBottleCapacityMutation, UpdateBottleCapacityMutationVariables>(UpdateBottleCapacityDocument, options);
      }
export type UpdateBottleCapacityMutationHookResult = ReturnType<typeof useUpdateBottleCapacityMutation>;
export type UpdateBottleCapacityMutationResult = Apollo.MutationResult<UpdateBottleCapacityMutation>;
export type UpdateBottleCapacityMutationOptions = Apollo.BaseMutationOptions<UpdateBottleCapacityMutation, UpdateBottleCapacityMutationVariables>;
export const CreateBottleCapacityDocument = gql`
    mutation CreateBottleCapacity($createBottleCapacityInput: CreateBottleCapacityInput!) {
  createBottleCapacity(createBottleCapacityInput: $createBottleCapacityInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateBottleCapacityMutationFn = Apollo.MutationFunction<CreateBottleCapacityMutation, CreateBottleCapacityMutationVariables>;

/**
 * __useCreateBottleCapacityMutation__
 *
 * To run a mutation, you first call `useCreateBottleCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBottleCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBottleCapacityMutation, { data, loading, error }] = useCreateBottleCapacityMutation({
 *   variables: {
 *      createBottleCapacityInput: // value for 'createBottleCapacityInput'
 *   },
 * });
 */
export function useCreateBottleCapacityMutation(baseOptions?: Apollo.MutationHookOptions<CreateBottleCapacityMutation, CreateBottleCapacityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBottleCapacityMutation, CreateBottleCapacityMutationVariables>(CreateBottleCapacityDocument, options);
      }
export type CreateBottleCapacityMutationHookResult = ReturnType<typeof useCreateBottleCapacityMutation>;
export type CreateBottleCapacityMutationResult = Apollo.MutationResult<CreateBottleCapacityMutation>;
export type CreateBottleCapacityMutationOptions = Apollo.BaseMutationOptions<CreateBottleCapacityMutation, CreateBottleCapacityMutationVariables>;
export const FindAllBottlePriceDocument = gql`
    query FindAllBottlePrice($findAllBottlePricesInput: FindAllBottlePricesInput!) {
  findAllBottlePrice(findAllBottlePricesInput: $findAllBottlePricesInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      isCr
      type
      price
      isActive
      bottleSize {
        name
      }
      bottlePriceSuppliers {
        supplier {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllBottlePriceQuery__
 *
 * To run a query within a React component, call `useFindAllBottlePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllBottlePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllBottlePriceQuery({
 *   variables: {
 *      findAllBottlePricesInput: // value for 'findAllBottlePricesInput'
 *   },
 * });
 */
export function useFindAllBottlePriceQuery(baseOptions: Apollo.QueryHookOptions<FindAllBottlePriceQuery, FindAllBottlePriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllBottlePriceQuery, FindAllBottlePriceQueryVariables>(FindAllBottlePriceDocument, options);
      }
export function useFindAllBottlePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllBottlePriceQuery, FindAllBottlePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllBottlePriceQuery, FindAllBottlePriceQueryVariables>(FindAllBottlePriceDocument, options);
        }
export type FindAllBottlePriceQueryHookResult = ReturnType<typeof useFindAllBottlePriceQuery>;
export type FindAllBottlePriceLazyQueryHookResult = ReturnType<typeof useFindAllBottlePriceLazyQuery>;
export type FindAllBottlePriceQueryResult = Apollo.QueryResult<FindAllBottlePriceQuery, FindAllBottlePriceQueryVariables>;
export const GetBottlePriceDocument = gql`
    query GetBottlePrice($getBottlePriceInput: GetBottlePriceInput!) {
  getBottlePrice(getBottlePriceInput: $getBottlePriceInput) {
    bottlePrice {
      id
      type
      isCr
      price
      isActive
      bottleSize {
        id
        name
      }
      bottlePriceSuppliers {
        supplier {
          id
          name
        }
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetBottlePriceQuery__
 *
 * To run a query within a React component, call `useGetBottlePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBottlePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBottlePriceQuery({
 *   variables: {
 *      getBottlePriceInput: // value for 'getBottlePriceInput'
 *   },
 * });
 */
export function useGetBottlePriceQuery(baseOptions: Apollo.QueryHookOptions<GetBottlePriceQuery, GetBottlePriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBottlePriceQuery, GetBottlePriceQueryVariables>(GetBottlePriceDocument, options);
      }
export function useGetBottlePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBottlePriceQuery, GetBottlePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBottlePriceQuery, GetBottlePriceQueryVariables>(GetBottlePriceDocument, options);
        }
export type GetBottlePriceQueryHookResult = ReturnType<typeof useGetBottlePriceQuery>;
export type GetBottlePriceLazyQueryHookResult = ReturnType<typeof useGetBottlePriceLazyQuery>;
export type GetBottlePriceQueryResult = Apollo.QueryResult<GetBottlePriceQuery, GetBottlePriceQueryVariables>;
export const UpdateBottlePriceDocument = gql`
    mutation updateBottlePrice($updateBottlePriceInput: UpdateBottlePriceInput!) {
  updateBottlePrice(updateBottlePriceInput: $updateBottlePriceInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateBottlePriceMutationFn = Apollo.MutationFunction<UpdateBottlePriceMutation, UpdateBottlePriceMutationVariables>;

/**
 * __useUpdateBottlePriceMutation__
 *
 * To run a mutation, you first call `useUpdateBottlePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBottlePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBottlePriceMutation, { data, loading, error }] = useUpdateBottlePriceMutation({
 *   variables: {
 *      updateBottlePriceInput: // value for 'updateBottlePriceInput'
 *   },
 * });
 */
export function useUpdateBottlePriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBottlePriceMutation, UpdateBottlePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBottlePriceMutation, UpdateBottlePriceMutationVariables>(UpdateBottlePriceDocument, options);
      }
export type UpdateBottlePriceMutationHookResult = ReturnType<typeof useUpdateBottlePriceMutation>;
export type UpdateBottlePriceMutationResult = Apollo.MutationResult<UpdateBottlePriceMutation>;
export type UpdateBottlePriceMutationOptions = Apollo.BaseMutationOptions<UpdateBottlePriceMutation, UpdateBottlePriceMutationVariables>;
export const CreateBottlePriceDocument = gql`
    mutation createBottlePrice($createBottlePriceInput: CreateBottlePriceInput!) {
  createBottlePrice(createBottlePriceInput: $createBottlePriceInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateBottlePriceMutationFn = Apollo.MutationFunction<CreateBottlePriceMutation, CreateBottlePriceMutationVariables>;

/**
 * __useCreateBottlePriceMutation__
 *
 * To run a mutation, you first call `useCreateBottlePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBottlePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBottlePriceMutation, { data, loading, error }] = useCreateBottlePriceMutation({
 *   variables: {
 *      createBottlePriceInput: // value for 'createBottlePriceInput'
 *   },
 * });
 */
export function useCreateBottlePriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateBottlePriceMutation, CreateBottlePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBottlePriceMutation, CreateBottlePriceMutationVariables>(CreateBottlePriceDocument, options);
      }
export type CreateBottlePriceMutationHookResult = ReturnType<typeof useCreateBottlePriceMutation>;
export type CreateBottlePriceMutationResult = Apollo.MutationResult<CreateBottlePriceMutation>;
export type CreateBottlePriceMutationOptions = Apollo.BaseMutationOptions<CreateBottlePriceMutation, CreateBottlePriceMutationVariables>;
export const FindAllBottleSizeDocument = gql`
    query FindAllBottleSize($findAllBottleSizesInput: FindAllBottleSizesInput!) {
  findAllBottleSize(findAllBottleSizesInput: $findAllBottleSizesInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      cc
      oz
      name
      lidSize
      isActive
      bottleSizeProductTypes {
        productType {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllBottleSizeQuery__
 *
 * To run a query within a React component, call `useFindAllBottleSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllBottleSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllBottleSizeQuery({
 *   variables: {
 *      findAllBottleSizesInput: // value for 'findAllBottleSizesInput'
 *   },
 * });
 */
export function useFindAllBottleSizeQuery(baseOptions: Apollo.QueryHookOptions<FindAllBottleSizeQuery, FindAllBottleSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllBottleSizeQuery, FindAllBottleSizeQueryVariables>(FindAllBottleSizeDocument, options);
      }
export function useFindAllBottleSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllBottleSizeQuery, FindAllBottleSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllBottleSizeQuery, FindAllBottleSizeQueryVariables>(FindAllBottleSizeDocument, options);
        }
export type FindAllBottleSizeQueryHookResult = ReturnType<typeof useFindAllBottleSizeQuery>;
export type FindAllBottleSizeLazyQueryHookResult = ReturnType<typeof useFindAllBottleSizeLazyQuery>;
export type FindAllBottleSizeQueryResult = Apollo.QueryResult<FindAllBottleSizeQuery, FindAllBottleSizeQueryVariables>;
export const FindAllBottleSizeSelectorDocument = gql`
    query FindAllBottleSizeSelector($findAllBottleSizesInput: FindAllBottleSizesInput!) {
  findAllBottleSize(findAllBottleSizesInput: $findAllBottleSizesInput) {
    response {
      status
    }
    pagination {
      totalPages
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllBottleSizeSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllBottleSizeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllBottleSizeSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllBottleSizeSelectorQuery({
 *   variables: {
 *      findAllBottleSizesInput: // value for 'findAllBottleSizesInput'
 *   },
 * });
 */
export function useFindAllBottleSizeSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllBottleSizeSelectorQuery, FindAllBottleSizeSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllBottleSizeSelectorQuery, FindAllBottleSizeSelectorQueryVariables>(FindAllBottleSizeSelectorDocument, options);
      }
export function useFindAllBottleSizeSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllBottleSizeSelectorQuery, FindAllBottleSizeSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllBottleSizeSelectorQuery, FindAllBottleSizeSelectorQueryVariables>(FindAllBottleSizeSelectorDocument, options);
        }
export type FindAllBottleSizeSelectorQueryHookResult = ReturnType<typeof useFindAllBottleSizeSelectorQuery>;
export type FindAllBottleSizeSelectorLazyQueryHookResult = ReturnType<typeof useFindAllBottleSizeSelectorLazyQuery>;
export type FindAllBottleSizeSelectorQueryResult = Apollo.QueryResult<FindAllBottleSizeSelectorQuery, FindAllBottleSizeSelectorQueryVariables>;
export const GetBottleSizeDocument = gql`
    query GetBottleSize($getBottleSizeInput: GetBottleSizeInput!) {
  getBottleSize(getBottleSizeInput: $getBottleSizeInput) {
    bottleSize {
      id
      cc
      oz
      name
      lidSize
      bottleSizeProductTypes {
        productType {
          id
          name
        }
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetBottleSizeQuery__
 *
 * To run a query within a React component, call `useGetBottleSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBottleSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBottleSizeQuery({
 *   variables: {
 *      getBottleSizeInput: // value for 'getBottleSizeInput'
 *   },
 * });
 */
export function useGetBottleSizeQuery(baseOptions: Apollo.QueryHookOptions<GetBottleSizeQuery, GetBottleSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBottleSizeQuery, GetBottleSizeQueryVariables>(GetBottleSizeDocument, options);
      }
export function useGetBottleSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBottleSizeQuery, GetBottleSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBottleSizeQuery, GetBottleSizeQueryVariables>(GetBottleSizeDocument, options);
        }
export type GetBottleSizeQueryHookResult = ReturnType<typeof useGetBottleSizeQuery>;
export type GetBottleSizeLazyQueryHookResult = ReturnType<typeof useGetBottleSizeLazyQuery>;
export type GetBottleSizeQueryResult = Apollo.QueryResult<GetBottleSizeQuery, GetBottleSizeQueryVariables>;
export const UpdateBottleSizeDocument = gql`
    mutation UpdateBottleSize($updateBottleSizeInput: UpdateBottleSizeInput!) {
  updateBottleSize(updateBottleSizeInput: $updateBottleSizeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateBottleSizeMutationFn = Apollo.MutationFunction<UpdateBottleSizeMutation, UpdateBottleSizeMutationVariables>;

/**
 * __useUpdateBottleSizeMutation__
 *
 * To run a mutation, you first call `useUpdateBottleSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBottleSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBottleSizeMutation, { data, loading, error }] = useUpdateBottleSizeMutation({
 *   variables: {
 *      updateBottleSizeInput: // value for 'updateBottleSizeInput'
 *   },
 * });
 */
export function useUpdateBottleSizeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBottleSizeMutation, UpdateBottleSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBottleSizeMutation, UpdateBottleSizeMutationVariables>(UpdateBottleSizeDocument, options);
      }
export type UpdateBottleSizeMutationHookResult = ReturnType<typeof useUpdateBottleSizeMutation>;
export type UpdateBottleSizeMutationResult = Apollo.MutationResult<UpdateBottleSizeMutation>;
export type UpdateBottleSizeMutationOptions = Apollo.BaseMutationOptions<UpdateBottleSizeMutation, UpdateBottleSizeMutationVariables>;
export const CreateBottleSizeDocument = gql`
    mutation CreateBottleSize($createBottleSizeInput: CreateBottleSizeInput!) {
  createBottleSize(createBottleSizeInput: $createBottleSizeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateBottleSizeMutationFn = Apollo.MutationFunction<CreateBottleSizeMutation, CreateBottleSizeMutationVariables>;

/**
 * __useCreateBottleSizeMutation__
 *
 * To run a mutation, you first call `useCreateBottleSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBottleSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBottleSizeMutation, { data, loading, error }] = useCreateBottleSizeMutation({
 *   variables: {
 *      createBottleSizeInput: // value for 'createBottleSizeInput'
 *   },
 * });
 */
export function useCreateBottleSizeMutation(baseOptions?: Apollo.MutationHookOptions<CreateBottleSizeMutation, CreateBottleSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBottleSizeMutation, CreateBottleSizeMutationVariables>(CreateBottleSizeDocument, options);
      }
export type CreateBottleSizeMutationHookResult = ReturnType<typeof useCreateBottleSizeMutation>;
export type CreateBottleSizeMutationResult = Apollo.MutationResult<CreateBottleSizeMutation>;
export type CreateBottleSizeMutationOptions = Apollo.BaseMutationOptions<CreateBottleSizeMutation, CreateBottleSizeMutationVariables>;
export const UpdateBottleSizeStatusDocument = gql`
    mutation UpdateBottleSizeStatus($updateBottleSizeStatusInput: UpdateBottleSizeStatusInput!) {
  updateBottleSizeStatus(
    updateBottleSizeStatusInput: $updateBottleSizeStatusInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateBottleSizeStatusMutationFn = Apollo.MutationFunction<UpdateBottleSizeStatusMutation, UpdateBottleSizeStatusMutationVariables>;

/**
 * __useUpdateBottleSizeStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBottleSizeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBottleSizeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBottleSizeStatusMutation, { data, loading, error }] = useUpdateBottleSizeStatusMutation({
 *   variables: {
 *      updateBottleSizeStatusInput: // value for 'updateBottleSizeStatusInput'
 *   },
 * });
 */
export function useUpdateBottleSizeStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBottleSizeStatusMutation, UpdateBottleSizeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBottleSizeStatusMutation, UpdateBottleSizeStatusMutationVariables>(UpdateBottleSizeStatusDocument, options);
      }
export type UpdateBottleSizeStatusMutationHookResult = ReturnType<typeof useUpdateBottleSizeStatusMutation>;
export type UpdateBottleSizeStatusMutationResult = Apollo.MutationResult<UpdateBottleSizeStatusMutation>;
export type UpdateBottleSizeStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBottleSizeStatusMutation, UpdateBottleSizeStatusMutationVariables>;
export const FindAllCapsulePricesTableDocument = gql`
    query FindAllCapsulePricesTable($findAllCapsulePricesInput: FindAllCapsulePricesInput!) {
  findAllCapsulePrices(findAllCapsulePricesInput: $findAllCapsulePricesInput) {
    data {
      id
      price
      isActive
      capacity
      density {
        name
      }
      supplier {
        name
      }
      productSize {
        name
      }
      capsuleType {
        name
      }
    }
    response {
      status
    }
    pagination {
      page
      totalCount
    }
  }
}
    `;

/**
 * __useFindAllCapsulePricesTableQuery__
 *
 * To run a query within a React component, call `useFindAllCapsulePricesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCapsulePricesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCapsulePricesTableQuery({
 *   variables: {
 *      findAllCapsulePricesInput: // value for 'findAllCapsulePricesInput'
 *   },
 * });
 */
export function useFindAllCapsulePricesTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllCapsulePricesTableQuery, FindAllCapsulePricesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCapsulePricesTableQuery, FindAllCapsulePricesTableQueryVariables>(FindAllCapsulePricesTableDocument, options);
      }
export function useFindAllCapsulePricesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCapsulePricesTableQuery, FindAllCapsulePricesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCapsulePricesTableQuery, FindAllCapsulePricesTableQueryVariables>(FindAllCapsulePricesTableDocument, options);
        }
export type FindAllCapsulePricesTableQueryHookResult = ReturnType<typeof useFindAllCapsulePricesTableQuery>;
export type FindAllCapsulePricesTableLazyQueryHookResult = ReturnType<typeof useFindAllCapsulePricesTableLazyQuery>;
export type FindAllCapsulePricesTableQueryResult = Apollo.QueryResult<FindAllCapsulePricesTableQuery, FindAllCapsulePricesTableQueryVariables>;
export const GetCapsulePriceDocument = gql`
    query GetCapsulePrice($getCapsulePriceInput: GetCapsulePriceInput!) {
  getCapsulePrice(getCapsulePriceInput: $getCapsulePriceInput) {
    capsulePrice {
      id
      price
      capacity
      density {
        id
        name
      }
      supplier {
        id
        name
      }
      productSize {
        id
        name
      }
      capsuleType {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetCapsulePriceQuery__
 *
 * To run a query within a React component, call `useGetCapsulePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapsulePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapsulePriceQuery({
 *   variables: {
 *      getCapsulePriceInput: // value for 'getCapsulePriceInput'
 *   },
 * });
 */
export function useGetCapsulePriceQuery(baseOptions: Apollo.QueryHookOptions<GetCapsulePriceQuery, GetCapsulePriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapsulePriceQuery, GetCapsulePriceQueryVariables>(GetCapsulePriceDocument, options);
      }
export function useGetCapsulePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapsulePriceQuery, GetCapsulePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapsulePriceQuery, GetCapsulePriceQueryVariables>(GetCapsulePriceDocument, options);
        }
export type GetCapsulePriceQueryHookResult = ReturnType<typeof useGetCapsulePriceQuery>;
export type GetCapsulePriceLazyQueryHookResult = ReturnType<typeof useGetCapsulePriceLazyQuery>;
export type GetCapsulePriceQueryResult = Apollo.QueryResult<GetCapsulePriceQuery, GetCapsulePriceQueryVariables>;
export const CreateCapsulePriceDocument = gql`
    mutation CreateCapsulePrice($createCapsulePriceInput: CreateCapsulePriceInput!) {
  createCapsulePrice(createCapsulePriceInput: $createCapsulePriceInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateCapsulePriceMutationFn = Apollo.MutationFunction<CreateCapsulePriceMutation, CreateCapsulePriceMutationVariables>;

/**
 * __useCreateCapsulePriceMutation__
 *
 * To run a mutation, you first call `useCreateCapsulePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapsulePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapsulePriceMutation, { data, loading, error }] = useCreateCapsulePriceMutation({
 *   variables: {
 *      createCapsulePriceInput: // value for 'createCapsulePriceInput'
 *   },
 * });
 */
export function useCreateCapsulePriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateCapsulePriceMutation, CreateCapsulePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCapsulePriceMutation, CreateCapsulePriceMutationVariables>(CreateCapsulePriceDocument, options);
      }
export type CreateCapsulePriceMutationHookResult = ReturnType<typeof useCreateCapsulePriceMutation>;
export type CreateCapsulePriceMutationResult = Apollo.MutationResult<CreateCapsulePriceMutation>;
export type CreateCapsulePriceMutationOptions = Apollo.BaseMutationOptions<CreateCapsulePriceMutation, CreateCapsulePriceMutationVariables>;
export const UpdateCapsulePriceDocument = gql`
    mutation UpdateCapsulePrice($updateCapsulePriceInput: UpdateCapsulePriceInput!) {
  updateCapsulePrice(updateCapsulePriceInput: $updateCapsulePriceInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateCapsulePriceMutationFn = Apollo.MutationFunction<UpdateCapsulePriceMutation, UpdateCapsulePriceMutationVariables>;

/**
 * __useUpdateCapsulePriceMutation__
 *
 * To run a mutation, you first call `useUpdateCapsulePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapsulePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapsulePriceMutation, { data, loading, error }] = useUpdateCapsulePriceMutation({
 *   variables: {
 *      updateCapsulePriceInput: // value for 'updateCapsulePriceInput'
 *   },
 * });
 */
export function useUpdateCapsulePriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCapsulePriceMutation, UpdateCapsulePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCapsulePriceMutation, UpdateCapsulePriceMutationVariables>(UpdateCapsulePriceDocument, options);
      }
export type UpdateCapsulePriceMutationHookResult = ReturnType<typeof useUpdateCapsulePriceMutation>;
export type UpdateCapsulePriceMutationResult = Apollo.MutationResult<UpdateCapsulePriceMutation>;
export type UpdateCapsulePriceMutationOptions = Apollo.BaseMutationOptions<UpdateCapsulePriceMutation, UpdateCapsulePriceMutationVariables>;
export const FindAllCapsuleTypeRadioGroupDocument = gql`
    query FindAllCapsuleTypeRadioGroup($findAllCapsuleTypesInput: FindAllCapsuleTypesInput!) {
  findAllCapsuleType(findAllCapsuleTypesInput: $findAllCapsuleTypesInput) {
    data {
      id
      name
      description
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllCapsuleTypeRadioGroupQuery__
 *
 * To run a query within a React component, call `useFindAllCapsuleTypeRadioGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCapsuleTypeRadioGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCapsuleTypeRadioGroupQuery({
 *   variables: {
 *      findAllCapsuleTypesInput: // value for 'findAllCapsuleTypesInput'
 *   },
 * });
 */
export function useFindAllCapsuleTypeRadioGroupQuery(baseOptions: Apollo.QueryHookOptions<FindAllCapsuleTypeRadioGroupQuery, FindAllCapsuleTypeRadioGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCapsuleTypeRadioGroupQuery, FindAllCapsuleTypeRadioGroupQueryVariables>(FindAllCapsuleTypeRadioGroupDocument, options);
      }
export function useFindAllCapsuleTypeRadioGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCapsuleTypeRadioGroupQuery, FindAllCapsuleTypeRadioGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCapsuleTypeRadioGroupQuery, FindAllCapsuleTypeRadioGroupQueryVariables>(FindAllCapsuleTypeRadioGroupDocument, options);
        }
export type FindAllCapsuleTypeRadioGroupQueryHookResult = ReturnType<typeof useFindAllCapsuleTypeRadioGroupQuery>;
export type FindAllCapsuleTypeRadioGroupLazyQueryHookResult = ReturnType<typeof useFindAllCapsuleTypeRadioGroupLazyQuery>;
export type FindAllCapsuleTypeRadioGroupQueryResult = Apollo.QueryResult<FindAllCapsuleTypeRadioGroupQuery, FindAllCapsuleTypeRadioGroupQueryVariables>;
export const FindAllCapsuleTypeSelectorDocument = gql`
    query FindAllCapsuleTypeSelector($findAllCapsuleTypesInput: FindAllCapsuleTypesInput!) {
  findAllCapsuleType(findAllCapsuleTypesInput: $findAllCapsuleTypesInput) {
    data {
      id
      name
      isActive
      description
    }
    response {
      status
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllCapsuleTypeSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllCapsuleTypeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCapsuleTypeSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCapsuleTypeSelectorQuery({
 *   variables: {
 *      findAllCapsuleTypesInput: // value for 'findAllCapsuleTypesInput'
 *   },
 * });
 */
export function useFindAllCapsuleTypeSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllCapsuleTypeSelectorQuery, FindAllCapsuleTypeSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCapsuleTypeSelectorQuery, FindAllCapsuleTypeSelectorQueryVariables>(FindAllCapsuleTypeSelectorDocument, options);
      }
export function useFindAllCapsuleTypeSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCapsuleTypeSelectorQuery, FindAllCapsuleTypeSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCapsuleTypeSelectorQuery, FindAllCapsuleTypeSelectorQueryVariables>(FindAllCapsuleTypeSelectorDocument, options);
        }
export type FindAllCapsuleTypeSelectorQueryHookResult = ReturnType<typeof useFindAllCapsuleTypeSelectorQuery>;
export type FindAllCapsuleTypeSelectorLazyQueryHookResult = ReturnType<typeof useFindAllCapsuleTypeSelectorLazyQuery>;
export type FindAllCapsuleTypeSelectorQueryResult = Apollo.QueryResult<FindAllCapsuleTypeSelectorQuery, FindAllCapsuleTypeSelectorQueryVariables>;
export const FindAllCapsuleTypeTableDocument = gql`
    query FindAllCapsuleTypeTable($findAllCapsuleTypesInput: FindAllCapsuleTypesInput!) {
  findAllCapsuleType(findAllCapsuleTypesInput: $findAllCapsuleTypesInput) {
    data {
      id
      name
      isActive
      description
    }
    response {
      status
    }
    pagination {
      page
      totalCount
    }
  }
}
    `;

/**
 * __useFindAllCapsuleTypeTableQuery__
 *
 * To run a query within a React component, call `useFindAllCapsuleTypeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCapsuleTypeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCapsuleTypeTableQuery({
 *   variables: {
 *      findAllCapsuleTypesInput: // value for 'findAllCapsuleTypesInput'
 *   },
 * });
 */
export function useFindAllCapsuleTypeTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllCapsuleTypeTableQuery, FindAllCapsuleTypeTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCapsuleTypeTableQuery, FindAllCapsuleTypeTableQueryVariables>(FindAllCapsuleTypeTableDocument, options);
      }
export function useFindAllCapsuleTypeTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCapsuleTypeTableQuery, FindAllCapsuleTypeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCapsuleTypeTableQuery, FindAllCapsuleTypeTableQueryVariables>(FindAllCapsuleTypeTableDocument, options);
        }
export type FindAllCapsuleTypeTableQueryHookResult = ReturnType<typeof useFindAllCapsuleTypeTableQuery>;
export type FindAllCapsuleTypeTableLazyQueryHookResult = ReturnType<typeof useFindAllCapsuleTypeTableLazyQuery>;
export type FindAllCapsuleTypeTableQueryResult = Apollo.QueryResult<FindAllCapsuleTypeTableQuery, FindAllCapsuleTypeTableQueryVariables>;
export const GetCapsuleTypeDocument = gql`
    query GetCapsuleType($getCapsuleTypeInput: GetCapsuleTypeInput!) {
  getCapsuleType(getCapsuleTypeInput: $getCapsuleTypeInput) {
    capsuleType {
      id
      name
      description
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetCapsuleTypeQuery__
 *
 * To run a query within a React component, call `useGetCapsuleTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapsuleTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapsuleTypeQuery({
 *   variables: {
 *      getCapsuleTypeInput: // value for 'getCapsuleTypeInput'
 *   },
 * });
 */
export function useGetCapsuleTypeQuery(baseOptions: Apollo.QueryHookOptions<GetCapsuleTypeQuery, GetCapsuleTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapsuleTypeQuery, GetCapsuleTypeQueryVariables>(GetCapsuleTypeDocument, options);
      }
export function useGetCapsuleTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapsuleTypeQuery, GetCapsuleTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapsuleTypeQuery, GetCapsuleTypeQueryVariables>(GetCapsuleTypeDocument, options);
        }
export type GetCapsuleTypeQueryHookResult = ReturnType<typeof useGetCapsuleTypeQuery>;
export type GetCapsuleTypeLazyQueryHookResult = ReturnType<typeof useGetCapsuleTypeLazyQuery>;
export type GetCapsuleTypeQueryResult = Apollo.QueryResult<GetCapsuleTypeQuery, GetCapsuleTypeQueryVariables>;
export const CreateCapsuleTypeDocument = gql`
    mutation CreateCapsuleType($createCapsuleTypeInput: CreateCapsuleTypeInput!) {
  createCapsuleType(createCapsuleTypeInput: $createCapsuleTypeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateCapsuleTypeMutationFn = Apollo.MutationFunction<CreateCapsuleTypeMutation, CreateCapsuleTypeMutationVariables>;

/**
 * __useCreateCapsuleTypeMutation__
 *
 * To run a mutation, you first call `useCreateCapsuleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapsuleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapsuleTypeMutation, { data, loading, error }] = useCreateCapsuleTypeMutation({
 *   variables: {
 *      createCapsuleTypeInput: // value for 'createCapsuleTypeInput'
 *   },
 * });
 */
export function useCreateCapsuleTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCapsuleTypeMutation, CreateCapsuleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCapsuleTypeMutation, CreateCapsuleTypeMutationVariables>(CreateCapsuleTypeDocument, options);
      }
export type CreateCapsuleTypeMutationHookResult = ReturnType<typeof useCreateCapsuleTypeMutation>;
export type CreateCapsuleTypeMutationResult = Apollo.MutationResult<CreateCapsuleTypeMutation>;
export type CreateCapsuleTypeMutationOptions = Apollo.BaseMutationOptions<CreateCapsuleTypeMutation, CreateCapsuleTypeMutationVariables>;
export const UpdateCapsuleTypeDocument = gql`
    mutation UpdateCapsuleType($updateCapsuleTypeInput: UpdateCapsuleTypeInput!) {
  updateCapsuleType(updateCapsuleTypeInput: $updateCapsuleTypeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateCapsuleTypeMutationFn = Apollo.MutationFunction<UpdateCapsuleTypeMutation, UpdateCapsuleTypeMutationVariables>;

/**
 * __useUpdateCapsuleTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCapsuleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapsuleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapsuleTypeMutation, { data, loading, error }] = useUpdateCapsuleTypeMutation({
 *   variables: {
 *      updateCapsuleTypeInput: // value for 'updateCapsuleTypeInput'
 *   },
 * });
 */
export function useUpdateCapsuleTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCapsuleTypeMutation, UpdateCapsuleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCapsuleTypeMutation, UpdateCapsuleTypeMutationVariables>(UpdateCapsuleTypeDocument, options);
      }
export type UpdateCapsuleTypeMutationHookResult = ReturnType<typeof useUpdateCapsuleTypeMutation>;
export type UpdateCapsuleTypeMutationResult = Apollo.MutationResult<UpdateCapsuleTypeMutation>;
export type UpdateCapsuleTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCapsuleTypeMutation, UpdateCapsuleTypeMutationVariables>;
export const FindAllCategoryForSelectorDocument = gql`
    query FindAllCategoryForSelector($findAllCategoriesInput: FindAllCategoriesInput!) {
  findAllCategories(findAllCategoriesInput: $findAllCategoriesInput) {
    data {
      id
      name
    }
    response {
      status
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllCategoryForSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllCategoryForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCategoryForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCategoryForSelectorQuery({
 *   variables: {
 *      findAllCategoriesInput: // value for 'findAllCategoriesInput'
 *   },
 * });
 */
export function useFindAllCategoryForSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllCategoryForSelectorQuery, FindAllCategoryForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCategoryForSelectorQuery, FindAllCategoryForSelectorQueryVariables>(FindAllCategoryForSelectorDocument, options);
      }
export function useFindAllCategoryForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCategoryForSelectorQuery, FindAllCategoryForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCategoryForSelectorQuery, FindAllCategoryForSelectorQueryVariables>(FindAllCategoryForSelectorDocument, options);
        }
export type FindAllCategoryForSelectorQueryHookResult = ReturnType<typeof useFindAllCategoryForSelectorQuery>;
export type FindAllCategoryForSelectorLazyQueryHookResult = ReturnType<typeof useFindAllCategoryForSelectorLazyQuery>;
export type FindAllCategoryForSelectorQueryResult = Apollo.QueryResult<FindAllCategoryForSelectorQuery, FindAllCategoryForSelectorQueryVariables>;
export const FindAllCoatingFormulationComponentDocument = gql`
    query FindAllCoatingFormulationComponent($getSandCoatingFormulationInput: GetSandCoatingFormulationInput!) {
  getSandCoatingFormulation(
    getSandCoatingFormulationInput: $getSandCoatingFormulationInput
  ) {
    response {
      status
    }
    sandCoatingFormulation {
      id
      cost
      weight
      unit
      isActive
      productSize {
        name
      }
      sandCoating {
        name
      }
      productType {
        name
      }
      subProductType {
        name
      }
      coatingFormulationComponent {
        id
        weight
        unit
        sandComponent {
          id
          name
          isActive
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllCoatingFormulationComponentQuery__
 *
 * To run a query within a React component, call `useFindAllCoatingFormulationComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCoatingFormulationComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCoatingFormulationComponentQuery({
 *   variables: {
 *      getSandCoatingFormulationInput: // value for 'getSandCoatingFormulationInput'
 *   },
 * });
 */
export function useFindAllCoatingFormulationComponentQuery(baseOptions: Apollo.QueryHookOptions<FindAllCoatingFormulationComponentQuery, FindAllCoatingFormulationComponentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCoatingFormulationComponentQuery, FindAllCoatingFormulationComponentQueryVariables>(FindAllCoatingFormulationComponentDocument, options);
      }
export function useFindAllCoatingFormulationComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCoatingFormulationComponentQuery, FindAllCoatingFormulationComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCoatingFormulationComponentQuery, FindAllCoatingFormulationComponentQueryVariables>(FindAllCoatingFormulationComponentDocument, options);
        }
export type FindAllCoatingFormulationComponentQueryHookResult = ReturnType<typeof useFindAllCoatingFormulationComponentQuery>;
export type FindAllCoatingFormulationComponentLazyQueryHookResult = ReturnType<typeof useFindAllCoatingFormulationComponentLazyQuery>;
export type FindAllCoatingFormulationComponentQueryResult = Apollo.QueryResult<FindAllCoatingFormulationComponentQuery, FindAllCoatingFormulationComponentQueryVariables>;
export const UpdateCoatingFormulationComponentDocument = gql`
    mutation UpdateCoatingFormulationComponent($updateCoatingFormulationComponentInput: UpdateCoatingFormulationComponentInput!) {
  updateCoatingFormulationComponent(
    updateCoatingFormulationComponentInput: $updateCoatingFormulationComponentInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateCoatingFormulationComponentMutationFn = Apollo.MutationFunction<UpdateCoatingFormulationComponentMutation, UpdateCoatingFormulationComponentMutationVariables>;

/**
 * __useUpdateCoatingFormulationComponentMutation__
 *
 * To run a mutation, you first call `useUpdateCoatingFormulationComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoatingFormulationComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoatingFormulationComponentMutation, { data, loading, error }] = useUpdateCoatingFormulationComponentMutation({
 *   variables: {
 *      updateCoatingFormulationComponentInput: // value for 'updateCoatingFormulationComponentInput'
 *   },
 * });
 */
export function useUpdateCoatingFormulationComponentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoatingFormulationComponentMutation, UpdateCoatingFormulationComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoatingFormulationComponentMutation, UpdateCoatingFormulationComponentMutationVariables>(UpdateCoatingFormulationComponentDocument, options);
      }
export type UpdateCoatingFormulationComponentMutationHookResult = ReturnType<typeof useUpdateCoatingFormulationComponentMutation>;
export type UpdateCoatingFormulationComponentMutationResult = Apollo.MutationResult<UpdateCoatingFormulationComponentMutation>;
export type UpdateCoatingFormulationComponentMutationOptions = Apollo.BaseMutationOptions<UpdateCoatingFormulationComponentMutation, UpdateCoatingFormulationComponentMutationVariables>;
export const CreateCoatingFormulationComponentDocument = gql`
    mutation CreateCoatingFormulationComponent($createCoatingFormulationComponentInput: CreateCoatingFormulationComponentInput!) {
  createCoatingFormulationComponent(
    createCoatingFormulationComponentInput: $createCoatingFormulationComponentInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateCoatingFormulationComponentMutationFn = Apollo.MutationFunction<CreateCoatingFormulationComponentMutation, CreateCoatingFormulationComponentMutationVariables>;

/**
 * __useCreateCoatingFormulationComponentMutation__
 *
 * To run a mutation, you first call `useCreateCoatingFormulationComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoatingFormulationComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoatingFormulationComponentMutation, { data, loading, error }] = useCreateCoatingFormulationComponentMutation({
 *   variables: {
 *      createCoatingFormulationComponentInput: // value for 'createCoatingFormulationComponentInput'
 *   },
 * });
 */
export function useCreateCoatingFormulationComponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoatingFormulationComponentMutation, CreateCoatingFormulationComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoatingFormulationComponentMutation, CreateCoatingFormulationComponentMutationVariables>(CreateCoatingFormulationComponentDocument, options);
      }
export type CreateCoatingFormulationComponentMutationHookResult = ReturnType<typeof useCreateCoatingFormulationComponentMutation>;
export type CreateCoatingFormulationComponentMutationResult = Apollo.MutationResult<CreateCoatingFormulationComponentMutation>;
export type CreateCoatingFormulationComponentMutationOptions = Apollo.BaseMutationOptions<CreateCoatingFormulationComponentMutation, CreateCoatingFormulationComponentMutationVariables>;
export const RemoveCoatingFormulationComponentDocument = gql`
    mutation RemoveCoatingFormulationComponent($removeCoatingFormulationComponentInput: RemoveCoatingFormulationComponentInput!) {
  removeCoatingFormulationComponent(
    removeCoatingFormulationComponentInput: $removeCoatingFormulationComponentInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type RemoveCoatingFormulationComponentMutationFn = Apollo.MutationFunction<RemoveCoatingFormulationComponentMutation, RemoveCoatingFormulationComponentMutationVariables>;

/**
 * __useRemoveCoatingFormulationComponentMutation__
 *
 * To run a mutation, you first call `useRemoveCoatingFormulationComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoatingFormulationComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoatingFormulationComponentMutation, { data, loading, error }] = useRemoveCoatingFormulationComponentMutation({
 *   variables: {
 *      removeCoatingFormulationComponentInput: // value for 'removeCoatingFormulationComponentInput'
 *   },
 * });
 */
export function useRemoveCoatingFormulationComponentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCoatingFormulationComponentMutation, RemoveCoatingFormulationComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCoatingFormulationComponentMutation, RemoveCoatingFormulationComponentMutationVariables>(RemoveCoatingFormulationComponentDocument, options);
      }
export type RemoveCoatingFormulationComponentMutationHookResult = ReturnType<typeof useRemoveCoatingFormulationComponentMutation>;
export type RemoveCoatingFormulationComponentMutationResult = Apollo.MutationResult<RemoveCoatingFormulationComponentMutation>;
export type RemoveCoatingFormulationComponentMutationOptions = Apollo.BaseMutationOptions<RemoveCoatingFormulationComponentMutation, RemoveCoatingFormulationComponentMutationVariables>;
export const GetSuperDashboardDocument = gql`
    query GetSuperDashboard {
  getSuperDashboard {
    response {
      status
    }
    users
    ingredients
    currentMonthUsers
  }
}
    `;

/**
 * __useGetSuperDashboardQuery__
 *
 * To run a query within a React component, call `useGetSuperDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuperDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetSuperDashboardQuery, GetSuperDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuperDashboardQuery, GetSuperDashboardQueryVariables>(GetSuperDashboardDocument, options);
      }
export function useGetSuperDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuperDashboardQuery, GetSuperDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuperDashboardQuery, GetSuperDashboardQueryVariables>(GetSuperDashboardDocument, options);
        }
export type GetSuperDashboardQueryHookResult = ReturnType<typeof useGetSuperDashboardQuery>;
export type GetSuperDashboardLazyQueryHookResult = ReturnType<typeof useGetSuperDashboardLazyQuery>;
export type GetSuperDashboardQueryResult = Apollo.QueryResult<GetSuperDashboardQuery, GetSuperDashboardQueryVariables>;
export const GetAdminDashboardDocument = gql`
    query GetAdminDashboard {
  getOrgDashboard {
    response {
      status
    }
    users
    formulas
    ingredients
  }
}
    `;

/**
 * __useGetAdminDashboardQuery__
 *
 * To run a query within a React component, call `useGetAdminDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDashboardQuery, GetAdminDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDashboardQuery, GetAdminDashboardQueryVariables>(GetAdminDashboardDocument, options);
      }
export function useGetAdminDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDashboardQuery, GetAdminDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDashboardQuery, GetAdminDashboardQueryVariables>(GetAdminDashboardDocument, options);
        }
export type GetAdminDashboardQueryHookResult = ReturnType<typeof useGetAdminDashboardQuery>;
export type GetAdminDashboardLazyQueryHookResult = ReturnType<typeof useGetAdminDashboardLazyQuery>;
export type GetAdminDashboardQueryResult = Apollo.QueryResult<GetAdminDashboardQuery, GetAdminDashboardQueryVariables>;
export const GetStaffDashboardDocument = gql`
    query GetStaffDashboard {
  getOrgDashboard {
    response {
      status
    }
    formulas
    myFormulas
    ingredients
  }
}
    `;

/**
 * __useGetStaffDashboardQuery__
 *
 * To run a query within a React component, call `useGetStaffDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetStaffDashboardQuery, GetStaffDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffDashboardQuery, GetStaffDashboardQueryVariables>(GetStaffDashboardDocument, options);
      }
export function useGetStaffDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffDashboardQuery, GetStaffDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffDashboardQuery, GetStaffDashboardQueryVariables>(GetStaffDashboardDocument, options);
        }
export type GetStaffDashboardQueryHookResult = ReturnType<typeof useGetStaffDashboardQuery>;
export type GetStaffDashboardLazyQueryHookResult = ReturnType<typeof useGetStaffDashboardLazyQuery>;
export type GetStaffDashboardQueryResult = Apollo.QueryResult<GetStaffDashboardQuery, GetStaffDashboardQueryVariables>;
export const FindAllDensitySelectorDocument = gql`
    query FindAllDensitySelector($findAllDensitiesInput: FindAllDensitiesInput!) {
  findAllDensities(findAllDensitiesInput: $findAllDensitiesInput) {
    data {
      id
      name
      description
    }
    response {
      status
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllDensitySelectorQuery__
 *
 * To run a query within a React component, call `useFindAllDensitySelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllDensitySelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllDensitySelectorQuery({
 *   variables: {
 *      findAllDensitiesInput: // value for 'findAllDensitiesInput'
 *   },
 * });
 */
export function useFindAllDensitySelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllDensitySelectorQuery, FindAllDensitySelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllDensitySelectorQuery, FindAllDensitySelectorQueryVariables>(FindAllDensitySelectorDocument, options);
      }
export function useFindAllDensitySelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllDensitySelectorQuery, FindAllDensitySelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllDensitySelectorQuery, FindAllDensitySelectorQueryVariables>(FindAllDensitySelectorDocument, options);
        }
export type FindAllDensitySelectorQueryHookResult = ReturnType<typeof useFindAllDensitySelectorQuery>;
export type FindAllDensitySelectorLazyQueryHookResult = ReturnType<typeof useFindAllDensitySelectorLazyQuery>;
export type FindAllDensitySelectorQueryResult = Apollo.QueryResult<FindAllDensitySelectorQuery, FindAllDensitySelectorQueryVariables>;
export const FindAllDvConstraintsTableDocument = gql`
    query FindAllDvConstraintsTable($findAllDailyValueConstraintsInput: FindAllDailyValueConstraintsInput!) {
  findAllDailyValueConstraints(
    findAllDailyValueConstraintsInput: $findAllDailyValueConstraintsInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      unit
      infants
      foodComponent
      adultsAndChildren
      children1To3Years
      pregnantAndLactatingWomen
    }
  }
}
    `;

/**
 * __useFindAllDvConstraintsTableQuery__
 *
 * To run a query within a React component, call `useFindAllDvConstraintsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllDvConstraintsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllDvConstraintsTableQuery({
 *   variables: {
 *      findAllDailyValueConstraintsInput: // value for 'findAllDailyValueConstraintsInput'
 *   },
 * });
 */
export function useFindAllDvConstraintsTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllDvConstraintsTableQuery, FindAllDvConstraintsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllDvConstraintsTableQuery, FindAllDvConstraintsTableQueryVariables>(FindAllDvConstraintsTableDocument, options);
      }
export function useFindAllDvConstraintsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllDvConstraintsTableQuery, FindAllDvConstraintsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllDvConstraintsTableQuery, FindAllDvConstraintsTableQueryVariables>(FindAllDvConstraintsTableDocument, options);
        }
export type FindAllDvConstraintsTableQueryHookResult = ReturnType<typeof useFindAllDvConstraintsTableQuery>;
export type FindAllDvConstraintsTableLazyQueryHookResult = ReturnType<typeof useFindAllDvConstraintsTableLazyQuery>;
export type FindAllDvConstraintsTableQueryResult = Apollo.QueryResult<FindAllDvConstraintsTableQuery, FindAllDvConstraintsTableQueryVariables>;
export const GetDvConstraintDocument = gql`
    query GetDvConstraint($getDailyValueConstraintInput: GetDailyValueConstraintInput!) {
  getDailyValueConstraint(
    getDailyValueConstraintInput: $getDailyValueConstraintInput
  ) {
    dailyValueConstraint {
      name
      unit
      infants
      foodComponent
      adultsAndChildren
      children1To3Years
      pregnantAndLactatingWomen
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetDvConstraintQuery__
 *
 * To run a query within a React component, call `useGetDvConstraintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDvConstraintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDvConstraintQuery({
 *   variables: {
 *      getDailyValueConstraintInput: // value for 'getDailyValueConstraintInput'
 *   },
 * });
 */
export function useGetDvConstraintQuery(baseOptions: Apollo.QueryHookOptions<GetDvConstraintQuery, GetDvConstraintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDvConstraintQuery, GetDvConstraintQueryVariables>(GetDvConstraintDocument, options);
      }
export function useGetDvConstraintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDvConstraintQuery, GetDvConstraintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDvConstraintQuery, GetDvConstraintQueryVariables>(GetDvConstraintDocument, options);
        }
export type GetDvConstraintQueryHookResult = ReturnType<typeof useGetDvConstraintQuery>;
export type GetDvConstraintLazyQueryHookResult = ReturnType<typeof useGetDvConstraintLazyQuery>;
export type GetDvConstraintQueryResult = Apollo.QueryResult<GetDvConstraintQuery, GetDvConstraintQueryVariables>;
export const UpdateDvConstraintDocument = gql`
    mutation UpdateDvConstraint($updateDailyValueConstraintInput: UpdateDailyValueConstraintInput!) {
  updateDailyValueConstraint(
    updateDailyValueConstraintInput: $updateDailyValueConstraintInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateDvConstraintMutationFn = Apollo.MutationFunction<UpdateDvConstraintMutation, UpdateDvConstraintMutationVariables>;

/**
 * __useUpdateDvConstraintMutation__
 *
 * To run a mutation, you first call `useUpdateDvConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDvConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDvConstraintMutation, { data, loading, error }] = useUpdateDvConstraintMutation({
 *   variables: {
 *      updateDailyValueConstraintInput: // value for 'updateDailyValueConstraintInput'
 *   },
 * });
 */
export function useUpdateDvConstraintMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDvConstraintMutation, UpdateDvConstraintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDvConstraintMutation, UpdateDvConstraintMutationVariables>(UpdateDvConstraintDocument, options);
      }
export type UpdateDvConstraintMutationHookResult = ReturnType<typeof useUpdateDvConstraintMutation>;
export type UpdateDvConstraintMutationResult = Apollo.MutationResult<UpdateDvConstraintMutation>;
export type UpdateDvConstraintMutationOptions = Apollo.BaseMutationOptions<UpdateDvConstraintMutation, UpdateDvConstraintMutationVariables>;
export const FindAllExcipientsDocument = gql`
    query FindAllExcipients($findAllExcipientsInput: FindAllExcipientsInput!) {
  findAllExcipients(findAllExcipientsInput: $findAllExcipientsInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllExcipientsQuery__
 *
 * To run a query within a React component, call `useFindAllExcipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllExcipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllExcipientsQuery({
 *   variables: {
 *      findAllExcipientsInput: // value for 'findAllExcipientsInput'
 *   },
 * });
 */
export function useFindAllExcipientsQuery(baseOptions: Apollo.QueryHookOptions<FindAllExcipientsQuery, FindAllExcipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllExcipientsQuery, FindAllExcipientsQueryVariables>(FindAllExcipientsDocument, options);
      }
export function useFindAllExcipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllExcipientsQuery, FindAllExcipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllExcipientsQuery, FindAllExcipientsQueryVariables>(FindAllExcipientsDocument, options);
        }
export type FindAllExcipientsQueryHookResult = ReturnType<typeof useFindAllExcipientsQuery>;
export type FindAllExcipientsLazyQueryHookResult = ReturnType<typeof useFindAllExcipientsLazyQuery>;
export type FindAllExcipientsQueryResult = Apollo.QueryResult<FindAllExcipientsQuery, FindAllExcipientsQueryVariables>;
export const FindAllExcipientSelectorDocument = gql`
    query FindAllExcipientSelector($findAllExcipientsInput: FindAllExcipientsInput!) {
  findAllExcipients(findAllExcipientsInput: $findAllExcipientsInput) {
    response {
      status
    }
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useFindAllExcipientSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllExcipientSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllExcipientSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllExcipientSelectorQuery({
 *   variables: {
 *      findAllExcipientsInput: // value for 'findAllExcipientsInput'
 *   },
 * });
 */
export function useFindAllExcipientSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllExcipientSelectorQuery, FindAllExcipientSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllExcipientSelectorQuery, FindAllExcipientSelectorQueryVariables>(FindAllExcipientSelectorDocument, options);
      }
export function useFindAllExcipientSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllExcipientSelectorQuery, FindAllExcipientSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllExcipientSelectorQuery, FindAllExcipientSelectorQueryVariables>(FindAllExcipientSelectorDocument, options);
        }
export type FindAllExcipientSelectorQueryHookResult = ReturnType<typeof useFindAllExcipientSelectorQuery>;
export type FindAllExcipientSelectorLazyQueryHookResult = ReturnType<typeof useFindAllExcipientSelectorLazyQuery>;
export type FindAllExcipientSelectorQueryResult = Apollo.QueryResult<FindAllExcipientSelectorQuery, FindAllExcipientSelectorQueryVariables>;
export const GetExcipientDocument = gql`
    query GetExcipient($getExcipientInput: GetExcipientInput!) {
  getExcipient(getExcipientInput: $getExcipientInput) {
    excipient {
      name
      isActive
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetExcipientQuery__
 *
 * To run a query within a React component, call `useGetExcipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExcipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExcipientQuery({
 *   variables: {
 *      getExcipientInput: // value for 'getExcipientInput'
 *   },
 * });
 */
export function useGetExcipientQuery(baseOptions: Apollo.QueryHookOptions<GetExcipientQuery, GetExcipientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExcipientQuery, GetExcipientQueryVariables>(GetExcipientDocument, options);
      }
export function useGetExcipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExcipientQuery, GetExcipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExcipientQuery, GetExcipientQueryVariables>(GetExcipientDocument, options);
        }
export type GetExcipientQueryHookResult = ReturnType<typeof useGetExcipientQuery>;
export type GetExcipientLazyQueryHookResult = ReturnType<typeof useGetExcipientLazyQuery>;
export type GetExcipientQueryResult = Apollo.QueryResult<GetExcipientQuery, GetExcipientQueryVariables>;
export const UpdateExcipientDocument = gql`
    mutation UpdateExcipient($updateExcipientInput: UpdateExcipientInput!) {
  updateExcipient(updateExcipientInput: $updateExcipientInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateExcipientMutationFn = Apollo.MutationFunction<UpdateExcipientMutation, UpdateExcipientMutationVariables>;

/**
 * __useUpdateExcipientMutation__
 *
 * To run a mutation, you first call `useUpdateExcipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExcipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExcipientMutation, { data, loading, error }] = useUpdateExcipientMutation({
 *   variables: {
 *      updateExcipientInput: // value for 'updateExcipientInput'
 *   },
 * });
 */
export function useUpdateExcipientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExcipientMutation, UpdateExcipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExcipientMutation, UpdateExcipientMutationVariables>(UpdateExcipientDocument, options);
      }
export type UpdateExcipientMutationHookResult = ReturnType<typeof useUpdateExcipientMutation>;
export type UpdateExcipientMutationResult = Apollo.MutationResult<UpdateExcipientMutation>;
export type UpdateExcipientMutationOptions = Apollo.BaseMutationOptions<UpdateExcipientMutation, UpdateExcipientMutationVariables>;
export const CreateExcipientDocument = gql`
    mutation CreateExcipient($createExcipientInput: CreateExcipientInput!) {
  createExcipient(createExcipientInput: $createExcipientInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateExcipientMutationFn = Apollo.MutationFunction<CreateExcipientMutation, CreateExcipientMutationVariables>;

/**
 * __useCreateExcipientMutation__
 *
 * To run a mutation, you first call `useCreateExcipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExcipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExcipientMutation, { data, loading, error }] = useCreateExcipientMutation({
 *   variables: {
 *      createExcipientInput: // value for 'createExcipientInput'
 *   },
 * });
 */
export function useCreateExcipientMutation(baseOptions?: Apollo.MutationHookOptions<CreateExcipientMutation, CreateExcipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExcipientMutation, CreateExcipientMutationVariables>(CreateExcipientDocument, options);
      }
export type CreateExcipientMutationHookResult = ReturnType<typeof useCreateExcipientMutation>;
export type CreateExcipientMutationResult = Apollo.MutationResult<CreateExcipientMutation>;
export type CreateExcipientMutationOptions = Apollo.BaseMutationOptions<CreateExcipientMutation, CreateExcipientMutationVariables>;
export const FindAllExcipientLabelSelectDocument = gql`
    query FindAllExcipientLabelSelect($findAllExcipientLabelsInput: FindAllExcipientLabelsInput!) {
  findAllExcipientLabels(
    findAllExcipientLabelsInput: $findAllExcipientLabelsInput
  ) {
    pagination {
      totalPages
    }
    response {
      status
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllExcipientLabelSelectQuery__
 *
 * To run a query within a React component, call `useFindAllExcipientLabelSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllExcipientLabelSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllExcipientLabelSelectQuery({
 *   variables: {
 *      findAllExcipientLabelsInput: // value for 'findAllExcipientLabelsInput'
 *   },
 * });
 */
export function useFindAllExcipientLabelSelectQuery(baseOptions: Apollo.QueryHookOptions<FindAllExcipientLabelSelectQuery, FindAllExcipientLabelSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllExcipientLabelSelectQuery, FindAllExcipientLabelSelectQueryVariables>(FindAllExcipientLabelSelectDocument, options);
      }
export function useFindAllExcipientLabelSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllExcipientLabelSelectQuery, FindAllExcipientLabelSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllExcipientLabelSelectQuery, FindAllExcipientLabelSelectQueryVariables>(FindAllExcipientLabelSelectDocument, options);
        }
export type FindAllExcipientLabelSelectQueryHookResult = ReturnType<typeof useFindAllExcipientLabelSelectQuery>;
export type FindAllExcipientLabelSelectLazyQueryHookResult = ReturnType<typeof useFindAllExcipientLabelSelectLazyQuery>;
export type FindAllExcipientLabelSelectQueryResult = Apollo.QueryResult<FindAllExcipientLabelSelectQuery, FindAllExcipientLabelSelectQueryVariables>;
export const FindAllExcipientLabelsDocument = gql`
    query FindAllExcipientLabels($findAllExcipientLabelsInput: FindAllExcipientLabelsInput!) {
  findAllExcipientLabels(
    findAllExcipientLabelsInput: $findAllExcipientLabelsInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllExcipientLabelsQuery__
 *
 * To run a query within a React component, call `useFindAllExcipientLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllExcipientLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllExcipientLabelsQuery({
 *   variables: {
 *      findAllExcipientLabelsInput: // value for 'findAllExcipientLabelsInput'
 *   },
 * });
 */
export function useFindAllExcipientLabelsQuery(baseOptions: Apollo.QueryHookOptions<FindAllExcipientLabelsQuery, FindAllExcipientLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllExcipientLabelsQuery, FindAllExcipientLabelsQueryVariables>(FindAllExcipientLabelsDocument, options);
      }
export function useFindAllExcipientLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllExcipientLabelsQuery, FindAllExcipientLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllExcipientLabelsQuery, FindAllExcipientLabelsQueryVariables>(FindAllExcipientLabelsDocument, options);
        }
export type FindAllExcipientLabelsQueryHookResult = ReturnType<typeof useFindAllExcipientLabelsQuery>;
export type FindAllExcipientLabelsLazyQueryHookResult = ReturnType<typeof useFindAllExcipientLabelsLazyQuery>;
export type FindAllExcipientLabelsQueryResult = Apollo.QueryResult<FindAllExcipientLabelsQuery, FindAllExcipientLabelsQueryVariables>;
export const GetExcipientLabelDocument = gql`
    query GetExcipientLabel($getExcipientLabelInput: GetExcipientLabelInput!) {
  getExcipientLabel(getExcipientLabelInput: $getExcipientLabelInput) {
    excipientLabel {
      name
      isActive
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetExcipientLabelQuery__
 *
 * To run a query within a React component, call `useGetExcipientLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExcipientLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExcipientLabelQuery({
 *   variables: {
 *      getExcipientLabelInput: // value for 'getExcipientLabelInput'
 *   },
 * });
 */
export function useGetExcipientLabelQuery(baseOptions: Apollo.QueryHookOptions<GetExcipientLabelQuery, GetExcipientLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExcipientLabelQuery, GetExcipientLabelQueryVariables>(GetExcipientLabelDocument, options);
      }
export function useGetExcipientLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExcipientLabelQuery, GetExcipientLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExcipientLabelQuery, GetExcipientLabelQueryVariables>(GetExcipientLabelDocument, options);
        }
export type GetExcipientLabelQueryHookResult = ReturnType<typeof useGetExcipientLabelQuery>;
export type GetExcipientLabelLazyQueryHookResult = ReturnType<typeof useGetExcipientLabelLazyQuery>;
export type GetExcipientLabelQueryResult = Apollo.QueryResult<GetExcipientLabelQuery, GetExcipientLabelQueryVariables>;
export const CreateExcipientLabelDocument = gql`
    mutation CreateExcipientLabel($createExcipientLabelInput: CreateExcipientLabelInput!) {
  createExcipientLabel(createExcipientLabelInput: $createExcipientLabelInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateExcipientLabelMutationFn = Apollo.MutationFunction<CreateExcipientLabelMutation, CreateExcipientLabelMutationVariables>;

/**
 * __useCreateExcipientLabelMutation__
 *
 * To run a mutation, you first call `useCreateExcipientLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExcipientLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExcipientLabelMutation, { data, loading, error }] = useCreateExcipientLabelMutation({
 *   variables: {
 *      createExcipientLabelInput: // value for 'createExcipientLabelInput'
 *   },
 * });
 */
export function useCreateExcipientLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateExcipientLabelMutation, CreateExcipientLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExcipientLabelMutation, CreateExcipientLabelMutationVariables>(CreateExcipientLabelDocument, options);
      }
export type CreateExcipientLabelMutationHookResult = ReturnType<typeof useCreateExcipientLabelMutation>;
export type CreateExcipientLabelMutationResult = Apollo.MutationResult<CreateExcipientLabelMutation>;
export type CreateExcipientLabelMutationOptions = Apollo.BaseMutationOptions<CreateExcipientLabelMutation, CreateExcipientLabelMutationVariables>;
export const UpdateExcipientLabelDocument = gql`
    mutation UpdateExcipientLabel($updateExcipientLabelInput: UpdateExcipientLabelInput!) {
  updateExcipientLabel(updateExcipientLabelInput: $updateExcipientLabelInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateExcipientLabelMutationFn = Apollo.MutationFunction<UpdateExcipientLabelMutation, UpdateExcipientLabelMutationVariables>;

/**
 * __useUpdateExcipientLabelMutation__
 *
 * To run a mutation, you first call `useUpdateExcipientLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExcipientLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExcipientLabelMutation, { data, loading, error }] = useUpdateExcipientLabelMutation({
 *   variables: {
 *      updateExcipientLabelInput: // value for 'updateExcipientLabelInput'
 *   },
 * });
 */
export function useUpdateExcipientLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExcipientLabelMutation, UpdateExcipientLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExcipientLabelMutation, UpdateExcipientLabelMutationVariables>(UpdateExcipientLabelDocument, options);
      }
export type UpdateExcipientLabelMutationHookResult = ReturnType<typeof useUpdateExcipientLabelMutation>;
export type UpdateExcipientLabelMutationResult = Apollo.MutationResult<UpdateExcipientLabelMutation>;
export type UpdateExcipientLabelMutationOptions = Apollo.BaseMutationOptions<UpdateExcipientLabelMutation, UpdateExcipientLabelMutationVariables>;
export const FindAllExcipientTypesDocument = gql`
    query FindAllExcipientTypes($findAllExcipientTypesInput: FindAllExcipientTypesInput!) {
  findAllExcipientTypes(findAllExcipientTypesInput: $findAllExcipientTypesInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
      loadAdd
      loadAddUnit
      perKgCost
      excipientLabel {
        name
      }
      productType {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllExcipientTypesQuery__
 *
 * To run a query within a React component, call `useFindAllExcipientTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllExcipientTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllExcipientTypesQuery({
 *   variables: {
 *      findAllExcipientTypesInput: // value for 'findAllExcipientTypesInput'
 *   },
 * });
 */
export function useFindAllExcipientTypesQuery(baseOptions: Apollo.QueryHookOptions<FindAllExcipientTypesQuery, FindAllExcipientTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllExcipientTypesQuery, FindAllExcipientTypesQueryVariables>(FindAllExcipientTypesDocument, options);
      }
export function useFindAllExcipientTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllExcipientTypesQuery, FindAllExcipientTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllExcipientTypesQuery, FindAllExcipientTypesQueryVariables>(FindAllExcipientTypesDocument, options);
        }
export type FindAllExcipientTypesQueryHookResult = ReturnType<typeof useFindAllExcipientTypesQuery>;
export type FindAllExcipientTypesLazyQueryHookResult = ReturnType<typeof useFindAllExcipientTypesLazyQuery>;
export type FindAllExcipientTypesQueryResult = Apollo.QueryResult<FindAllExcipientTypesQuery, FindAllExcipientTypesQueryVariables>;
export const FindAllExcipientTypesSelectorDocument = gql`
    query FindAllExcipientTypesSelector($findAllExcipientTypesInput: FindAllExcipientTypesInput!) {
  findAllExcipientTypes(findAllExcipientTypesInput: $findAllExcipientTypesInput) {
    response {
      status
    }
    data {
      id
      name
      isActive
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllExcipientTypesSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllExcipientTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllExcipientTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllExcipientTypesSelectorQuery({
 *   variables: {
 *      findAllExcipientTypesInput: // value for 'findAllExcipientTypesInput'
 *   },
 * });
 */
export function useFindAllExcipientTypesSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllExcipientTypesSelectorQuery, FindAllExcipientTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllExcipientTypesSelectorQuery, FindAllExcipientTypesSelectorQueryVariables>(FindAllExcipientTypesSelectorDocument, options);
      }
export function useFindAllExcipientTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllExcipientTypesSelectorQuery, FindAllExcipientTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllExcipientTypesSelectorQuery, FindAllExcipientTypesSelectorQueryVariables>(FindAllExcipientTypesSelectorDocument, options);
        }
export type FindAllExcipientTypesSelectorQueryHookResult = ReturnType<typeof useFindAllExcipientTypesSelectorQuery>;
export type FindAllExcipientTypesSelectorLazyQueryHookResult = ReturnType<typeof useFindAllExcipientTypesSelectorLazyQuery>;
export type FindAllExcipientTypesSelectorQueryResult = Apollo.QueryResult<FindAllExcipientTypesSelectorQuery, FindAllExcipientTypesSelectorQueryVariables>;
export const GetExcipientTypeDocument = gql`
    query GetExcipientType($getExcipientTypeInput: GetExcipientTypeInput!) {
  getExcipientType(getExcipientTypeInput: $getExcipientTypeInput) {
    excipientType {
      id
      name
      isActive
      loadAdd
      loadAddUnit
      perKgCost
      excipientLabel {
        id
      }
      productType {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetExcipientTypeQuery__
 *
 * To run a query within a React component, call `useGetExcipientTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExcipientTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExcipientTypeQuery({
 *   variables: {
 *      getExcipientTypeInput: // value for 'getExcipientTypeInput'
 *   },
 * });
 */
export function useGetExcipientTypeQuery(baseOptions: Apollo.QueryHookOptions<GetExcipientTypeQuery, GetExcipientTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExcipientTypeQuery, GetExcipientTypeQueryVariables>(GetExcipientTypeDocument, options);
      }
export function useGetExcipientTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExcipientTypeQuery, GetExcipientTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExcipientTypeQuery, GetExcipientTypeQueryVariables>(GetExcipientTypeDocument, options);
        }
export type GetExcipientTypeQueryHookResult = ReturnType<typeof useGetExcipientTypeQuery>;
export type GetExcipientTypeLazyQueryHookResult = ReturnType<typeof useGetExcipientTypeLazyQuery>;
export type GetExcipientTypeQueryResult = Apollo.QueryResult<GetExcipientTypeQuery, GetExcipientTypeQueryVariables>;
export const UpdateExcipientTypeDocument = gql`
    mutation UpdateExcipientType($updateExcipientTypeInput: UpdateExcipientTypeInput!) {
  updateExcipientType(updateExcipientTypeInput: $updateExcipientTypeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateExcipientTypeMutationFn = Apollo.MutationFunction<UpdateExcipientTypeMutation, UpdateExcipientTypeMutationVariables>;

/**
 * __useUpdateExcipientTypeMutation__
 *
 * To run a mutation, you first call `useUpdateExcipientTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExcipientTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExcipientTypeMutation, { data, loading, error }] = useUpdateExcipientTypeMutation({
 *   variables: {
 *      updateExcipientTypeInput: // value for 'updateExcipientTypeInput'
 *   },
 * });
 */
export function useUpdateExcipientTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExcipientTypeMutation, UpdateExcipientTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExcipientTypeMutation, UpdateExcipientTypeMutationVariables>(UpdateExcipientTypeDocument, options);
      }
export type UpdateExcipientTypeMutationHookResult = ReturnType<typeof useUpdateExcipientTypeMutation>;
export type UpdateExcipientTypeMutationResult = Apollo.MutationResult<UpdateExcipientTypeMutation>;
export type UpdateExcipientTypeMutationOptions = Apollo.BaseMutationOptions<UpdateExcipientTypeMutation, UpdateExcipientTypeMutationVariables>;
export const CreateExcipientTypeDocument = gql`
    mutation CreateExcipientType($createExcipientTypeInput: CreateExcipientTypeInput!) {
  createExcipientType(createExcipientTypeInput: $createExcipientTypeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateExcipientTypeMutationFn = Apollo.MutationFunction<CreateExcipientTypeMutation, CreateExcipientTypeMutationVariables>;

/**
 * __useCreateExcipientTypeMutation__
 *
 * To run a mutation, you first call `useCreateExcipientTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExcipientTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExcipientTypeMutation, { data, loading, error }] = useCreateExcipientTypeMutation({
 *   variables: {
 *      createExcipientTypeInput: // value for 'createExcipientTypeInput'
 *   },
 * });
 */
export function useCreateExcipientTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateExcipientTypeMutation, CreateExcipientTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExcipientTypeMutation, CreateExcipientTypeMutationVariables>(CreateExcipientTypeDocument, options);
      }
export type CreateExcipientTypeMutationHookResult = ReturnType<typeof useCreateExcipientTypeMutation>;
export type CreateExcipientTypeMutationResult = Apollo.MutationResult<CreateExcipientTypeMutation>;
export type CreateExcipientTypeMutationOptions = Apollo.BaseMutationOptions<CreateExcipientTypeMutation, CreateExcipientTypeMutationVariables>;
export const FindAllFlavorsTableDocument = gql`
    query FindAllFlavorsTable($findAllSweetenersInput: FindAllSweetenersInput!) {
  findAllSweeteners(findAllSweetenersInput: $findAllSweetenersInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      size
      nature
      isActive
      mgPerServing
      costPerServing
      productType {
        name
      }
      productSize {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllFlavorsTableQuery__
 *
 * To run a query within a React component, call `useFindAllFlavorsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllFlavorsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllFlavorsTableQuery({
 *   variables: {
 *      findAllSweetenersInput: // value for 'findAllSweetenersInput'
 *   },
 * });
 */
export function useFindAllFlavorsTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllFlavorsTableQuery, FindAllFlavorsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllFlavorsTableQuery, FindAllFlavorsTableQueryVariables>(FindAllFlavorsTableDocument, options);
      }
export function useFindAllFlavorsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllFlavorsTableQuery, FindAllFlavorsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllFlavorsTableQuery, FindAllFlavorsTableQueryVariables>(FindAllFlavorsTableDocument, options);
        }
export type FindAllFlavorsTableQueryHookResult = ReturnType<typeof useFindAllFlavorsTableQuery>;
export type FindAllFlavorsTableLazyQueryHookResult = ReturnType<typeof useFindAllFlavorsTableLazyQuery>;
export type FindAllFlavorsTableQueryResult = Apollo.QueryResult<FindAllFlavorsTableQuery, FindAllFlavorsTableQueryVariables>;
export const GetFlavorDocument = gql`
    query GetFlavor($getSweetenerInput: GetSweetenerInput!) {
  getSweetener(getSweetenerInput: $getSweetenerInput) {
    sweetener {
      name
      size
      nature
      isActive
      mgPerServing
      costPerServing
      productType {
        id
        name
      }
      productSize {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetFlavorQuery__
 *
 * To run a query within a React component, call `useGetFlavorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlavorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlavorQuery({
 *   variables: {
 *      getSweetenerInput: // value for 'getSweetenerInput'
 *   },
 * });
 */
export function useGetFlavorQuery(baseOptions: Apollo.QueryHookOptions<GetFlavorQuery, GetFlavorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlavorQuery, GetFlavorQueryVariables>(GetFlavorDocument, options);
      }
export function useGetFlavorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlavorQuery, GetFlavorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlavorQuery, GetFlavorQueryVariables>(GetFlavorDocument, options);
        }
export type GetFlavorQueryHookResult = ReturnType<typeof useGetFlavorQuery>;
export type GetFlavorLazyQueryHookResult = ReturnType<typeof useGetFlavorLazyQuery>;
export type GetFlavorQueryResult = Apollo.QueryResult<GetFlavorQuery, GetFlavorQueryVariables>;
export const CreateFlavorDocument = gql`
    mutation CreateFlavor($createSweetenerInput: CreateSweetenerInput!) {
  createSweetener(createSweetenerInput: $createSweetenerInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateFlavorMutationFn = Apollo.MutationFunction<CreateFlavorMutation, CreateFlavorMutationVariables>;

/**
 * __useCreateFlavorMutation__
 *
 * To run a mutation, you first call `useCreateFlavorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlavorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlavorMutation, { data, loading, error }] = useCreateFlavorMutation({
 *   variables: {
 *      createSweetenerInput: // value for 'createSweetenerInput'
 *   },
 * });
 */
export function useCreateFlavorMutation(baseOptions?: Apollo.MutationHookOptions<CreateFlavorMutation, CreateFlavorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFlavorMutation, CreateFlavorMutationVariables>(CreateFlavorDocument, options);
      }
export type CreateFlavorMutationHookResult = ReturnType<typeof useCreateFlavorMutation>;
export type CreateFlavorMutationResult = Apollo.MutationResult<CreateFlavorMutation>;
export type CreateFlavorMutationOptions = Apollo.BaseMutationOptions<CreateFlavorMutation, CreateFlavorMutationVariables>;
export const UpdateFlavorDocument = gql`
    mutation UpdateFlavor($updateSweetenerInput: UpdateSweetenerInput!) {
  updateSweetener(updateSweetenerInput: $updateSweetenerInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateFlavorMutationFn = Apollo.MutationFunction<UpdateFlavorMutation, UpdateFlavorMutationVariables>;

/**
 * __useUpdateFlavorMutation__
 *
 * To run a mutation, you first call `useUpdateFlavorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlavorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlavorMutation, { data, loading, error }] = useUpdateFlavorMutation({
 *   variables: {
 *      updateSweetenerInput: // value for 'updateSweetenerInput'
 *   },
 * });
 */
export function useUpdateFlavorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFlavorMutation, UpdateFlavorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFlavorMutation, UpdateFlavorMutationVariables>(UpdateFlavorDocument, options);
      }
export type UpdateFlavorMutationHookResult = ReturnType<typeof useUpdateFlavorMutation>;
export type UpdateFlavorMutationResult = Apollo.MutationResult<UpdateFlavorMutation>;
export type UpdateFlavorMutationOptions = Apollo.BaseMutationOptions<UpdateFlavorMutation, UpdateFlavorMutationVariables>;
export const FindRecentFormulasDocument = gql`
    query FindRecentFormulas($findAllFormulasInput: FindAllFormulasInput!) {
  findAllFormulas(findAllFormulasInput: $findAllFormulasInput) {
    data {
      id
      name
      productType {
        name
      }
      productFormulationType {
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindRecentFormulasQuery__
 *
 * To run a query within a React component, call `useFindRecentFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRecentFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRecentFormulasQuery({
 *   variables: {
 *      findAllFormulasInput: // value for 'findAllFormulasInput'
 *   },
 * });
 */
export function useFindRecentFormulasQuery(baseOptions: Apollo.QueryHookOptions<FindRecentFormulasQuery, FindRecentFormulasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRecentFormulasQuery, FindRecentFormulasQueryVariables>(FindRecentFormulasDocument, options);
      }
export function useFindRecentFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRecentFormulasQuery, FindRecentFormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRecentFormulasQuery, FindRecentFormulasQueryVariables>(FindRecentFormulasDocument, options);
        }
export type FindRecentFormulasQueryHookResult = ReturnType<typeof useFindRecentFormulasQuery>;
export type FindRecentFormulasLazyQueryHookResult = ReturnType<typeof useFindRecentFormulasLazyQuery>;
export type FindRecentFormulasQueryResult = Apollo.QueryResult<FindRecentFormulasQuery, FindRecentFormulasQueryVariables>;
export const FindAllFormulasDocument = gql`
    query FindAllFormulas($findAllFormulasInput: FindAllFormulasInput!) {
  findAllFormulas(findAllFormulasInput: $findAllFormulasInput) {
    data {
      id
      name
      createdAt
      status
      user {
        firstName
        lastName
      }
      productType {
        name
      }
      productFormulationType {
        name
      }
    }
    pagination {
      page
      totalCount
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllFormulasQuery__
 *
 * To run a query within a React component, call `useFindAllFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllFormulasQuery({
 *   variables: {
 *      findAllFormulasInput: // value for 'findAllFormulasInput'
 *   },
 * });
 */
export function useFindAllFormulasQuery(baseOptions: Apollo.QueryHookOptions<FindAllFormulasQuery, FindAllFormulasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllFormulasQuery, FindAllFormulasQueryVariables>(FindAllFormulasDocument, options);
      }
export function useFindAllFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllFormulasQuery, FindAllFormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllFormulasQuery, FindAllFormulasQueryVariables>(FindAllFormulasDocument, options);
        }
export type FindAllFormulasQueryHookResult = ReturnType<typeof useFindAllFormulasQuery>;
export type FindAllFormulasLazyQueryHookResult = ReturnType<typeof useFindAllFormulasLazyQuery>;
export type FindAllFormulasQueryResult = Apollo.QueryResult<FindAllFormulasQuery, FindAllFormulasQueryVariables>;
export const CalcFormulaCostDocument = gql`
    query CalcFormulaCost($calcFormulaCostInput: CalcFormulaCostInput!) {
  calcFormulaCost(calcFormulaCostInput: $calcFormulaCostInput) {
    response {
      status
    }
    formulaCostSuggestion {
      organicPercentage
      cost {
        mfgCost
        coMfgCost
        lohCost
        neckband
        flavorCost
        per1000Cost
        coatingCost
        bottlePrice
        sweetenerCost
        syrupBaseCost
        excipientCost
        conversionCost
        ingredientsCost
        sandCoatingCost
        miscellaneousCost
        bottleCapacityInstance {
          id
          fillPercentage
          productSize {
            name
          }
          bottleSize {
            name
            lidSize
          }
        }
        outerCapsulePrice {
          price
          productSize {
            name
          }
        }
        innerCapsulePrice {
          price
          productSize {
            name
          }
        }
        capsulePrice {
          price
          productSize {
            name
          }
          density {
            name
          }
        }
      }
      weights {
        totalWeight
        flavorWeight
        coatingWeight
        excipientWeight
        syrupBaseWeight
        sweetenerWeight
        ingredientsWeight
        sandCoatingWeight
      }
      weightPercentage {
        flavorWeight
        coatingWeight
        excipientWeight
        sweetenerWeight
        syrupBaseWeight
        ingredientsWeight
        sandCoatingWeight
      }
      costPercentage {
        lohCost
        neckband
        flavorCost
        coatingCost
        bottlePrice
        sweetenerCost
        syrupBaseCost
        excipientCost
        conversionCost
        sandCoatingCost
        ingredientsCost
        miscellaneousCost
      }
      formulaIngredients {
        ingCostContribution
        ingredient {
          name
        }
        macroNutrientsWeight {
          moisture
          calories
          protein
          carbohydrates
          dietaryFiber
          totalSugars
          addedSugar
          totalFat
          saturatedFat
          monounsaturatedFat
          polyunsaturatedFat
          transFat
          cholesterol
        }
        microNutrientsWeight {
          vitaminA
          biotin
          pantothenicAcid
          thiamin
          riboflavin
          niacin
          vitaminB6
          vitaminB12
          vitaminC
          vitaminD
          vitaminE
          folate
          vitaminK
          vitaminK2
          folicAcid
          calcium
          phosphorus
          magnesium
          sodium
          potassium
          chloride
          iron
          zinc
          iodine
          selenium
          copper
          manganese
          chromium
          molybdenum
          boron
          choline
        }
      }
    }
  }
}
    `;

/**
 * __useCalcFormulaCostQuery__
 *
 * To run a query within a React component, call `useCalcFormulaCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalcFormulaCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalcFormulaCostQuery({
 *   variables: {
 *      calcFormulaCostInput: // value for 'calcFormulaCostInput'
 *   },
 * });
 */
export function useCalcFormulaCostQuery(baseOptions: Apollo.QueryHookOptions<CalcFormulaCostQuery, CalcFormulaCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalcFormulaCostQuery, CalcFormulaCostQueryVariables>(CalcFormulaCostDocument, options);
      }
export function useCalcFormulaCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalcFormulaCostQuery, CalcFormulaCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalcFormulaCostQuery, CalcFormulaCostQueryVariables>(CalcFormulaCostDocument, options);
        }
export type CalcFormulaCostQueryHookResult = ReturnType<typeof useCalcFormulaCostQuery>;
export type CalcFormulaCostLazyQueryHookResult = ReturnType<typeof useCalcFormulaCostLazyQuery>;
export type CalcFormulaCostQueryResult = Apollo.QueryResult<CalcFormulaCostQuery, CalcFormulaCostQueryVariables>;
export const GetFormulaDocument = gql`
    query GetFormula($getFormulaInput: GetFormulaInput!) {
  getFormula(getFormulaInput: $getFormulaInput) {
    response {
      status
    }
    formula {
      name
      description
      status
      bottleCap
      bottleType
      coMfgCostType
      capOverride
      coMfgCost
      coMfgCostPercentage
      veganType
      proteinBase
      factBoxType
      formulaAgeGroups {
        ageGroupType
        dvType
        servingSize
        servingUnit
        servingContainer
      }
      miscellaneousCost
      organicPercentage
      beadletId
      tabletTypeId
      servingSize
      servingUnit
      servingContainer
      miniTabFormulation
      sandCoatingId
      tabletCoatingId
      productSize {
        id
        name
      }
      productType {
        id
        name
        type
      }
      subProductType {
        id
        name
      }
      productFormulationType {
        id
        name
        type
      }
      excipientType {
        id
        name
        excipientLabel {
          id
        }
      }
      formulaTabletCoatings {
        id
        type
        colorsHex
        coatingColor
      }
      formulaCapsuleTypes {
        type
        capsuleType {
          id
          name
        }
      }
      formulaSweeteners {
        id
        type
        nature
        sweetener {
          id
          name
        }
      }
      formulaIngredients {
        id
        value
        unit
        type
        potency
        overage
        ingredientId
        showCfu
        ingredient {
          name
          potency
          isActive
        }
      }
      formulaBlends {
        name
        formulaIngredients {
          id
          unit
          type
          value
          potency
          overage
          ingredientId
          showCfu
          ingredient {
            name
            potency
            isActive
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFormulaQuery__
 *
 * To run a query within a React component, call `useGetFormulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulaQuery({
 *   variables: {
 *      getFormulaInput: // value for 'getFormulaInput'
 *   },
 * });
 */
export function useGetFormulaQuery(baseOptions: Apollo.QueryHookOptions<GetFormulaQuery, GetFormulaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormulaQuery, GetFormulaQueryVariables>(GetFormulaDocument, options);
      }
export function useGetFormulaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormulaQuery, GetFormulaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormulaQuery, GetFormulaQueryVariables>(GetFormulaDocument, options);
        }
export type GetFormulaQueryHookResult = ReturnType<typeof useGetFormulaQuery>;
export type GetFormulaLazyQueryHookResult = ReturnType<typeof useGetFormulaLazyQuery>;
export type GetFormulaQueryResult = Apollo.QueryResult<GetFormulaQuery, GetFormulaQueryVariables>;
export const GetFactSheetDocument = gql`
    query GetFactSheet($getFactSheetInput: GetFactSheetInput!) {
  getFactSheet(getFactSheetInput: $getFactSheetInput) {
    response {
      status
    }
    pdfStr
  }
}
    `;

/**
 * __useGetFactSheetQuery__
 *
 * To run a query within a React component, call `useGetFactSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactSheetQuery({
 *   variables: {
 *      getFactSheetInput: // value for 'getFactSheetInput'
 *   },
 * });
 */
export function useGetFactSheetQuery(baseOptions: Apollo.QueryHookOptions<GetFactSheetQuery, GetFactSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFactSheetQuery, GetFactSheetQueryVariables>(GetFactSheetDocument, options);
      }
export function useGetFactSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFactSheetQuery, GetFactSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFactSheetQuery, GetFactSheetQueryVariables>(GetFactSheetDocument, options);
        }
export type GetFactSheetQueryHookResult = ReturnType<typeof useGetFactSheetQuery>;
export type GetFactSheetLazyQueryHookResult = ReturnType<typeof useGetFactSheetLazyQuery>;
export type GetFactSheetQueryResult = Apollo.QueryResult<GetFactSheetQuery, GetFactSheetQueryVariables>;
export const GetFormulaDetailDocument = gql`
    query GetFormulaDetail($getFormulaInput: GetFormulaInput!) {
  getFormula(getFormulaInput: $getFormulaInput) {
    response {
      status
    }
    formula {
      name
      description
      servingSize
      servingContainer
      mfgCost
      bottleCap
      bottleType
      coMfgCost
      coMfgCostType
      coMfgCostPercentage
      beadletId
      tabletTypeId
      tabletCoatingId
      miscellaneousCost
      organicPercentage
      veganType
      proteinBase
      factBoxType
      miniTabFormulation
      formulaAgeGroups {
        ageGroupType
        dvType
        servingSize
        servingUnit
        servingContainer
      }
      productType {
        name
        type
      }
      subProductType {
        name
      }
      productFormulationType {
        name
      }
      productSize {
        name
      }
      excipientType {
        name
        excipientLabel {
          name
        }
      }
      sandCoating {
        name
      }
      beadlet {
        name
      }
      tabletCoating {
        name
      }
      formulaTabletCoatings {
        type
        coatingColor
      }
      formulaCapsuleTypes {
        type
        capsuleType {
          name
        }
      }
      formulaSweeteners {
        type
        nature
        sweetener {
          size
        }
      }
      outerCapsulePrice {
        price
        productSize {
          name
        }
      }
      innerCapsulePrice {
        price
        productSize {
          name
        }
      }
      capsulePrice {
        price
        productSize {
          name
        }
        density {
          name
        }
      }
      formulaCost {
        lohCost
        neckband
        flavorCost
        per1000Cost
        coatingCost
        bottlePrice
        sweetenerCost
        syrupBaseCost
        excipientCost
        conversionCost
        ingredientsCost
        sandCoatingCost
      }
      formulaWeights {
        totalWeight
        flavorWeight
        coatingWeight
        excipientWeight
        syrupBaseWeight
        sweetenerWeight
        ingredientsWeight
        sandCoatingWeight
      }
      formulaWeightsPercentage {
        flavorWeight
        coatingWeight
        excipientWeight
        sweetenerWeight
        syrupBaseWeight
        ingredientsWeight
        sandCoatingWeight
      }
      formulaCostPercentage {
        lohCost
        neckband
        flavorCost
        coatingCost
        bottlePrice
        sweetenerCost
        syrupBaseCost
        excipientCost
        conversionCost
        sandCoatingCost
        ingredientsCost
        miscellaneousCost
      }
      formulaIngredients {
        value
        potency
        unit
        type
        mgWeight
        mgVolume
        density
        totalCost
        ingCostContribution
        showCfu
        ingredient {
          id
          name
        }
        macroNutrientsWeight {
          moisture
          calories
          protein
          carbohydrates
          dietaryFiber
          totalSugars
          addedSugar
          totalFat
          saturatedFat
          monounsaturatedFat
          polyunsaturatedFat
          transFat
          cholesterol
        }
        microNutrientsWeight {
          vitaminA
          biotin
          pantothenicAcid
          thiamin
          riboflavin
          niacin
          vitaminB6
          vitaminB12
          vitaminC
          vitaminD
          vitaminE
          folate
          vitaminK
          vitaminK2
          folicAcid
          calcium
          phosphorus
          magnesium
          sodium
          potassium
          chloride
          iron
          zinc
          iodine
          selenium
          copper
          manganese
          chromium
          molybdenum
          boron
          choline
        }
      }
      formulaBlends {
        name
        formulaIngredients {
          value
          potency
          unit
          type
          mgWeight
          totalCost
          ingCostContribution
          showCfu
          ingredient {
            id
            name
          }
          macroNutrientsWeight {
            moisture
            calories
            protein
            carbohydrates
            dietaryFiber
            totalSugars
            addedSugar
            totalFat
            saturatedFat
            monounsaturatedFat
            polyunsaturatedFat
            transFat
            cholesterol
          }
          microNutrientsWeight {
            vitaminA
            biotin
            pantothenicAcid
            thiamin
            riboflavin
            niacin
            vitaminB6
            vitaminB12
            vitaminC
            vitaminD
            vitaminE
            folate
            vitaminK
            vitaminK2
            folicAcid
            calcium
            phosphorus
            magnesium
            sodium
            potassium
            chloride
            iron
            zinc
            iodine
            selenium
            copper
            manganese
            chromium
            molybdenum
            boron
            choline
          }
        }
      }
      attachment {
        attachmentUrl
      }
      bottleCapacity {
        fillPercentage
        productSize {
          name
          max
        }
        bottleSize {
          lidSize
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetFormulaDetailQuery__
 *
 * To run a query within a React component, call `useGetFormulaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulaDetailQuery({
 *   variables: {
 *      getFormulaInput: // value for 'getFormulaInput'
 *   },
 * });
 */
export function useGetFormulaDetailQuery(baseOptions: Apollo.QueryHookOptions<GetFormulaDetailQuery, GetFormulaDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormulaDetailQuery, GetFormulaDetailQueryVariables>(GetFormulaDetailDocument, options);
      }
export function useGetFormulaDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormulaDetailQuery, GetFormulaDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormulaDetailQuery, GetFormulaDetailQueryVariables>(GetFormulaDetailDocument, options);
        }
export type GetFormulaDetailQueryHookResult = ReturnType<typeof useGetFormulaDetailQuery>;
export type GetFormulaDetailLazyQueryHookResult = ReturnType<typeof useGetFormulaDetailLazyQuery>;
export type GetFormulaDetailQueryResult = Apollo.QueryResult<GetFormulaDetailQuery, GetFormulaDetailQueryVariables>;
export const FindAllDosageFormulasDocument = gql`
    query FindAllDosageFormulas($findAllDosageFormulasInputs: FindAllDosageFormulasInputs!) {
  findAllDosageFormulas(findAllDosageFormulasInputs: $findAllDosageFormulasInputs) {
    data {
      name
      count
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllDosageFormulasQuery__
 *
 * To run a query within a React component, call `useFindAllDosageFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllDosageFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllDosageFormulasQuery({
 *   variables: {
 *      findAllDosageFormulasInputs: // value for 'findAllDosageFormulasInputs'
 *   },
 * });
 */
export function useFindAllDosageFormulasQuery(baseOptions: Apollo.QueryHookOptions<FindAllDosageFormulasQuery, FindAllDosageFormulasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllDosageFormulasQuery, FindAllDosageFormulasQueryVariables>(FindAllDosageFormulasDocument, options);
      }
export function useFindAllDosageFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllDosageFormulasQuery, FindAllDosageFormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllDosageFormulasQuery, FindAllDosageFormulasQueryVariables>(FindAllDosageFormulasDocument, options);
        }
export type FindAllDosageFormulasQueryHookResult = ReturnType<typeof useFindAllDosageFormulasQuery>;
export type FindAllDosageFormulasLazyQueryHookResult = ReturnType<typeof useFindAllDosageFormulasLazyQuery>;
export type FindAllDosageFormulasQueryResult = Apollo.QueryResult<FindAllDosageFormulasQuery, FindAllDosageFormulasQueryVariables>;
export const FindAllDosageTypeFormulasDocument = gql`
    query FindAllDosageTypeFormulas($findAllDosageTypeFormulasInput: FindAllDosageTypeFormulasInput!) {
  findAllDosageTypeFormulas(
    findAllDosageTypeFormulasInput: $findAllDosageTypeFormulasInput
  ) {
    data {
      name
      count
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllDosageTypeFormulasQuery__
 *
 * To run a query within a React component, call `useFindAllDosageTypeFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllDosageTypeFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllDosageTypeFormulasQuery({
 *   variables: {
 *      findAllDosageTypeFormulasInput: // value for 'findAllDosageTypeFormulasInput'
 *   },
 * });
 */
export function useFindAllDosageTypeFormulasQuery(baseOptions: Apollo.QueryHookOptions<FindAllDosageTypeFormulasQuery, FindAllDosageTypeFormulasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllDosageTypeFormulasQuery, FindAllDosageTypeFormulasQueryVariables>(FindAllDosageTypeFormulasDocument, options);
      }
export function useFindAllDosageTypeFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllDosageTypeFormulasQuery, FindAllDosageTypeFormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllDosageTypeFormulasQuery, FindAllDosageTypeFormulasQueryVariables>(FindAllDosageTypeFormulasDocument, options);
        }
export type FindAllDosageTypeFormulasQueryHookResult = ReturnType<typeof useFindAllDosageTypeFormulasQuery>;
export type FindAllDosageTypeFormulasLazyQueryHookResult = ReturnType<typeof useFindAllDosageTypeFormulasLazyQuery>;
export type FindAllDosageTypeFormulasQueryResult = Apollo.QueryResult<FindAllDosageTypeFormulasQuery, FindAllDosageTypeFormulasQueryVariables>;
export const FindFormulasCountByYearDocument = gql`
    query FindFormulasCountByYear($findFormulasCountByYearInput: FindFormulasCountByYearInput!) {
  findFormulasCountByYear(
    findFormulasCountByYearInput: $findFormulasCountByYearInput
  ) {
    data
    response {
      status
    }
  }
}
    `;

/**
 * __useFindFormulasCountByYearQuery__
 *
 * To run a query within a React component, call `useFindFormulasCountByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFormulasCountByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFormulasCountByYearQuery({
 *   variables: {
 *      findFormulasCountByYearInput: // value for 'findFormulasCountByYearInput'
 *   },
 * });
 */
export function useFindFormulasCountByYearQuery(baseOptions: Apollo.QueryHookOptions<FindFormulasCountByYearQuery, FindFormulasCountByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFormulasCountByYearQuery, FindFormulasCountByYearQueryVariables>(FindFormulasCountByYearDocument, options);
      }
export function useFindFormulasCountByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFormulasCountByYearQuery, FindFormulasCountByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFormulasCountByYearQuery, FindFormulasCountByYearQueryVariables>(FindFormulasCountByYearDocument, options);
        }
export type FindFormulasCountByYearQueryHookResult = ReturnType<typeof useFindFormulasCountByYearQuery>;
export type FindFormulasCountByYearLazyQueryHookResult = ReturnType<typeof useFindFormulasCountByYearLazyQuery>;
export type FindFormulasCountByYearQueryResult = Apollo.QueryResult<FindFormulasCountByYearQuery, FindFormulasCountByYearQueryVariables>;
export const GetDosageFormulasCountDocument = gql`
    query GetDosageFormulasCount($getDosageFormulasCountInput: GetDosageFormulasCountInput!) {
  getDosageFormulasCount(
    getDosageFormulasCountInput: $getDosageFormulasCountInput
  ) {
    response {
      status
    }
    data {
      name
      count
    }
  }
}
    `;

/**
 * __useGetDosageFormulasCountQuery__
 *
 * To run a query within a React component, call `useGetDosageFormulasCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDosageFormulasCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDosageFormulasCountQuery({
 *   variables: {
 *      getDosageFormulasCountInput: // value for 'getDosageFormulasCountInput'
 *   },
 * });
 */
export function useGetDosageFormulasCountQuery(baseOptions: Apollo.QueryHookOptions<GetDosageFormulasCountQuery, GetDosageFormulasCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDosageFormulasCountQuery, GetDosageFormulasCountQueryVariables>(GetDosageFormulasCountDocument, options);
      }
export function useGetDosageFormulasCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDosageFormulasCountQuery, GetDosageFormulasCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDosageFormulasCountQuery, GetDosageFormulasCountQueryVariables>(GetDosageFormulasCountDocument, options);
        }
export type GetDosageFormulasCountQueryHookResult = ReturnType<typeof useGetDosageFormulasCountQuery>;
export type GetDosageFormulasCountLazyQueryHookResult = ReturnType<typeof useGetDosageFormulasCountLazyQuery>;
export type GetDosageFormulasCountQueryResult = Apollo.QueryResult<GetDosageFormulasCountQuery, GetDosageFormulasCountQueryVariables>;
export const GetFormulasIngredientReportDocument = gql`
    query GetFormulasIngredientReport($getFormulasIngredientInput: GetFormulasIngredientInput!) {
  getFormulasIngredient(getFormulasIngredientInput: $getFormulasIngredientInput) {
    response {
      status
    }
    data {
      category
      subCategory
      name
      usage
      rank
    }
  }
}
    `;

/**
 * __useGetFormulasIngredientReportQuery__
 *
 * To run a query within a React component, call `useGetFormulasIngredientReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulasIngredientReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulasIngredientReportQuery({
 *   variables: {
 *      getFormulasIngredientInput: // value for 'getFormulasIngredientInput'
 *   },
 * });
 */
export function useGetFormulasIngredientReportQuery(baseOptions: Apollo.QueryHookOptions<GetFormulasIngredientReportQuery, GetFormulasIngredientReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormulasIngredientReportQuery, GetFormulasIngredientReportQueryVariables>(GetFormulasIngredientReportDocument, options);
      }
export function useGetFormulasIngredientReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormulasIngredientReportQuery, GetFormulasIngredientReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormulasIngredientReportQuery, GetFormulasIngredientReportQueryVariables>(GetFormulasIngredientReportDocument, options);
        }
export type GetFormulasIngredientReportQueryHookResult = ReturnType<typeof useGetFormulasIngredientReportQuery>;
export type GetFormulasIngredientReportLazyQueryHookResult = ReturnType<typeof useGetFormulasIngredientReportLazyQuery>;
export type GetFormulasIngredientReportQueryResult = Apollo.QueryResult<GetFormulasIngredientReportQuery, GetFormulasIngredientReportQueryVariables>;
export const UpdateFormulaStatusDocument = gql`
    mutation UpdateFormulaStatus($updateFormulaStatusInput: UpdateFormulaStatusInput!) {
  updateFormulaStatus(updateFormulaStatusInput: $updateFormulaStatusInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateFormulaStatusMutationFn = Apollo.MutationFunction<UpdateFormulaStatusMutation, UpdateFormulaStatusMutationVariables>;

/**
 * __useUpdateFormulaStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFormulaStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormulaStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormulaStatusMutation, { data, loading, error }] = useUpdateFormulaStatusMutation({
 *   variables: {
 *      updateFormulaStatusInput: // value for 'updateFormulaStatusInput'
 *   },
 * });
 */
export function useUpdateFormulaStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormulaStatusMutation, UpdateFormulaStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormulaStatusMutation, UpdateFormulaStatusMutationVariables>(UpdateFormulaStatusDocument, options);
      }
export type UpdateFormulaStatusMutationHookResult = ReturnType<typeof useUpdateFormulaStatusMutation>;
export type UpdateFormulaStatusMutationResult = Apollo.MutationResult<UpdateFormulaStatusMutation>;
export type UpdateFormulaStatusMutationOptions = Apollo.BaseMutationOptions<UpdateFormulaStatusMutation, UpdateFormulaStatusMutationVariables>;
export const CreateFormulaDocument = gql`
    mutation CreateFormula($createFormulaInput: CreateFormulaInput!) {
  createFormula(createFormulaInput: $createFormulaInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateFormulaMutationFn = Apollo.MutationFunction<CreateFormulaMutation, CreateFormulaMutationVariables>;

/**
 * __useCreateFormulaMutation__
 *
 * To run a mutation, you first call `useCreateFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormulaMutation, { data, loading, error }] = useCreateFormulaMutation({
 *   variables: {
 *      createFormulaInput: // value for 'createFormulaInput'
 *   },
 * });
 */
export function useCreateFormulaMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormulaMutation, CreateFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormulaMutation, CreateFormulaMutationVariables>(CreateFormulaDocument, options);
      }
export type CreateFormulaMutationHookResult = ReturnType<typeof useCreateFormulaMutation>;
export type CreateFormulaMutationResult = Apollo.MutationResult<CreateFormulaMutation>;
export type CreateFormulaMutationOptions = Apollo.BaseMutationOptions<CreateFormulaMutation, CreateFormulaMutationVariables>;
export const UpdateFormulaDocument = gql`
    mutation UpdateFormula($updateFormulaInput: UpdateFormulaInput!) {
  updateFormula(updateFormulaInput: $updateFormulaInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateFormulaMutationFn = Apollo.MutationFunction<UpdateFormulaMutation, UpdateFormulaMutationVariables>;

/**
 * __useUpdateFormulaMutation__
 *
 * To run a mutation, you first call `useUpdateFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormulaMutation, { data, loading, error }] = useUpdateFormulaMutation({
 *   variables: {
 *      updateFormulaInput: // value for 'updateFormulaInput'
 *   },
 * });
 */
export function useUpdateFormulaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormulaMutation, UpdateFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormulaMutation, UpdateFormulaMutationVariables>(UpdateFormulaDocument, options);
      }
export type UpdateFormulaMutationHookResult = ReturnType<typeof useUpdateFormulaMutation>;
export type UpdateFormulaMutationResult = Apollo.MutationResult<UpdateFormulaMutation>;
export type UpdateFormulaMutationOptions = Apollo.BaseMutationOptions<UpdateFormulaMutation, UpdateFormulaMutationVariables>;
export const UpdateDraftedFormulaDocument = gql`
    mutation UpdateDraftedFormula($updateDraftedFormulaInput: UpdateDraftedFormulaInput!) {
  updateDraftedFormula(updateDraftedFormulaInput: $updateDraftedFormulaInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateDraftedFormulaMutationFn = Apollo.MutationFunction<UpdateDraftedFormulaMutation, UpdateDraftedFormulaMutationVariables>;

/**
 * __useUpdateDraftedFormulaMutation__
 *
 * To run a mutation, you first call `useUpdateDraftedFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftedFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftedFormulaMutation, { data, loading, error }] = useUpdateDraftedFormulaMutation({
 *   variables: {
 *      updateDraftedFormulaInput: // value for 'updateDraftedFormulaInput'
 *   },
 * });
 */
export function useUpdateDraftedFormulaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftedFormulaMutation, UpdateDraftedFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftedFormulaMutation, UpdateDraftedFormulaMutationVariables>(UpdateDraftedFormulaDocument, options);
      }
export type UpdateDraftedFormulaMutationHookResult = ReturnType<typeof useUpdateDraftedFormulaMutation>;
export type UpdateDraftedFormulaMutationResult = Apollo.MutationResult<UpdateDraftedFormulaMutation>;
export type UpdateDraftedFormulaMutationOptions = Apollo.BaseMutationOptions<UpdateDraftedFormulaMutation, UpdateDraftedFormulaMutationVariables>;
export const SaveFormulaAsDraftDocument = gql`
    mutation SaveFormulaAsDraft($saveFormulaAsDraftInput: SaveFormulaAsDraftInput!) {
  saveFormulaAsDraft(saveFormulaAsDraftInput: $saveFormulaAsDraftInput) {
    response {
      status
      message
    }
    formula {
      id
    }
  }
}
    `;
export type SaveFormulaAsDraftMutationFn = Apollo.MutationFunction<SaveFormulaAsDraftMutation, SaveFormulaAsDraftMutationVariables>;

/**
 * __useSaveFormulaAsDraftMutation__
 *
 * To run a mutation, you first call `useSaveFormulaAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFormulaAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFormulaAsDraftMutation, { data, loading, error }] = useSaveFormulaAsDraftMutation({
 *   variables: {
 *      saveFormulaAsDraftInput: // value for 'saveFormulaAsDraftInput'
 *   },
 * });
 */
export function useSaveFormulaAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveFormulaAsDraftMutation, SaveFormulaAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFormulaAsDraftMutation, SaveFormulaAsDraftMutationVariables>(SaveFormulaAsDraftDocument, options);
      }
export type SaveFormulaAsDraftMutationHookResult = ReturnType<typeof useSaveFormulaAsDraftMutation>;
export type SaveFormulaAsDraftMutationResult = Apollo.MutationResult<SaveFormulaAsDraftMutation>;
export type SaveFormulaAsDraftMutationOptions = Apollo.BaseMutationOptions<SaveFormulaAsDraftMutation, SaveFormulaAsDraftMutationVariables>;
export const FindAllProductIngredientSyrupTypesTableDocument = gql`
    query FindAllProductIngredientSyrupTypesTable($findAllProductIngredientSyrupTypesInput: FindAllProductIngredientSyrupTypesInput!) {
  findAllProductIngredientSyrupTypes(
    findAllProductIngredientSyrupTypesInput: $findAllProductIngredientSyrupTypesInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      percentage
      productIngredients {
        id
        name
        isActive
      }
    }
  }
}
    `;

/**
 * __useFindAllProductIngredientSyrupTypesTableQuery__
 *
 * To run a query within a React component, call `useFindAllProductIngredientSyrupTypesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductIngredientSyrupTypesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductIngredientSyrupTypesTableQuery({
 *   variables: {
 *      findAllProductIngredientSyrupTypesInput: // value for 'findAllProductIngredientSyrupTypesInput'
 *   },
 * });
 */
export function useFindAllProductIngredientSyrupTypesTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductIngredientSyrupTypesTableQuery, FindAllProductIngredientSyrupTypesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductIngredientSyrupTypesTableQuery, FindAllProductIngredientSyrupTypesTableQueryVariables>(FindAllProductIngredientSyrupTypesTableDocument, options);
      }
export function useFindAllProductIngredientSyrupTypesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductIngredientSyrupTypesTableQuery, FindAllProductIngredientSyrupTypesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductIngredientSyrupTypesTableQuery, FindAllProductIngredientSyrupTypesTableQueryVariables>(FindAllProductIngredientSyrupTypesTableDocument, options);
        }
export type FindAllProductIngredientSyrupTypesTableQueryHookResult = ReturnType<typeof useFindAllProductIngredientSyrupTypesTableQuery>;
export type FindAllProductIngredientSyrupTypesTableLazyQueryHookResult = ReturnType<typeof useFindAllProductIngredientSyrupTypesTableLazyQuery>;
export type FindAllProductIngredientSyrupTypesTableQueryResult = Apollo.QueryResult<FindAllProductIngredientSyrupTypesTableQuery, FindAllProductIngredientSyrupTypesTableQueryVariables>;
export const CreateProductIngredientSyrupTypeDocument = gql`
    mutation CreateProductIngredientSyrupType($createProductIngredientSyrupTypeInput: CreateProductIngredientSyrupTypeInput!) {
  createProductIngredientSyrupType(
    createProductIngredientSyrupTypeInput: $createProductIngredientSyrupTypeInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateProductIngredientSyrupTypeMutationFn = Apollo.MutationFunction<CreateProductIngredientSyrupTypeMutation, CreateProductIngredientSyrupTypeMutationVariables>;

/**
 * __useCreateProductIngredientSyrupTypeMutation__
 *
 * To run a mutation, you first call `useCreateProductIngredientSyrupTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductIngredientSyrupTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductIngredientSyrupTypeMutation, { data, loading, error }] = useCreateProductIngredientSyrupTypeMutation({
 *   variables: {
 *      createProductIngredientSyrupTypeInput: // value for 'createProductIngredientSyrupTypeInput'
 *   },
 * });
 */
export function useCreateProductIngredientSyrupTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductIngredientSyrupTypeMutation, CreateProductIngredientSyrupTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductIngredientSyrupTypeMutation, CreateProductIngredientSyrupTypeMutationVariables>(CreateProductIngredientSyrupTypeDocument, options);
      }
export type CreateProductIngredientSyrupTypeMutationHookResult = ReturnType<typeof useCreateProductIngredientSyrupTypeMutation>;
export type CreateProductIngredientSyrupTypeMutationResult = Apollo.MutationResult<CreateProductIngredientSyrupTypeMutation>;
export type CreateProductIngredientSyrupTypeMutationOptions = Apollo.BaseMutationOptions<CreateProductIngredientSyrupTypeMutation, CreateProductIngredientSyrupTypeMutationVariables>;
export const UpdateProductIngredientSyrupTypeDocument = gql`
    mutation UpdateProductIngredientSyrupType($updateProductIngredientSyrupTypeInput: UpdateProductIngredientSyrupTypeInput!) {
  updateProductIngredientSyrupType(
    updateProductIngredientSyrupTypeInput: $updateProductIngredientSyrupTypeInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateProductIngredientSyrupTypeMutationFn = Apollo.MutationFunction<UpdateProductIngredientSyrupTypeMutation, UpdateProductIngredientSyrupTypeMutationVariables>;

/**
 * __useUpdateProductIngredientSyrupTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProductIngredientSyrupTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductIngredientSyrupTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductIngredientSyrupTypeMutation, { data, loading, error }] = useUpdateProductIngredientSyrupTypeMutation({
 *   variables: {
 *      updateProductIngredientSyrupTypeInput: // value for 'updateProductIngredientSyrupTypeInput'
 *   },
 * });
 */
export function useUpdateProductIngredientSyrupTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductIngredientSyrupTypeMutation, UpdateProductIngredientSyrupTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductIngredientSyrupTypeMutation, UpdateProductIngredientSyrupTypeMutationVariables>(UpdateProductIngredientSyrupTypeDocument, options);
      }
export type UpdateProductIngredientSyrupTypeMutationHookResult = ReturnType<typeof useUpdateProductIngredientSyrupTypeMutation>;
export type UpdateProductIngredientSyrupTypeMutationResult = Apollo.MutationResult<UpdateProductIngredientSyrupTypeMutation>;
export type UpdateProductIngredientSyrupTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProductIngredientSyrupTypeMutation, UpdateProductIngredientSyrupTypeMutationVariables>;
export const RemoveProductIngredientSyrupTypeDocument = gql`
    mutation RemoveProductIngredientSyrupType($removeProductIngredientSyrupTypeInput: RemoveProductIngredientSyrupTypeInput!) {
  removeProductIngredientSyrupType(
    removeProductIngredientSyrupTypeInput: $removeProductIngredientSyrupTypeInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type RemoveProductIngredientSyrupTypeMutationFn = Apollo.MutationFunction<RemoveProductIngredientSyrupTypeMutation, RemoveProductIngredientSyrupTypeMutationVariables>;

/**
 * __useRemoveProductIngredientSyrupTypeMutation__
 *
 * To run a mutation, you first call `useRemoveProductIngredientSyrupTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductIngredientSyrupTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductIngredientSyrupTypeMutation, { data, loading, error }] = useRemoveProductIngredientSyrupTypeMutation({
 *   variables: {
 *      removeProductIngredientSyrupTypeInput: // value for 'removeProductIngredientSyrupTypeInput'
 *   },
 * });
 */
export function useRemoveProductIngredientSyrupTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductIngredientSyrupTypeMutation, RemoveProductIngredientSyrupTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductIngredientSyrupTypeMutation, RemoveProductIngredientSyrupTypeMutationVariables>(RemoveProductIngredientSyrupTypeDocument, options);
      }
export type RemoveProductIngredientSyrupTypeMutationHookResult = ReturnType<typeof useRemoveProductIngredientSyrupTypeMutation>;
export type RemoveProductIngredientSyrupTypeMutationResult = Apollo.MutationResult<RemoveProductIngredientSyrupTypeMutation>;
export type RemoveProductIngredientSyrupTypeMutationOptions = Apollo.BaseMutationOptions<RemoveProductIngredientSyrupTypeMutation, RemoveProductIngredientSyrupTypeMutationVariables>;
export const FindAllProductFormulationSyrupTypesTableDocument = gql`
    query FindAllProductFormulationSyrupTypesTable($findAllProductFormulationSyrupTypesInput: FindAllProductFormulationSyrupTypesInput!) {
  findAllProductFormulationSyrupTypes(
    findAllProductFormulationSyrupTypesInput: $findAllProductFormulationSyrupTypesInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      cost
      weight
      isActive
      productType {
        name
      }
      productSize {
        name
      }
      subProductType {
        name
      }
      productFormulationType {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllProductFormulationSyrupTypesTableQuery__
 *
 * To run a query within a React component, call `useFindAllProductFormulationSyrupTypesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductFormulationSyrupTypesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductFormulationSyrupTypesTableQuery({
 *   variables: {
 *      findAllProductFormulationSyrupTypesInput: // value for 'findAllProductFormulationSyrupTypesInput'
 *   },
 * });
 */
export function useFindAllProductFormulationSyrupTypesTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductFormulationSyrupTypesTableQuery, FindAllProductFormulationSyrupTypesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductFormulationSyrupTypesTableQuery, FindAllProductFormulationSyrupTypesTableQueryVariables>(FindAllProductFormulationSyrupTypesTableDocument, options);
      }
export function useFindAllProductFormulationSyrupTypesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductFormulationSyrupTypesTableQuery, FindAllProductFormulationSyrupTypesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductFormulationSyrupTypesTableQuery, FindAllProductFormulationSyrupTypesTableQueryVariables>(FindAllProductFormulationSyrupTypesTableDocument, options);
        }
export type FindAllProductFormulationSyrupTypesTableQueryHookResult = ReturnType<typeof useFindAllProductFormulationSyrupTypesTableQuery>;
export type FindAllProductFormulationSyrupTypesTableLazyQueryHookResult = ReturnType<typeof useFindAllProductFormulationSyrupTypesTableLazyQuery>;
export type FindAllProductFormulationSyrupTypesTableQueryResult = Apollo.QueryResult<FindAllProductFormulationSyrupTypesTableQuery, FindAllProductFormulationSyrupTypesTableQueryVariables>;
export const FindAllProductFormulationSyrupTypesSelectorDocument = gql`
    query FindAllProductFormulationSyrupTypesSelector($findAllProductFormulationSyrupTypesInput: FindAllProductFormulationSyrupTypesInput!) {
  findAllProductFormulationSyrupTypes(
    findAllProductFormulationSyrupTypesInput: $findAllProductFormulationSyrupTypesInput
  ) {
    response {
      status
    }
    pagination {
      totalPages
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllProductFormulationSyrupTypesSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllProductFormulationSyrupTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductFormulationSyrupTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductFormulationSyrupTypesSelectorQuery({
 *   variables: {
 *      findAllProductFormulationSyrupTypesInput: // value for 'findAllProductFormulationSyrupTypesInput'
 *   },
 * });
 */
export function useFindAllProductFormulationSyrupTypesSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductFormulationSyrupTypesSelectorQuery, FindAllProductFormulationSyrupTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductFormulationSyrupTypesSelectorQuery, FindAllProductFormulationSyrupTypesSelectorQueryVariables>(FindAllProductFormulationSyrupTypesSelectorDocument, options);
      }
export function useFindAllProductFormulationSyrupTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductFormulationSyrupTypesSelectorQuery, FindAllProductFormulationSyrupTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductFormulationSyrupTypesSelectorQuery, FindAllProductFormulationSyrupTypesSelectorQueryVariables>(FindAllProductFormulationSyrupTypesSelectorDocument, options);
        }
export type FindAllProductFormulationSyrupTypesSelectorQueryHookResult = ReturnType<typeof useFindAllProductFormulationSyrupTypesSelectorQuery>;
export type FindAllProductFormulationSyrupTypesSelectorLazyQueryHookResult = ReturnType<typeof useFindAllProductFormulationSyrupTypesSelectorLazyQuery>;
export type FindAllProductFormulationSyrupTypesSelectorQueryResult = Apollo.QueryResult<FindAllProductFormulationSyrupTypesSelectorQuery, FindAllProductFormulationSyrupTypesSelectorQueryVariables>;
export const GetProductFormulationSyrupTypeDocument = gql`
    query GetProductFormulationSyrupType($getProductFormulationSyrupTypeInput: GetProductFormulationSyrupTypeInput!) {
  getProductFormulationSyrupType(
    getProductFormulationSyrupTypeInput: $getProductFormulationSyrupTypeInput
  ) {
    productFormulationSyrupType {
      cost
      unit
      weight
      name
      productType {
        id
        name
      }
      subProductType {
        id
        name
      }
      productSize {
        id
        name
      }
      productFormulationType {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetProductFormulationSyrupTypeQuery__
 *
 * To run a query within a React component, call `useGetProductFormulationSyrupTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductFormulationSyrupTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductFormulationSyrupTypeQuery({
 *   variables: {
 *      getProductFormulationSyrupTypeInput: // value for 'getProductFormulationSyrupTypeInput'
 *   },
 * });
 */
export function useGetProductFormulationSyrupTypeQuery(baseOptions: Apollo.QueryHookOptions<GetProductFormulationSyrupTypeQuery, GetProductFormulationSyrupTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductFormulationSyrupTypeQuery, GetProductFormulationSyrupTypeQueryVariables>(GetProductFormulationSyrupTypeDocument, options);
      }
export function useGetProductFormulationSyrupTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductFormulationSyrupTypeQuery, GetProductFormulationSyrupTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductFormulationSyrupTypeQuery, GetProductFormulationSyrupTypeQueryVariables>(GetProductFormulationSyrupTypeDocument, options);
        }
export type GetProductFormulationSyrupTypeQueryHookResult = ReturnType<typeof useGetProductFormulationSyrupTypeQuery>;
export type GetProductFormulationSyrupTypeLazyQueryHookResult = ReturnType<typeof useGetProductFormulationSyrupTypeLazyQuery>;
export type GetProductFormulationSyrupTypeQueryResult = Apollo.QueryResult<GetProductFormulationSyrupTypeQuery, GetProductFormulationSyrupTypeQueryVariables>;
export const CreateProductFormulationSyrupTypeDocument = gql`
    mutation CreateProductFormulationSyrupType($createProductFormulationSyrupTypeInput: CreateProductFormulationSyrupTypeInput!) {
  createProductFormulationSyrupType(
    createProductFormulationSyrupTypeInput: $createProductFormulationSyrupTypeInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateProductFormulationSyrupTypeMutationFn = Apollo.MutationFunction<CreateProductFormulationSyrupTypeMutation, CreateProductFormulationSyrupTypeMutationVariables>;

/**
 * __useCreateProductFormulationSyrupTypeMutation__
 *
 * To run a mutation, you first call `useCreateProductFormulationSyrupTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductFormulationSyrupTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductFormulationSyrupTypeMutation, { data, loading, error }] = useCreateProductFormulationSyrupTypeMutation({
 *   variables: {
 *      createProductFormulationSyrupTypeInput: // value for 'createProductFormulationSyrupTypeInput'
 *   },
 * });
 */
export function useCreateProductFormulationSyrupTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductFormulationSyrupTypeMutation, CreateProductFormulationSyrupTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductFormulationSyrupTypeMutation, CreateProductFormulationSyrupTypeMutationVariables>(CreateProductFormulationSyrupTypeDocument, options);
      }
export type CreateProductFormulationSyrupTypeMutationHookResult = ReturnType<typeof useCreateProductFormulationSyrupTypeMutation>;
export type CreateProductFormulationSyrupTypeMutationResult = Apollo.MutationResult<CreateProductFormulationSyrupTypeMutation>;
export type CreateProductFormulationSyrupTypeMutationOptions = Apollo.BaseMutationOptions<CreateProductFormulationSyrupTypeMutation, CreateProductFormulationSyrupTypeMutationVariables>;
export const UpdateProductFormulationSyrupTypeDocument = gql`
    mutation UpdateProductFormulationSyrupType($updateProductFormulationSyrupTypeInput: UpdateProductFormulationSyrupTypeInput!) {
  updateProductFormulationSyrupType(
    updateProductFormulationSyrupTypeInput: $updateProductFormulationSyrupTypeInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateProductFormulationSyrupTypeMutationFn = Apollo.MutationFunction<UpdateProductFormulationSyrupTypeMutation, UpdateProductFormulationSyrupTypeMutationVariables>;

/**
 * __useUpdateProductFormulationSyrupTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProductFormulationSyrupTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductFormulationSyrupTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductFormulationSyrupTypeMutation, { data, loading, error }] = useUpdateProductFormulationSyrupTypeMutation({
 *   variables: {
 *      updateProductFormulationSyrupTypeInput: // value for 'updateProductFormulationSyrupTypeInput'
 *   },
 * });
 */
export function useUpdateProductFormulationSyrupTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductFormulationSyrupTypeMutation, UpdateProductFormulationSyrupTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductFormulationSyrupTypeMutation, UpdateProductFormulationSyrupTypeMutationVariables>(UpdateProductFormulationSyrupTypeDocument, options);
      }
export type UpdateProductFormulationSyrupTypeMutationHookResult = ReturnType<typeof useUpdateProductFormulationSyrupTypeMutation>;
export type UpdateProductFormulationSyrupTypeMutationResult = Apollo.MutationResult<UpdateProductFormulationSyrupTypeMutation>;
export type UpdateProductFormulationSyrupTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProductFormulationSyrupTypeMutation, UpdateProductFormulationSyrupTypeMutationVariables>;
export const FindAllIngredientsDocument = gql`
    query FindAllIngredients($findAllIngredientsInput: FindAllIngredientsInput!) {
  findAllIngredients(findAllIngredientsInput: $findAllIngredientsInput) {
    data {
      id
      name
      cost
      isActive
      category {
        name
      }
      subCategory {
        name
      }
    }
    pagination {
      page
      totalCount
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllIngredientsQuery__
 *
 * To run a query within a React component, call `useFindAllIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllIngredientsQuery({
 *   variables: {
 *      findAllIngredientsInput: // value for 'findAllIngredientsInput'
 *   },
 * });
 */
export function useFindAllIngredientsQuery(baseOptions: Apollo.QueryHookOptions<FindAllIngredientsQuery, FindAllIngredientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllIngredientsQuery, FindAllIngredientsQueryVariables>(FindAllIngredientsDocument, options);
      }
export function useFindAllIngredientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllIngredientsQuery, FindAllIngredientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllIngredientsQuery, FindAllIngredientsQueryVariables>(FindAllIngredientsDocument, options);
        }
export type FindAllIngredientsQueryHookResult = ReturnType<typeof useFindAllIngredientsQuery>;
export type FindAllIngredientsLazyQueryHookResult = ReturnType<typeof useFindAllIngredientsLazyQuery>;
export type FindAllIngredientsQueryResult = Apollo.QueryResult<FindAllIngredientsQuery, FindAllIngredientsQueryVariables>;
export const FindAllSyrupBaseIngredientsDocument = gql`
    query FindAllSyrupBaseIngredients($findAllIngredientsInput: FindAllIngredientsInput!) {
  findAllSyrupBaseIngredients(findAllIngredientsInput: $findAllIngredientsInput) {
    data {
      id
      name
      isActive
      productFormulationSyrupType {
        name
      }
    }
    pagination {
      page
      totalCount
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllSyrupBaseIngredientsQuery__
 *
 * To run a query within a React component, call `useFindAllSyrupBaseIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSyrupBaseIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSyrupBaseIngredientsQuery({
 *   variables: {
 *      findAllIngredientsInput: // value for 'findAllIngredientsInput'
 *   },
 * });
 */
export function useFindAllSyrupBaseIngredientsQuery(baseOptions: Apollo.QueryHookOptions<FindAllSyrupBaseIngredientsQuery, FindAllSyrupBaseIngredientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSyrupBaseIngredientsQuery, FindAllSyrupBaseIngredientsQueryVariables>(FindAllSyrupBaseIngredientsDocument, options);
      }
export function useFindAllSyrupBaseIngredientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSyrupBaseIngredientsQuery, FindAllSyrupBaseIngredientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSyrupBaseIngredientsQuery, FindAllSyrupBaseIngredientsQueryVariables>(FindAllSyrupBaseIngredientsDocument, options);
        }
export type FindAllSyrupBaseIngredientsQueryHookResult = ReturnType<typeof useFindAllSyrupBaseIngredientsQuery>;
export type FindAllSyrupBaseIngredientsLazyQueryHookResult = ReturnType<typeof useFindAllSyrupBaseIngredientsLazyQuery>;
export type FindAllSyrupBaseIngredientsQueryResult = Apollo.QueryResult<FindAllSyrupBaseIngredientsQuery, FindAllSyrupBaseIngredientsQueryVariables>;
export const FindAllIngredientsSelectorDocument = gql`
    query FindAllIngredientsSelector($findAllIngredientsInput: FindAllIngredientsInput!) {
  findAllIngredients(findAllIngredientsInput: $findAllIngredientsInput) {
    data {
      id
      name
      isActive
    }
    pagination {
      totalPages
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllIngredientsSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllIngredientsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllIngredientsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllIngredientsSelectorQuery({
 *   variables: {
 *      findAllIngredientsInput: // value for 'findAllIngredientsInput'
 *   },
 * });
 */
export function useFindAllIngredientsSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllIngredientsSelectorQuery, FindAllIngredientsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllIngredientsSelectorQuery, FindAllIngredientsSelectorQueryVariables>(FindAllIngredientsSelectorDocument, options);
      }
export function useFindAllIngredientsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllIngredientsSelectorQuery, FindAllIngredientsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllIngredientsSelectorQuery, FindAllIngredientsSelectorQueryVariables>(FindAllIngredientsSelectorDocument, options);
        }
export type FindAllIngredientsSelectorQueryHookResult = ReturnType<typeof useFindAllIngredientsSelectorQuery>;
export type FindAllIngredientsSelectorLazyQueryHookResult = ReturnType<typeof useFindAllIngredientsSelectorLazyQuery>;
export type FindAllIngredientsSelectorQueryResult = Apollo.QueryResult<FindAllIngredientsSelectorQuery, FindAllIngredientsSelectorQueryVariables>;
export const FindAllIngredientsForSelectorDocument = gql`
    query FindAllIngredientsForSelector($findAllIngredientsInput: FindAllIngredientsInput!) {
  findAllIngredients(findAllIngredientsInput: $findAllIngredientsInput) {
    data {
      id
      name
      potency
      suggestedOverage
      isActive
      gummyOverage
    }
    pagination {
      totalPages
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllIngredientsForSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllIngredientsForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllIngredientsForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllIngredientsForSelectorQuery({
 *   variables: {
 *      findAllIngredientsInput: // value for 'findAllIngredientsInput'
 *   },
 * });
 */
export function useFindAllIngredientsForSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllIngredientsForSelectorQuery, FindAllIngredientsForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllIngredientsForSelectorQuery, FindAllIngredientsForSelectorQueryVariables>(FindAllIngredientsForSelectorDocument, options);
      }
export function useFindAllIngredientsForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllIngredientsForSelectorQuery, FindAllIngredientsForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllIngredientsForSelectorQuery, FindAllIngredientsForSelectorQueryVariables>(FindAllIngredientsForSelectorDocument, options);
        }
export type FindAllIngredientsForSelectorQueryHookResult = ReturnType<typeof useFindAllIngredientsForSelectorQuery>;
export type FindAllIngredientsForSelectorLazyQueryHookResult = ReturnType<typeof useFindAllIngredientsForSelectorLazyQuery>;
export type FindAllIngredientsForSelectorQueryResult = Apollo.QueryResult<FindAllIngredientsForSelectorQuery, FindAllIngredientsForSelectorQueryVariables>;
export const FindAllAllergensDocument = gql`
    query FindAllAllergens($findAllAllergensInput: FindAllAllergensInput!) {
  findAllAllergens(findAllAllergensInput: $findAllAllergensInput) {
    data {
      id
      name
      description
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllAllergensQuery__
 *
 * To run a query within a React component, call `useFindAllAllergensQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAllergensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAllergensQuery({
 *   variables: {
 *      findAllAllergensInput: // value for 'findAllAllergensInput'
 *   },
 * });
 */
export function useFindAllAllergensQuery(baseOptions: Apollo.QueryHookOptions<FindAllAllergensQuery, FindAllAllergensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAllergensQuery, FindAllAllergensQueryVariables>(FindAllAllergensDocument, options);
      }
export function useFindAllAllergensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAllergensQuery, FindAllAllergensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAllergensQuery, FindAllAllergensQueryVariables>(FindAllAllergensDocument, options);
        }
export type FindAllAllergensQueryHookResult = ReturnType<typeof useFindAllAllergensQuery>;
export type FindAllAllergensLazyQueryHookResult = ReturnType<typeof useFindAllAllergensLazyQuery>;
export type FindAllAllergensQueryResult = Apollo.QueryResult<FindAllAllergensQuery, FindAllAllergensQueryVariables>;
export const GetIngredientDocument = gql`
    query GetIngredient($getIngredientInput: GetIngredientInput!) {
  getIngredient(getIngredientInput: $getIngredientInput) {
    response {
      status
    }
    ingredient {
      id
      name
      type
      latinName
      tradeMarkName
      scientificName
      description
      isOrganic
      cost
      amount
      showB3
      potency
      shelfLife
      nutrients
      nutrientName
      gummyOverage
      suggestedOverage
      proBiotic
      manufacturingCountry
      originCountry
      density
      lossOnDrying
      avergageParticleSize
      ingredientProductTypes {
        productTypeId
      }
      ingredientAllergens {
        allergen {
          id
        }
      }
      ingredientSuppliers {
        type
        supplier {
          id
          name
        }
      }
      category {
        id
        name
      }
      subCategory {
        id
        name
      }
      ingredientInfo {
        ingredientId
        organic
        moisture
        calories
        protein
        carbohydrates
        dietaryFiber
        totalSugars
        addedSugar
        totalFat
        saturatedFat
        monounsaturatedFat
        polyunsaturatedFat
        transFat
        vitaminA
        biotin
        thiamin
        riboflavin
        niacin
        vitaminB6
        vitaminB12
        vitaminC
        vitaminD
        vitaminE
        magnesium
        zinc
        vitaminK2
        choline
        iodine
        folate
        cholesterol
        calcium
        iron
        potassium
        boron
        sodium
        arsenic
        cadmium
        lead
        mercury
        chloride
        copper
        chromium
        selenium
        manganese
        phosphorus
        molybdenum
        pantothenicAcid
      }
      ingredientCarriers {
        carrier {
          id
          name
        }
        percentage
      }
      ingredientSubComponents {
        name
        percentage
      }
    }
  }
}
    `;

/**
 * __useGetIngredientQuery__
 *
 * To run a query within a React component, call `useGetIngredientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIngredientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIngredientQuery({
 *   variables: {
 *      getIngredientInput: // value for 'getIngredientInput'
 *   },
 * });
 */
export function useGetIngredientQuery(baseOptions: Apollo.QueryHookOptions<GetIngredientQuery, GetIngredientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIngredientQuery, GetIngredientQueryVariables>(GetIngredientDocument, options);
      }
export function useGetIngredientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIngredientQuery, GetIngredientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIngredientQuery, GetIngredientQueryVariables>(GetIngredientDocument, options);
        }
export type GetIngredientQueryHookResult = ReturnType<typeof useGetIngredientQuery>;
export type GetIngredientLazyQueryHookResult = ReturnType<typeof useGetIngredientLazyQuery>;
export type GetIngredientQueryResult = Apollo.QueryResult<GetIngredientQuery, GetIngredientQueryVariables>;
export const GetSyrupBaseIngredientDocument = gql`
    query GetSyrupBaseIngredient($getIngredientInput: GetIngredientInput!) {
  getIngredient(getIngredientInput: $getIngredientInput) {
    response {
      status
    }
    ingredient {
      id
      name
      type
      productFormulationSyrupType {
        id
        name
      }
      ingredientProductTypes {
        productTypeId
      }
      ingredientInfo {
        ingredientId
        organic
        moisture
        calories
        protein
        carbohydrates
        dietaryFiber
        totalSugars
        addedSugar
        totalFat
        saturatedFat
        monounsaturatedFat
        polyunsaturatedFat
        transFat
        vitaminA
        biotin
        thiamin
        riboflavin
        niacin
        vitaminB6
        vitaminB12
        vitaminC
        vitaminD
        vitaminE
        magnesium
        zinc
        vitaminK2
        choline
        iodine
        folate
        cholesterol
        calcium
        iron
        potassium
        boron
        sodium
        arsenic
        cadmium
        lead
        mercury
        chloride
        copper
        chromium
        selenium
        manganese
        phosphorus
        molybdenum
        pantothenicAcid
      }
    }
  }
}
    `;

/**
 * __useGetSyrupBaseIngredientQuery__
 *
 * To run a query within a React component, call `useGetSyrupBaseIngredientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyrupBaseIngredientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSyrupBaseIngredientQuery({
 *   variables: {
 *      getIngredientInput: // value for 'getIngredientInput'
 *   },
 * });
 */
export function useGetSyrupBaseIngredientQuery(baseOptions: Apollo.QueryHookOptions<GetSyrupBaseIngredientQuery, GetSyrupBaseIngredientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSyrupBaseIngredientQuery, GetSyrupBaseIngredientQueryVariables>(GetSyrupBaseIngredientDocument, options);
      }
export function useGetSyrupBaseIngredientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSyrupBaseIngredientQuery, GetSyrupBaseIngredientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSyrupBaseIngredientQuery, GetSyrupBaseIngredientQueryVariables>(GetSyrupBaseIngredientDocument, options);
        }
export type GetSyrupBaseIngredientQueryHookResult = ReturnType<typeof useGetSyrupBaseIngredientQuery>;
export type GetSyrupBaseIngredientLazyQueryHookResult = ReturnType<typeof useGetSyrupBaseIngredientLazyQuery>;
export type GetSyrupBaseIngredientQueryResult = Apollo.QueryResult<GetSyrupBaseIngredientQuery, GetSyrupBaseIngredientQueryVariables>;
export const CreateIngredientDocument = gql`
    mutation CreateIngredient($createIngredientInput: CreateIngredientInput!) {
  createIngredient(createIngredientInput: $createIngredientInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateIngredientMutationFn = Apollo.MutationFunction<CreateIngredientMutation, CreateIngredientMutationVariables>;

/**
 * __useCreateIngredientMutation__
 *
 * To run a mutation, you first call `useCreateIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIngredientMutation, { data, loading, error }] = useCreateIngredientMutation({
 *   variables: {
 *      createIngredientInput: // value for 'createIngredientInput'
 *   },
 * });
 */
export function useCreateIngredientMutation(baseOptions?: Apollo.MutationHookOptions<CreateIngredientMutation, CreateIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIngredientMutation, CreateIngredientMutationVariables>(CreateIngredientDocument, options);
      }
export type CreateIngredientMutationHookResult = ReturnType<typeof useCreateIngredientMutation>;
export type CreateIngredientMutationResult = Apollo.MutationResult<CreateIngredientMutation>;
export type CreateIngredientMutationOptions = Apollo.BaseMutationOptions<CreateIngredientMutation, CreateIngredientMutationVariables>;
export const CreateSyrupBaseIngredientDocument = gql`
    mutation CreateSyrupBaseIngredient($createSyrupBaseIngredientsInput: CreateSyrupBaseIngredientsInput!) {
  createSyrupBaseIngredient(
    createSyrupBaseIngredientsInput: $createSyrupBaseIngredientsInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSyrupBaseIngredientMutationFn = Apollo.MutationFunction<CreateSyrupBaseIngredientMutation, CreateSyrupBaseIngredientMutationVariables>;

/**
 * __useCreateSyrupBaseIngredientMutation__
 *
 * To run a mutation, you first call `useCreateSyrupBaseIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSyrupBaseIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSyrupBaseIngredientMutation, { data, loading, error }] = useCreateSyrupBaseIngredientMutation({
 *   variables: {
 *      createSyrupBaseIngredientsInput: // value for 'createSyrupBaseIngredientsInput'
 *   },
 * });
 */
export function useCreateSyrupBaseIngredientMutation(baseOptions?: Apollo.MutationHookOptions<CreateSyrupBaseIngredientMutation, CreateSyrupBaseIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSyrupBaseIngredientMutation, CreateSyrupBaseIngredientMutationVariables>(CreateSyrupBaseIngredientDocument, options);
      }
export type CreateSyrupBaseIngredientMutationHookResult = ReturnType<typeof useCreateSyrupBaseIngredientMutation>;
export type CreateSyrupBaseIngredientMutationResult = Apollo.MutationResult<CreateSyrupBaseIngredientMutation>;
export type CreateSyrupBaseIngredientMutationOptions = Apollo.BaseMutationOptions<CreateSyrupBaseIngredientMutation, CreateSyrupBaseIngredientMutationVariables>;
export const UpdateIngredientDocument = gql`
    mutation UpdateIngredient($updateIngredientInput: UpdateIngredientInput!) {
  updateIngredient(updateIngredientInput: $updateIngredientInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateIngredientMutationFn = Apollo.MutationFunction<UpdateIngredientMutation, UpdateIngredientMutationVariables>;

/**
 * __useUpdateIngredientMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientMutation, { data, loading, error }] = useUpdateIngredientMutation({
 *   variables: {
 *      updateIngredientInput: // value for 'updateIngredientInput'
 *   },
 * });
 */
export function useUpdateIngredientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientMutation, UpdateIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientMutation, UpdateIngredientMutationVariables>(UpdateIngredientDocument, options);
      }
export type UpdateIngredientMutationHookResult = ReturnType<typeof useUpdateIngredientMutation>;
export type UpdateIngredientMutationResult = Apollo.MutationResult<UpdateIngredientMutation>;
export type UpdateIngredientMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientMutation, UpdateIngredientMutationVariables>;
export const UpdateSyrupBaseIngredientDocument = gql`
    mutation UpdateSyrupBaseIngredient($updateSyrupBaseIngredientsInput: UpdateSyrupBaseIngredientsInput!) {
  updateSyrupBaseIngredient(
    updateSyrupBaseIngredientsInput: $updateSyrupBaseIngredientsInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSyrupBaseIngredientMutationFn = Apollo.MutationFunction<UpdateSyrupBaseIngredientMutation, UpdateSyrupBaseIngredientMutationVariables>;

/**
 * __useUpdateSyrupBaseIngredientMutation__
 *
 * To run a mutation, you first call `useUpdateSyrupBaseIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSyrupBaseIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSyrupBaseIngredientMutation, { data, loading, error }] = useUpdateSyrupBaseIngredientMutation({
 *   variables: {
 *      updateSyrupBaseIngredientsInput: // value for 'updateSyrupBaseIngredientsInput'
 *   },
 * });
 */
export function useUpdateSyrupBaseIngredientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSyrupBaseIngredientMutation, UpdateSyrupBaseIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSyrupBaseIngredientMutation, UpdateSyrupBaseIngredientMutationVariables>(UpdateSyrupBaseIngredientDocument, options);
      }
export type UpdateSyrupBaseIngredientMutationHookResult = ReturnType<typeof useUpdateSyrupBaseIngredientMutation>;
export type UpdateSyrupBaseIngredientMutationResult = Apollo.MutationResult<UpdateSyrupBaseIngredientMutation>;
export type UpdateSyrupBaseIngredientMutationOptions = Apollo.BaseMutationOptions<UpdateSyrupBaseIngredientMutation, UpdateSyrupBaseIngredientMutationVariables>;
export const UpdateIngredientInfoDocument = gql`
    mutation UpdateIngredientInfo($updateIngredientInfoInput: UpdateIngredientInfoInput!) {
  updateIngredientInfo(updateIngredientInfoInput: $updateIngredientInfoInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateIngredientInfoMutationFn = Apollo.MutationFunction<UpdateIngredientInfoMutation, UpdateIngredientInfoMutationVariables>;

/**
 * __useUpdateIngredientInfoMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientInfoMutation, { data, loading, error }] = useUpdateIngredientInfoMutation({
 *   variables: {
 *      updateIngredientInfoInput: // value for 'updateIngredientInfoInput'
 *   },
 * });
 */
export function useUpdateIngredientInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientInfoMutation, UpdateIngredientInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientInfoMutation, UpdateIngredientInfoMutationVariables>(UpdateIngredientInfoDocument, options);
      }
export type UpdateIngredientInfoMutationHookResult = ReturnType<typeof useUpdateIngredientInfoMutation>;
export type UpdateIngredientInfoMutationResult = Apollo.MutationResult<UpdateIngredientInfoMutation>;
export type UpdateIngredientInfoMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientInfoMutation, UpdateIngredientInfoMutationVariables>;
export const UpdateIngredientAllergensDocument = gql`
    mutation UpdateIngredientAllergens($updateIngredientAllergensInput: UpdateIngredientAllergensInput!) {
  updateIngredientAllergens(
    updateIngredientAllergensInput: $updateIngredientAllergensInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateIngredientAllergensMutationFn = Apollo.MutationFunction<UpdateIngredientAllergensMutation, UpdateIngredientAllergensMutationVariables>;

/**
 * __useUpdateIngredientAllergensMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientAllergensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientAllergensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientAllergensMutation, { data, loading, error }] = useUpdateIngredientAllergensMutation({
 *   variables: {
 *      updateIngredientAllergensInput: // value for 'updateIngredientAllergensInput'
 *   },
 * });
 */
export function useUpdateIngredientAllergensMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientAllergensMutation, UpdateIngredientAllergensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientAllergensMutation, UpdateIngredientAllergensMutationVariables>(UpdateIngredientAllergensDocument, options);
      }
export type UpdateIngredientAllergensMutationHookResult = ReturnType<typeof useUpdateIngredientAllergensMutation>;
export type UpdateIngredientAllergensMutationResult = Apollo.MutationResult<UpdateIngredientAllergensMutation>;
export type UpdateIngredientAllergensMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientAllergensMutation, UpdateIngredientAllergensMutationVariables>;
export const UpdateIngredientSuppliersDocument = gql`
    mutation UpdateIngredientSuppliers($updateIngredientSuppliersInput: UpdateIngredientSuppliersInput!) {
  updateIngredientSuppliers(
    updateIngredientSuppliersInput: $updateIngredientSuppliersInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateIngredientSuppliersMutationFn = Apollo.MutationFunction<UpdateIngredientSuppliersMutation, UpdateIngredientSuppliersMutationVariables>;

/**
 * __useUpdateIngredientSuppliersMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientSuppliersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientSuppliersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientSuppliersMutation, { data, loading, error }] = useUpdateIngredientSuppliersMutation({
 *   variables: {
 *      updateIngredientSuppliersInput: // value for 'updateIngredientSuppliersInput'
 *   },
 * });
 */
export function useUpdateIngredientSuppliersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientSuppliersMutation, UpdateIngredientSuppliersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientSuppliersMutation, UpdateIngredientSuppliersMutationVariables>(UpdateIngredientSuppliersDocument, options);
      }
export type UpdateIngredientSuppliersMutationHookResult = ReturnType<typeof useUpdateIngredientSuppliersMutation>;
export type UpdateIngredientSuppliersMutationResult = Apollo.MutationResult<UpdateIngredientSuppliersMutation>;
export type UpdateIngredientSuppliersMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientSuppliersMutation, UpdateIngredientSuppliersMutationVariables>;
export const UpdateIngredientStatusDocument = gql`
    mutation UpdateIngredientStatus($UpdateIngredientStatus: UpdateIngredientStatus!) {
  updateIngredientStatus(UpdateIngredientStatus: $UpdateIngredientStatus) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateIngredientStatusMutationFn = Apollo.MutationFunction<UpdateIngredientStatusMutation, UpdateIngredientStatusMutationVariables>;

/**
 * __useUpdateIngredientStatusMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientStatusMutation, { data, loading, error }] = useUpdateIngredientStatusMutation({
 *   variables: {
 *      UpdateIngredientStatus: // value for 'UpdateIngredientStatus'
 *   },
 * });
 */
export function useUpdateIngredientStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientStatusMutation, UpdateIngredientStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientStatusMutation, UpdateIngredientStatusMutationVariables>(UpdateIngredientStatusDocument, options);
      }
export type UpdateIngredientStatusMutationHookResult = ReturnType<typeof useUpdateIngredientStatusMutation>;
export type UpdateIngredientStatusMutationResult = Apollo.MutationResult<UpdateIngredientStatusMutation>;
export type UpdateIngredientStatusMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientStatusMutation, UpdateIngredientStatusMutationVariables>;
export const UpdateIngredientCarriersDocument = gql`
    mutation updateIngredientCarriers($updateIngredientCarriersInput: UpdateIngredientCarriersInput!) {
  updateIngredientCarriers(
    updateIngredientCarriersInput: $updateIngredientCarriersInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateIngredientCarriersMutationFn = Apollo.MutationFunction<UpdateIngredientCarriersMutation, UpdateIngredientCarriersMutationVariables>;

/**
 * __useUpdateIngredientCarriersMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientCarriersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientCarriersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientCarriersMutation, { data, loading, error }] = useUpdateIngredientCarriersMutation({
 *   variables: {
 *      updateIngredientCarriersInput: // value for 'updateIngredientCarriersInput'
 *   },
 * });
 */
export function useUpdateIngredientCarriersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientCarriersMutation, UpdateIngredientCarriersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientCarriersMutation, UpdateIngredientCarriersMutationVariables>(UpdateIngredientCarriersDocument, options);
      }
export type UpdateIngredientCarriersMutationHookResult = ReturnType<typeof useUpdateIngredientCarriersMutation>;
export type UpdateIngredientCarriersMutationResult = Apollo.MutationResult<UpdateIngredientCarriersMutation>;
export type UpdateIngredientCarriersMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientCarriersMutation, UpdateIngredientCarriersMutationVariables>;
export const UpdateIngredientSubComponentsDocument = gql`
    mutation updateIngredientSubComponents($updateIngredientSubComponentsInput: UpdateIngredientSubComponentsInput!) {
  updateIngredientSubComponents(
    updateIngredientSubComponentsInput: $updateIngredientSubComponentsInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateIngredientSubComponentsMutationFn = Apollo.MutationFunction<UpdateIngredientSubComponentsMutation, UpdateIngredientSubComponentsMutationVariables>;

/**
 * __useUpdateIngredientSubComponentsMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientSubComponentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientSubComponentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientSubComponentsMutation, { data, loading, error }] = useUpdateIngredientSubComponentsMutation({
 *   variables: {
 *      updateIngredientSubComponentsInput: // value for 'updateIngredientSubComponentsInput'
 *   },
 * });
 */
export function useUpdateIngredientSubComponentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientSubComponentsMutation, UpdateIngredientSubComponentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientSubComponentsMutation, UpdateIngredientSubComponentsMutationVariables>(UpdateIngredientSubComponentsDocument, options);
      }
export type UpdateIngredientSubComponentsMutationHookResult = ReturnType<typeof useUpdateIngredientSubComponentsMutation>;
export type UpdateIngredientSubComponentsMutationResult = Apollo.MutationResult<UpdateIngredientSubComponentsMutation>;
export type UpdateIngredientSubComponentsMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientSubComponentsMutation, UpdateIngredientSubComponentsMutationVariables>;
export const FindAllOrganizationsUsersCountDocument = gql`
    query FindAllOrganizationsUsersCount {
  findAllOrganizationsUsersCount {
    response {
      status
    }
    data {
      id
      name
      usersCount
    }
  }
}
    `;

/**
 * __useFindAllOrganizationsUsersCountQuery__
 *
 * To run a query within a React component, call `useFindAllOrganizationsUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllOrganizationsUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllOrganizationsUsersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllOrganizationsUsersCountQuery(baseOptions?: Apollo.QueryHookOptions<FindAllOrganizationsUsersCountQuery, FindAllOrganizationsUsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllOrganizationsUsersCountQuery, FindAllOrganizationsUsersCountQueryVariables>(FindAllOrganizationsUsersCountDocument, options);
      }
export function useFindAllOrganizationsUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllOrganizationsUsersCountQuery, FindAllOrganizationsUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllOrganizationsUsersCountQuery, FindAllOrganizationsUsersCountQueryVariables>(FindAllOrganizationsUsersCountDocument, options);
        }
export type FindAllOrganizationsUsersCountQueryHookResult = ReturnType<typeof useFindAllOrganizationsUsersCountQuery>;
export type FindAllOrganizationsUsersCountLazyQueryHookResult = ReturnType<typeof useFindAllOrganizationsUsersCountLazyQuery>;
export type FindAllOrganizationsUsersCountQueryResult = Apollo.QueryResult<FindAllOrganizationsUsersCountQuery, FindAllOrganizationsUsersCountQueryVariables>;
export const FindAllProductExcipientsDocument = gql`
    query FindAllProductExcipients($getExcipientTypeInput: GetExcipientTypeInput!) {
  getExcipientType(getExcipientTypeInput: $getExcipientTypeInput) {
    excipientType {
      id
      name
      loadAdd
      excipientLabel {
        name
      }
      productType {
        name
      }
      productExcipients {
        id
        percentage
        perKgCost
        excipient {
          id
          name
        }
        productExcipientSupplier {
          supplier {
            id
            name
          }
        }
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllProductExcipientsQuery__
 *
 * To run a query within a React component, call `useFindAllProductExcipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductExcipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductExcipientsQuery({
 *   variables: {
 *      getExcipientTypeInput: // value for 'getExcipientTypeInput'
 *   },
 * });
 */
export function useFindAllProductExcipientsQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductExcipientsQuery, FindAllProductExcipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductExcipientsQuery, FindAllProductExcipientsQueryVariables>(FindAllProductExcipientsDocument, options);
      }
export function useFindAllProductExcipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductExcipientsQuery, FindAllProductExcipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductExcipientsQuery, FindAllProductExcipientsQueryVariables>(FindAllProductExcipientsDocument, options);
        }
export type FindAllProductExcipientsQueryHookResult = ReturnType<typeof useFindAllProductExcipientsQuery>;
export type FindAllProductExcipientsLazyQueryHookResult = ReturnType<typeof useFindAllProductExcipientsLazyQuery>;
export type FindAllProductExcipientsQueryResult = Apollo.QueryResult<FindAllProductExcipientsQuery, FindAllProductExcipientsQueryVariables>;
export const UpdateProductExcipientDocument = gql`
    mutation UpdateProductExcipient($updateProductExcipientInput: UpdateProductExcipientInput!) {
  updateProductExcipient(
    updateProductExcipientInput: $updateProductExcipientInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateProductExcipientMutationFn = Apollo.MutationFunction<UpdateProductExcipientMutation, UpdateProductExcipientMutationVariables>;

/**
 * __useUpdateProductExcipientMutation__
 *
 * To run a mutation, you first call `useUpdateProductExcipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductExcipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductExcipientMutation, { data, loading, error }] = useUpdateProductExcipientMutation({
 *   variables: {
 *      updateProductExcipientInput: // value for 'updateProductExcipientInput'
 *   },
 * });
 */
export function useUpdateProductExcipientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductExcipientMutation, UpdateProductExcipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductExcipientMutation, UpdateProductExcipientMutationVariables>(UpdateProductExcipientDocument, options);
      }
export type UpdateProductExcipientMutationHookResult = ReturnType<typeof useUpdateProductExcipientMutation>;
export type UpdateProductExcipientMutationResult = Apollo.MutationResult<UpdateProductExcipientMutation>;
export type UpdateProductExcipientMutationOptions = Apollo.BaseMutationOptions<UpdateProductExcipientMutation, UpdateProductExcipientMutationVariables>;
export const CreateProductExcipientDocument = gql`
    mutation CreateProductExcipient($createProductExcipientInput: CreateProductExcipientInput!) {
  createProductExcipient(
    createProductExcipientInput: $createProductExcipientInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateProductExcipientMutationFn = Apollo.MutationFunction<CreateProductExcipientMutation, CreateProductExcipientMutationVariables>;

/**
 * __useCreateProductExcipientMutation__
 *
 * To run a mutation, you first call `useCreateProductExcipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductExcipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductExcipientMutation, { data, loading, error }] = useCreateProductExcipientMutation({
 *   variables: {
 *      createProductExcipientInput: // value for 'createProductExcipientInput'
 *   },
 * });
 */
export function useCreateProductExcipientMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductExcipientMutation, CreateProductExcipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductExcipientMutation, CreateProductExcipientMutationVariables>(CreateProductExcipientDocument, options);
      }
export type CreateProductExcipientMutationHookResult = ReturnType<typeof useCreateProductExcipientMutation>;
export type CreateProductExcipientMutationResult = Apollo.MutationResult<CreateProductExcipientMutation>;
export type CreateProductExcipientMutationOptions = Apollo.BaseMutationOptions<CreateProductExcipientMutation, CreateProductExcipientMutationVariables>;
export const RemoveProductExcipientDocument = gql`
    mutation RemoveProductExcipient($removeProductExcipientInput: RemoveProductExcipientInput!) {
  removeProductExcipient(
    removeProductExcipientInput: $removeProductExcipientInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type RemoveProductExcipientMutationFn = Apollo.MutationFunction<RemoveProductExcipientMutation, RemoveProductExcipientMutationVariables>;

/**
 * __useRemoveProductExcipientMutation__
 *
 * To run a mutation, you first call `useRemoveProductExcipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductExcipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductExcipientMutation, { data, loading, error }] = useRemoveProductExcipientMutation({
 *   variables: {
 *      removeProductExcipientInput: // value for 'removeProductExcipientInput'
 *   },
 * });
 */
export function useRemoveProductExcipientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductExcipientMutation, RemoveProductExcipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductExcipientMutation, RemoveProductExcipientMutationVariables>(RemoveProductExcipientDocument, options);
      }
export type RemoveProductExcipientMutationHookResult = ReturnType<typeof useRemoveProductExcipientMutation>;
export type RemoveProductExcipientMutationResult = Apollo.MutationResult<RemoveProductExcipientMutation>;
export type RemoveProductExcipientMutationOptions = Apollo.BaseMutationOptions<RemoveProductExcipientMutation, RemoveProductExcipientMutationVariables>;
export const FindAllProductFormulationTypeTableDocument = gql`
    query FindAllProductFormulationTypeTable($findAllProductFormulationTypeInput: FindAllProductFormulationTypeInput!) {
  findAllProductFormulationType(
    findAllProductFormulationTypeInput: $findAllProductFormulationTypeInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
      conversionCost
      isInnerCapTab
      innerComponentCost
      lohInside
      productType {
        id
        name
      }
      subProductType {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllProductFormulationTypeTableQuery__
 *
 * To run a query within a React component, call `useFindAllProductFormulationTypeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductFormulationTypeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductFormulationTypeTableQuery({
 *   variables: {
 *      findAllProductFormulationTypeInput: // value for 'findAllProductFormulationTypeInput'
 *   },
 * });
 */
export function useFindAllProductFormulationTypeTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductFormulationTypeTableQuery, FindAllProductFormulationTypeTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductFormulationTypeTableQuery, FindAllProductFormulationTypeTableQueryVariables>(FindAllProductFormulationTypeTableDocument, options);
      }
export function useFindAllProductFormulationTypeTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductFormulationTypeTableQuery, FindAllProductFormulationTypeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductFormulationTypeTableQuery, FindAllProductFormulationTypeTableQueryVariables>(FindAllProductFormulationTypeTableDocument, options);
        }
export type FindAllProductFormulationTypeTableQueryHookResult = ReturnType<typeof useFindAllProductFormulationTypeTableQuery>;
export type FindAllProductFormulationTypeTableLazyQueryHookResult = ReturnType<typeof useFindAllProductFormulationTypeTableLazyQuery>;
export type FindAllProductFormulationTypeTableQueryResult = Apollo.QueryResult<FindAllProductFormulationTypeTableQuery, FindAllProductFormulationTypeTableQueryVariables>;
export const FindAllProductFormulationTypeSelectorDocument = gql`
    query FindAllProductFormulationTypeSelector($findAllProductFormulationTypeInput: FindAllProductFormulationTypeInput!) {
  findAllProductFormulationType(
    findAllProductFormulationTypeInput: $findAllProductFormulationTypeInput
  ) {
    data {
      id
      name
      type
      isActive
    }
    response {
      status
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllProductFormulationTypeSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllProductFormulationTypeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductFormulationTypeSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductFormulationTypeSelectorQuery({
 *   variables: {
 *      findAllProductFormulationTypeInput: // value for 'findAllProductFormulationTypeInput'
 *   },
 * });
 */
export function useFindAllProductFormulationTypeSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductFormulationTypeSelectorQuery, FindAllProductFormulationTypeSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductFormulationTypeSelectorQuery, FindAllProductFormulationTypeSelectorQueryVariables>(FindAllProductFormulationTypeSelectorDocument, options);
      }
export function useFindAllProductFormulationTypeSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductFormulationTypeSelectorQuery, FindAllProductFormulationTypeSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductFormulationTypeSelectorQuery, FindAllProductFormulationTypeSelectorQueryVariables>(FindAllProductFormulationTypeSelectorDocument, options);
        }
export type FindAllProductFormulationTypeSelectorQueryHookResult = ReturnType<typeof useFindAllProductFormulationTypeSelectorQuery>;
export type FindAllProductFormulationTypeSelectorLazyQueryHookResult = ReturnType<typeof useFindAllProductFormulationTypeSelectorLazyQuery>;
export type FindAllProductFormulationTypeSelectorQueryResult = Apollo.QueryResult<FindAllProductFormulationTypeSelectorQuery, FindAllProductFormulationTypeSelectorQueryVariables>;
export const GetProductFormulationTypeDocument = gql`
    query GetProductFormulationType($getProductFormulationTypeInput: GetProductFormulationTypeInput!) {
  getProductFormulationType(
    getProductFormulationTypeInput: $getProductFormulationTypeInput
  ) {
    productFormulationType {
      id
      name
      isActive
      conversionCost
      isInnerCapTab
      innerComponentCost
      lohInside
      productType {
        id
        name
        type
      }
      subProductType {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetProductFormulationTypeQuery__
 *
 * To run a query within a React component, call `useGetProductFormulationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductFormulationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductFormulationTypeQuery({
 *   variables: {
 *      getProductFormulationTypeInput: // value for 'getProductFormulationTypeInput'
 *   },
 * });
 */
export function useGetProductFormulationTypeQuery(baseOptions: Apollo.QueryHookOptions<GetProductFormulationTypeQuery, GetProductFormulationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductFormulationTypeQuery, GetProductFormulationTypeQueryVariables>(GetProductFormulationTypeDocument, options);
      }
export function useGetProductFormulationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductFormulationTypeQuery, GetProductFormulationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductFormulationTypeQuery, GetProductFormulationTypeQueryVariables>(GetProductFormulationTypeDocument, options);
        }
export type GetProductFormulationTypeQueryHookResult = ReturnType<typeof useGetProductFormulationTypeQuery>;
export type GetProductFormulationTypeLazyQueryHookResult = ReturnType<typeof useGetProductFormulationTypeLazyQuery>;
export type GetProductFormulationTypeQueryResult = Apollo.QueryResult<GetProductFormulationTypeQuery, GetProductFormulationTypeQueryVariables>;
export const UpdateProductFormulationTypeDocument = gql`
    mutation UpdateProductFormulationType($updateProductFormulationTypeInput: UpdateProductFormulationTypeInput!) {
  updateProductFormulationType(
    updateProductFormulationTypeInput: $updateProductFormulationTypeInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateProductFormulationTypeMutationFn = Apollo.MutationFunction<UpdateProductFormulationTypeMutation, UpdateProductFormulationTypeMutationVariables>;

/**
 * __useUpdateProductFormulationTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProductFormulationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductFormulationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductFormulationTypeMutation, { data, loading, error }] = useUpdateProductFormulationTypeMutation({
 *   variables: {
 *      updateProductFormulationTypeInput: // value for 'updateProductFormulationTypeInput'
 *   },
 * });
 */
export function useUpdateProductFormulationTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductFormulationTypeMutation, UpdateProductFormulationTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductFormulationTypeMutation, UpdateProductFormulationTypeMutationVariables>(UpdateProductFormulationTypeDocument, options);
      }
export type UpdateProductFormulationTypeMutationHookResult = ReturnType<typeof useUpdateProductFormulationTypeMutation>;
export type UpdateProductFormulationTypeMutationResult = Apollo.MutationResult<UpdateProductFormulationTypeMutation>;
export type UpdateProductFormulationTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProductFormulationTypeMutation, UpdateProductFormulationTypeMutationVariables>;
export const FindAllProductIngredientsSelectorDocument = gql`
    query FindAllProductIngredientsSelector($findAllProductIngredientsInput: FindAllProductIngredientsInput!) {
  findAllProductIngredients(
    findAllProductIngredientsInput: $findAllProductIngredientsInput
  ) {
    response {
      status
    }
    pagination {
      totalPages
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllProductIngredientsSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllProductIngredientsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductIngredientsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductIngredientsSelectorQuery({
 *   variables: {
 *      findAllProductIngredientsInput: // value for 'findAllProductIngredientsInput'
 *   },
 * });
 */
export function useFindAllProductIngredientsSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductIngredientsSelectorQuery, FindAllProductIngredientsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductIngredientsSelectorQuery, FindAllProductIngredientsSelectorQueryVariables>(FindAllProductIngredientsSelectorDocument, options);
      }
export function useFindAllProductIngredientsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductIngredientsSelectorQuery, FindAllProductIngredientsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductIngredientsSelectorQuery, FindAllProductIngredientsSelectorQueryVariables>(FindAllProductIngredientsSelectorDocument, options);
        }
export type FindAllProductIngredientsSelectorQueryHookResult = ReturnType<typeof useFindAllProductIngredientsSelectorQuery>;
export type FindAllProductIngredientsSelectorLazyQueryHookResult = ReturnType<typeof useFindAllProductIngredientsSelectorLazyQuery>;
export type FindAllProductIngredientsSelectorQueryResult = Apollo.QueryResult<FindAllProductIngredientsSelectorQuery, FindAllProductIngredientsSelectorQueryVariables>;
export const FindAllProductIngredientsDocument = gql`
    query FindAllProductIngredients($findAllProductIngredientsInput: FindAllProductIngredientsInput!) {
  findAllProductIngredients(
    findAllProductIngredientsInput: $findAllProductIngredientsInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllProductIngredientsQuery__
 *
 * To run a query within a React component, call `useFindAllProductIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductIngredientsQuery({
 *   variables: {
 *      findAllProductIngredientsInput: // value for 'findAllProductIngredientsInput'
 *   },
 * });
 */
export function useFindAllProductIngredientsQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductIngredientsQuery, FindAllProductIngredientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductIngredientsQuery, FindAllProductIngredientsQueryVariables>(FindAllProductIngredientsDocument, options);
      }
export function useFindAllProductIngredientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductIngredientsQuery, FindAllProductIngredientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductIngredientsQuery, FindAllProductIngredientsQueryVariables>(FindAllProductIngredientsDocument, options);
        }
export type FindAllProductIngredientsQueryHookResult = ReturnType<typeof useFindAllProductIngredientsQuery>;
export type FindAllProductIngredientsLazyQueryHookResult = ReturnType<typeof useFindAllProductIngredientsLazyQuery>;
export type FindAllProductIngredientsQueryResult = Apollo.QueryResult<FindAllProductIngredientsQuery, FindAllProductIngredientsQueryVariables>;
export const GetProductIngredientDocument = gql`
    query GetProductIngredient($getProductIngredientInput: GetProductIngredientInput!) {
  getProductIngredient(getProductIngredientInput: $getProductIngredientInput) {
    productIngredient {
      id
      name
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetProductIngredientQuery__
 *
 * To run a query within a React component, call `useGetProductIngredientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductIngredientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductIngredientQuery({
 *   variables: {
 *      getProductIngredientInput: // value for 'getProductIngredientInput'
 *   },
 * });
 */
export function useGetProductIngredientQuery(baseOptions: Apollo.QueryHookOptions<GetProductIngredientQuery, GetProductIngredientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductIngredientQuery, GetProductIngredientQueryVariables>(GetProductIngredientDocument, options);
      }
export function useGetProductIngredientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductIngredientQuery, GetProductIngredientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductIngredientQuery, GetProductIngredientQueryVariables>(GetProductIngredientDocument, options);
        }
export type GetProductIngredientQueryHookResult = ReturnType<typeof useGetProductIngredientQuery>;
export type GetProductIngredientLazyQueryHookResult = ReturnType<typeof useGetProductIngredientLazyQuery>;
export type GetProductIngredientQueryResult = Apollo.QueryResult<GetProductIngredientQuery, GetProductIngredientQueryVariables>;
export const UpdateProductIngredientDocument = gql`
    mutation UpdateProductIngredient($updateProductIngredientInput: UpdateProductIngredientInput!) {
  updateProductIngredient(
    updateProductIngredientInput: $updateProductIngredientInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateProductIngredientMutationFn = Apollo.MutationFunction<UpdateProductIngredientMutation, UpdateProductIngredientMutationVariables>;

/**
 * __useUpdateProductIngredientMutation__
 *
 * To run a mutation, you first call `useUpdateProductIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductIngredientMutation, { data, loading, error }] = useUpdateProductIngredientMutation({
 *   variables: {
 *      updateProductIngredientInput: // value for 'updateProductIngredientInput'
 *   },
 * });
 */
export function useUpdateProductIngredientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductIngredientMutation, UpdateProductIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductIngredientMutation, UpdateProductIngredientMutationVariables>(UpdateProductIngredientDocument, options);
      }
export type UpdateProductIngredientMutationHookResult = ReturnType<typeof useUpdateProductIngredientMutation>;
export type UpdateProductIngredientMutationResult = Apollo.MutationResult<UpdateProductIngredientMutation>;
export type UpdateProductIngredientMutationOptions = Apollo.BaseMutationOptions<UpdateProductIngredientMutation, UpdateProductIngredientMutationVariables>;
export const CreateProductIngredientDocument = gql`
    mutation CreateProductIngredient($createProductIngredientInput: CreateProductIngredientInput!) {
  createProductIngredient(
    createProductIngredientInput: $createProductIngredientInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateProductIngredientMutationFn = Apollo.MutationFunction<CreateProductIngredientMutation, CreateProductIngredientMutationVariables>;

/**
 * __useCreateProductIngredientMutation__
 *
 * To run a mutation, you first call `useCreateProductIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductIngredientMutation, { data, loading, error }] = useCreateProductIngredientMutation({
 *   variables: {
 *      createProductIngredientInput: // value for 'createProductIngredientInput'
 *   },
 * });
 */
export function useCreateProductIngredientMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductIngredientMutation, CreateProductIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductIngredientMutation, CreateProductIngredientMutationVariables>(CreateProductIngredientDocument, options);
      }
export type CreateProductIngredientMutationHookResult = ReturnType<typeof useCreateProductIngredientMutation>;
export type CreateProductIngredientMutationResult = Apollo.MutationResult<CreateProductIngredientMutation>;
export type CreateProductIngredientMutationOptions = Apollo.BaseMutationOptions<CreateProductIngredientMutation, CreateProductIngredientMutationVariables>;
export const FindAllProductSizeSelectorDocument = gql`
    query FindAllProductSizeSelector($findAllProductSizesInput: FindAllProductSizesInput!) {
  findAllProductSize(findAllProductSizesInput: $findAllProductSizesInput) {
    data {
      id
      name
      isActive
    }
    response {
      status
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllProductSizeSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllProductSizeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductSizeSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductSizeSelectorQuery({
 *   variables: {
 *      findAllProductSizesInput: // value for 'findAllProductSizesInput'
 *   },
 * });
 */
export function useFindAllProductSizeSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductSizeSelectorQuery, FindAllProductSizeSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductSizeSelectorQuery, FindAllProductSizeSelectorQueryVariables>(FindAllProductSizeSelectorDocument, options);
      }
export function useFindAllProductSizeSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductSizeSelectorQuery, FindAllProductSizeSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductSizeSelectorQuery, FindAllProductSizeSelectorQueryVariables>(FindAllProductSizeSelectorDocument, options);
        }
export type FindAllProductSizeSelectorQueryHookResult = ReturnType<typeof useFindAllProductSizeSelectorQuery>;
export type FindAllProductSizeSelectorLazyQueryHookResult = ReturnType<typeof useFindAllProductSizeSelectorLazyQuery>;
export type FindAllProductSizeSelectorQueryResult = Apollo.QueryResult<FindAllProductSizeSelectorQuery, FindAllProductSizeSelectorQueryVariables>;
export const FindAllProductSizeDocument = gql`
    query FindAllProductSize($findAllProductSizesInput: FindAllProductSizesInput!) {
  findAllProductSize(findAllProductSizesInput: $findAllProductSizesInput) {
    data {
      id
      name
      min
      max
      gummyWeight
      isActive
      emptyWtMg
      productType {
        name
      }
      subProductType {
        name
      }
    }
    pagination {
      page
      totalCount
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllProductSizeQuery__
 *
 * To run a query within a React component, call `useFindAllProductSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductSizeQuery({
 *   variables: {
 *      findAllProductSizesInput: // value for 'findAllProductSizesInput'
 *   },
 * });
 */
export function useFindAllProductSizeQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductSizeQuery, FindAllProductSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductSizeQuery, FindAllProductSizeQueryVariables>(FindAllProductSizeDocument, options);
      }
export function useFindAllProductSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductSizeQuery, FindAllProductSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductSizeQuery, FindAllProductSizeQueryVariables>(FindAllProductSizeDocument, options);
        }
export type FindAllProductSizeQueryHookResult = ReturnType<typeof useFindAllProductSizeQuery>;
export type FindAllProductSizeLazyQueryHookResult = ReturnType<typeof useFindAllProductSizeLazyQuery>;
export type FindAllProductSizeQueryResult = Apollo.QueryResult<FindAllProductSizeQuery, FindAllProductSizeQueryVariables>;
export const GetProductSizeDocument = gql`
    query GetProductSize($getProductSizeInput: GetProductSizeInput!) {
  getProductSize(getProductSizeInput: $getProductSizeInput) {
    productSize {
      id
      name
      min
      max
      gummyWeight
      emptyWtMg
      productType {
        id
        name
      }
      subProductType {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetProductSizeQuery__
 *
 * To run a query within a React component, call `useGetProductSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSizeQuery({
 *   variables: {
 *      getProductSizeInput: // value for 'getProductSizeInput'
 *   },
 * });
 */
export function useGetProductSizeQuery(baseOptions: Apollo.QueryHookOptions<GetProductSizeQuery, GetProductSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSizeQuery, GetProductSizeQueryVariables>(GetProductSizeDocument, options);
      }
export function useGetProductSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSizeQuery, GetProductSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSizeQuery, GetProductSizeQueryVariables>(GetProductSizeDocument, options);
        }
export type GetProductSizeQueryHookResult = ReturnType<typeof useGetProductSizeQuery>;
export type GetProductSizeLazyQueryHookResult = ReturnType<typeof useGetProductSizeLazyQuery>;
export type GetProductSizeQueryResult = Apollo.QueryResult<GetProductSizeQuery, GetProductSizeQueryVariables>;
export const UpdateProductSizeDocument = gql`
    mutation UpdateProductSize($updateProductSizeInput: UpdateProductSizeInput!) {
  updateProductSize(updateProductSizeInput: $updateProductSizeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateProductSizeMutationFn = Apollo.MutationFunction<UpdateProductSizeMutation, UpdateProductSizeMutationVariables>;

/**
 * __useUpdateProductSizeMutation__
 *
 * To run a mutation, you first call `useUpdateProductSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductSizeMutation, { data, loading, error }] = useUpdateProductSizeMutation({
 *   variables: {
 *      updateProductSizeInput: // value for 'updateProductSizeInput'
 *   },
 * });
 */
export function useUpdateProductSizeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductSizeMutation, UpdateProductSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductSizeMutation, UpdateProductSizeMutationVariables>(UpdateProductSizeDocument, options);
      }
export type UpdateProductSizeMutationHookResult = ReturnType<typeof useUpdateProductSizeMutation>;
export type UpdateProductSizeMutationResult = Apollo.MutationResult<UpdateProductSizeMutation>;
export type UpdateProductSizeMutationOptions = Apollo.BaseMutationOptions<UpdateProductSizeMutation, UpdateProductSizeMutationVariables>;
export const CreateProductSizeDocument = gql`
    mutation CreateProductSize($createProductSizeInput: CreateProductSizeInput!) {
  createProductSize(createProductSizeInput: $createProductSizeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateProductSizeMutationFn = Apollo.MutationFunction<CreateProductSizeMutation, CreateProductSizeMutationVariables>;

/**
 * __useCreateProductSizeMutation__
 *
 * To run a mutation, you first call `useCreateProductSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductSizeMutation, { data, loading, error }] = useCreateProductSizeMutation({
 *   variables: {
 *      createProductSizeInput: // value for 'createProductSizeInput'
 *   },
 * });
 */
export function useCreateProductSizeMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductSizeMutation, CreateProductSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductSizeMutation, CreateProductSizeMutationVariables>(CreateProductSizeDocument, options);
      }
export type CreateProductSizeMutationHookResult = ReturnType<typeof useCreateProductSizeMutation>;
export type CreateProductSizeMutationResult = Apollo.MutationResult<CreateProductSizeMutation>;
export type CreateProductSizeMutationOptions = Apollo.BaseMutationOptions<CreateProductSizeMutation, CreateProductSizeMutationVariables>;
export const FindProductTypeTableDocument = gql`
    query FindProductTypeTable($findAllProductTypeInput: FindAllProductTypesInput!) {
  findAllProductType(findAllProductTypeInput: $findAllProductTypeInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      type
      isActive
    }
  }
}
    `;

/**
 * __useFindProductTypeTableQuery__
 *
 * To run a query within a React component, call `useFindProductTypeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProductTypeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProductTypeTableQuery({
 *   variables: {
 *      findAllProductTypeInput: // value for 'findAllProductTypeInput'
 *   },
 * });
 */
export function useFindProductTypeTableQuery(baseOptions: Apollo.QueryHookOptions<FindProductTypeTableQuery, FindProductTypeTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindProductTypeTableQuery, FindProductTypeTableQueryVariables>(FindProductTypeTableDocument, options);
      }
export function useFindProductTypeTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindProductTypeTableQuery, FindProductTypeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindProductTypeTableQuery, FindProductTypeTableQueryVariables>(FindProductTypeTableDocument, options);
        }
export type FindProductTypeTableQueryHookResult = ReturnType<typeof useFindProductTypeTableQuery>;
export type FindProductTypeTableLazyQueryHookResult = ReturnType<typeof useFindProductTypeTableLazyQuery>;
export type FindProductTypeTableQueryResult = Apollo.QueryResult<FindProductTypeTableQuery, FindProductTypeTableQueryVariables>;
export const FindAllProductTypeSelectDocument = gql`
    query FindAllProductTypeSelect($findAllProductTypeInput: FindAllProductTypesInput!) {
  findAllProductType(findAllProductTypeInput: $findAllProductTypeInput) {
    pagination {
      totalPages
    }
    response {
      status
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllProductTypeSelectQuery__
 *
 * To run a query within a React component, call `useFindAllProductTypeSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductTypeSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductTypeSelectQuery({
 *   variables: {
 *      findAllProductTypeInput: // value for 'findAllProductTypeInput'
 *   },
 * });
 */
export function useFindAllProductTypeSelectQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductTypeSelectQuery, FindAllProductTypeSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductTypeSelectQuery, FindAllProductTypeSelectQueryVariables>(FindAllProductTypeSelectDocument, options);
      }
export function useFindAllProductTypeSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductTypeSelectQuery, FindAllProductTypeSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductTypeSelectQuery, FindAllProductTypeSelectQueryVariables>(FindAllProductTypeSelectDocument, options);
        }
export type FindAllProductTypeSelectQueryHookResult = ReturnType<typeof useFindAllProductTypeSelectQuery>;
export type FindAllProductTypeSelectLazyQueryHookResult = ReturnType<typeof useFindAllProductTypeSelectLazyQuery>;
export type FindAllProductTypeSelectQueryResult = Apollo.QueryResult<FindAllProductTypeSelectQuery, FindAllProductTypeSelectQueryVariables>;
export const FindAllProductTypeDocument = gql`
    query FindAllProductType($findAllProductTypeInput: FindAllProductTypesInput!) {
  findAllProductType(findAllProductTypeInput: $findAllProductTypeInput) {
    data {
      id
      name
      type
      isActive
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllProductTypeQuery__
 *
 * To run a query within a React component, call `useFindAllProductTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProductTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProductTypeQuery({
 *   variables: {
 *      findAllProductTypeInput: // value for 'findAllProductTypeInput'
 *   },
 * });
 */
export function useFindAllProductTypeQuery(baseOptions: Apollo.QueryHookOptions<FindAllProductTypeQuery, FindAllProductTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProductTypeQuery, FindAllProductTypeQueryVariables>(FindAllProductTypeDocument, options);
      }
export function useFindAllProductTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProductTypeQuery, FindAllProductTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProductTypeQuery, FindAllProductTypeQueryVariables>(FindAllProductTypeDocument, options);
        }
export type FindAllProductTypeQueryHookResult = ReturnType<typeof useFindAllProductTypeQuery>;
export type FindAllProductTypeLazyQueryHookResult = ReturnType<typeof useFindAllProductTypeLazyQuery>;
export type FindAllProductTypeQueryResult = Apollo.QueryResult<FindAllProductTypeQuery, FindAllProductTypeQueryVariables>;
export const GetProductTypeDocument = gql`
    query GetProductType($getProductTypeInput: GetProductTypeInput!) {
  getProductType(getProductTypeInput: $getProductTypeInput) {
    productType {
      name
      isActive
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetProductTypeQuery__
 *
 * To run a query within a React component, call `useGetProductTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductTypeQuery({
 *   variables: {
 *      getProductTypeInput: // value for 'getProductTypeInput'
 *   },
 * });
 */
export function useGetProductTypeQuery(baseOptions: Apollo.QueryHookOptions<GetProductTypeQuery, GetProductTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductTypeQuery, GetProductTypeQueryVariables>(GetProductTypeDocument, options);
      }
export function useGetProductTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductTypeQuery, GetProductTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductTypeQuery, GetProductTypeQueryVariables>(GetProductTypeDocument, options);
        }
export type GetProductTypeQueryHookResult = ReturnType<typeof useGetProductTypeQuery>;
export type GetProductTypeLazyQueryHookResult = ReturnType<typeof useGetProductTypeLazyQuery>;
export type GetProductTypeQueryResult = Apollo.QueryResult<GetProductTypeQuery, GetProductTypeQueryVariables>;
export const UpdateProductTypeDocument = gql`
    mutation UpdateProductType($updateProductTypeInput: UpdateProductTypeInput!) {
  updateProductType(updateProductTypeInput: $updateProductTypeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateProductTypeMutationFn = Apollo.MutationFunction<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>;

/**
 * __useUpdateProductTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductTypeMutation, { data, loading, error }] = useUpdateProductTypeMutation({
 *   variables: {
 *      updateProductTypeInput: // value for 'updateProductTypeInput'
 *   },
 * });
 */
export function useUpdateProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>(UpdateProductTypeDocument, options);
      }
export type UpdateProductTypeMutationHookResult = ReturnType<typeof useUpdateProductTypeMutation>;
export type UpdateProductTypeMutationResult = Apollo.MutationResult<UpdateProductTypeMutation>;
export type UpdateProductTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>;
export const FindAllSandCoatingDocument = gql`
    query FindAllSandCoating($findAllSandCoatingInput: FindAllSandCoatingInput!) {
  findAllSandCoating(findAllSandCoatingInput: $findAllSandCoatingInput) {
    response {
      status
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllSandCoatingQuery__
 *
 * To run a query within a React component, call `useFindAllSandCoatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSandCoatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSandCoatingQuery({
 *   variables: {
 *      findAllSandCoatingInput: // value for 'findAllSandCoatingInput'
 *   },
 * });
 */
export function useFindAllSandCoatingQuery(baseOptions: Apollo.QueryHookOptions<FindAllSandCoatingQuery, FindAllSandCoatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSandCoatingQuery, FindAllSandCoatingQueryVariables>(FindAllSandCoatingDocument, options);
      }
export function useFindAllSandCoatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSandCoatingQuery, FindAllSandCoatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSandCoatingQuery, FindAllSandCoatingQueryVariables>(FindAllSandCoatingDocument, options);
        }
export type FindAllSandCoatingQueryHookResult = ReturnType<typeof useFindAllSandCoatingQuery>;
export type FindAllSandCoatingLazyQueryHookResult = ReturnType<typeof useFindAllSandCoatingLazyQuery>;
export type FindAllSandCoatingQueryResult = Apollo.QueryResult<FindAllSandCoatingQuery, FindAllSandCoatingQueryVariables>;
export const FindAllSandCoatingSelectorDocument = gql`
    query FindAllSandCoatingSelector($findAllSandCoatingInput: FindAllSandCoatingInput!) {
  findAllSandCoating(findAllSandCoatingInput: $findAllSandCoatingInput) {
    response {
      status
    }
    data {
      id
      name
      isActive
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllSandCoatingSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllSandCoatingSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSandCoatingSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSandCoatingSelectorQuery({
 *   variables: {
 *      findAllSandCoatingInput: // value for 'findAllSandCoatingInput'
 *   },
 * });
 */
export function useFindAllSandCoatingSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllSandCoatingSelectorQuery, FindAllSandCoatingSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSandCoatingSelectorQuery, FindAllSandCoatingSelectorQueryVariables>(FindAllSandCoatingSelectorDocument, options);
      }
export function useFindAllSandCoatingSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSandCoatingSelectorQuery, FindAllSandCoatingSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSandCoatingSelectorQuery, FindAllSandCoatingSelectorQueryVariables>(FindAllSandCoatingSelectorDocument, options);
        }
export type FindAllSandCoatingSelectorQueryHookResult = ReturnType<typeof useFindAllSandCoatingSelectorQuery>;
export type FindAllSandCoatingSelectorLazyQueryHookResult = ReturnType<typeof useFindAllSandCoatingSelectorLazyQuery>;
export type FindAllSandCoatingSelectorQueryResult = Apollo.QueryResult<FindAllSandCoatingSelectorQuery, FindAllSandCoatingSelectorQueryVariables>;
export const FindAllSandCoatingTableDocument = gql`
    query FindAllSandCoatingTable($findAllSandCoatingInput: FindAllSandCoatingInput!) {
  findAllSandCoating(findAllSandCoatingInput: $findAllSandCoatingInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllSandCoatingTableQuery__
 *
 * To run a query within a React component, call `useFindAllSandCoatingTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSandCoatingTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSandCoatingTableQuery({
 *   variables: {
 *      findAllSandCoatingInput: // value for 'findAllSandCoatingInput'
 *   },
 * });
 */
export function useFindAllSandCoatingTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllSandCoatingTableQuery, FindAllSandCoatingTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSandCoatingTableQuery, FindAllSandCoatingTableQueryVariables>(FindAllSandCoatingTableDocument, options);
      }
export function useFindAllSandCoatingTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSandCoatingTableQuery, FindAllSandCoatingTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSandCoatingTableQuery, FindAllSandCoatingTableQueryVariables>(FindAllSandCoatingTableDocument, options);
        }
export type FindAllSandCoatingTableQueryHookResult = ReturnType<typeof useFindAllSandCoatingTableQuery>;
export type FindAllSandCoatingTableLazyQueryHookResult = ReturnType<typeof useFindAllSandCoatingTableLazyQuery>;
export type FindAllSandCoatingTableQueryResult = Apollo.QueryResult<FindAllSandCoatingTableQuery, FindAllSandCoatingTableQueryVariables>;
export const GetSandCoatingDocument = gql`
    query GetSandCoating($getSandCoatingInput: GetSandCoatingInput!) {
  getSandCoating(getSandCoatingInput: $getSandCoatingInput) {
    response {
      status
    }
    sandCoating {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useGetSandCoatingQuery__
 *
 * To run a query within a React component, call `useGetSandCoatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandCoatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandCoatingQuery({
 *   variables: {
 *      getSandCoatingInput: // value for 'getSandCoatingInput'
 *   },
 * });
 */
export function useGetSandCoatingQuery(baseOptions: Apollo.QueryHookOptions<GetSandCoatingQuery, GetSandCoatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSandCoatingQuery, GetSandCoatingQueryVariables>(GetSandCoatingDocument, options);
      }
export function useGetSandCoatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSandCoatingQuery, GetSandCoatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSandCoatingQuery, GetSandCoatingQueryVariables>(GetSandCoatingDocument, options);
        }
export type GetSandCoatingQueryHookResult = ReturnType<typeof useGetSandCoatingQuery>;
export type GetSandCoatingLazyQueryHookResult = ReturnType<typeof useGetSandCoatingLazyQuery>;
export type GetSandCoatingQueryResult = Apollo.QueryResult<GetSandCoatingQuery, GetSandCoatingQueryVariables>;
export const CreateSandCoatingDocument = gql`
    mutation CreateSandCoating($createSandCoatingInput: CreateSandCoatingInput!) {
  createSandCoating(createSandCoatingInput: $createSandCoatingInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSandCoatingMutationFn = Apollo.MutationFunction<CreateSandCoatingMutation, CreateSandCoatingMutationVariables>;

/**
 * __useCreateSandCoatingMutation__
 *
 * To run a mutation, you first call `useCreateSandCoatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSandCoatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSandCoatingMutation, { data, loading, error }] = useCreateSandCoatingMutation({
 *   variables: {
 *      createSandCoatingInput: // value for 'createSandCoatingInput'
 *   },
 * });
 */
export function useCreateSandCoatingMutation(baseOptions?: Apollo.MutationHookOptions<CreateSandCoatingMutation, CreateSandCoatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSandCoatingMutation, CreateSandCoatingMutationVariables>(CreateSandCoatingDocument, options);
      }
export type CreateSandCoatingMutationHookResult = ReturnType<typeof useCreateSandCoatingMutation>;
export type CreateSandCoatingMutationResult = Apollo.MutationResult<CreateSandCoatingMutation>;
export type CreateSandCoatingMutationOptions = Apollo.BaseMutationOptions<CreateSandCoatingMutation, CreateSandCoatingMutationVariables>;
export const UpdateSandCoatingDocument = gql`
    mutation UpdateSandCoating($updateSandCoatingInput: UpdateSandCoatingInput!) {
  updateSandCoating(updateSandCoatingInput: $updateSandCoatingInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSandCoatingMutationFn = Apollo.MutationFunction<UpdateSandCoatingMutation, UpdateSandCoatingMutationVariables>;

/**
 * __useUpdateSandCoatingMutation__
 *
 * To run a mutation, you first call `useUpdateSandCoatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSandCoatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSandCoatingMutation, { data, loading, error }] = useUpdateSandCoatingMutation({
 *   variables: {
 *      updateSandCoatingInput: // value for 'updateSandCoatingInput'
 *   },
 * });
 */
export function useUpdateSandCoatingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSandCoatingMutation, UpdateSandCoatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSandCoatingMutation, UpdateSandCoatingMutationVariables>(UpdateSandCoatingDocument, options);
      }
export type UpdateSandCoatingMutationHookResult = ReturnType<typeof useUpdateSandCoatingMutation>;
export type UpdateSandCoatingMutationResult = Apollo.MutationResult<UpdateSandCoatingMutation>;
export type UpdateSandCoatingMutationOptions = Apollo.BaseMutationOptions<UpdateSandCoatingMutation, UpdateSandCoatingMutationVariables>;
export const FindAllSandCoatingFormulationDocument = gql`
    query FindAllSandCoatingFormulation($findAllSandCoatingFormulationInput: FindAllSandCoatingFormulationInput!) {
  findAllSandCoatingFormulation(
    findAllSandCoatingFormulationInput: $findAllSandCoatingFormulationInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      cost
      weight
      unit
      isActive
      productSize {
        name
      }
      sandCoating {
        name
      }
      productType {
        name
      }
      subProductType {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllSandCoatingFormulationQuery__
 *
 * To run a query within a React component, call `useFindAllSandCoatingFormulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSandCoatingFormulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSandCoatingFormulationQuery({
 *   variables: {
 *      findAllSandCoatingFormulationInput: // value for 'findAllSandCoatingFormulationInput'
 *   },
 * });
 */
export function useFindAllSandCoatingFormulationQuery(baseOptions: Apollo.QueryHookOptions<FindAllSandCoatingFormulationQuery, FindAllSandCoatingFormulationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSandCoatingFormulationQuery, FindAllSandCoatingFormulationQueryVariables>(FindAllSandCoatingFormulationDocument, options);
      }
export function useFindAllSandCoatingFormulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSandCoatingFormulationQuery, FindAllSandCoatingFormulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSandCoatingFormulationQuery, FindAllSandCoatingFormulationQueryVariables>(FindAllSandCoatingFormulationDocument, options);
        }
export type FindAllSandCoatingFormulationQueryHookResult = ReturnType<typeof useFindAllSandCoatingFormulationQuery>;
export type FindAllSandCoatingFormulationLazyQueryHookResult = ReturnType<typeof useFindAllSandCoatingFormulationLazyQuery>;
export type FindAllSandCoatingFormulationQueryResult = Apollo.QueryResult<FindAllSandCoatingFormulationQuery, FindAllSandCoatingFormulationQueryVariables>;
export const GetSandCoatingFormulationDocument = gql`
    query GetSandCoatingFormulation($getSandCoatingFormulationInput: GetSandCoatingFormulationInput!) {
  getSandCoatingFormulation(
    getSandCoatingFormulationInput: $getSandCoatingFormulationInput
  ) {
    response {
      status
    }
    sandCoatingFormulation {
      id
      cost
      weight
      unit
      isActive
      productSize {
        id
        name
      }
      sandCoating {
        id
        name
      }
      productType {
        id
        name
      }
      subProductType {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSandCoatingFormulationQuery__
 *
 * To run a query within a React component, call `useGetSandCoatingFormulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandCoatingFormulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandCoatingFormulationQuery({
 *   variables: {
 *      getSandCoatingFormulationInput: // value for 'getSandCoatingFormulationInput'
 *   },
 * });
 */
export function useGetSandCoatingFormulationQuery(baseOptions: Apollo.QueryHookOptions<GetSandCoatingFormulationQuery, GetSandCoatingFormulationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSandCoatingFormulationQuery, GetSandCoatingFormulationQueryVariables>(GetSandCoatingFormulationDocument, options);
      }
export function useGetSandCoatingFormulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSandCoatingFormulationQuery, GetSandCoatingFormulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSandCoatingFormulationQuery, GetSandCoatingFormulationQueryVariables>(GetSandCoatingFormulationDocument, options);
        }
export type GetSandCoatingFormulationQueryHookResult = ReturnType<typeof useGetSandCoatingFormulationQuery>;
export type GetSandCoatingFormulationLazyQueryHookResult = ReturnType<typeof useGetSandCoatingFormulationLazyQuery>;
export type GetSandCoatingFormulationQueryResult = Apollo.QueryResult<GetSandCoatingFormulationQuery, GetSandCoatingFormulationQueryVariables>;
export const CreateSandCoatingFormulationDocument = gql`
    mutation CreateSandCoatingFormulation($createSandCoatingFormulationInput: CreateSandCoatingFormulationInput!) {
  createSandCoatingFormulation(
    createSandCoatingFormulationInput: $createSandCoatingFormulationInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSandCoatingFormulationMutationFn = Apollo.MutationFunction<CreateSandCoatingFormulationMutation, CreateSandCoatingFormulationMutationVariables>;

/**
 * __useCreateSandCoatingFormulationMutation__
 *
 * To run a mutation, you first call `useCreateSandCoatingFormulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSandCoatingFormulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSandCoatingFormulationMutation, { data, loading, error }] = useCreateSandCoatingFormulationMutation({
 *   variables: {
 *      createSandCoatingFormulationInput: // value for 'createSandCoatingFormulationInput'
 *   },
 * });
 */
export function useCreateSandCoatingFormulationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSandCoatingFormulationMutation, CreateSandCoatingFormulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSandCoatingFormulationMutation, CreateSandCoatingFormulationMutationVariables>(CreateSandCoatingFormulationDocument, options);
      }
export type CreateSandCoatingFormulationMutationHookResult = ReturnType<typeof useCreateSandCoatingFormulationMutation>;
export type CreateSandCoatingFormulationMutationResult = Apollo.MutationResult<CreateSandCoatingFormulationMutation>;
export type CreateSandCoatingFormulationMutationOptions = Apollo.BaseMutationOptions<CreateSandCoatingFormulationMutation, CreateSandCoatingFormulationMutationVariables>;
export const UpdateSandCoatingFormulationDocument = gql`
    mutation UpdateSandCoatingFormulation($updateSandCoatingFormulationInput: UpdateSandCoatingFormulationInput!) {
  updateSandCoatingFormulation(
    updateSandCoatingFormulationInput: $updateSandCoatingFormulationInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSandCoatingFormulationMutationFn = Apollo.MutationFunction<UpdateSandCoatingFormulationMutation, UpdateSandCoatingFormulationMutationVariables>;

/**
 * __useUpdateSandCoatingFormulationMutation__
 *
 * To run a mutation, you first call `useUpdateSandCoatingFormulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSandCoatingFormulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSandCoatingFormulationMutation, { data, loading, error }] = useUpdateSandCoatingFormulationMutation({
 *   variables: {
 *      updateSandCoatingFormulationInput: // value for 'updateSandCoatingFormulationInput'
 *   },
 * });
 */
export function useUpdateSandCoatingFormulationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSandCoatingFormulationMutation, UpdateSandCoatingFormulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSandCoatingFormulationMutation, UpdateSandCoatingFormulationMutationVariables>(UpdateSandCoatingFormulationDocument, options);
      }
export type UpdateSandCoatingFormulationMutationHookResult = ReturnType<typeof useUpdateSandCoatingFormulationMutation>;
export type UpdateSandCoatingFormulationMutationResult = Apollo.MutationResult<UpdateSandCoatingFormulationMutation>;
export type UpdateSandCoatingFormulationMutationOptions = Apollo.BaseMutationOptions<UpdateSandCoatingFormulationMutation, UpdateSandCoatingFormulationMutationVariables>;
export const FindAllSandComponentForSelectorDocument = gql`
    query FindAllSandComponentForSelector($findAllSandComponentInput: FindAllSandComponentInput!) {
  findAllSandComponent(findAllSandComponentInput: $findAllSandComponentInput) {
    response {
      status
    }
    pagination {
      totalPages
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllSandComponentForSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllSandComponentForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSandComponentForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSandComponentForSelectorQuery({
 *   variables: {
 *      findAllSandComponentInput: // value for 'findAllSandComponentInput'
 *   },
 * });
 */
export function useFindAllSandComponentForSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllSandComponentForSelectorQuery, FindAllSandComponentForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSandComponentForSelectorQuery, FindAllSandComponentForSelectorQueryVariables>(FindAllSandComponentForSelectorDocument, options);
      }
export function useFindAllSandComponentForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSandComponentForSelectorQuery, FindAllSandComponentForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSandComponentForSelectorQuery, FindAllSandComponentForSelectorQueryVariables>(FindAllSandComponentForSelectorDocument, options);
        }
export type FindAllSandComponentForSelectorQueryHookResult = ReturnType<typeof useFindAllSandComponentForSelectorQuery>;
export type FindAllSandComponentForSelectorLazyQueryHookResult = ReturnType<typeof useFindAllSandComponentForSelectorLazyQuery>;
export type FindAllSandComponentForSelectorQueryResult = Apollo.QueryResult<FindAllSandComponentForSelectorQuery, FindAllSandComponentForSelectorQueryVariables>;
export const FindAllSandComponentTableDocument = gql`
    query FindAllSandComponentTable($findAllSandComponentInput: FindAllSandComponentInput!) {
  findAllSandComponent(findAllSandComponentInput: $findAllSandComponentInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllSandComponentTableQuery__
 *
 * To run a query within a React component, call `useFindAllSandComponentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSandComponentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSandComponentTableQuery({
 *   variables: {
 *      findAllSandComponentInput: // value for 'findAllSandComponentInput'
 *   },
 * });
 */
export function useFindAllSandComponentTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllSandComponentTableQuery, FindAllSandComponentTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSandComponentTableQuery, FindAllSandComponentTableQueryVariables>(FindAllSandComponentTableDocument, options);
      }
export function useFindAllSandComponentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSandComponentTableQuery, FindAllSandComponentTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSandComponentTableQuery, FindAllSandComponentTableQueryVariables>(FindAllSandComponentTableDocument, options);
        }
export type FindAllSandComponentTableQueryHookResult = ReturnType<typeof useFindAllSandComponentTableQuery>;
export type FindAllSandComponentTableLazyQueryHookResult = ReturnType<typeof useFindAllSandComponentTableLazyQuery>;
export type FindAllSandComponentTableQueryResult = Apollo.QueryResult<FindAllSandComponentTableQuery, FindAllSandComponentTableQueryVariables>;
export const GetSandComponentDocument = gql`
    query GetSandComponent($getSandComponentInput: GetSandComponentInput!) {
  getSandComponent(getSandComponentInput: $getSandComponentInput) {
    response {
      status
    }
    sandComponent {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useGetSandComponentQuery__
 *
 * To run a query within a React component, call `useGetSandComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandComponentQuery({
 *   variables: {
 *      getSandComponentInput: // value for 'getSandComponentInput'
 *   },
 * });
 */
export function useGetSandComponentQuery(baseOptions: Apollo.QueryHookOptions<GetSandComponentQuery, GetSandComponentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSandComponentQuery, GetSandComponentQueryVariables>(GetSandComponentDocument, options);
      }
export function useGetSandComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSandComponentQuery, GetSandComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSandComponentQuery, GetSandComponentQueryVariables>(GetSandComponentDocument, options);
        }
export type GetSandComponentQueryHookResult = ReturnType<typeof useGetSandComponentQuery>;
export type GetSandComponentLazyQueryHookResult = ReturnType<typeof useGetSandComponentLazyQuery>;
export type GetSandComponentQueryResult = Apollo.QueryResult<GetSandComponentQuery, GetSandComponentQueryVariables>;
export const CreateSandComponentDocument = gql`
    mutation CreateSandComponent($createSandComponentInput: CreateSandComponentInput!) {
  createSandComponent(createSandComponentInput: $createSandComponentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSandComponentMutationFn = Apollo.MutationFunction<CreateSandComponentMutation, CreateSandComponentMutationVariables>;

/**
 * __useCreateSandComponentMutation__
 *
 * To run a mutation, you first call `useCreateSandComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSandComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSandComponentMutation, { data, loading, error }] = useCreateSandComponentMutation({
 *   variables: {
 *      createSandComponentInput: // value for 'createSandComponentInput'
 *   },
 * });
 */
export function useCreateSandComponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSandComponentMutation, CreateSandComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSandComponentMutation, CreateSandComponentMutationVariables>(CreateSandComponentDocument, options);
      }
export type CreateSandComponentMutationHookResult = ReturnType<typeof useCreateSandComponentMutation>;
export type CreateSandComponentMutationResult = Apollo.MutationResult<CreateSandComponentMutation>;
export type CreateSandComponentMutationOptions = Apollo.BaseMutationOptions<CreateSandComponentMutation, CreateSandComponentMutationVariables>;
export const UpdateSandComponentDocument = gql`
    mutation UpdateSandComponent($updateSandComponentInput: UpdateSandComponentInput!) {
  updateSandComponent(updateSandComponentInput: $updateSandComponentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSandComponentMutationFn = Apollo.MutationFunction<UpdateSandComponentMutation, UpdateSandComponentMutationVariables>;

/**
 * __useUpdateSandComponentMutation__
 *
 * To run a mutation, you first call `useUpdateSandComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSandComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSandComponentMutation, { data, loading, error }] = useUpdateSandComponentMutation({
 *   variables: {
 *      updateSandComponentInput: // value for 'updateSandComponentInput'
 *   },
 * });
 */
export function useUpdateSandComponentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSandComponentMutation, UpdateSandComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSandComponentMutation, UpdateSandComponentMutationVariables>(UpdateSandComponentDocument, options);
      }
export type UpdateSandComponentMutationHookResult = ReturnType<typeof useUpdateSandComponentMutation>;
export type UpdateSandComponentMutationResult = Apollo.MutationResult<UpdateSandComponentMutation>;
export type UpdateSandComponentMutationOptions = Apollo.BaseMutationOptions<UpdateSandComponentMutation, UpdateSandComponentMutationVariables>;
export const FindAllServingSizeSelectorDocument = gql`
    query FindAllServingSizeSelector($findAllServingSizesInput: FindAllServingSizesInput!) {
  findAllServingSize(findAllServingSizesInput: $findAllServingSizesInput) {
    data {
      id
      size
      isActive
    }
    pagination {
      totalPages
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllServingSizeSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllServingSizeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllServingSizeSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllServingSizeSelectorQuery({
 *   variables: {
 *      findAllServingSizesInput: // value for 'findAllServingSizesInput'
 *   },
 * });
 */
export function useFindAllServingSizeSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllServingSizeSelectorQuery, FindAllServingSizeSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllServingSizeSelectorQuery, FindAllServingSizeSelectorQueryVariables>(FindAllServingSizeSelectorDocument, options);
      }
export function useFindAllServingSizeSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllServingSizeSelectorQuery, FindAllServingSizeSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllServingSizeSelectorQuery, FindAllServingSizeSelectorQueryVariables>(FindAllServingSizeSelectorDocument, options);
        }
export type FindAllServingSizeSelectorQueryHookResult = ReturnType<typeof useFindAllServingSizeSelectorQuery>;
export type FindAllServingSizeSelectorLazyQueryHookResult = ReturnType<typeof useFindAllServingSizeSelectorLazyQuery>;
export type FindAllServingSizeSelectorQueryResult = Apollo.QueryResult<FindAllServingSizeSelectorQuery, FindAllServingSizeSelectorQueryVariables>;
export const FindAllServingSizeDocument = gql`
    query FindAllServingSize($findAllServingSizesInput: FindAllServingSizesInput!) {
  findAllServingSize(findAllServingSizesInput: $findAllServingSizesInput) {
    data {
      id
      size
      isActive
    }
    pagination {
      page
      totalCount
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllServingSizeQuery__
 *
 * To run a query within a React component, call `useFindAllServingSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllServingSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllServingSizeQuery({
 *   variables: {
 *      findAllServingSizesInput: // value for 'findAllServingSizesInput'
 *   },
 * });
 */
export function useFindAllServingSizeQuery(baseOptions: Apollo.QueryHookOptions<FindAllServingSizeQuery, FindAllServingSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllServingSizeQuery, FindAllServingSizeQueryVariables>(FindAllServingSizeDocument, options);
      }
export function useFindAllServingSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllServingSizeQuery, FindAllServingSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllServingSizeQuery, FindAllServingSizeQueryVariables>(FindAllServingSizeDocument, options);
        }
export type FindAllServingSizeQueryHookResult = ReturnType<typeof useFindAllServingSizeQuery>;
export type FindAllServingSizeLazyQueryHookResult = ReturnType<typeof useFindAllServingSizeLazyQuery>;
export type FindAllServingSizeQueryResult = Apollo.QueryResult<FindAllServingSizeQuery, FindAllServingSizeQueryVariables>;
export const GetServingSizeDocument = gql`
    query GetServingSize($getServingSizeInput: GetServingSizeInput!) {
  getServingSize(getServingSizeInput: $getServingSizeInput) {
    servingSize {
      id
      size
      isActive
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetServingSizeQuery__
 *
 * To run a query within a React component, call `useGetServingSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServingSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServingSizeQuery({
 *   variables: {
 *      getServingSizeInput: // value for 'getServingSizeInput'
 *   },
 * });
 */
export function useGetServingSizeQuery(baseOptions: Apollo.QueryHookOptions<GetServingSizeQuery, GetServingSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServingSizeQuery, GetServingSizeQueryVariables>(GetServingSizeDocument, options);
      }
export function useGetServingSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServingSizeQuery, GetServingSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServingSizeQuery, GetServingSizeQueryVariables>(GetServingSizeDocument, options);
        }
export type GetServingSizeQueryHookResult = ReturnType<typeof useGetServingSizeQuery>;
export type GetServingSizeLazyQueryHookResult = ReturnType<typeof useGetServingSizeLazyQuery>;
export type GetServingSizeQueryResult = Apollo.QueryResult<GetServingSizeQuery, GetServingSizeQueryVariables>;
export const UpdateServingSizeDocument = gql`
    mutation UpdateServingSize($updateServingSizeInput: UpdateServingSizeInput!) {
  updateServingSize(updateServingSizeInput: $updateServingSizeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateServingSizeMutationFn = Apollo.MutationFunction<UpdateServingSizeMutation, UpdateServingSizeMutationVariables>;

/**
 * __useUpdateServingSizeMutation__
 *
 * To run a mutation, you first call `useUpdateServingSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServingSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServingSizeMutation, { data, loading, error }] = useUpdateServingSizeMutation({
 *   variables: {
 *      updateServingSizeInput: // value for 'updateServingSizeInput'
 *   },
 * });
 */
export function useUpdateServingSizeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServingSizeMutation, UpdateServingSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServingSizeMutation, UpdateServingSizeMutationVariables>(UpdateServingSizeDocument, options);
      }
export type UpdateServingSizeMutationHookResult = ReturnType<typeof useUpdateServingSizeMutation>;
export type UpdateServingSizeMutationResult = Apollo.MutationResult<UpdateServingSizeMutation>;
export type UpdateServingSizeMutationOptions = Apollo.BaseMutationOptions<UpdateServingSizeMutation, UpdateServingSizeMutationVariables>;
export const CreateServingSizeDocument = gql`
    mutation CreateServingSize($createServingSizeInput: CreateServingSizeInput!) {
  createServingSize(createServingSizeInput: $createServingSizeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateServingSizeMutationFn = Apollo.MutationFunction<CreateServingSizeMutation, CreateServingSizeMutationVariables>;

/**
 * __useCreateServingSizeMutation__
 *
 * To run a mutation, you first call `useCreateServingSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServingSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServingSizeMutation, { data, loading, error }] = useCreateServingSizeMutation({
 *   variables: {
 *      createServingSizeInput: // value for 'createServingSizeInput'
 *   },
 * });
 */
export function useCreateServingSizeMutation(baseOptions?: Apollo.MutationHookOptions<CreateServingSizeMutation, CreateServingSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServingSizeMutation, CreateServingSizeMutationVariables>(CreateServingSizeDocument, options);
      }
export type CreateServingSizeMutationHookResult = ReturnType<typeof useCreateServingSizeMutation>;
export type CreateServingSizeMutationResult = Apollo.MutationResult<CreateServingSizeMutation>;
export type CreateServingSizeMutationOptions = Apollo.BaseMutationOptions<CreateServingSizeMutation, CreateServingSizeMutationVariables>;
export const FetchUserSettingDocument = gql`
    query FetchUserSetting {
  fetchUser {
    response {
      status
    }
    user {
      id
      email
      phone
      lastName
      firstName
      organization {
        id
        name
        address {
          address1
          address2
          city
          zip
          country
          state
          countryCode
        }
      }
    }
  }
}
    `;

/**
 * __useFetchUserSettingQuery__
 *
 * To run a query within a React component, call `useFetchUserSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchUserSettingQuery(baseOptions?: Apollo.QueryHookOptions<FetchUserSettingQuery, FetchUserSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserSettingQuery, FetchUserSettingQueryVariables>(FetchUserSettingDocument, options);
      }
export function useFetchUserSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserSettingQuery, FetchUserSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserSettingQuery, FetchUserSettingQueryVariables>(FetchUserSettingDocument, options);
        }
export type FetchUserSettingQueryHookResult = ReturnType<typeof useFetchUserSettingQuery>;
export type FetchUserSettingLazyQueryHookResult = ReturnType<typeof useFetchUserSettingLazyQuery>;
export type FetchUserSettingQueryResult = Apollo.QueryResult<FetchUserSettingQuery, FetchUserSettingQueryVariables>;
export const UpdateUserInfoDocument = gql`
    mutation UpdateUserInfo($updateUserInfoInput: UpdateUserInfoInput!) {
  updateUserInfo(updateUserInfoInput: $updateUserInfoInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateUserInfoMutationFn = Apollo.MutationFunction<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;

/**
 * __useUpdateUserInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInfoMutation, { data, loading, error }] = useUpdateUserInfoMutation({
 *   variables: {
 *      updateUserInfoInput: // value for 'updateUserInfoInput'
 *   },
 * });
 */
export function useUpdateUserInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>(UpdateUserInfoDocument, options);
      }
export type UpdateUserInfoMutationHookResult = ReturnType<typeof useUpdateUserInfoMutation>;
export type UpdateUserInfoMutationResult = Apollo.MutationResult<UpdateUserInfoMutation>;
export type UpdateUserInfoMutationOptions = Apollo.BaseMutationOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;
export const FindAllStaffDocument = gql`
    query FindAllStaff($findAllStaffInput: FindAllStaffInput!) {
  findAllStaff(findAllStaffInput: $findAllStaffInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      firstName
      lastName
      email
      phone
      status
      staffRole
      createdAt
    }
  }
}
    `;

/**
 * __useFindAllStaffQuery__
 *
 * To run a query within a React component, call `useFindAllStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllStaffQuery({
 *   variables: {
 *      findAllStaffInput: // value for 'findAllStaffInput'
 *   },
 * });
 */
export function useFindAllStaffQuery(baseOptions: Apollo.QueryHookOptions<FindAllStaffQuery, FindAllStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllStaffQuery, FindAllStaffQueryVariables>(FindAllStaffDocument, options);
      }
export function useFindAllStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllStaffQuery, FindAllStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllStaffQuery, FindAllStaffQueryVariables>(FindAllStaffDocument, options);
        }
export type FindAllStaffQueryHookResult = ReturnType<typeof useFindAllStaffQuery>;
export type FindAllStaffLazyQueryHookResult = ReturnType<typeof useFindAllStaffLazyQuery>;
export type FindAllStaffQueryResult = Apollo.QueryResult<FindAllStaffQuery, FindAllStaffQueryVariables>;
export const FindAllOrgStaffDocument = gql`
    query FindAllOrgStaff($findAllOrgStaffInput: FindAllOrgStaffInput!) {
  findAllOrgStaff(findAllOrgStaffInput: $findAllOrgStaffInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      firstName
      lastName
      email
      phone
      status
      staffRole
      createdAt
    }
  }
}
    `;

/**
 * __useFindAllOrgStaffQuery__
 *
 * To run a query within a React component, call `useFindAllOrgStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllOrgStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllOrgStaffQuery({
 *   variables: {
 *      findAllOrgStaffInput: // value for 'findAllOrgStaffInput'
 *   },
 * });
 */
export function useFindAllOrgStaffQuery(baseOptions: Apollo.QueryHookOptions<FindAllOrgStaffQuery, FindAllOrgStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllOrgStaffQuery, FindAllOrgStaffQueryVariables>(FindAllOrgStaffDocument, options);
      }
export function useFindAllOrgStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllOrgStaffQuery, FindAllOrgStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllOrgStaffQuery, FindAllOrgStaffQueryVariables>(FindAllOrgStaffDocument, options);
        }
export type FindAllOrgStaffQueryHookResult = ReturnType<typeof useFindAllOrgStaffQuery>;
export type FindAllOrgStaffLazyQueryHookResult = ReturnType<typeof useFindAllOrgStaffLazyQuery>;
export type FindAllOrgStaffQueryResult = Apollo.QueryResult<FindAllOrgStaffQuery, FindAllOrgStaffQueryVariables>;
export const GetOrgStaffDocument = gql`
    query GetOrgStaff($getOrgStaffInput: GetOrgStaffInput!) {
  getOrgStaff(getOrgStaffInput: $getOrgStaffInput) {
    response {
      status
    }
    user {
      id
      email
      phone
      lastName
      firstName
      staffRole
    }
  }
}
    `;

/**
 * __useGetOrgStaffQuery__
 *
 * To run a query within a React component, call `useGetOrgStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgStaffQuery({
 *   variables: {
 *      getOrgStaffInput: // value for 'getOrgStaffInput'
 *   },
 * });
 */
export function useGetOrgStaffQuery(baseOptions: Apollo.QueryHookOptions<GetOrgStaffQuery, GetOrgStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgStaffQuery, GetOrgStaffQueryVariables>(GetOrgStaffDocument, options);
      }
export function useGetOrgStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgStaffQuery, GetOrgStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgStaffQuery, GetOrgStaffQueryVariables>(GetOrgStaffDocument, options);
        }
export type GetOrgStaffQueryHookResult = ReturnType<typeof useGetOrgStaffQuery>;
export type GetOrgStaffLazyQueryHookResult = ReturnType<typeof useGetOrgStaffLazyQuery>;
export type GetOrgStaffQueryResult = Apollo.QueryResult<GetOrgStaffQuery, GetOrgStaffQueryVariables>;
export const CreateStaffDocument = gql`
    mutation CreateStaff($createStaffInput: CreateStaffInput!) {
  createStaff(createStaffInput: $createStaffInput) {
    clientSecret
    response {
      status
      message
    }
  }
}
    `;
export type CreateStaffMutationFn = Apollo.MutationFunction<CreateStaffMutation, CreateStaffMutationVariables>;

/**
 * __useCreateStaffMutation__
 *
 * To run a mutation, you first call `useCreateStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaffMutation, { data, loading, error }] = useCreateStaffMutation({
 *   variables: {
 *      createStaffInput: // value for 'createStaffInput'
 *   },
 * });
 */
export function useCreateStaffMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaffMutation, CreateStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaffMutation, CreateStaffMutationVariables>(CreateStaffDocument, options);
      }
export type CreateStaffMutationHookResult = ReturnType<typeof useCreateStaffMutation>;
export type CreateStaffMutationResult = Apollo.MutationResult<CreateStaffMutation>;
export type CreateStaffMutationOptions = Apollo.BaseMutationOptions<CreateStaffMutation, CreateStaffMutationVariables>;
export const CreateOrgStaffDocument = gql`
    mutation CreateOrgStaff($createOrgStaffInput: CreateOrgStaffInput!) {
  createOrgStaff(createOrgStaffInput: $createOrgStaffInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateOrgStaffMutationFn = Apollo.MutationFunction<CreateOrgStaffMutation, CreateOrgStaffMutationVariables>;

/**
 * __useCreateOrgStaffMutation__
 *
 * To run a mutation, you first call `useCreateOrgStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgStaffMutation, { data, loading, error }] = useCreateOrgStaffMutation({
 *   variables: {
 *      createOrgStaffInput: // value for 'createOrgStaffInput'
 *   },
 * });
 */
export function useCreateOrgStaffMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrgStaffMutation, CreateOrgStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrgStaffMutation, CreateOrgStaffMutationVariables>(CreateOrgStaffDocument, options);
      }
export type CreateOrgStaffMutationHookResult = ReturnType<typeof useCreateOrgStaffMutation>;
export type CreateOrgStaffMutationResult = Apollo.MutationResult<CreateOrgStaffMutation>;
export type CreateOrgStaffMutationOptions = Apollo.BaseMutationOptions<CreateOrgStaffMutation, CreateOrgStaffMutationVariables>;
export const UpdateStaffInfoDocument = gql`
    mutation UpdateStaffInfo($updateStaffInfoInput: UpdateStaffInfoInput!) {
  updateStaffInfo(updateStaffInfoInput: $updateStaffInfoInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateStaffInfoMutationFn = Apollo.MutationFunction<UpdateStaffInfoMutation, UpdateStaffInfoMutationVariables>;

/**
 * __useUpdateStaffInfoMutation__
 *
 * To run a mutation, you first call `useUpdateStaffInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaffInfoMutation, { data, loading, error }] = useUpdateStaffInfoMutation({
 *   variables: {
 *      updateStaffInfoInput: // value for 'updateStaffInfoInput'
 *   },
 * });
 */
export function useUpdateStaffInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStaffInfoMutation, UpdateStaffInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStaffInfoMutation, UpdateStaffInfoMutationVariables>(UpdateStaffInfoDocument, options);
      }
export type UpdateStaffInfoMutationHookResult = ReturnType<typeof useUpdateStaffInfoMutation>;
export type UpdateStaffInfoMutationResult = Apollo.MutationResult<UpdateStaffInfoMutation>;
export type UpdateStaffInfoMutationOptions = Apollo.BaseMutationOptions<UpdateStaffInfoMutation, UpdateStaffInfoMutationVariables>;
export const UpdateOrgStaffInfoDocument = gql`
    mutation UpdateOrgStaffInfo($updateOrgStaffInfoInput: UpdateOrgStaffInfoInput!) {
  updateOrgStaffInfo(updateOrgStaffInfoInput: $updateOrgStaffInfoInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateOrgStaffInfoMutationFn = Apollo.MutationFunction<UpdateOrgStaffInfoMutation, UpdateOrgStaffInfoMutationVariables>;

/**
 * __useUpdateOrgStaffInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOrgStaffInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgStaffInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgStaffInfoMutation, { data, loading, error }] = useUpdateOrgStaffInfoMutation({
 *   variables: {
 *      updateOrgStaffInfoInput: // value for 'updateOrgStaffInfoInput'
 *   },
 * });
 */
export function useUpdateOrgStaffInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgStaffInfoMutation, UpdateOrgStaffInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgStaffInfoMutation, UpdateOrgStaffInfoMutationVariables>(UpdateOrgStaffInfoDocument, options);
      }
export type UpdateOrgStaffInfoMutationHookResult = ReturnType<typeof useUpdateOrgStaffInfoMutation>;
export type UpdateOrgStaffInfoMutationResult = Apollo.MutationResult<UpdateOrgStaffInfoMutation>;
export type UpdateOrgStaffInfoMutationOptions = Apollo.BaseMutationOptions<UpdateOrgStaffInfoMutation, UpdateOrgStaffInfoMutationVariables>;
export const ActiveStaffSubscriptionDocument = gql`
    mutation ActiveStaffSubscription($activeStaffSubscriptionInput: ActiveStaffSubscriptionInput!) {
  activeStaffSubscription(
    activeStaffSubscriptionInput: $activeStaffSubscriptionInput
  ) {
    clientSecret
    response {
      status
      message
    }
  }
}
    `;
export type ActiveStaffSubscriptionMutationFn = Apollo.MutationFunction<ActiveStaffSubscriptionMutation, ActiveStaffSubscriptionMutationVariables>;

/**
 * __useActiveStaffSubscriptionMutation__
 *
 * To run a mutation, you first call `useActiveStaffSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveStaffSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeStaffSubscriptionMutation, { data, loading, error }] = useActiveStaffSubscriptionMutation({
 *   variables: {
 *      activeStaffSubscriptionInput: // value for 'activeStaffSubscriptionInput'
 *   },
 * });
 */
export function useActiveStaffSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ActiveStaffSubscriptionMutation, ActiveStaffSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveStaffSubscriptionMutation, ActiveStaffSubscriptionMutationVariables>(ActiveStaffSubscriptionDocument, options);
      }
export type ActiveStaffSubscriptionMutationHookResult = ReturnType<typeof useActiveStaffSubscriptionMutation>;
export type ActiveStaffSubscriptionMutationResult = Apollo.MutationResult<ActiveStaffSubscriptionMutation>;
export type ActiveStaffSubscriptionMutationOptions = Apollo.BaseMutationOptions<ActiveStaffSubscriptionMutation, ActiveStaffSubscriptionMutationVariables>;
export const FindPriceAndProductsDocument = gql`
    query FindPriceAndProducts {
  findPriceAndProducts {
    prices {
      id
      amount
      interval
      product {
        id
        name
        description
        images
        marketingFeatures {
          name
        }
      }
    }
    response {
      message
      status
    }
  }
}
    `;

/**
 * __useFindPriceAndProductsQuery__
 *
 * To run a query within a React component, call `useFindPriceAndProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPriceAndProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPriceAndProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindPriceAndProductsQuery(baseOptions?: Apollo.QueryHookOptions<FindPriceAndProductsQuery, FindPriceAndProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPriceAndProductsQuery, FindPriceAndProductsQueryVariables>(FindPriceAndProductsDocument, options);
      }
export function useFindPriceAndProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPriceAndProductsQuery, FindPriceAndProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPriceAndProductsQuery, FindPriceAndProductsQueryVariables>(FindPriceAndProductsDocument, options);
        }
export type FindPriceAndProductsQueryHookResult = ReturnType<typeof useFindPriceAndProductsQuery>;
export type FindPriceAndProductsLazyQueryHookResult = ReturnType<typeof useFindPriceAndProductsLazyQuery>;
export type FindPriceAndProductsQueryResult = Apollo.QueryResult<FindPriceAndProductsQuery, FindPriceAndProductsQueryVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($createSubscriptionInput: CreateSubscriptionInput!) {
  createSubscription(createSubscriptionInput: $createSubscriptionInput) {
    response {
      message
      status
    }
    clientSecret
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      createSubscriptionInput: // value for 'createSubscriptionInput'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const FindOnePriceAndProductsDocument = gql`
    query FindOnePriceAndProducts($getStripePriceInput: GetStripePriceInput!) {
  findOnePriceAndProducts(getStripePriceInput: $getStripePriceInput) {
    response {
      message
      status
    }
    price {
      amount
      interval
      isTrialEnded
      billAbleAmount
    }
  }
}
    `;

/**
 * __useFindOnePriceAndProductsQuery__
 *
 * To run a query within a React component, call `useFindOnePriceAndProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOnePriceAndProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOnePriceAndProductsQuery({
 *   variables: {
 *      getStripePriceInput: // value for 'getStripePriceInput'
 *   },
 * });
 */
export function useFindOnePriceAndProductsQuery(baseOptions: Apollo.QueryHookOptions<FindOnePriceAndProductsQuery, FindOnePriceAndProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOnePriceAndProductsQuery, FindOnePriceAndProductsQueryVariables>(FindOnePriceAndProductsDocument, options);
      }
export function useFindOnePriceAndProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOnePriceAndProductsQuery, FindOnePriceAndProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOnePriceAndProductsQuery, FindOnePriceAndProductsQueryVariables>(FindOnePriceAndProductsDocument, options);
        }
export type FindOnePriceAndProductsQueryHookResult = ReturnType<typeof useFindOnePriceAndProductsQuery>;
export type FindOnePriceAndProductsLazyQueryHookResult = ReturnType<typeof useFindOnePriceAndProductsLazyQuery>;
export type FindOnePriceAndProductsQueryResult = Apollo.QueryResult<FindOnePriceAndProductsQuery, FindOnePriceAndProductsQueryVariables>;
export const GetPaymentMethodsDocument = gql`
    query GetPaymentMethods {
  getPaymentMethods {
    response {
      message
      status
    }
    paymentMethods {
      id
      brand
      type
      last4
      name
      default
    }
  }
}
    `;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation RemovePaymentMethod($removePaymentMethodInput: RemovePaymentMethodInput!) {
  removePaymentMethod(removePaymentMethodInput: $removePaymentMethodInput) {
    response {
      message
      status
    }
  }
}
    `;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      removePaymentMethodInput: // value for 'removePaymentMethodInput'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
      }
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const SetDefaultPaymentMethodDocument = gql`
    mutation SetDefaultPaymentMethod($setDefaultPaymentMethodInput: SetDefaultPaymentMethodInput!) {
  setDefaultPaymentMethod(
    setDefaultPaymentMethodInput: $setDefaultPaymentMethodInput
  ) {
    response {
      message
      status
    }
  }
}
    `;
export type SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutation({
 *   variables: {
 *      setDefaultPaymentMethodInput: // value for 'setDefaultPaymentMethodInput'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument, options);
      }
export type SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($cancelSubscriptionInput: CancelSubscriptionInput!) {
  cancelSubscription(cancelSubscriptionInput: $cancelSubscriptionInput) {
    response {
      message
      status
    }
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      cancelSubscriptionInput: // value for 'cancelSubscriptionInput'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ChangeSubscriptionPlanDocument = gql`
    mutation ChangeSubscriptionPlan($changeSubscriptionPlanInput: ChangeSubscriptionPlanInput!) {
  changeSubscriptionPlan(
    changeSubscriptionPlanInput: $changeSubscriptionPlanInput
  ) {
    clientSecret
    response {
      message
      status
    }
  }
}
    `;
export type ChangeSubscriptionPlanMutationFn = Apollo.MutationFunction<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;

/**
 * __useChangeSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPlanMutation, { data, loading, error }] = useChangeSubscriptionPlanMutation({
 *   variables: {
 *      changeSubscriptionPlanInput: // value for 'changeSubscriptionPlanInput'
 *   },
 * });
 */
export function useChangeSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>(ChangeSubscriptionPlanDocument, options);
      }
export type ChangeSubscriptionPlanMutationHookResult = ReturnType<typeof useChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationResult = Apollo.MutationResult<ChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;
export const AddPaymentMethodDocument = gql`
    mutation AddPaymentMethod($addPaymentMethodInput: AddPaymentMethodInput!) {
  addPaymentMethod(addPaymentMethodInput: $addPaymentMethodInput) {
    clientSecret
    response {
      message
      status
    }
  }
}
    `;
export type AddPaymentMethodMutationFn = Apollo.MutationFunction<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;

/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      addPaymentMethodInput: // value for 'addPaymentMethodInput'
 *   },
 * });
 */
export function useAddPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>(AddPaymentMethodDocument, options);
      }
export type AddPaymentMethodMutationHookResult = ReturnType<typeof useAddPaymentMethodMutation>;
export type AddPaymentMethodMutationResult = Apollo.MutationResult<AddPaymentMethodMutation>;
export type AddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const CreateSetupIntentDocument = gql`
    mutation CreateSetupIntent {
  createSetupIntent {
    clientSecret
    response {
      message
      status
    }
  }
}
    `;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const FindAllInvoicesDocument = gql`
    query FindAllInvoices($findAllInvoicesInput: FindAllInvoicesInput!) {
  findAllInvoices(findAllInvoicesInput: $findAllInvoicesInput) {
    response {
      message
      status
    }
    data {
      id
      amount
      status
      createdAt
      invoiceNumber
    }
    pagination {
      page
      totalCount
    }
  }
}
    `;

/**
 * __useFindAllInvoicesQuery__
 *
 * To run a query within a React component, call `useFindAllInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllInvoicesQuery({
 *   variables: {
 *      findAllInvoicesInput: // value for 'findAllInvoicesInput'
 *   },
 * });
 */
export function useFindAllInvoicesQuery(baseOptions: Apollo.QueryHookOptions<FindAllInvoicesQuery, FindAllInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllInvoicesQuery, FindAllInvoicesQueryVariables>(FindAllInvoicesDocument, options);
      }
export function useFindAllInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllInvoicesQuery, FindAllInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllInvoicesQuery, FindAllInvoicesQueryVariables>(FindAllInvoicesDocument, options);
        }
export type FindAllInvoicesQueryHookResult = ReturnType<typeof useFindAllInvoicesQuery>;
export type FindAllInvoicesLazyQueryHookResult = ReturnType<typeof useFindAllInvoicesLazyQuery>;
export type FindAllInvoicesQueryResult = Apollo.QueryResult<FindAllInvoicesQuery, FindAllInvoicesQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($getInvoiceInput: GetInvoiceInput!) {
  getInvoice(getInvoiceInput: $getInvoiceInput) {
    response {
      message
      status
    }
    hostedInvoiceUrl
  }
}
    `;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      getInvoiceInput: // value for 'getInvoiceInput'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const FindAllOrgInvoicesDocument = gql`
    query findAllOrgInvoices($findInvoicesByOrgIdInput: FindInvoicesByOrgIdInput!) {
  findAllOrgInvoices(findInvoicesByOrgIdInput: $findInvoicesByOrgIdInput) {
    response {
      message
      status
    }
    data {
      id
      amount
      status
      createdAt
      invoiceNumber
    }
    pagination {
      page
      totalCount
    }
  }
}
    `;

/**
 * __useFindAllOrgInvoicesQuery__
 *
 * To run a query within a React component, call `useFindAllOrgInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllOrgInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllOrgInvoicesQuery({
 *   variables: {
 *      findInvoicesByOrgIdInput: // value for 'findInvoicesByOrgIdInput'
 *   },
 * });
 */
export function useFindAllOrgInvoicesQuery(baseOptions: Apollo.QueryHookOptions<FindAllOrgInvoicesQuery, FindAllOrgInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllOrgInvoicesQuery, FindAllOrgInvoicesQueryVariables>(FindAllOrgInvoicesDocument, options);
      }
export function useFindAllOrgInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllOrgInvoicesQuery, FindAllOrgInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllOrgInvoicesQuery, FindAllOrgInvoicesQueryVariables>(FindAllOrgInvoicesDocument, options);
        }
export type FindAllOrgInvoicesQueryHookResult = ReturnType<typeof useFindAllOrgInvoicesQuery>;
export type FindAllOrgInvoicesLazyQueryHookResult = ReturnType<typeof useFindAllOrgInvoicesLazyQuery>;
export type FindAllOrgInvoicesQueryResult = Apollo.QueryResult<FindAllOrgInvoicesQuery, FindAllOrgInvoicesQueryVariables>;
export const FindAllSubProductTypeTableDocument = gql`
    query FindAllSubProductTypeTable($findAllSubProductTypeInput: FindAllSubProductTypesInput!) {
  findAllSubProductType(findAllSubProductTypeInput: $findAllSubProductTypeInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      isActive
      productType {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllSubProductTypeTableQuery__
 *
 * To run a query within a React component, call `useFindAllSubProductTypeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSubProductTypeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSubProductTypeTableQuery({
 *   variables: {
 *      findAllSubProductTypeInput: // value for 'findAllSubProductTypeInput'
 *   },
 * });
 */
export function useFindAllSubProductTypeTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllSubProductTypeTableQuery, FindAllSubProductTypeTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSubProductTypeTableQuery, FindAllSubProductTypeTableQueryVariables>(FindAllSubProductTypeTableDocument, options);
      }
export function useFindAllSubProductTypeTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSubProductTypeTableQuery, FindAllSubProductTypeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSubProductTypeTableQuery, FindAllSubProductTypeTableQueryVariables>(FindAllSubProductTypeTableDocument, options);
        }
export type FindAllSubProductTypeTableQueryHookResult = ReturnType<typeof useFindAllSubProductTypeTableQuery>;
export type FindAllSubProductTypeTableLazyQueryHookResult = ReturnType<typeof useFindAllSubProductTypeTableLazyQuery>;
export type FindAllSubProductTypeTableQueryResult = Apollo.QueryResult<FindAllSubProductTypeTableQuery, FindAllSubProductTypeTableQueryVariables>;
export const FindAllSubProductTypeDocument = gql`
    query FindAllSubProductType($findAllSubProductTypeInput: FindAllSubProductTypesInput!) {
  findAllSubProductType(findAllSubProductTypeInput: $findAllSubProductTypeInput) {
    data {
      id
      name
      isActive
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllSubProductTypeQuery__
 *
 * To run a query within a React component, call `useFindAllSubProductTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSubProductTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSubProductTypeQuery({
 *   variables: {
 *      findAllSubProductTypeInput: // value for 'findAllSubProductTypeInput'
 *   },
 * });
 */
export function useFindAllSubProductTypeQuery(baseOptions: Apollo.QueryHookOptions<FindAllSubProductTypeQuery, FindAllSubProductTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSubProductTypeQuery, FindAllSubProductTypeQueryVariables>(FindAllSubProductTypeDocument, options);
      }
export function useFindAllSubProductTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSubProductTypeQuery, FindAllSubProductTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSubProductTypeQuery, FindAllSubProductTypeQueryVariables>(FindAllSubProductTypeDocument, options);
        }
export type FindAllSubProductTypeQueryHookResult = ReturnType<typeof useFindAllSubProductTypeQuery>;
export type FindAllSubProductTypeLazyQueryHookResult = ReturnType<typeof useFindAllSubProductTypeLazyQuery>;
export type FindAllSubProductTypeQueryResult = Apollo.QueryResult<FindAllSubProductTypeQuery, FindAllSubProductTypeQueryVariables>;
export const FindAllSubProductTypeSelectorDocument = gql`
    query FindAllSubProductTypeSelector($findAllSubProductTypeInput: FindAllSubProductTypesInput!) {
  findAllSubProductType(findAllSubProductTypeInput: $findAllSubProductTypeInput) {
    data {
      id
      name
      isActive
    }
    response {
      status
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllSubProductTypeSelectorQuery__
 *
 * To run a query within a React component, call `useFindAllSubProductTypeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSubProductTypeSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSubProductTypeSelectorQuery({
 *   variables: {
 *      findAllSubProductTypeInput: // value for 'findAllSubProductTypeInput'
 *   },
 * });
 */
export function useFindAllSubProductTypeSelectorQuery(baseOptions: Apollo.QueryHookOptions<FindAllSubProductTypeSelectorQuery, FindAllSubProductTypeSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSubProductTypeSelectorQuery, FindAllSubProductTypeSelectorQueryVariables>(FindAllSubProductTypeSelectorDocument, options);
      }
export function useFindAllSubProductTypeSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSubProductTypeSelectorQuery, FindAllSubProductTypeSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSubProductTypeSelectorQuery, FindAllSubProductTypeSelectorQueryVariables>(FindAllSubProductTypeSelectorDocument, options);
        }
export type FindAllSubProductTypeSelectorQueryHookResult = ReturnType<typeof useFindAllSubProductTypeSelectorQuery>;
export type FindAllSubProductTypeSelectorLazyQueryHookResult = ReturnType<typeof useFindAllSubProductTypeSelectorLazyQuery>;
export type FindAllSubProductTypeSelectorQueryResult = Apollo.QueryResult<FindAllSubProductTypeSelectorQuery, FindAllSubProductTypeSelectorQueryVariables>;
export const GetSubProductTypeDocument = gql`
    query GetSubProductType($getSubProductTypeInput: GetSubProductTypeInput!) {
  getSubProductType(getSubProductTypeInput: $getSubProductTypeInput) {
    subProductType {
      name
      isActive
      productType {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetSubProductTypeQuery__
 *
 * To run a query within a React component, call `useGetSubProductTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubProductTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubProductTypeQuery({
 *   variables: {
 *      getSubProductTypeInput: // value for 'getSubProductTypeInput'
 *   },
 * });
 */
export function useGetSubProductTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSubProductTypeQuery, GetSubProductTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubProductTypeQuery, GetSubProductTypeQueryVariables>(GetSubProductTypeDocument, options);
      }
export function useGetSubProductTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubProductTypeQuery, GetSubProductTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubProductTypeQuery, GetSubProductTypeQueryVariables>(GetSubProductTypeDocument, options);
        }
export type GetSubProductTypeQueryHookResult = ReturnType<typeof useGetSubProductTypeQuery>;
export type GetSubProductTypeLazyQueryHookResult = ReturnType<typeof useGetSubProductTypeLazyQuery>;
export type GetSubProductTypeQueryResult = Apollo.QueryResult<GetSubProductTypeQuery, GetSubProductTypeQueryVariables>;
export const UpdateSubProductTypeDocument = gql`
    mutation UpdateSubProductType($updateSubProductTypeInput: UpdateSubProductTypeInput!) {
  updateSubProductType(updateSubProductTypeInput: $updateSubProductTypeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSubProductTypeMutationFn = Apollo.MutationFunction<UpdateSubProductTypeMutation, UpdateSubProductTypeMutationVariables>;

/**
 * __useUpdateSubProductTypeMutation__
 *
 * To run a mutation, you first call `useUpdateSubProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubProductTypeMutation, { data, loading, error }] = useUpdateSubProductTypeMutation({
 *   variables: {
 *      updateSubProductTypeInput: // value for 'updateSubProductTypeInput'
 *   },
 * });
 */
export function useUpdateSubProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubProductTypeMutation, UpdateSubProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubProductTypeMutation, UpdateSubProductTypeMutationVariables>(UpdateSubProductTypeDocument, options);
      }
export type UpdateSubProductTypeMutationHookResult = ReturnType<typeof useUpdateSubProductTypeMutation>;
export type UpdateSubProductTypeMutationResult = Apollo.MutationResult<UpdateSubProductTypeMutation>;
export type UpdateSubProductTypeMutationOptions = Apollo.BaseMutationOptions<UpdateSubProductTypeMutation, UpdateSubProductTypeMutationVariables>;
export const CreateSubProductTypeDocument = gql`
    mutation CreateSubProductType($createSubProductTypeInput: CreateSubProductTypeInput!) {
  createSubProductType(createSubProductTypeInput: $createSubProductTypeInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSubProductTypeMutationFn = Apollo.MutationFunction<CreateSubProductTypeMutation, CreateSubProductTypeMutationVariables>;

/**
 * __useCreateSubProductTypeMutation__
 *
 * To run a mutation, you first call `useCreateSubProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubProductTypeMutation, { data, loading, error }] = useCreateSubProductTypeMutation({
 *   variables: {
 *      createSubProductTypeInput: // value for 'createSubProductTypeInput'
 *   },
 * });
 */
export function useCreateSubProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubProductTypeMutation, CreateSubProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubProductTypeMutation, CreateSubProductTypeMutationVariables>(CreateSubProductTypeDocument, options);
      }
export type CreateSubProductTypeMutationHookResult = ReturnType<typeof useCreateSubProductTypeMutation>;
export type CreateSubProductTypeMutationResult = Apollo.MutationResult<CreateSubProductTypeMutation>;
export type CreateSubProductTypeMutationOptions = Apollo.BaseMutationOptions<CreateSubProductTypeMutation, CreateSubProductTypeMutationVariables>;
export const FindTableSuppliersDocument = gql`
    query FindTableSuppliers($findAllSuppliersInput: FindAllSuppliersInput!) {
  findAllSuppliers(findAllSuppliersInput: $findAllSuppliersInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      status
      organizationId
      contact {
        name
        designation
      }
    }
  }
}
    `;

/**
 * __useFindTableSuppliersQuery__
 *
 * To run a query within a React component, call `useFindTableSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTableSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTableSuppliersQuery({
 *   variables: {
 *      findAllSuppliersInput: // value for 'findAllSuppliersInput'
 *   },
 * });
 */
export function useFindTableSuppliersQuery(baseOptions: Apollo.QueryHookOptions<FindTableSuppliersQuery, FindTableSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTableSuppliersQuery, FindTableSuppliersQueryVariables>(FindTableSuppliersDocument, options);
      }
export function useFindTableSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTableSuppliersQuery, FindTableSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTableSuppliersQuery, FindTableSuppliersQueryVariables>(FindTableSuppliersDocument, options);
        }
export type FindTableSuppliersQueryHookResult = ReturnType<typeof useFindTableSuppliersQuery>;
export type FindTableSuppliersLazyQueryHookResult = ReturnType<typeof useFindTableSuppliersLazyQuery>;
export type FindTableSuppliersQueryResult = Apollo.QueryResult<FindTableSuppliersQuery, FindTableSuppliersQueryVariables>;
export const FindAllSuppliersDocument = gql`
    query FindAllSuppliers($findAllSuppliersInput: FindAllSuppliersInput!) {
  findAllSuppliers(findAllSuppliersInput: $findAllSuppliersInput) {
    data {
      id
      name
      status
      description
    }
    pagination {
      page
      totalPages
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllSuppliersQuery__
 *
 * To run a query within a React component, call `useFindAllSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSuppliersQuery({
 *   variables: {
 *      findAllSuppliersInput: // value for 'findAllSuppliersInput'
 *   },
 * });
 */
export function useFindAllSuppliersQuery(baseOptions: Apollo.QueryHookOptions<FindAllSuppliersQuery, FindAllSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSuppliersQuery, FindAllSuppliersQueryVariables>(FindAllSuppliersDocument, options);
      }
export function useFindAllSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSuppliersQuery, FindAllSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSuppliersQuery, FindAllSuppliersQueryVariables>(FindAllSuppliersDocument, options);
        }
export type FindAllSuppliersQueryHookResult = ReturnType<typeof useFindAllSuppliersQuery>;
export type FindAllSuppliersLazyQueryHookResult = ReturnType<typeof useFindAllSuppliersLazyQuery>;
export type FindAllSuppliersQueryResult = Apollo.QueryResult<FindAllSuppliersQuery, FindAllSuppliersQueryVariables>;
export const FindAllSuppliersSelectDocument = gql`
    query FindAllSuppliersSelect($findAllSuppliersInput: FindAllSuppliersInput!) {
  findAllSuppliers(findAllSuppliersInput: $findAllSuppliersInput) {
    data {
      id
      name
    }
    response {
      status
    }
    pagination {
      totalPages
    }
  }
}
    `;

/**
 * __useFindAllSuppliersSelectQuery__
 *
 * To run a query within a React component, call `useFindAllSuppliersSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSuppliersSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSuppliersSelectQuery({
 *   variables: {
 *      findAllSuppliersInput: // value for 'findAllSuppliersInput'
 *   },
 * });
 */
export function useFindAllSuppliersSelectQuery(baseOptions: Apollo.QueryHookOptions<FindAllSuppliersSelectQuery, FindAllSuppliersSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSuppliersSelectQuery, FindAllSuppliersSelectQueryVariables>(FindAllSuppliersSelectDocument, options);
      }
export function useFindAllSuppliersSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSuppliersSelectQuery, FindAllSuppliersSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSuppliersSelectQuery, FindAllSuppliersSelectQueryVariables>(FindAllSuppliersSelectDocument, options);
        }
export type FindAllSuppliersSelectQueryHookResult = ReturnType<typeof useFindAllSuppliersSelectQuery>;
export type FindAllSuppliersSelectLazyQueryHookResult = ReturnType<typeof useFindAllSuppliersSelectLazyQuery>;
export type FindAllSuppliersSelectQueryResult = Apollo.QueryResult<FindAllSuppliersSelectQuery, FindAllSuppliersSelectQueryVariables>;
export const GetSupplierDocument = gql`
    query GetSupplier($getSupplierInput: GetSupplierInput!) {
  getSupplier(getSupplierInput: $getSupplierInput) {
    supplier {
      name
      description
      contact {
        id
        city
        name
        email
        state
        phoneNo
        zipCode
        country
        address1
        address2
        designation
        countryCode
      }
      additionalContacts {
        id
        name
        email
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetSupplierQuery__
 *
 * To run a query within a React component, call `useGetSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierQuery({
 *   variables: {
 *      getSupplierInput: // value for 'getSupplierInput'
 *   },
 * });
 */
export function useGetSupplierQuery(baseOptions: Apollo.QueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
      }
export function useGetSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
        }
export type GetSupplierQueryHookResult = ReturnType<typeof useGetSupplierQuery>;
export type GetSupplierLazyQueryHookResult = ReturnType<typeof useGetSupplierLazyQuery>;
export type GetSupplierQueryResult = Apollo.QueryResult<GetSupplierQuery, GetSupplierQueryVariables>;
export const CreateSupplierDocument = gql`
    mutation CreateSupplier($createSupplierInput: CreateSupplierInput!) {
  createSupplier(createSupplierInput: $createSupplierInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      createSupplierInput: // value for 'createSupplierInput'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const UpdateSupplierDocument = gql`
    mutation UpdateSupplier($updateSupplierInput: UpdateSupplierInput!) {
  updateSupplier(updateSupplierInput: $updateSupplierInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSupplierMutationFn = Apollo.MutationFunction<UpdateSupplierMutation, UpdateSupplierMutationVariables>;

/**
 * __useUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMutation, { data, loading, error }] = useUpdateSupplierMutation({
 *   variables: {
 *      updateSupplierInput: // value for 'updateSupplierInput'
 *   },
 * });
 */
export function useUpdateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierMutation, UpdateSupplierMutationVariables>(UpdateSupplierDocument, options);
      }
export type UpdateSupplierMutationHookResult = ReturnType<typeof useUpdateSupplierMutation>;
export type UpdateSupplierMutationResult = Apollo.MutationResult<UpdateSupplierMutation>;
export type UpdateSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const UpdateContactByContactableIdDocument = gql`
    mutation UpdateContactByContactableId($updateContactByContactableIdInput: UpdateContactByContactableIdInput!) {
  updateContactByContactableId(
    updateContactByContactableIdInput: $updateContactByContactableIdInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateContactByContactableIdMutationFn = Apollo.MutationFunction<UpdateContactByContactableIdMutation, UpdateContactByContactableIdMutationVariables>;

/**
 * __useUpdateContactByContactableIdMutation__
 *
 * To run a mutation, you first call `useUpdateContactByContactableIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactByContactableIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactByContactableIdMutation, { data, loading, error }] = useUpdateContactByContactableIdMutation({
 *   variables: {
 *      updateContactByContactableIdInput: // value for 'updateContactByContactableIdInput'
 *   },
 * });
 */
export function useUpdateContactByContactableIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactByContactableIdMutation, UpdateContactByContactableIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactByContactableIdMutation, UpdateContactByContactableIdMutationVariables>(UpdateContactByContactableIdDocument, options);
      }
export type UpdateContactByContactableIdMutationHookResult = ReturnType<typeof useUpdateContactByContactableIdMutation>;
export type UpdateContactByContactableIdMutationResult = Apollo.MutationResult<UpdateContactByContactableIdMutation>;
export type UpdateContactByContactableIdMutationOptions = Apollo.BaseMutationOptions<UpdateContactByContactableIdMutation, UpdateContactByContactableIdMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($createContactInput: CreateContactInput!) {
  createContact(createContactInput: $createContactInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      createContactInput: // value for 'createContactInput'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateAdditionalContactDocument = gql`
    mutation UpdateAdditionalContact($updateAdditionalContactsInput: UpdateAdditionalContactsInput!) {
  updateAdditionalContact(
    updateAdditionalContactsInput: $updateAdditionalContactsInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateAdditionalContactMutationFn = Apollo.MutationFunction<UpdateAdditionalContactMutation, UpdateAdditionalContactMutationVariables>;

/**
 * __useUpdateAdditionalContactMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalContactMutation, { data, loading, error }] = useUpdateAdditionalContactMutation({
 *   variables: {
 *      updateAdditionalContactsInput: // value for 'updateAdditionalContactsInput'
 *   },
 * });
 */
export function useUpdateAdditionalContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdditionalContactMutation, UpdateAdditionalContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdditionalContactMutation, UpdateAdditionalContactMutationVariables>(UpdateAdditionalContactDocument, options);
      }
export type UpdateAdditionalContactMutationHookResult = ReturnType<typeof useUpdateAdditionalContactMutation>;
export type UpdateAdditionalContactMutationResult = Apollo.MutationResult<UpdateAdditionalContactMutation>;
export type UpdateAdditionalContactMutationOptions = Apollo.BaseMutationOptions<UpdateAdditionalContactMutation, UpdateAdditionalContactMutationVariables>;
export const CreateAdditionalContactDocument = gql`
    mutation CreateAdditionalContact($createAdditionalContactInput: CreateAdditionalContactInput!) {
  createAdditionalContact(
    createAdditionalContactInput: $createAdditionalContactInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateAdditionalContactMutationFn = Apollo.MutationFunction<CreateAdditionalContactMutation, CreateAdditionalContactMutationVariables>;

/**
 * __useCreateAdditionalContactMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalContactMutation, { data, loading, error }] = useCreateAdditionalContactMutation({
 *   variables: {
 *      createAdditionalContactInput: // value for 'createAdditionalContactInput'
 *   },
 * });
 */
export function useCreateAdditionalContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdditionalContactMutation, CreateAdditionalContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdditionalContactMutation, CreateAdditionalContactMutationVariables>(CreateAdditionalContactDocument, options);
      }
export type CreateAdditionalContactMutationHookResult = ReturnType<typeof useCreateAdditionalContactMutation>;
export type CreateAdditionalContactMutationResult = Apollo.MutationResult<CreateAdditionalContactMutation>;
export type CreateAdditionalContactMutationOptions = Apollo.BaseMutationOptions<CreateAdditionalContactMutation, CreateAdditionalContactMutationVariables>;
export const FetchSweetenerComponentSelectorDocument = gql`
    query FetchSweetenerComponentSelector($findAllSweetenerComponentsInput: FindAllSweetenerComponentsInput!) {
  findAllSweetenersComponent(
    findAllSweetenerComponentsInput: $findAllSweetenerComponentsInput
  ) {
    response {
      status
    }
    pagination {
      totalPages
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFetchSweetenerComponentSelectorQuery__
 *
 * To run a query within a React component, call `useFetchSweetenerComponentSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSweetenerComponentSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSweetenerComponentSelectorQuery({
 *   variables: {
 *      findAllSweetenerComponentsInput: // value for 'findAllSweetenerComponentsInput'
 *   },
 * });
 */
export function useFetchSweetenerComponentSelectorQuery(baseOptions: Apollo.QueryHookOptions<FetchSweetenerComponentSelectorQuery, FetchSweetenerComponentSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSweetenerComponentSelectorQuery, FetchSweetenerComponentSelectorQueryVariables>(FetchSweetenerComponentSelectorDocument, options);
      }
export function useFetchSweetenerComponentSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSweetenerComponentSelectorQuery, FetchSweetenerComponentSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSweetenerComponentSelectorQuery, FetchSweetenerComponentSelectorQueryVariables>(FetchSweetenerComponentSelectorDocument, options);
        }
export type FetchSweetenerComponentSelectorQueryHookResult = ReturnType<typeof useFetchSweetenerComponentSelectorQuery>;
export type FetchSweetenerComponentSelectorLazyQueryHookResult = ReturnType<typeof useFetchSweetenerComponentSelectorLazyQuery>;
export type FetchSweetenerComponentSelectorQueryResult = Apollo.QueryResult<FetchSweetenerComponentSelectorQuery, FetchSweetenerComponentSelectorQueryVariables>;
export const FindAllSweetenersComponentDocument = gql`
    query FindAllSweetenersComponent($findAllSweetenerComponentsInput: FindAllSweetenerComponentsInput!) {
  findAllSweetenersComponent(
    findAllSweetenerComponentsInput: $findAllSweetenerComponentsInput
  ) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      costPerKg
      isActive
    }
  }
}
    `;

/**
 * __useFindAllSweetenersComponentQuery__
 *
 * To run a query within a React component, call `useFindAllSweetenersComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSweetenersComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSweetenersComponentQuery({
 *   variables: {
 *      findAllSweetenerComponentsInput: // value for 'findAllSweetenerComponentsInput'
 *   },
 * });
 */
export function useFindAllSweetenersComponentQuery(baseOptions: Apollo.QueryHookOptions<FindAllSweetenersComponentQuery, FindAllSweetenersComponentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSweetenersComponentQuery, FindAllSweetenersComponentQueryVariables>(FindAllSweetenersComponentDocument, options);
      }
export function useFindAllSweetenersComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSweetenersComponentQuery, FindAllSweetenersComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSweetenersComponentQuery, FindAllSweetenersComponentQueryVariables>(FindAllSweetenersComponentDocument, options);
        }
export type FindAllSweetenersComponentQueryHookResult = ReturnType<typeof useFindAllSweetenersComponentQuery>;
export type FindAllSweetenersComponentLazyQueryHookResult = ReturnType<typeof useFindAllSweetenersComponentLazyQuery>;
export type FindAllSweetenersComponentQueryResult = Apollo.QueryResult<FindAllSweetenersComponentQuery, FindAllSweetenersComponentQueryVariables>;
export const GetSweetenerComponentDocument = gql`
    query GetSweetenerComponent($getSweetenerComponentInput: GetSweetenerComponentInput!) {
  getSweetenerComponent(getSweetenerComponentInput: $getSweetenerComponentInput) {
    sweetenerComponent {
      id
      name
      costPerKg
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetSweetenerComponentQuery__
 *
 * To run a query within a React component, call `useGetSweetenerComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSweetenerComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSweetenerComponentQuery({
 *   variables: {
 *      getSweetenerComponentInput: // value for 'getSweetenerComponentInput'
 *   },
 * });
 */
export function useGetSweetenerComponentQuery(baseOptions: Apollo.QueryHookOptions<GetSweetenerComponentQuery, GetSweetenerComponentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSweetenerComponentQuery, GetSweetenerComponentQueryVariables>(GetSweetenerComponentDocument, options);
      }
export function useGetSweetenerComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSweetenerComponentQuery, GetSweetenerComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSweetenerComponentQuery, GetSweetenerComponentQueryVariables>(GetSweetenerComponentDocument, options);
        }
export type GetSweetenerComponentQueryHookResult = ReturnType<typeof useGetSweetenerComponentQuery>;
export type GetSweetenerComponentLazyQueryHookResult = ReturnType<typeof useGetSweetenerComponentLazyQuery>;
export type GetSweetenerComponentQueryResult = Apollo.QueryResult<GetSweetenerComponentQuery, GetSweetenerComponentQueryVariables>;
export const UpdateSweetenerComponentDocument = gql`
    mutation UpdateSweetenerComponent($updateSweetenerComponentInput: UpdateSweetenerComponentInput!) {
  updateSweetenerComponent(
    updateSweetenerComponentInput: $updateSweetenerComponentInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSweetenerComponentMutationFn = Apollo.MutationFunction<UpdateSweetenerComponentMutation, UpdateSweetenerComponentMutationVariables>;

/**
 * __useUpdateSweetenerComponentMutation__
 *
 * To run a mutation, you first call `useUpdateSweetenerComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSweetenerComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSweetenerComponentMutation, { data, loading, error }] = useUpdateSweetenerComponentMutation({
 *   variables: {
 *      updateSweetenerComponentInput: // value for 'updateSweetenerComponentInput'
 *   },
 * });
 */
export function useUpdateSweetenerComponentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSweetenerComponentMutation, UpdateSweetenerComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSweetenerComponentMutation, UpdateSweetenerComponentMutationVariables>(UpdateSweetenerComponentDocument, options);
      }
export type UpdateSweetenerComponentMutationHookResult = ReturnType<typeof useUpdateSweetenerComponentMutation>;
export type UpdateSweetenerComponentMutationResult = Apollo.MutationResult<UpdateSweetenerComponentMutation>;
export type UpdateSweetenerComponentMutationOptions = Apollo.BaseMutationOptions<UpdateSweetenerComponentMutation, UpdateSweetenerComponentMutationVariables>;
export const CreateSweetenerComponentDocument = gql`
    mutation CreateSweetenerComponent($createSweetenerComponentInput: CreateSweetenerComponentInput!) {
  createSweetenerComponent(
    createSweetenerComponentInput: $createSweetenerComponentInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSweetenerComponentMutationFn = Apollo.MutationFunction<CreateSweetenerComponentMutation, CreateSweetenerComponentMutationVariables>;

/**
 * __useCreateSweetenerComponentMutation__
 *
 * To run a mutation, you first call `useCreateSweetenerComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSweetenerComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSweetenerComponentMutation, { data, loading, error }] = useCreateSweetenerComponentMutation({
 *   variables: {
 *      createSweetenerComponentInput: // value for 'createSweetenerComponentInput'
 *   },
 * });
 */
export function useCreateSweetenerComponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSweetenerComponentMutation, CreateSweetenerComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSweetenerComponentMutation, CreateSweetenerComponentMutationVariables>(CreateSweetenerComponentDocument, options);
      }
export type CreateSweetenerComponentMutationHookResult = ReturnType<typeof useCreateSweetenerComponentMutation>;
export type CreateSweetenerComponentMutationResult = Apollo.MutationResult<CreateSweetenerComponentMutation>;
export type CreateSweetenerComponentMutationOptions = Apollo.BaseMutationOptions<CreateSweetenerComponentMutation, CreateSweetenerComponentMutationVariables>;
export const FindAllSweetenerElementsDocument = gql`
    query findAllSweetenerElements($getSweetenerInput: GetSweetenerInput!) {
  getSweetener(getSweetenerInput: $getSweetenerInput) {
    sweetener {
      id
      name
      type
      size
      nature
      isActive
      costPerServing
      mgPerServing
      productType {
        name
      }
      productSize {
        name
      }
      productFormulationType {
        name
      }
      sweetenerElements {
        id
        qtPerMg
        sweetenerComponent {
          id
          name
          isActive
        }
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFindAllSweetenerElementsQuery__
 *
 * To run a query within a React component, call `useFindAllSweetenerElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSweetenerElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSweetenerElementsQuery({
 *   variables: {
 *      getSweetenerInput: // value for 'getSweetenerInput'
 *   },
 * });
 */
export function useFindAllSweetenerElementsQuery(baseOptions: Apollo.QueryHookOptions<FindAllSweetenerElementsQuery, FindAllSweetenerElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSweetenerElementsQuery, FindAllSweetenerElementsQueryVariables>(FindAllSweetenerElementsDocument, options);
      }
export function useFindAllSweetenerElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSweetenerElementsQuery, FindAllSweetenerElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSweetenerElementsQuery, FindAllSweetenerElementsQueryVariables>(FindAllSweetenerElementsDocument, options);
        }
export type FindAllSweetenerElementsQueryHookResult = ReturnType<typeof useFindAllSweetenerElementsQuery>;
export type FindAllSweetenerElementsLazyQueryHookResult = ReturnType<typeof useFindAllSweetenerElementsLazyQuery>;
export type FindAllSweetenerElementsQueryResult = Apollo.QueryResult<FindAllSweetenerElementsQuery, FindAllSweetenerElementsQueryVariables>;
export const UpdateSweetenerElementDocument = gql`
    mutation UpdateSweetenerElement($updateSweetenerElementsInput: UpdateSweetenerElementsInput!) {
  updateSweetenerElement(
    updateSweetenerElementsInput: $updateSweetenerElementsInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSweetenerElementMutationFn = Apollo.MutationFunction<UpdateSweetenerElementMutation, UpdateSweetenerElementMutationVariables>;

/**
 * __useUpdateSweetenerElementMutation__
 *
 * To run a mutation, you first call `useUpdateSweetenerElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSweetenerElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSweetenerElementMutation, { data, loading, error }] = useUpdateSweetenerElementMutation({
 *   variables: {
 *      updateSweetenerElementsInput: // value for 'updateSweetenerElementsInput'
 *   },
 * });
 */
export function useUpdateSweetenerElementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSweetenerElementMutation, UpdateSweetenerElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSweetenerElementMutation, UpdateSweetenerElementMutationVariables>(UpdateSweetenerElementDocument, options);
      }
export type UpdateSweetenerElementMutationHookResult = ReturnType<typeof useUpdateSweetenerElementMutation>;
export type UpdateSweetenerElementMutationResult = Apollo.MutationResult<UpdateSweetenerElementMutation>;
export type UpdateSweetenerElementMutationOptions = Apollo.BaseMutationOptions<UpdateSweetenerElementMutation, UpdateSweetenerElementMutationVariables>;
export const CreateSweetenerElementDocument = gql`
    mutation CreateSweetenerElement($createSweetenerElementsInput: CreateSweetenerElementsInput!) {
  createSweetenerElement(
    createSweetenerElementsInput: $createSweetenerElementsInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSweetenerElementMutationFn = Apollo.MutationFunction<CreateSweetenerElementMutation, CreateSweetenerElementMutationVariables>;

/**
 * __useCreateSweetenerElementMutation__
 *
 * To run a mutation, you first call `useCreateSweetenerElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSweetenerElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSweetenerElementMutation, { data, loading, error }] = useCreateSweetenerElementMutation({
 *   variables: {
 *      createSweetenerElementsInput: // value for 'createSweetenerElementsInput'
 *   },
 * });
 */
export function useCreateSweetenerElementMutation(baseOptions?: Apollo.MutationHookOptions<CreateSweetenerElementMutation, CreateSweetenerElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSweetenerElementMutation, CreateSweetenerElementMutationVariables>(CreateSweetenerElementDocument, options);
      }
export type CreateSweetenerElementMutationHookResult = ReturnType<typeof useCreateSweetenerElementMutation>;
export type CreateSweetenerElementMutationResult = Apollo.MutationResult<CreateSweetenerElementMutation>;
export type CreateSweetenerElementMutationOptions = Apollo.BaseMutationOptions<CreateSweetenerElementMutation, CreateSweetenerElementMutationVariables>;
export const RemoveSweetenerElementDocument = gql`
    mutation RemoveSweetenerElement($removeSweetenerElementsInput: RemoveSweetenerElementsInput!) {
  removeSweetenerElement(
    removeSweetenerElementsInput: $removeSweetenerElementsInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type RemoveSweetenerElementMutationFn = Apollo.MutationFunction<RemoveSweetenerElementMutation, RemoveSweetenerElementMutationVariables>;

/**
 * __useRemoveSweetenerElementMutation__
 *
 * To run a mutation, you first call `useRemoveSweetenerElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSweetenerElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSweetenerElementMutation, { data, loading, error }] = useRemoveSweetenerElementMutation({
 *   variables: {
 *      removeSweetenerElementsInput: // value for 'removeSweetenerElementsInput'
 *   },
 * });
 */
export function useRemoveSweetenerElementMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSweetenerElementMutation, RemoveSweetenerElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSweetenerElementMutation, RemoveSweetenerElementMutationVariables>(RemoveSweetenerElementDocument, options);
      }
export type RemoveSweetenerElementMutationHookResult = ReturnType<typeof useRemoveSweetenerElementMutation>;
export type RemoveSweetenerElementMutationResult = Apollo.MutationResult<RemoveSweetenerElementMutation>;
export type RemoveSweetenerElementMutationOptions = Apollo.BaseMutationOptions<RemoveSweetenerElementMutation, RemoveSweetenerElementMutationVariables>;
export const FindAllSweetenersDocument = gql`
    query FindAllSweeteners($findAllSweetenersInput: FindAllSweetenersInput!) {
  findAllSweeteners(findAllSweetenersInput: $findAllSweetenersInput) {
    response {
      status
    }
    data {
      name
      id
    }
  }
}
    `;

/**
 * __useFindAllSweetenersQuery__
 *
 * To run a query within a React component, call `useFindAllSweetenersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSweetenersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSweetenersQuery({
 *   variables: {
 *      findAllSweetenersInput: // value for 'findAllSweetenersInput'
 *   },
 * });
 */
export function useFindAllSweetenersQuery(baseOptions: Apollo.QueryHookOptions<FindAllSweetenersQuery, FindAllSweetenersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSweetenersQuery, FindAllSweetenersQueryVariables>(FindAllSweetenersDocument, options);
      }
export function useFindAllSweetenersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSweetenersQuery, FindAllSweetenersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSweetenersQuery, FindAllSweetenersQueryVariables>(FindAllSweetenersDocument, options);
        }
export type FindAllSweetenersQueryHookResult = ReturnType<typeof useFindAllSweetenersQuery>;
export type FindAllSweetenersLazyQueryHookResult = ReturnType<typeof useFindAllSweetenersLazyQuery>;
export type FindAllSweetenersQueryResult = Apollo.QueryResult<FindAllSweetenersQuery, FindAllSweetenersQueryVariables>;
export const FindAllSweetenersTableDocument = gql`
    query FindAllSweetenersTable($findAllSweetenersInput: FindAllSweetenersInput!) {
  findAllSweeteners(findAllSweetenersInput: $findAllSweetenersInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      name
      size
      nature
      isActive
      mgPerServing
      costPerServing
      productType {
        name
      }
      productSize {
        name
      }
      productFormulationType {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllSweetenersTableQuery__
 *
 * To run a query within a React component, call `useFindAllSweetenersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSweetenersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSweetenersTableQuery({
 *   variables: {
 *      findAllSweetenersInput: // value for 'findAllSweetenersInput'
 *   },
 * });
 */
export function useFindAllSweetenersTableQuery(baseOptions: Apollo.QueryHookOptions<FindAllSweetenersTableQuery, FindAllSweetenersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSweetenersTableQuery, FindAllSweetenersTableQueryVariables>(FindAllSweetenersTableDocument, options);
      }
export function useFindAllSweetenersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSweetenersTableQuery, FindAllSweetenersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSweetenersTableQuery, FindAllSweetenersTableQueryVariables>(FindAllSweetenersTableDocument, options);
        }
export type FindAllSweetenersTableQueryHookResult = ReturnType<typeof useFindAllSweetenersTableQuery>;
export type FindAllSweetenersTableLazyQueryHookResult = ReturnType<typeof useFindAllSweetenersTableLazyQuery>;
export type FindAllSweetenersTableQueryResult = Apollo.QueryResult<FindAllSweetenersTableQuery, FindAllSweetenersTableQueryVariables>;
export const GetSweetenerDocument = gql`
    query GetSweetener($getSweetenerInput: GetSweetenerInput!) {
  getSweetener(getSweetenerInput: $getSweetenerInput) {
    sweetener {
      name
      size
      nature
      isActive
      mgPerServing
      costPerServing
      productType {
        id
        name
      }
      productSize {
        id
        name
      }
      productFormulationType {
        id
        name
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useGetSweetenerQuery__
 *
 * To run a query within a React component, call `useGetSweetenerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSweetenerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSweetenerQuery({
 *   variables: {
 *      getSweetenerInput: // value for 'getSweetenerInput'
 *   },
 * });
 */
export function useGetSweetenerQuery(baseOptions: Apollo.QueryHookOptions<GetSweetenerQuery, GetSweetenerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSweetenerQuery, GetSweetenerQueryVariables>(GetSweetenerDocument, options);
      }
export function useGetSweetenerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSweetenerQuery, GetSweetenerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSweetenerQuery, GetSweetenerQueryVariables>(GetSweetenerDocument, options);
        }
export type GetSweetenerQueryHookResult = ReturnType<typeof useGetSweetenerQuery>;
export type GetSweetenerLazyQueryHookResult = ReturnType<typeof useGetSweetenerLazyQuery>;
export type GetSweetenerQueryResult = Apollo.QueryResult<GetSweetenerQuery, GetSweetenerQueryVariables>;
export const CreateSweetenerDocument = gql`
    mutation CreateSweetener($createSweetenerInput: CreateSweetenerInput!) {
  createSweetener(createSweetenerInput: $createSweetenerInput) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateSweetenerMutationFn = Apollo.MutationFunction<CreateSweetenerMutation, CreateSweetenerMutationVariables>;

/**
 * __useCreateSweetenerMutation__
 *
 * To run a mutation, you first call `useCreateSweetenerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSweetenerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSweetenerMutation, { data, loading, error }] = useCreateSweetenerMutation({
 *   variables: {
 *      createSweetenerInput: // value for 'createSweetenerInput'
 *   },
 * });
 */
export function useCreateSweetenerMutation(baseOptions?: Apollo.MutationHookOptions<CreateSweetenerMutation, CreateSweetenerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSweetenerMutation, CreateSweetenerMutationVariables>(CreateSweetenerDocument, options);
      }
export type CreateSweetenerMutationHookResult = ReturnType<typeof useCreateSweetenerMutation>;
export type CreateSweetenerMutationResult = Apollo.MutationResult<CreateSweetenerMutation>;
export type CreateSweetenerMutationOptions = Apollo.BaseMutationOptions<CreateSweetenerMutation, CreateSweetenerMutationVariables>;
export const UpdateSweetenerDocument = gql`
    mutation UpdateSweetener($updateSweetenerInput: UpdateSweetenerInput!) {
  updateSweetener(updateSweetenerInput: $updateSweetenerInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateSweetenerMutationFn = Apollo.MutationFunction<UpdateSweetenerMutation, UpdateSweetenerMutationVariables>;

/**
 * __useUpdateSweetenerMutation__
 *
 * To run a mutation, you first call `useUpdateSweetenerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSweetenerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSweetenerMutation, { data, loading, error }] = useUpdateSweetenerMutation({
 *   variables: {
 *      updateSweetenerInput: // value for 'updateSweetenerInput'
 *   },
 * });
 */
export function useUpdateSweetenerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSweetenerMutation, UpdateSweetenerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSweetenerMutation, UpdateSweetenerMutationVariables>(UpdateSweetenerDocument, options);
      }
export type UpdateSweetenerMutationHookResult = ReturnType<typeof useUpdateSweetenerMutation>;
export type UpdateSweetenerMutationResult = Apollo.MutationResult<UpdateSweetenerMutation>;
export type UpdateSweetenerMutationOptions = Apollo.BaseMutationOptions<UpdateSweetenerMutation, UpdateSweetenerMutationVariables>;
export const FindAllTabletTypeDocument = gql`
    query FindAllTabletType($findAllProductFormulationTypeInput: FindAllProductFormulationTypeInput!) {
  findAllProductFormulationType(
    findAllProductFormulationTypeInput: $findAllProductFormulationTypeInput
  ) {
    response {
      status
    }
    data {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useFindAllTabletTypeQuery__
 *
 * To run a query within a React component, call `useFindAllTabletTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllTabletTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllTabletTypeQuery({
 *   variables: {
 *      findAllProductFormulationTypeInput: // value for 'findAllProductFormulationTypeInput'
 *   },
 * });
 */
export function useFindAllTabletTypeQuery(baseOptions: Apollo.QueryHookOptions<FindAllTabletTypeQuery, FindAllTabletTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllTabletTypeQuery, FindAllTabletTypeQueryVariables>(FindAllTabletTypeDocument, options);
      }
export function useFindAllTabletTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllTabletTypeQuery, FindAllTabletTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllTabletTypeQuery, FindAllTabletTypeQueryVariables>(FindAllTabletTypeDocument, options);
        }
export type FindAllTabletTypeQueryHookResult = ReturnType<typeof useFindAllTabletTypeQuery>;
export type FindAllTabletTypeLazyQueryHookResult = ReturnType<typeof useFindAllTabletTypeLazyQuery>;
export type FindAllTabletTypeQueryResult = Apollo.QueryResult<FindAllTabletTypeQuery, FindAllTabletTypeQueryVariables>;
export const FetchUserDocument = gql`
    query FetchUser {
  fetchUser {
    response {
      status
      message
    }
    user {
      id
      firstName
      lastName
      email
      isAccepted
      userRoles {
        role {
          type
        }
      }
    }
  }
}
    `;

/**
 * __useFetchUserQuery__
 *
 * To run a query within a React component, call `useFetchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchUserQuery(baseOptions?: Apollo.QueryHookOptions<FetchUserQuery, FetchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserQuery, FetchUserQueryVariables>(FetchUserDocument, options);
      }
export function useFetchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserQuery, FetchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserQuery, FetchUserQueryVariables>(FetchUserDocument, options);
        }
export type FetchUserQueryHookResult = ReturnType<typeof useFetchUserQuery>;
export type FetchUserLazyQueryHookResult = ReturnType<typeof useFetchUserLazyQuery>;
export type FetchUserQueryResult = Apollo.QueryResult<FetchUserQuery, FetchUserQueryVariables>;
export const FindAllAdminDocument = gql`
    query FindAllAdmin($findAllAdminInput: FindAllAdminInput!) {
  findAllAdmin(findAllAdminInput: $findAllAdminInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      firstName
      lastName
      email
      phone
      status
      createdAt
      organizationId
      organization {
        name
        maxUser
        activeStaff
        totalStaff
      }
    }
  }
}
    `;

/**
 * __useFindAllAdminQuery__
 *
 * To run a query within a React component, call `useFindAllAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAdminQuery({
 *   variables: {
 *      findAllAdminInput: // value for 'findAllAdminInput'
 *   },
 * });
 */
export function useFindAllAdminQuery(baseOptions: Apollo.QueryHookOptions<FindAllAdminQuery, FindAllAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAdminQuery, FindAllAdminQueryVariables>(FindAllAdminDocument, options);
      }
export function useFindAllAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAdminQuery, FindAllAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAdminQuery, FindAllAdminQueryVariables>(FindAllAdminDocument, options);
        }
export type FindAllAdminQueryHookResult = ReturnType<typeof useFindAllAdminQuery>;
export type FindAllAdminLazyQueryHookResult = ReturnType<typeof useFindAllAdminLazyQuery>;
export type FindAllAdminQueryResult = Apollo.QueryResult<FindAllAdminQuery, FindAllAdminQueryVariables>;
export const FindAllUsersDocument = gql`
    query FindAllUsers($findAllUsersInput: FindAllUsersInput!) {
  findAllUsers(findAllUsersInput: $findAllUsersInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      firstName
      lastName
      email
      createdAt
      userRoles {
        role {
          name
        }
      }
      organization {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllUsersQuery__
 *
 * To run a query within a React component, call `useFindAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllUsersQuery({
 *   variables: {
 *      findAllUsersInput: // value for 'findAllUsersInput'
 *   },
 * });
 */
export function useFindAllUsersQuery(baseOptions: Apollo.QueryHookOptions<FindAllUsersQuery, FindAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllUsersQuery, FindAllUsersQueryVariables>(FindAllUsersDocument, options);
      }
export function useFindAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllUsersQuery, FindAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllUsersQuery, FindAllUsersQueryVariables>(FindAllUsersDocument, options);
        }
export type FindAllUsersQueryHookResult = ReturnType<typeof useFindAllUsersQuery>;
export type FindAllUsersLazyQueryHookResult = ReturnType<typeof useFindAllUsersLazyQuery>;
export type FindAllUsersQueryResult = Apollo.QueryResult<FindAllUsersQuery, FindAllUsersQueryVariables>;
export const FindAllUsersSelectDocument = gql`
    query FindAllUsersSelect($findAllUsersInput: FindAllUsersInput!) {
  findAllUsers(findAllUsersInput: $findAllUsersInput) {
    response {
      status
    }
    pagination {
      page
      totalCount
    }
    data {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useFindAllUsersSelectQuery__
 *
 * To run a query within a React component, call `useFindAllUsersSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllUsersSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllUsersSelectQuery({
 *   variables: {
 *      findAllUsersInput: // value for 'findAllUsersInput'
 *   },
 * });
 */
export function useFindAllUsersSelectQuery(baseOptions: Apollo.QueryHookOptions<FindAllUsersSelectQuery, FindAllUsersSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllUsersSelectQuery, FindAllUsersSelectQueryVariables>(FindAllUsersSelectDocument, options);
      }
export function useFindAllUsersSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllUsersSelectQuery, FindAllUsersSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllUsersSelectQuery, FindAllUsersSelectQueryVariables>(FindAllUsersSelectDocument, options);
        }
export type FindAllUsersSelectQueryHookResult = ReturnType<typeof useFindAllUsersSelectQuery>;
export type FindAllUsersSelectLazyQueryHookResult = ReturnType<typeof useFindAllUsersSelectLazyQuery>;
export type FindAllUsersSelectQueryResult = Apollo.QueryResult<FindAllUsersSelectQuery, FindAllUsersSelectQueryVariables>;
export const FindOrgUserSelectDocument = gql`
    query FindOrgUserSelect($findAllAdminInput: FindAllAdminInput!) {
  findAllAdmin(findAllAdminInput: $findAllAdminInput) {
    response {
      status
    }
    pagination {
      totalPages
    }
    data {
      firstName
      lastName
      organization {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFindOrgUserSelectQuery__
 *
 * To run a query within a React component, call `useFindOrgUserSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrgUserSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrgUserSelectQuery({
 *   variables: {
 *      findAllAdminInput: // value for 'findAllAdminInput'
 *   },
 * });
 */
export function useFindOrgUserSelectQuery(baseOptions: Apollo.QueryHookOptions<FindOrgUserSelectQuery, FindOrgUserSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrgUserSelectQuery, FindOrgUserSelectQueryVariables>(FindOrgUserSelectDocument, options);
      }
export function useFindOrgUserSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrgUserSelectQuery, FindOrgUserSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrgUserSelectQuery, FindOrgUserSelectQueryVariables>(FindOrgUserSelectDocument, options);
        }
export type FindOrgUserSelectQueryHookResult = ReturnType<typeof useFindOrgUserSelectQuery>;
export type FindOrgUserSelectLazyQueryHookResult = ReturnType<typeof useFindOrgUserSelectLazyQuery>;
export type FindOrgUserSelectQueryResult = Apollo.QueryResult<FindOrgUserSelectQuery, FindOrgUserSelectQueryVariables>;
export const FindUsersCountByYearDocument = gql`
    query FindUsersCountByYear($findUsersCountByYearInput: FindUsersCountByYearInput!) {
  findUsersCountByYear(findUsersCountByYearInput: $findUsersCountByYearInput) {
    response {
      status
    }
    data
  }
}
    `;

/**
 * __useFindUsersCountByYearQuery__
 *
 * To run a query within a React component, call `useFindUsersCountByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersCountByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersCountByYearQuery({
 *   variables: {
 *      findUsersCountByYearInput: // value for 'findUsersCountByYearInput'
 *   },
 * });
 */
export function useFindUsersCountByYearQuery(baseOptions: Apollo.QueryHookOptions<FindUsersCountByYearQuery, FindUsersCountByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUsersCountByYearQuery, FindUsersCountByYearQueryVariables>(FindUsersCountByYearDocument, options);
      }
export function useFindUsersCountByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUsersCountByYearQuery, FindUsersCountByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUsersCountByYearQuery, FindUsersCountByYearQueryVariables>(FindUsersCountByYearDocument, options);
        }
export type FindUsersCountByYearQueryHookResult = ReturnType<typeof useFindUsersCountByYearQuery>;
export type FindUsersCountByYearLazyQueryHookResult = ReturnType<typeof useFindUsersCountByYearLazyQuery>;
export type FindUsersCountByYearQueryResult = Apollo.QueryResult<FindUsersCountByYearQuery, FindUsersCountByYearQueryVariables>;
export const GetPlatformUsersCountDocument = gql`
    query GetPlatformUsersCount {
  getPlatformUsersCount {
    response {
      status
    }
    data {
      ios
      web
      android
    }
  }
}
    `;

/**
 * __useGetPlatformUsersCountQuery__
 *
 * To run a query within a React component, call `useGetPlatformUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformUsersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlatformUsersCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPlatformUsersCountQuery, GetPlatformUsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformUsersCountQuery, GetPlatformUsersCountQueryVariables>(GetPlatformUsersCountDocument, options);
      }
export function useGetPlatformUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformUsersCountQuery, GetPlatformUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformUsersCountQuery, GetPlatformUsersCountQueryVariables>(GetPlatformUsersCountDocument, options);
        }
export type GetPlatformUsersCountQueryHookResult = ReturnType<typeof useGetPlatformUsersCountQuery>;
export type GetPlatformUsersCountLazyQueryHookResult = ReturnType<typeof useGetPlatformUsersCountLazyQuery>;
export type GetPlatformUsersCountQueryResult = Apollo.QueryResult<GetPlatformUsersCountQuery, GetPlatformUsersCountQueryVariables>;
export const FindUsersStatsDocument = gql`
    query FindUsersStats($findUsersStatsInput: FindUsersStatsInput!) {
  findUsersStats(findUsersStatsInput: $findUsersStatsInput) {
    response {
      status
    }
    data {
      staff
      orgAdmins
      activeUsers
    }
  }
}
    `;

/**
 * __useFindUsersStatsQuery__
 *
 * To run a query within a React component, call `useFindUsersStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersStatsQuery({
 *   variables: {
 *      findUsersStatsInput: // value for 'findUsersStatsInput'
 *   },
 * });
 */
export function useFindUsersStatsQuery(baseOptions: Apollo.QueryHookOptions<FindUsersStatsQuery, FindUsersStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUsersStatsQuery, FindUsersStatsQueryVariables>(FindUsersStatsDocument, options);
      }
export function useFindUsersStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUsersStatsQuery, FindUsersStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUsersStatsQuery, FindUsersStatsQueryVariables>(FindUsersStatsDocument, options);
        }
export type FindUsersStatsQueryHookResult = ReturnType<typeof useFindUsersStatsQuery>;
export type FindUsersStatsLazyQueryHookResult = ReturnType<typeof useFindUsersStatsLazyQuery>;
export type FindUsersStatsQueryResult = Apollo.QueryResult<FindUsersStatsQuery, FindUsersStatsQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($getUserInput: GetUserInput!) {
  getUser(getUserInput: $getUserInput) {
    response {
      status
    }
    user {
      id
      email
      phone
      lastName
      staffRole
      firstName
      organization {
        id
        name
        maxUser
        address {
          address1
          address2
          city
          zip
          country
          state
          countryCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      getUserInput: // value for 'getUserInput'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetStaffDocument = gql`
    query GetStaff($getUserInput: GetUserInput!) {
  getUser(getUserInput: $getUserInput) {
    response {
      status
    }
    user {
      id
      email
      phone
      lastName
      firstName
      staffRole
    }
  }
}
    `;

/**
 * __useGetStaffQuery__
 *
 * To run a query within a React component, call `useGetStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffQuery({
 *   variables: {
 *      getUserInput: // value for 'getUserInput'
 *   },
 * });
 */
export function useGetStaffQuery(baseOptions: Apollo.QueryHookOptions<GetStaffQuery, GetStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffQuery, GetStaffQueryVariables>(GetStaffDocument, options);
      }
export function useGetStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffQuery, GetStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffQuery, GetStaffQueryVariables>(GetStaffDocument, options);
        }
export type GetStaffQueryHookResult = ReturnType<typeof useGetStaffQuery>;
export type GetStaffLazyQueryHookResult = ReturnType<typeof useGetStaffLazyQuery>;
export type GetStaffQueryResult = Apollo.QueryResult<GetStaffQuery, GetStaffQueryVariables>;
export const GetCurrentUserSubscriptionDocument = gql`
    query GetCurrentUserSubscription {
  getCurrentUserSubscription {
    response {
      message
      status
    }
    subscription {
      id
      createdAt
      trialStart
      trialEnd
      status
      interval
      currentPeriodStart
      currentPeriodEnd
      cancelAtPeriodEnd
      cancelAt
      pricingId
    }
  }
}
    `;

/**
 * __useGetCurrentUserSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, options);
      }
export function useGetCurrentUserSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, options);
        }
export type GetCurrentUserSubscriptionQueryHookResult = ReturnType<typeof useGetCurrentUserSubscriptionQuery>;
export type GetCurrentUserSubscriptionLazyQueryHookResult = ReturnType<typeof useGetCurrentUserSubscriptionLazyQuery>;
export type GetCurrentUserSubscriptionQueryResult = Apollo.QueryResult<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>;
export const GetStaffSubscriptionDocument = gql`
    query GetStaffSubscription($getSubscriptionInput: GetSubscriptionInput!) {
  getStaffSubscription(getSubscriptionInput: $getSubscriptionInput) {
    response {
      message
      status
    }
    subscription {
      id
      createdAt
      trialStart
      trialEnd
      status
      interval
      pricingId
      cancelAtPeriodEnd
      currentPeriodStart
      currentPeriodEnd
      cancelAt
    }
  }
}
    `;

/**
 * __useGetStaffSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetStaffSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffSubscriptionQuery({
 *   variables: {
 *      getSubscriptionInput: // value for 'getSubscriptionInput'
 *   },
 * });
 */
export function useGetStaffSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetStaffSubscriptionQuery, GetStaffSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffSubscriptionQuery, GetStaffSubscriptionQueryVariables>(GetStaffSubscriptionDocument, options);
      }
export function useGetStaffSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffSubscriptionQuery, GetStaffSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffSubscriptionQuery, GetStaffSubscriptionQueryVariables>(GetStaffSubscriptionDocument, options);
        }
export type GetStaffSubscriptionQueryHookResult = ReturnType<typeof useGetStaffSubscriptionQuery>;
export type GetStaffSubscriptionLazyQueryHookResult = ReturnType<typeof useGetStaffSubscriptionLazyQuery>;
export type GetStaffSubscriptionQueryResult = Apollo.QueryResult<GetStaffSubscriptionQuery, GetStaffSubscriptionQueryVariables>;
export const GetOrgStaffSubscriptionDocument = gql`
    query GetOrgStaffSubscription($getOrgStaffSubscriptionInput: GetOrgStaffSubscriptionInput!) {
  getOrgStaffSubscription(
    getOrgStaffSubscriptionInput: $getOrgStaffSubscriptionInput
  ) {
    response {
      message
      status
    }
    subscription {
      id
      createdAt
      trialStart
      trialEnd
      status
      interval
      pricingId
      cancelAtPeriodEnd
      currentPeriodStart
      currentPeriodEnd
      cancelAt
    }
  }
}
    `;

/**
 * __useGetOrgStaffSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetOrgStaffSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgStaffSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgStaffSubscriptionQuery({
 *   variables: {
 *      getOrgStaffSubscriptionInput: // value for 'getOrgStaffSubscriptionInput'
 *   },
 * });
 */
export function useGetOrgStaffSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetOrgStaffSubscriptionQuery, GetOrgStaffSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgStaffSubscriptionQuery, GetOrgStaffSubscriptionQueryVariables>(GetOrgStaffSubscriptionDocument, options);
      }
export function useGetOrgStaffSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgStaffSubscriptionQuery, GetOrgStaffSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgStaffSubscriptionQuery, GetOrgStaffSubscriptionQueryVariables>(GetOrgStaffSubscriptionDocument, options);
        }
export type GetOrgStaffSubscriptionQueryHookResult = ReturnType<typeof useGetOrgStaffSubscriptionQuery>;
export type GetOrgStaffSubscriptionLazyQueryHookResult = ReturnType<typeof useGetOrgStaffSubscriptionLazyQuery>;
export type GetOrgStaffSubscriptionQueryResult = Apollo.QueryResult<GetOrgStaffSubscriptionQuery, GetOrgStaffSubscriptionQueryVariables>;
export const GetOrganizationSubscriptionDocument = gql`
    query GetOrganizationSubscription($getSubscriptionByOrgIdInput: GetSubscriptionByOrgIdInput!) {
  getOrganizationSubscription(
    getSubscriptionByOrgIdInput: $getSubscriptionByOrgIdInput
  ) {
    response {
      message
      status
    }
    subscription {
      id
      trialStart
      trialEnd
      status
      interval
      cancelAtPeriodEnd
      currentPeriodStart
      currentPeriodEnd
      cancelAt
    }
  }
}
    `;

/**
 * __useGetOrganizationSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSubscriptionQuery({
 *   variables: {
 *      getSubscriptionByOrgIdInput: // value for 'getSubscriptionByOrgIdInput'
 *   },
 * });
 */
export function useGetOrganizationSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSubscriptionQuery, GetOrganizationSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSubscriptionQuery, GetOrganizationSubscriptionQueryVariables>(GetOrganizationSubscriptionDocument, options);
      }
export function useGetOrganizationSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSubscriptionQuery, GetOrganizationSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSubscriptionQuery, GetOrganizationSubscriptionQueryVariables>(GetOrganizationSubscriptionDocument, options);
        }
export type GetOrganizationSubscriptionQueryHookResult = ReturnType<typeof useGetOrganizationSubscriptionQuery>;
export type GetOrganizationSubscriptionLazyQueryHookResult = ReturnType<typeof useGetOrganizationSubscriptionLazyQuery>;
export type GetOrganizationSubscriptionQueryResult = Apollo.QueryResult<GetOrganizationSubscriptionQuery, GetOrganizationSubscriptionQueryVariables>;
export const GetOrgAdminDocument = gql`
    query GetOrgAdmin($getUserInput: GetUserInput!) {
  getOrgAdmin(getUserInput: $getUserInput) {
    response {
      status
    }
    user {
      id
      email
      phone
      lastName
      staffRole
      firstName
      organization {
        id
        name
        maxUser
      }
    }
  }
}
    `;

/**
 * __useGetOrgAdminQuery__
 *
 * To run a query within a React component, call `useGetOrgAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgAdminQuery({
 *   variables: {
 *      getUserInput: // value for 'getUserInput'
 *   },
 * });
 */
export function useGetOrgAdminQuery(baseOptions: Apollo.QueryHookOptions<GetOrgAdminQuery, GetOrgAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgAdminQuery, GetOrgAdminQueryVariables>(GetOrgAdminDocument, options);
      }
export function useGetOrgAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgAdminQuery, GetOrgAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgAdminQuery, GetOrgAdminQueryVariables>(GetOrgAdminDocument, options);
        }
export type GetOrgAdminQueryHookResult = ReturnType<typeof useGetOrgAdminQuery>;
export type GetOrgAdminLazyQueryHookResult = ReturnType<typeof useGetOrgAdminLazyQuery>;
export type GetOrgAdminQueryResult = Apollo.QueryResult<GetOrgAdminQuery, GetOrgAdminQueryVariables>;
export const LoginDocument = gql`
    mutation Login($loginInput: LoginInput!) {
  login(loginInput: $loginInput) {
    token
    response {
      status
      message
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginInput: // value for 'loginInput'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SignUpUserDocument = gql`
    mutation SignUpUser($userSignUpInput: UserSignUpInput!) {
  signUpUser(userSignUpInput: $userSignUpInput) {
    response {
      status
      message
    }
  }
}
    `;
export type SignUpUserMutationFn = Apollo.MutationFunction<SignUpUserMutation, SignUpUserMutationVariables>;

/**
 * __useSignUpUserMutation__
 *
 * To run a mutation, you first call `useSignUpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUserMutation, { data, loading, error }] = useSignUpUserMutation({
 *   variables: {
 *      userSignUpInput: // value for 'userSignUpInput'
 *   },
 * });
 */
export function useSignUpUserMutation(baseOptions?: Apollo.MutationHookOptions<SignUpUserMutation, SignUpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpUserMutation, SignUpUserMutationVariables>(SignUpUserDocument, options);
      }
export type SignUpUserMutationHookResult = ReturnType<typeof useSignUpUserMutation>;
export type SignUpUserMutationResult = Apollo.MutationResult<SignUpUserMutation>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<SignUpUserMutation, SignUpUserMutationVariables>;
export const InviteOrganizationDocument = gql`
    mutation InviteOrganization($inviteOrganizationInput: InviteOrganizationInput!) {
  inviteOrganization(inviteOrganizationInput: $inviteOrganizationInput) {
    response {
      status
      message
    }
  }
}
    `;
export type InviteOrganizationMutationFn = Apollo.MutationFunction<InviteOrganizationMutation, InviteOrganizationMutationVariables>;

/**
 * __useInviteOrganizationMutation__
 *
 * To run a mutation, you first call `useInviteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteOrganizationMutation, { data, loading, error }] = useInviteOrganizationMutation({
 *   variables: {
 *      inviteOrganizationInput: // value for 'inviteOrganizationInput'
 *   },
 * });
 */
export function useInviteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<InviteOrganizationMutation, InviteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteOrganizationMutation, InviteOrganizationMutationVariables>(InviteOrganizationDocument, options);
      }
export type InviteOrganizationMutationHookResult = ReturnType<typeof useInviteOrganizationMutation>;
export type InviteOrganizationMutationResult = Apollo.MutationResult<InviteOrganizationMutation>;
export type InviteOrganizationMutationOptions = Apollo.BaseMutationOptions<InviteOrganizationMutation, InviteOrganizationMutationVariables>;
export const UpdateOrgAndUserDocument = gql`
    mutation UpdateOrgAndUser($updateOrgAndUserInput: UpdateOrgAndUserInput!) {
  updateOrgAndUser(updateOrgAndUserInput: $updateOrgAndUserInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateOrgAndUserMutationFn = Apollo.MutationFunction<UpdateOrgAndUserMutation, UpdateOrgAndUserMutationVariables>;

/**
 * __useUpdateOrgAndUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrgAndUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgAndUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgAndUserMutation, { data, loading, error }] = useUpdateOrgAndUserMutation({
 *   variables: {
 *      updateOrgAndUserInput: // value for 'updateOrgAndUserInput'
 *   },
 * });
 */
export function useUpdateOrgAndUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgAndUserMutation, UpdateOrgAndUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgAndUserMutation, UpdateOrgAndUserMutationVariables>(UpdateOrgAndUserDocument, options);
      }
export type UpdateOrgAndUserMutationHookResult = ReturnType<typeof useUpdateOrgAndUserMutation>;
export type UpdateOrgAndUserMutationResult = Apollo.MutationResult<UpdateOrgAndUserMutation>;
export type UpdateOrgAndUserMutationOptions = Apollo.BaseMutationOptions<UpdateOrgAndUserMutation, UpdateOrgAndUserMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($updatePasswordInput: UpdatePasswordInput!) {
  updatePassword(updatePasswordInput: $updatePasswordInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      updatePasswordInput: // value for 'updatePasswordInput'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($forgotPasswordInput: ForgotPasswordInput!) {
  forgotPassword(forgotPasswordInput: $forgotPasswordInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      forgotPasswordInput: // value for 'forgotPasswordInput'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ConfirmPasswordDocument = gql`
    mutation ConfirmPassword($verifyEmailAndSetPasswordInput: VerifyUserAndUpdatePasswordInput!) {
  verifyEmailAndSetPassword(
    verifyEmailAndSetPasswordInput: $verifyEmailAndSetPasswordInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type ConfirmPasswordMutationFn = Apollo.MutationFunction<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>;

/**
 * __useConfirmPasswordMutation__
 *
 * To run a mutation, you first call `useConfirmPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPasswordMutation, { data, loading, error }] = useConfirmPasswordMutation({
 *   variables: {
 *      verifyEmailAndSetPasswordInput: // value for 'verifyEmailAndSetPasswordInput'
 *   },
 * });
 */
export function useConfirmPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>(ConfirmPasswordDocument, options);
      }
export type ConfirmPasswordMutationHookResult = ReturnType<typeof useConfirmPasswordMutation>;
export type ConfirmPasswordMutationResult = Apollo.MutationResult<ConfirmPasswordMutation>;
export type ConfirmPasswordMutationOptions = Apollo.BaseMutationOptions<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($changePasswordInput: ChangePasswordInput!) {
  changePassword(changePasswordInput: $changePasswordInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      changePasswordInput: // value for 'changePasswordInput'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UpdateUserStatusDocument = gql`
    mutation UpdateUserStatus($updateUserStatusInput: UpdateUserStatusInput!) {
  updateUserStatus(updateUserStatusInput: $updateUserStatusInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateUserStatusMutationFn = Apollo.MutationFunction<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;

/**
 * __useUpdateUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStatusMutation, { data, loading, error }] = useUpdateUserStatusMutation({
 *   variables: {
 *      updateUserStatusInput: // value for 'updateUserStatusInput'
 *   },
 * });
 */
export function useUpdateUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>(UpdateUserStatusDocument, options);
      }
export type UpdateUserStatusMutationHookResult = ReturnType<typeof useUpdateUserStatusMutation>;
export type UpdateUserStatusMutationResult = Apollo.MutationResult<UpdateUserStatusMutation>;
export type UpdateUserStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;
export const UpdateConsentDocument = gql`
    mutation updateConsent {
  updateConsent {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateConsentMutationFn = Apollo.MutationFunction<UpdateConsentMutation, UpdateConsentMutationVariables>;

/**
 * __useUpdateConsentMutation__
 *
 * To run a mutation, you first call `useUpdateConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsentMutation, { data, loading, error }] = useUpdateConsentMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateConsentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConsentMutation, UpdateConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConsentMutation, UpdateConsentMutationVariables>(UpdateConsentDocument, options);
      }
export type UpdateConsentMutationHookResult = ReturnType<typeof useUpdateConsentMutation>;
export type UpdateConsentMutationResult = Apollo.MutationResult<UpdateConsentMutation>;
export type UpdateConsentMutationOptions = Apollo.BaseMutationOptions<UpdateConsentMutation, UpdateConsentMutationVariables>;
export const VerifyCodeDocument = gql`
    mutation VerifyCode($verifyCodeInput: VerifyCodeInput!) {
  verifyCode(verifyCodeInput: $verifyCodeInput) {
    response {
      status
      message
    }
    token
  }
}
    `;
export type VerifyCodeMutationFn = Apollo.MutationFunction<VerifyCodeMutation, VerifyCodeMutationVariables>;

/**
 * __useVerifyCodeMutation__
 *
 * To run a mutation, you first call `useVerifyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCodeMutation, { data, loading, error }] = useVerifyCodeMutation({
 *   variables: {
 *      verifyCodeInput: // value for 'verifyCodeInput'
 *   },
 * });
 */
export function useVerifyCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCodeMutation, VerifyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCodeMutation, VerifyCodeMutationVariables>(VerifyCodeDocument, options);
      }
export type VerifyCodeMutationHookResult = ReturnType<typeof useVerifyCodeMutation>;
export type VerifyCodeMutationResult = Apollo.MutationResult<VerifyCodeMutation>;
export type VerifyCodeMutationOptions = Apollo.BaseMutationOptions<VerifyCodeMutation, VerifyCodeMutationVariables>;